(
    function (skyward, $, undefined)
    {
        skyward.gradebook = skyward.gradebook || {};

        var BROWSE_NAME = "Gradebook";
        var EXPANDED_CLASS_NAME = "gradebookContainerExpanded";
        var COLLAPSED_CLASS_NAME = "gradebookContainerCollapsed";
        var CHILDREN_COLLAPSED_CLASS_NAME = "collapseChildRecords";
        var ALERT_HEADER = "Gradebook Alert";
        var PENDING_SCORE = "pendingScore";
        var GRADEBOOK_UPDATE_STATUS_WRAPPER = "GradebookUpdateStatusWrapper";
        var GRADEBOOK_EXPAND_ANIMATION_DURATION = 1000;
        var GRADEBOOK_EXPAND_ANIMATION_SCROLL_THRESHOLD = 200; //Arbitrary number that we can tweak this as we see fit. No need to make them wait a full second to scroll a tiny bit.
        var GRADEBOOK_EXIT_SCORING_MODE = "Exit Scoring Mode";
        var FLASH_COLOR = "#c9f0c9";
        var ON_LOAD_WARNING_SELECTOR = ".js-gradebookBannerWarningOnLoad";
        var TOOLBAR_LEFT_SELECTOR = ".js-gradebookToolbarLeft";
        var GRADE_COLUMN_HIDDEN_SELECTOR = "gradeBucketColumnHidden";
        const PREVENT_CLICK_CLASS_NAME = 'js-preventClick';
        const RESIZE_COLUMN_MIN_WIDTH = 65;
        const RESIZE_COLUMN_MAX_WIDTH = 300;
        const SHOW_INDICATORS_MIN_WIDTH = 131;
        const BORDER_SHADOW_WIDTH = 13;

        // Collapsible column constants. These are currently maintained in several places
        // If updates are made here, make sure those updates are also reflected in:
        // CollapsibleColumnConstants.cs, dailyattendance.js, gradebook.js
        const _collapsibleClassNames =
        {
            AfterBaseLockedColumn: "afterBaseLockedColumn",
            BeforeBaseLockedColumn: "beforeBaseLockedColumn",
            BeforeCollapsibleColumns: "beforeCollapsibleColumns",
            Collapsed: "collapsed",
            CollapsibleBrowseColumn: "collapsibleBrowseColumn",
            Expanded: "expanded",
            HiddenBrowseColumn: "hiddenBrowseColumn",
            LastBefore: "lastBefore"
        };

        var gradebookLoadTimes;

        var init = function (selector)
        {
            if ($(selector).find(".mobileGradebookScoreEntry").length > 0)
            {
                var mobileGradebookScoreEntry = $(selector).find(".mobileGradebookScoreEntry");
                mobileGradebookScoreEntry.on("change", ".NoCount, .IsMissing", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("change", ".Score", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("click", ".attemptCount", function (event, returnData)
                {
                    var data = $(this).data();
                    attemptsPopup(data);
                });
                mobileGradebookScoreEntry.on("gradebookInputCodeEELValid", ".scoreClarifier", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("eelComplete", ".codeEEL, .quickEntryText", updateAssignmentIndicatorsMobile);
                mobileGradebookScoreEntry.on("change", ".codeEELValue", function ()
                {
                    var codeEEL = $(this).parent(".codeEEL");
                    updateAssignmentIndicatorsMobile.apply(codeEEL);
                });
            }

            var gradebookContainer = $(selector + " #" + BROWSE_NAME);

            $(selector).find('#SourceAssignments').on('click', ".checkbox", validateCopyAssignmentCheckbox);

            var pageLoadStopwatch;
            var domInsertStopwatch;

            var gradebookStatsPrePageLoad = function ()
            {
                gradebookLoadTimes = {};
                pageLoadStopwatch = skyward.time.stopwatch();
            };

            var gradebookStatsServerResponsePostLoad = function ()
            {
                gradebookLoadTimes["Server Response"] = pageLoadStopwatch.duration();
            };

            var gradebookStatsDOMInsertionPreLoad = function ()
            {
                domInsertStopwatch = skyward.time.stopwatch();
            };

            var gradebookStatsDOMInsertionPostLoad = function ()
            {
                gradebookLoadTimes["DOM Insertion"] = domInsertStopwatch.duration();
            };

            var gradebookStatsPostPageLoad = function ()
            {
                gradebookLoadTimes["Total"] = pageLoadStopwatch.duration();
            };

            $(selector + " #OODDestinationClosedBuckets").on("eelComplete", ".codeEEL", function ()
            {
                updatePercentFromGradeMarkDefaultPercent($(this), 'StudentGradeBucketPercentScore');
            });

            $(selector + " #OODDestinationPercents").on("eelComplete", ".codeEEL", function ()
            {
                updatePercentFromGradeMarkDefaultPercent($(this), 'StudentStartingPercentScore');
            });

            var placeholderDiv = $(selector).find('#gradebookPlaceholder');

            if (placeholderDiv.length > 0 && gradebookContainer.length == 0)
            {
                placeholderDiv.on('PageLoadingPreLoad', gradebookStatsPrePageLoad);
                placeholderDiv.on('ServerResponsePostLoad', gradebookStatsServerResponsePostLoad);
                placeholderDiv.on('DOMInsertionPreLoad', gradebookStatsDOMInsertionPreLoad);
                placeholderDiv.on('DOMInsertionPostLoad', gradebookStatsDOMInsertionPostLoad);
                placeholderDiv.on('PageLoadingPostLoad', gradebookStatsPostPageLoad);
            }

            if (gradebookContainer.length == 0)
            {
                return;
            }

            var gradebookBrowse = $('#' + BROWSE_NAME);
            var gradebookData = gradebookBrowse.data();
            var gradebookPlaceholder = gradebookBrowse.parent();
            var enabledGradeSheetGradeMarkScoringWidth = '3.1em';
            var disabledGradeSheetGradeMarkScoringWidth = '3.9em';
            gradebookBrowse.off();
            // re-add locked column simulated focus listener
            skyward.browse.bindLockedBodySimulatedFocus(gradebookBrowse);
            var gradebook =
            {
                id: BROWSE_NAME,
                currentRow: 0,
                browse: gradebookBrowse,
                controls: $('#' + BROWSE_NAME + '_controls'),
                unlockedHeader: $('#' + BROWSE_NAME + '_unlockedHeader'),
                lockedHeader: $('#' + BROWSE_NAME + '_lockedHeader'),
                lockedRowHeader: $('#' + BROWSE_NAME + '_lockedHeaderRow'),
                unlockedRowHeader: $('#' + BROWSE_NAME + '_unlockedRowHeader'),
                unlockedRowSpacerHeader: $('#' + BROWSE_NAME + '_unlockedRowSpacerHeader'),
                lockedHeaderSpacerRow: $('#' + BROWSE_NAME + '_lockedHeaderSpacerRow'),
                unlockedAveragesRowHeader: $('#' + BROWSE_NAME + '_unlockedAveragesRowHeader'),
                dataContainer: $('#' + BROWSE_NAME + '_dataContainer'),
                body: $('#' + BROWSE_NAME + '_body'),
                unlockedBody: $('#' + BROWSE_NAME + '_unlockedBody'),
                lockedBody: $('#' + BROWSE_NAME + '_lockedBody'),
                lockedBodyTable: $("#" + BROWSE_NAME + "_lockedBodyTable"),
                header: $('#' + BROWSE_NAME + '_header'),
                headerSpacer: $('#' + BROWSE_NAME + '_headerSpacer'),
                headerSpacerDiv: $('#' + BROWSE_NAME + '_headerSpacerDiv'),
                editButton: $("#UpdateEditMode"),
                massAssign: $('#MassAssignScores'),
                hideDuringEditMode: $('#DisplayTypeButton'),
                editMode: gradebookData.singleassignment == true,
                readOnly: gradebookData.readOnly == 'true',
                colorData: function ()
                {
                    return gradebook.unlockedBody.data().grademarkcolordata;
                },
                reloadGradebook: function (area, controller, action, additionalData)
                {
                    if (gradebook.gradebookFullyLoadedPromise && !gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.gradebookFullyLoadedPromise.reject(new skyward.error.CancellationError("Not fully loaded"));
                    }

                    gradebookStatsPrePageLoad();
                    gradebook.showLoadingIcon();

                    var data = getRequiredGradebookData();

                    if (additionalData)
                    {
                        $.extend(data, additionalData);
                    }

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + area + "/" + controller + "/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: data,
                            activityIndicator: { silent: true },
                            success: function (returnData)
                            {
                                gradebookStatsServerResponsePostLoad();
                                if (returnData.html)
                                {
                                    gradebook.updateGradebookContents(returnData.html);
                                    gradebookStatsPostPageLoad();
                                }
                            }
                        });
                },
                showLoadingIcon: function ()
                {
                    gradebookPlaceholder.get(0).innerHTML = '';
                    var pageLoadingDiv = '<div class="pageLoadingDataContainer" >' + skyward.window.getImageHtml() + '<span class="pageLoadingMessage">Loading Gradebook</span></div>';
                    gradebookPlaceholder.prepend(pageLoadingDiv);
                },
                showLoadingIconInContainer: function (container)
                {
                    var pageLoadingImage = skyward.window.getImage();
                    container.append(pageLoadingImage);
                },
                removeLoadingIconFromContainer: function (container)
                {
                    container.find(".pageLoadingGif").remove();
                },
                updateGradebookContents: function (html)
                {
                    gradebookStatsDOMInsertionPreLoad();
                    gradebookPlaceholder.remove(".pageLoadingGif");
                    gradebookPlaceholder.get(0).innerHTML = html;
                    skyward.window.notifyDOMLoad("#moduleContent");
                    gradebookStatsDOMInsertionPostLoad();
                },
                expandCollapseLockedColumns: function ()
                {
                    var clickedElement = $(this);

                    if (!gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.queueFunctionToCallOnCompletionOfLoad(gradebook.expandCollapseLockedColumns, clickedElement, {});
                        return;
                    }

                    var collapse;
                    var classToLookFor = `.${_collapsibleClassNames.CollapsibleBrowseColumn}`;
                    var iconButtonClicked = clickedElement.hasClass('gradebookLockedIconColumnButton');
                    if (iconButtonClicked)
                    {
                        classToLookFor += '.beforeBaseLockedColumn';
                    }
                    else
                    {
                        classToLookFor += `.${_collapsibleClassNames.AfterBaseLockedColumn}`;
                    }
                    if (gradebookBrowse.find(classToLookFor + `.${_collapsibleClassNames.HiddenBrowseColumn}`).length == 0)
                    {
                        collapse = true;
                        skyward.svg.swapSvg(clickedElement.find("svg"), "ChevronRight", "GradebookHeader");
                        gradebookBrowse.find(classToLookFor).addClass(_collapsibleClassNames.HiddenBrowseColumn);

                        gradebook.updateLockedBodyWidths();
                    }
                    else
                    {
                        collapse = false;
                        skyward.svg.swapSvg(clickedElement.find("svg"), "ChevronLeft", "GradebookHeader");
                        gradebookBrowse.find(classToLookFor).removeClass(_collapsibleClassNames.HiddenBrowseColumn);

                        gradebook.updateLockedBodyWidths();
                    }

                    gradebookBrowse.trigger("Gradebook.UpdateLockedColumnState",
                    {
                        collapse: collapse,
                        fieldToSet: iconButtonClicked ? 'HideLockedIcons' : 'HideLockedColumns'
                    });

                    gradebook.resize();
                },
                updateLockedBodyWidths: function ()
                {
                    var lockedTableWidth = gradebook.lockedBodyTable.width();

                    var boxShadowPadding = 12;
                    $('#' + BROWSE_NAME).find(".lockedBrowseBody_scrollwrapper").width(lockedTableWidth + boxShadowPadding);

                    var hideScrollbarWidth = 100;
                    gradebook.lockedBody.width(lockedTableWidth + hideScrollbarWidth);
                },
                updateTeacherSectionSetting: function (event, extraParameters)
                {
                    var data = gradebookBrowse.data();
                    var action = "UpdateCollapsedLockedColumnState";
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    data.hidden = extraParameters.collapse;
                    data.fieldToSet = extraParameters.fieldToSet
                    $.ajax({
                        activityIndicator: { silent: true },
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: data
                    });
                },
                loadGradebookLayers: function (options)
                {
                    var action = "GetGradebookLayers";
                    var data = gradebookBrowse.data();
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.each(data.layers, function (k, v)
                    {
                        var layerData =
                        {
                            layer: k,
                            layerPostData: JSON.stringify(v)
                        };

                        $.extend(layerData, data);

                        if (layerData.layer == "UpdateStaffMeet" && (!options || !options.requiresStaffMeetUpdate))
                        {
                            return false;
                        }

                        var ajax = $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                                type: "POST",
                                dataType: "JSON",
                                data: layerData,
                                activityIndicator: { silent: true },
                                success: function (returnData)
                                {
                                    if (returnData.returnData)
                                    {
                                        gradebook.insertGradebookLayersIntoDOM(returnData.returnData);
                                    }
                                }
                            });
                    });
                },
                insertGradebookLayersIntoDOM: function (returnData)
                {
                    $.each(returnData, function (k, v)
                    {
                        //If more layer types are added make sure that you handle the fact that data might already be on the screen and do not duplicate it
                        if (k == "AssignmentAttendanceIndicator")
                        {
                            var attendanceHeaderCell = gradebookBrowse.find(".todaysAttendance");
                            var attendanceHeaderCellData;

                            if (attendanceHeaderCell.length > 0)
                            {
                                attendanceHeaderCellData = attendanceHeaderCell.data();
                            }

                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, dateList)
                                {
                                    for (var i = 0; i < dateList.length; i++)
                                    {
                                        var assignmentData = dateList[i];
                                        var date = assignmentData.Date;
                                        var showOnGradesheetAssignments = assignmentData.ShowOnGradesheetAssignments;

                                        if (v.PostData.DisplayAssignmentAttendanceIndicator && showOnGradesheetAssignments)
                                        {
                                            //Add indicator to all appropriate student assignment cells
                                            gradebookBrowse.find(".assignmentNameSpan:contains('" + date + "')").each(function ()
                                            {
                                                var assignmentID = $(this).parents(".assignmentHeaderCell").data().assignmentid;

                                                var studentAssignmentCell = getAssignmentCellByField({ studentsectionid: studentSectionID, assignmentid: assignmentID }, "Score");

                                                if (studentAssignmentCell.find('.skipStudentAssignment').length == 0)
                                                {
                                                    var indicatorRow = studentAssignmentCell.find(".assignmentIndicatorButton > .assignmentIndicatorsFirstRow");

                                                    //If the icon has already been added then we don't need to do anything
                                                    var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.AttendanceTypeIndicator));

                                                    if (indicatorRow.find(iconClassSelector).length < 1)
                                                    {
                                                        indicatorRow.append(v.HTMLToInject.AttendanceTypeIndicator);
                                                        indicatorRow.removeClass("hiddenAttendanceType");
                                                        updateStudentAssignmentButtonDisplay(studentAssignmentCell);
                                                    }
                                                }
                                            });
                                        }

                                        //Look for todays attendance column
                                        if (attendanceHeaderCell && attendanceHeaderCell.length > 0)
                                        {

                                            var todaysDate = attendanceHeaderCellData.date;
                                            if (todaysDate == date)
                                            {
                                                var unlockedRow = gradebook.unlockedBody.find("tr[data-student-section-id='" + studentSectionID + "']");
                                                if (unlockedRow.length > 0)
                                                {
                                                    var attendanceColumnDisplay = dateList[i].TypeCode + " - " + dateList[i].ReasonCode;

                                                    var lockedRow = gradebook.lockedBody.find("tr[data-row='" + unlockedRow.data().row + "']");
                                                    var todaysAttendanceCell = lockedRow.find("td[data-column='" + attendanceHeaderCellData.column + "']");
                                                    todaysAttendanceCell.find("div").html(attendanceColumnDisplay);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        }
                        else if (k == "AssignmentMultipleAttemptsIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, studentAssignmentID)
                                {
                                    if (v.PostData.DisplayAssignmentMultipleAttemptsIndicator)
                                    {
                                        //Add indicator to all appropriate student assignment cells
                                        gradebookBrowse.find("input.hasAttempts[data-studentassignmentid='" + studentAssignmentID + "']").each(function ()
                                        {
                                            var studentAssignmentInput = $(this);
                                            var studentAssignmentCell = studentAssignmentInput.parents('.assignmentCell');
                                            var indicatorRow = studentAssignmentCell.find(".assignmentIndicatorButton > .assignmentIndicatorsFirstRow");

                                            //If the icon has already been added then we don't need to do anything
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.MultipleAttemptsIndicator));

                                            if (indicatorRow.find(iconClassSelector).length < 1)
                                            {
                                                indicatorRow.prepend(v.HTMLToInject.MultipleAttemptsIndicator);
                                                indicatorRow.removeClass("hiddenMultipleAttempts");
                                                updateStudentAssignmentButtonDisplay(studentAssignmentCell);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "StudentGradingPeriodCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, gradingPeriodList)
                                {
                                    for (var i = 0; i < gradingPeriodList.length; i++)
                                    {
                                        var gradingPeriodID = gradingPeriodList[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.gradeBucketCell[data-grading-period-id='" + gradingPeriodID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.CommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.CommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "SubjectGradeBucketCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, calculationGroupSubjectGradeBuckets)
                                {
                                    for (var i = 0; i < calculationGroupSubjectGradeBuckets.length; i++)
                                    {
                                        var calculationGroupSubjectGradeBucketID = calculationGroupSubjectGradeBuckets[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.subjectCell[data-calculation-group-subject-grade-bucket-id='" + calculationGroupSubjectGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.SubjectCommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.SubjectCommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "AcademicStandardGradeBucketCommentIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, calculationGroupAcademicStandardGradeBuckets)
                                {
                                    for (var i = 0; i < calculationGroupAcademicStandardGradeBuckets.length; i++)
                                    {
                                        var calculationGroupAcademicStandardGradeBucketID = calculationGroupAcademicStandardGradeBuckets[i];

                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.academicStandardCell[data-calculation-group-academic-standard-grade-bucket-id='" + calculationGroupAcademicStandardGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.AcademicStandardCommentIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                cell.find(".studentGradeBucketIndicators").removeClass('hiddenComments').append(v.HTMLToInject.AcademicStandardCommentIndicator);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                        else if (k == "WarningIndicator")
                        {
                            if (v.CellsToUpdateDataJSON)
                            {
                                $.each(JSON.parse(v.CellsToUpdateDataJSON), function (studentSectionID, gradingPeriodGradeBucketIDs)
                                {
                                    $.each(gradingPeriodGradeBucketIDs, function (gradingPeriodGradeBucketID, value)
                                    {
                                        gradebookBrowse.find("tr.gradesheetBrowseRow[data-student-section-id='" + studentSectionID + "'] td.gradeBucketCell[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']").each(function ()
                                        {
                                            var cell = $(this);
                                            var iconClassSelector = getClassSelectorFromAllClassesOnElement($(v.HTMLToInject.WarningIndicator).find("svg"));

                                            if (cell.find(iconClassSelector).length < 1)
                                            {
                                                if (value === true)
                                                {
                                                    cell.find(".studentGradeBucketIndicators").removeClass('hiddenWarning').append(v.HTMLToInject.WarningIndicator);
                                                }
                                                else
                                                {
                                                    cell.find(".studentGradeBucketIndicators").addClass('hiddenWarning').append(v.HTMLToInject.WarningIndicator);
                                                }
                                            }
                                        });
                                    });
                                });
                            }
                        }
                    });

                    gradebook.resize();
                },
                getSectionData: function (cell)
                {
                    var row = cell.parents("tr").first();
                    var rowData;

                    if (row.parents("div").first().hasClass('lockedBrowseBody'))
                    {
                        var rowNumber = row.data().row;
                        var unlockedRowData = $('#Gradebook_unlockedRow' + rowNumber).data();
                        return { sectionID: unlockedRowData.sectionId, sectionIDHash: unlockedRowData.sectionIdHash };
                    }
                    else
                    {
                        rowData = row.data();
                        return { sectionID: rowData.sectionId, sectionIDHash: rowData.sectionIdHash };
                    }
                },
                getRepresentedAssignmentID: function (assignmentId, sectionId)
                {
                    var headerCell = $("#assignment" + assignmentId + "HeaderCell");
                    var headerCellData = headerCell.data();
                    if (headerCellData && headerCellData.representedAssignmentIds && headerCellData.representedAssignmentIds[sectionId])
                    {
                        return headerCellData.representedAssignmentIds[sectionId];
                    }

                    return null;
                },
                //When we are showing a class group and an assignment is in all sections,
                //we render 1 assignment column that might represent 4 assignments across 4 sections.
                //The gradebook has a 'driver' assignment with a data attribute to show all the assignments it represents.
                //This function takes a passed in assignmentID and checks if its on the gradesheet, and if not, finds the assignment for the driver section that represents it
                getEffectiveAssignmentID: function (assignmentID, studentSectionID, sectionID, gradingPeriodGradeBucketID)
                {
                    var effectiveAssignmentID = assignmentID;

                    var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + assignmentID + "_Score");

                    if (studentAssignmentCell == null || studentAssignmentCell.length == 0)
                    {
                        gradebook.unlockedHeader.find(".assignmentHeaderCell.js_gradingPeriodGradeBucketID" + gradingPeriodGradeBucketID).each(function ()
                        {
                            var assignmentHeaderCell = $(this);
                            var assignmentHeaderCellData = assignmentHeaderCell.data();

                            if (assignmentHeaderCellData && assignmentHeaderCellData.representedAssignmentIds && assignmentHeaderCellData.representedAssignmentIds[sectionID] == assignmentID)
                            {
                                effectiveAssignmentID = assignmentHeaderCellData.assignmentid;
                                studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");
                            }
                        });
                    }

                    return effectiveAssignmentID;

                },
                loadCellContents: function (button, cellData, loadSettings, expandAnimationPromise)
                {
                    var loadContentsPromise = new $.Deferred();

                    button.find("svg").hide();
                    gradebook.showLoadingIconInContainer(button);

                    var action = "FetchGradebookCells";
                    var data = gradebookBrowse.data();
                    if (data.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    var requiredData = getRequiredGradebookData();
                    $.extend(requiredData, data);
                    $.extend(requiredData, cellData);

                    var columnExpanded = button.parents("td");
                    var columnNumberExpanded = columnExpanded.data().column;
                    var nextColumnIndex = (parseInt(columnNumberExpanded) + 1);
                    requiredData.startingColumnIndex = nextColumnIndex;
                    requiredData.hasAdditionalColumnsAfterThis = columnExpanded.next("td").length > 0;

                    var expandedColumnInUnlockedHeaderRow = gradebook.unlockedRowHeader.find("td[data-column='" + columnNumberExpanded + "']");
                    var nextColumnInUnlockedHeaderRow = expandedColumnInUnlockedHeaderRow.nextAll("td:visible").first();

                    if (requiredData['objectType'] == 'Assignment')
                    {
                        $.extend(requiredData, { 'representedAssignmentIds': JSON.stringify(expandedColumnInUnlockedHeaderRow.data('representedAssignmentIds')) });
                    }

                    var cellTypeClass = expandedColumnInUnlockedHeaderRow.hasClass("gradeBucketHeaderCell")
                        ? "gradeBucketHeaderCell"
                        : expandedColumnInUnlockedHeaderRow.hasClass("subjectHeaderColumn")
                            ? "subjectHeaderColumn"
                            : expandedColumnInUnlockedHeaderRow.hasClass("academicStandardHeaderCell")
                                ? "academicStandardHeaderCell"
                                : "assignmentHeaderCell";

                    var columnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookTertiaryContainer").last().data("level");

                    if (columnLevel == null)
                    {
                        columnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookSecondaryContainer").last().data("level");
                    }

                    requiredData.hasSiblingNextAtLevel = {};
                    requiredData.hasSiblingNextAtLevel[0] = expandedColumnInUnlockedHeaderRow.next("td").data("subjectId") == expandedColumnInUnlockedHeaderRow.data("subjectId"); //has same subject
                    for (var i = 1; i <= columnLevel; i++)
                    {
                        var nextColumnLevel = expandedColumnInUnlockedHeaderRow.next("td." + cellTypeClass).find("div.gradebookTertiaryContainer").last().data("level");
                        if (nextColumnLevel == null)
                        {
                            nextColumnLevel = expandedColumnInUnlockedHeaderRow.find("div.gradebookSecondaryContainer").last().data("level");
                        }
                        if (i < nextColumnLevel)
                        {
                            requiredData.hasSiblingNextAtLevel[i] = true;
                        }
                        else
                        {
                            requiredData.hasSiblingNextAtLevel[i] = false;
                        }
                    }
                    requiredData.hasSiblingNextAtLevel = JSON.stringify(requiredData.hasSiblingNextAtLevel);

                    $.ajax(
                        {
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                            type: "POST",
                            dataType: "JSON",
                            data: requiredData,
                            activityIndicator: { silent: true },
                            error: function ()
                            {
                                loadContentsPromise.resolve();
                            },
                            success: async function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                    loadContentsPromise.resolve();
                                }
                                else
                                {
                                    var rows = JSON.parse(returnData.jsonGradebookRows);
                                    await Promise.all(rows.map(async rowJSON =>
                                    {
                                        if (rowJSON != null)
                                        {
                                            rowJSON.JSONGradebookColumns = await skyward.global.processViewPartHtml(rowJSON.JSONGradebookColumns);
                                        }
                                    }));
                                    $.when(expandAnimationPromise).done(function ()
                                    {
                                        var promises = [];

                                        $.each(rows, function ()
                                        {
                                            var rowPromise = new $.Deferred();
                                            var rowJSON = this;

                                            var rowElement;
                                            switch (rowJSON.RowType)
                                            {
                                                case 'Header':
                                                    rowElement = gradebook.unlockedRowHeader;
                                                    break;
                                                case 'HeaderSpacer':
                                                    rowElement = gradebook.unlockedRowSpacerHeader;
                                                    break;
                                                case 'Average':
                                                    rowElement = gradebook.unlockedAveragesRowHeader;
                                                    break;
                                                default:
                                                    rowElement = gradebook.unlockedBody.find("tr.gradesheetBrowseRow[data-student-section-id='" + rowJSON.StudentSectionID + "']");
                                            }

                                            if (rowElement.length > 0)
                                            {
                                                var columnToInsertAfter = rowElement.find("td[data-column='" + columnNumberExpanded + "']:not('hidden')");
                                                var offset = rowJSON.ColumnOffset;

                                                $.each($(rowJSON.JSONGradebookColumns), function ()
                                                {
                                                    var gradebookColumn = $(this);

                                                    if (gradebookColumn != null)
                                                    {
                                                        var columnToInsert = gradebookColumn;
                                                        gradebookColumn.find('.studentAssignmentScoreInput').addClass('js-maskInitialized');
                                                        if (loadSettings && loadSettings.defaultCollapsed == true)
                                                        {
                                                            columnToInsert.addClass(COLLAPSED_CLASS_NAME);
                                                        }

                                                        columnToInsert.insertAfter(columnToInsertAfter);
                                                        columnToInsertAfter = columnToInsert;
                                                    }
                                                });

                                                if (columnToInsertAfter.nextAll("td").length > 0)
                                                {
                                                    $.each(columnToInsertAfter.nextAll("td"), function ()
                                                    {
                                                        var affectedColumn = $(this);

                                                        if (affectedColumn && affectedColumn.length > 0)
                                                        {
                                                            var columnNumber = affectedColumn.data().column;

                                                            if (columnNumber)
                                                            {
                                                                var newColumnNumber = parseInt(affectedColumn.data().column) + offset;
                                                                affectedColumn.data("column", newColumnNumber);
                                                                affectedColumn.attr("data-column", newColumnNumber);
                                                            }
                                                        }
                                                    });

                                                    rowPromise.resolve();
                                                }
                                                else
                                                {
                                                    rowPromise.resolve();
                                                }
                                                promises.push(rowPromise);
                                            }
                                        });

                                        if (!loadSettings || !loadSettings.defaultCollapsed)
                                        {
                                            gradebook.expandChildrenCells(loadSettings, button, nextColumnInUnlockedHeaderRow);
                                        }

                                        $.when.apply($, promises).then(function ()
                                        {
                                            gradebook.updateScoringModeControls();
                                            if (gradebook.editMode)
                                            {
                                                var buttonText = gradebook.editButton.find('.textAfter');
                                                enterScoringMode(buttonText);
                                            }

                                            var setFocusOnInput = true;
                                            if (loadSettings != null && loadSettings.setFocusOnInput != null)
                                            {
                                                setFocusOnInput = loadSettings.setFocusOnInput
                                            }
                                            if (setFocusOnInput && gradebook.currentCell && gradebook.currentRow != null)
                                            {
                                                gradebook.updateCurrentCellInRow(columnNumberExpanded);
                                            }
                                            loadContentsPromise.resolve();
                                        });
                                    });
                                }
                            }
                        });

                    return loadContentsPromise.promise();
                },
                resetCellBackgroundColor: function (cell)
                {
                    var cellData = cell.data();

                    if (cellData)
                    {
                        cell.css({ backgroundColor: cellData.backgroundColor, color: cellData.color });
                    }
                },
                hasBackgroundColorOverride: function (cell)
                {
                    return cell.hasClass("updatedWithErrors") || cell.hasClass('hasErrors') || cell.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress") || cell.hasClass("gradeBucketGradeChangeDenied");
                },
                toggleBucketDisplay: function (event)
                {
                    var bucket = $(this);
                    gradebook.toggleChildrenCellDisplay(bucket, { allowDuplicates: false });

                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleSubjectDisplay: function (event)
                {
                    var subjectBucket = $(this);
                    gradebook.toggleChildrenCellDisplay(subjectBucket, { allowDuplicates: false });

                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleAcademicStandardDisplay: function (event)
                {
                    var standardBucket = $(this);
                    gradebook.toggleChildrenCellDisplay(standardBucket, { allowDuplicates: false });
                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleAssignmentDisplay: function (event)
                {
                    var assignmentCell = $(this);
                    gradebook.toggleChildrenCellDisplay(assignmentCell, { allowDuplicates: true });
                    event.preventDefault();
                    event.stopPropagation();
                },
                toggleChildrenCellDisplay: function (button, loadSettings)
                {
                    var toggleDisplayDeferred;

                    if (loadSettings && loadSettings.toggleDisplayDeferred)
                    {
                        toggleDisplayDeferred = loadSettings.toggleDisplayDeferred;
                    }
                    else
                    {
                        toggleDisplayDeferred = new $.Deferred();
                        loadSettings.toggleDisplayDeferred = toggleDisplayDeferred;
                    }

                    if (!gradebook.isGradebookFullyLoaded())
                    {
                        gradebook.queueFunctionToCallOnCompletionOfLoad(gradebook.toggleChildrenCellDisplay, null, { allowDuplicates: loadSettings.allowDuplicates }, [button, loadSettings]);
                        return toggleDisplayDeferred.promise();
                    }

                    gradebook.gradebookFullyLoadedPromise = new $.Deferred();

                    var data = button.data();
                    var collapsed = button.hasClass(COLLAPSED_CLASS_NAME);
                    //update teacher section setting objects
                    var action = "ToggleContainerDisplay";

                    data.collapsed = !collapsed;
                    data.teacherSectionSettingId = gradebookData.teacherSectionSettingId;

                    if (gradebookData.isTeacherTracker.toString().toLowerCase() == "true")
                    {
                        action += "TeacherTracker";
                    }

                    var animationResponseData =
                    {
                        animationPromise: new $.Deferred(),
                        requiresPostLoadScroll: false
                    };

                    if ((loadSettings && loadSettings.animate == false) || data.collapsed)
                    {
                        animationResponseData.animationPromise.resolve();
                    }
                    else
                    {
                        animationResponseData = gradebook.animateColumnExpand(button.parents("td").first(), loadSettings);
                    }

                    var updateDisplaySettingPromise = new $.Deferred();

                    if (data.objectType != 'Assignment')
                    {
                        updateDisplaySettingPromise = $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                                type: "POST",
                                dataType: "JSON",
                                data: data,
                                activityIndicator: { silent: true },
                                success: function (returnData) {
                                }
                            });
                    }
                    else
                    {
                        updateDisplaySettingPromise.resolve();
                    }

                    $.when(updateDisplaySettingPromise).done(function ()
                        {
                            var myPromise = new $.Deferred();
                            var isLoaded = data.isLoaded; //make sure we set this when we come back with the columns
                            if (!isLoaded)
                            {
                                myPromise = gradebook.loadCellContents(button, data, loadSettings, animationResponseData.animationPromise);
                                button.data().isLoaded = true;
                            }
                            else
                            {
                                $.when(animationResponseData.animationPromise).done(function ()
                                {
                                    myPromise.resolve();
                                });
                            }

                            $.when(myPromise).done(function ()
                            {
                                gradebook.removeLoadingIconFromContainer(button);

                                if (collapsed)
                                {
                                    if (!loadSettings || !loadSettings.defaultCollapsed)
                                    {
                                        button.removeClass(COLLAPSED_CLASS_NAME);
                                        button.addClass(EXPANDED_CLASS_NAME);
                                        skyward.svg.swapSvg(button.find("svg"), "ChevronLeft", "GradebookHeader");
                                    }

                                    if (isLoaded)
                                    {
                                        var expandedColumnInUnlockedHeaderRow = gradebook.unlockedRowHeader.find("td[data-column='" + button.parents("td").data().column + "']");
                                        var nextColumnInUnlockedHeaderRow = expandedColumnInUnlockedHeaderRow.nextAll("td:visible").first();

                                        if (!loadSettings || !loadSettings.defaultCollapsed)
                                        {
                                            gradebook.expandChildrenCells(loadSettings, button, nextColumnInUnlockedHeaderRow);
                                        }
                                    }

                                }
                                else
                                {
                                    button.addClass(COLLAPSED_CLASS_NAME);
                                    button.removeClass(EXPANDED_CLASS_NAME);
                                    skyward.svg.swapSvg(button.find("svg"), "ChevronRight", "GradebookHeader");
                                    gradebook.collapseChildrenCells(button);
                                }

                                button.find("svg").show();

                                if (animationResponseData && animationResponseData.requiresPostLoadScroll)
                                {
                                    gradebook.animateColumnExpand(button.parents("td").first(), loadSettings, true);
                                }

                                gradebook.gradebookFullyLoadedPromise.resolve();
                                toggleDisplayDeferred.resolve();

                                if (!isLoaded)
                                {
                                    //Make sure that if we got new contents to take care of them
                                    gradebook.gradebookLoadComplete(button.parents("td"), true);
                                }
                                else
                                {
                                    //gradebook.gradebookLoadComplete handles resize
                                    gradebook.callQueuedFunctions();
                                    gradebook.resize();
                                }

                            });
                        });

                    return toggleDisplayDeferred.promise();
                },
                collapseChildrenCells: function (button)
                {
                    var data = button.data();
                    var parentContainerID = data.containerId;

                    var td = $("#" + parentContainerID);

                    $("." + parentContainerID).each(function ()
                    {
                        var cell = $(this);
                        var iconRowID = cell[0].id + "_icons";

                        if (cell.hasClass('subjectHeaderCell'))
                        {
                            var subjectButton = $("#" + iconRowID).find(".subjectExpander");
                            if (subjectButton.length > 0)
                            {
                                gradebook.collapseChildrenCells(subjectButton);
                            }
                        }

                        if (cell.hasClass('academicStandardHeaderCell'))
                        {
                            var standardButton = $("#" + iconRowID).find(".academicStandardExpander");
                            if (standardButton.length > 0)
                            {
                                gradebook.collapseChildrenCells(standardButton);
                            }
                        }

                        if (cell.hasClass('assignmentHeaderCell') && !cell.hasClass('advancedAssignmentCell'))
                        {
                            var assignmentButton = $("#assignmentHeaderCell" + cell.data().assignmentid + ".gradebookIconHeaderCell").find(".assignmentExpander");

                            if (assignmentButton.length)
                            {
                                gradebook.collapseChildrenCells(assignmentButton);

                                assignmentButton.addClass(COLLAPSED_CLASS_NAME);
                                assignmentButton.removeClass(EXPANDED_CLASS_NAME);
                                skyward.svg.swapSvg(assignmentButton.find("svg"), "ChevronRight", "GradebookHeader");
                            }
                        }

                        cell.addClass(COLLAPSED_CLASS_NAME);
                        cell.removeClass(EXPANDED_CLASS_NAME);
                    });

                    if (td.hasClass('subjectHeaderCell'))
                    {
                        updateRoundedCornerClassesOnCollapse(td);
                    }
                    else if (td.hasClass('academicStandardHeaderCell'))
                    {
                        var gradebookSecondaryContainer = td.find(".gradebookSecondaryContainer");

                        var nextVisibleTD = td.nextAll("td:visible").first();
                        if (!gradebook.nextCellHasSameParentAsMe(gradebookSecondaryContainer, nextVisibleTD))
                        {
                            updateRoundedCornerClassesOnCollapse(gradebookSecondaryContainer);
                        }

                        gradebookSecondaryContainer.find(".gradebookTertiaryContainer").each(function ()
                        {
                            var tertiaryDiv = $(this);
                            if (!gradebook.nextCellHasSameParentAsMe(tertiaryDiv, nextVisibleTD))
                            {
                                updateRoundedCornerClassesOnCollapse(tertiaryDiv);
                            }
                        });

                        var classes = td.attr("class").split(' ');
                        var childIndentifierClass = null;

                        $.each(classes, function (k, v)
                        {
                            if (v.indexOf("gpgb") == 0)
                            {
                                childIndentifierClass = v;
                            }
                        });

                        if (td.nextAll("." + childIndentifierClass).length < 1)
                        {
                            var nextCellData = td.nextAll("td:visible").first().data();

                            if (!nextCellData || nextCellData.subjectId != td.data().subjectId)
                            {
                                updateRoundedCornerClassesOnCollapse(td);
                            }
                        }
                    }
                    else if (td.hasClass('assignmentHeaderCell'))
                    {
                        td.find(".assignmentHeaderDataContainer").removeClass("advancedAssignmentExpanded");
                        getAverageScoreContent(td.data().assignmentid).attr('colspan', 1);
                        updateAssignmentHeaderCellExpandClasses(td.data().assignmentid, false); //todo: this is too slow for some reason. Fix it
                        setAssignmentHeaderCellToDefaultColors(td.data().assignmentid);
                    }
                },
                expandChildrenCells: function (loadSettings, button, nextVisibleTDBeforeChildLoad, isFromRecursive)
                {
                    isFromRecursive = isFromRecursive ? isFromRecursive : false;

                    var data = button.data();
                    var parentContainerID = data.containerId;
                    var td = $('#' + parentContainerID + ":not(" + gradebook.getClassesToPreventCollapseExpand() + ")");
                    var nextVisibleTD = nextVisibleTDBeforeChildLoad == null ? td.nextAll("td:visible").first() : nextVisibleTDBeforeChildLoad;
                    var nextVisibleTDData = nextVisibleTD ? nextVisibleTD.data() : null;

                    if (td.hasClass('subjectHeaderCell'))
                    {
                        updateRoundedCornerClassesOnExpand(td);
                    }
                    else if (td.hasClass('academicStandardHeaderCell'))
                    {
                        var gradebookSecondaryContainer = td.find(".gradebookSecondaryContainer");

                        gradebookSecondaryContainer.find(".gradebookTertiaryContainer").each(function ()
                        {
                            var tertiaryDiv = $(this);
                            if (!gradebook.nextCellHasSameParentAsMe(tertiaryDiv, nextVisibleTD))
                            {
                                updateRoundedCornerClassesOnExpand(tertiaryDiv);
                            }
                        });

                        if (!gradebook.nextCellHasSameParentAsMe(gradebookSecondaryContainer, nextVisibleTD))
                        {
                            updateRoundedCornerClassesOnExpand(gradebookSecondaryContainer);
                        }

                        if (!nextVisibleTDData || nextVisibleTDData.subjectId != td.data().subjectId)
                        {
                            updateRoundedCornerClassesOnExpand(td);
                        }
                    }
                    else if (td.hasClass('assignmentHeaderCell'))
                    {
                        td.find(".assignmentHeaderDataContainer").addClass("advancedAssignmentExpanded");
                        var advancedAssignmentHeaderCells = $('.advancedAssignmentCell' + td.data().assignmentid + '.assignmentHeaderCell');
                        updateAssignmentHeaderCellExpandClasses(td.data().assignmentid, true);
                        getAverageScoreContent(td.data().assignmentid).attr('colspan', advancedAssignmentHeaderCells.length + 1);
                    }

                    $("." + COLLAPSED_CLASS_NAME + "." + parentContainerID).each(function ()
                    {
                        var cell = $(this);
                        var iconRowID = cell[0].id + "_icons";

                        if (cell.hasClass('subjectHeaderCell'))
                        {
                            var subjectButton = $("#" + iconRowID).find(".subjectExpander");
                            if (subjectButton.length > 0 && subjectButton.hasClass(EXPANDED_CLASS_NAME))
                            {
                                gradebook.expandChildrenCells(loadSettings, subjectButton, null, true);
                            }
                        }

                        if (cell.hasClass('academicStandardHeaderCell'))
                        {
                            var standardButton = $("#" + iconRowID).find(".academicStandardExpander");
                            if (standardButton.length > 0 && standardButton.hasClass(EXPANDED_CLASS_NAME))
                            {
                                gradebook.expandChildrenCells(loadSettings, standardButton, null, true);
                            }
                        }

                        cell.removeClass(COLLAPSED_CLASS_NAME);
                        cell.addClass(EXPANDED_CLASS_NAME);
                    });
                },
                nextCellHasSameParentAsMe: function (divToCheck, nextVisibleTD)
                {
                    var childDiv = divToCheck.find(".gradebookTertiaryContainer").first();
                    var childLevelData = childDiv && childDiv.length ? childDiv.data() : {};

                    var nextTDAtLevelData = nextVisibleTD.find(".gradebookTertiaryContainer[data-level='" + childLevelData.level + "']").data();

                    if (!nextTDAtLevelData || childLevelData.parentAcademicStandardId != nextTDAtLevelData.parentAcademicStandardId)
                    {
                        return false;
                    }

                    return true;
                },
                gradebookFullyLoadedPromise: new $.Deferred(),
                isGradebookFullyLoaded: function ()
                {
                    return gradebook.gradebookFullyLoadedPromise.state() == "resolved";
                },
                functionsToCallOnCompletionOfLoad: [],
                queueFunctionToCallOnCompletionOfLoad: function (func, thisElement, settings, args)
                {
                    var newFuncToTrigger =
                    {
                        key: func.name,
                        func: func,
                        element: thisElement,
                        args: args
                    };

                    var existingFunctionLocation = -1;

                    for (var i = 0; i < gradebook.functionsToCallOnCompletionOfLoad.length; i++)
                    {
                        if (gradebook.functionsToCallOnCompletionOfLoad[i].key === newFuncToTrigger.key)
                        {
                            existingFunctionLocation = i;
                        }
                    }

                    var allowDuplicates = settings && settings.allowDuplicates;
                    if (existingFunctionLocation > -1 && !allowDuplicates)
                    {
                        //We probably don't want to queue up the same function multiple times. If we do we will need to change this...maybe add a param to skip this part and always push
                        //For now I think this should be good
                        gradebook.functionsToCallOnCompletionOfLoad[existingFunctionLocation] = newFuncToTrigger;
                    }
                    else
                    {
                        gradebook.functionsToCallOnCompletionOfLoad.push(newFuncToTrigger);
                    }
                },
                addColumnResizeEvents: function ()
                {
                    var resizeDivs = [];
                    gradebook.browse.find(".tdResizeDiv").each(function ()
                    {
                        var element = $(this);
                        var parentTD = element.parents("td").first();
                        var lockedBrowse = element.parents(".lockedHeader").first().length > 0;
                        var parentData = parentTD.data();
                        var columnIndex = parentData.column;
                        var minWidth = parentData.minWidth;
                        if (minWidth == null)
                        {
                            minWidth = RESIZE_COLUMN_MIN_WIDTH;
                        }
                        var resizable = // See jQuery Resizable API documentation for more info
                        {
                            minWidth: minWidth, //todo elementdata has minWidth then that otherwise resize column
                            maxWidth: RESIZE_COLUMN_MAX_WIDTH,
                            alsoResize: gradebook.getColumnsToResize(columnIndex, lockedBrowse),
                            handles: "e"
                        };

                        if (lockedBrowse) //element.hasClass("locked"))
                        {
                            resizable.resize = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                _event.stopPropagation();
                            };
                            resizable.stop = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                gradebook.applyResizeOnStop(columnIndex, ui.size.width, true);
                            };
                        }
                        else
                        {
                            resizable.resize = function (_event, ui)
                            {
                                gradebook.setDisplayStudentGradeBucketIndicators(columnIndex, ui.size.width);
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, false);
                                _event.stopPropagation();
                                _event.preventDefault();
                            };
                            resizable.stop = function (_event, ui)
                            {
                                gradebook.applyResizeOnResize(columnIndex, ui.size.width, true);
                                gradebook.applyResizeOnStop(columnIndex, ui.size.width, false);
                                parentTD.addClass(PREVENT_CLICK_CLASS_NAME);
                                let removePreventClickClass = function () { $(this).removeClass(PREVENT_CLICK_CLASS_NAME) }.bind(parentTD);
                                setTimeout(() => { removePreventClickClass() }, 200);
                                _event.preventDefault();
                            };
                        }
                        resizeDivs.push({ element: element, resizable: resizable });
                    });

                    for (var index = 0; index < resizeDivs.length; index++)
                    {
                        var item = resizeDivs[index];
                        item.element.resizable(item.resizable);
                    }
                },
                gradebookLoadComplete: function (scope, requiresNotifyDOMLoad, options) //scope will be null on normal gradebook load. On an expand of a column it will be the element that was expanded. No implementation yet but that should probably happen at some point
                {
                    gradebook.setStudents();

                    loadAverages(); //todo: Implement scope someday
                    gradebook.loadGradebookLayers(options); //todo: Implement scope someday

                    if (options && options.requireMissingCountLoad)
                    {
                        loadAssignmentCounts();
                    }

                    gradebook.callQueuedFunctions();

                    if (requiresNotifyDOMLoad)
                    {
                        //Gradebook_controls will need to be called manually
                        skyward.window.notifyDOMLoad("#Gradebook_header");
                        skyward.window.notifyDOMLoad("#Gradebook_body");
                    }

                    //Columns might have been added, re highlight the selected row to get em all
                    if (gradebook.currentRow != null)
                    {
                        var gbData = getRequiredGradebookData();
                        var animateScroll = false;
                        if (gbData.highlightedStudentSectionId != null)
                        {
                            animateScroll = true;
                        }
                        setCurrentRecord(gradebook.currentRow, gradebook.currentCell, animateScroll);
                    }

                    var data = getRequiredGradebookData();

                    //Reset row chunking values to defaults
                    data.currentPage = 0;
                    data.totalRowsRendered = null;
                    data.rowsToFetch = 25;

                    gradebook.addColumnResizeEvents();
                    gradebook.resize();
                },
                callQueuedFunctions: function ()
                {
                    var queue = gradebook.functionsToCallOnCompletionOfLoad;

                    var processNextElementInQueue = function (queue)
                    {
                        var queueElement = queue.shift();

                        $.when(queueElement.func.apply(queueElement.element, queueElement.args)).done(function ()
                        {
                            if (queue.length > 0)
                            {
                                processNextElementInQueue(queue);
                            }
                        });
                    };

                    if (queue.length > 0)
                    {
                        processNextElementInQueue(queue);
                    }

                    gradebook.functionsToCallOnCompletionOfLoad = [];
                },
                fetchGradebookRows: function (currentPage, defaultRowsToFetch)
                {
                    var data = getRequiredGradebookData();

                    var getChunk = function (currentPage, rowsToFetch, totalRowsRendered)
                    {
                        data.rowsToFetch = rowsToFetch;
                        data.currentPage = currentPage;
                        data.totalRowsRendered = totalRowsRendered;

                        var action = "FetchGradebookRows";

                        if (data.isTeacherTracker)
                        {
                            action += "TeacherTracker";
                        }

                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                            type: "POST",
                            dataType: "viewparthtml",
                            data: data,
                            activityIndicator: { silent: true },
                            success: function (returnData)
                            {
                                var html = $(returnData);

                                if (html.hasClass("gradebookException"))
                                {
                                    gradebook.displayException(html);
                                    gradebook.gradebookFullyLoadedPromise.resolve();
                                    return gradebook.gradebookFullyLoadedPromise.promise();
                                }

                                var browseHtml = $(html[0]);
                                let relatedHashesScript = null;
                                if ($(html).length >= 2 &&
                                    $(html[1]).attr("id") != null &&
                                    $(html[1]).attr("id").indexOf("relatedHashes_") > -1)
                                {
                                    //RequestDataHashRegistry.ScriptId ever changes to not start with relatedHashes this will need to update.
                                    relatedHashesScript = $(html[1]);
                                }
                                var unlockedRows = browseHtml.find("tr.gradesheetBrowseRow:not(.locked)");
                                var lockedRows = browseHtml.find("tr.gradesheetBrowseRow.locked");

                                for (var i = 0; i < lockedRows.length; i++)
                                {
                                    gradebook.unlockedBody.find("table").append($(unlockedRows[i]));
                                    var lockedRow = $(lockedRows[i]);
                                    gradebook.lockedBody.find("table").append(lockedRow);

                                    if (lockedRow.hasClass("current"))
                                    {
                                        setCurrentRecord(lockedRow.data().row, null, false, true);
                                    }
                                }

                                if (relatedHashesScript != null)
                                {
                                    gradebook.browse.after(relatedHashesScript);
                                }

                                currentPage++;

                                var rowsSkipped = html.data()?.rowsskipped; //TODO: Remove with the stream dream..STREAM DREAM! STREAM DREAM!
                                if (rowsSkipped == null || rowsSkipped == "")
                                {
                                    rowsSkipped = 0;
                                }

                                if (gradebookData.rowsskipped)
                                {
                                    gradebookData.rowsskipped += rowsSkipped;
                                }

                                gradebook.updateScoringModeControls();

                                if (gradebook.editMode)
                                {
                                    var buttonText = gradebook.editButton.find('.textAfter');
                                    enterScoringMode(buttonText);
                                }

                                if ((lockedRows.length + rowsSkipped) < defaultRowsToFetch)
                                {
                                    gradebook.gradebookFullyLoadedPromise.resolve();
                                    return gradebook.gradebookFullyLoadedPromise.promise();
                                }

                                getChunk(currentPage, rowsToFetch, gradebook.lockedBodyTable.find('.browseRow').length);
                            }
                        });
                    };

                    if (!currentPage || currentPage <= 0)
                    {
                        gradebook.lockedBody.empty();
                        gradebook.unlockedBody.empty();
                    }

                    getChunk(currentPage, defaultRowsToFetch, gradebook.lockedBodyTable.find('.browseRow').length);
                },
                displayException: function (html)
                {
                    gradebook.browse.html(html);
                },
                updateScoringModeControls: function ()
                {
                    gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                    gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                    gradebook.rowCount = gradebook.unlockedBody.find("table > tbody> tr").length + (gradebookData.rowsskipped == null || gradebookData.rowsskipped == '' ? 0 : gradebookData.rowsskipped);
                    gradebook.studentAssignmentInputs = gradebook.browse.find('.gradebookInput.gradebookScoringModeControl.studentAssignment');
                    gradebook.studentAssignmentGradeMarkInputs = gradebook.browse.find('.gradebookScoringModeControl.studentAssignment.gradeMarkScoring.gradebookInputCodeEEL');
                },
                removeDefaultKeyEvents: function ()
                {
                    gradebook.body.find('.codeEEL').off('keydown');
                },
                displayStudentGroupInfo: function ()
                {
                    var container = $(this);
                    var data = container.data();
                    var html = gradebook.getStudentGroupInfo.apply(container);
                    var anchorTo = container.find(".studentGroupColorStrip").first();

                    if (anchorTo.length == 0)
                    {
                        anchorTo = container;
                    }

                    var options =
                    {
                        anchorTo: anchorTo
                    };

                    var title = data.title
                        ? data.title
                        : "Student Group Filter";

                    skyward.modalLayer.showDialog(title, html, { text: "Close", icon: "Close" }, options);
                },
                getStudentGroupInfo: function ()
                {
                    var container = $(this);

                    var data = container.data();

                    var html = "";

                    var parent;

                    if (container.hasClass("studentGroupColorStrips"))
                    {
                        parent = container;
                    }
                    else
                    {
                        parent = container.parents(".studentGroupColorStrips").first();
                    }

                    parent.find(".studentGroupColorStrip").each(function ()
                    {
                        var strip = $(this);
                        var stripData = strip.data();

                        var studentGroupDiv = "<div class='legendOptions'>";

                        var colorBlockDiv = '<div class="studentGroupColorStrip" style="background-color: ' + stripData.color + '"></div>';
                        var nameSpan = '<span style="padding-left: 5px">' + stripData.name + '</span>';

                        studentGroupDiv += colorBlockDiv;
                        studentGroupDiv += nameSpan;
                        studentGroupDiv += "</div>";

                        html += studentGroupDiv;
                    });

                    return html;

                },
                displayGradebookFilterInfo: function ()
                {
                    var container = $(this);

                    var data = container.data();

                    var hasStudentGroupFilter = data.hasStudentGroupFilter.toString().toLowerCase() == "true";
                    var hasFilteredStudent = data.hasFilteredStudent.toString().toLowerCase() == "true";

                    var html = "";

                    if (hasStudentGroupFilter)
                    {
                        html += gradebook.getStudentGroupInfo.apply(container);
                    }
                    if (hasFilteredStudent)
                    {
                        var studentNameCell = gradebook.lockedBody.find("tr .studentNameContainer.studentNameText, tr .studentNameContainer .studentNameTextAnchor .anchorText");
                        if (studentNameCell && studentNameCell.length > 0)
                        {
                            html += "Currently filtered to '" + studentNameCell.html() + "'.";
                        }
                        else
                        {
                            html += "Currently filtered to a specific student.";
                        }
                    }

                    var title = hasStudentGroupFilter && !hasFilteredStudent
                        ? "Student Group Filter"
                        : "Student Filter";

                    var options =
                    {
                        anchorTo: container
                    };

                    skyward.modalLayer.showDialog(title, html, { text: "Close", icon: "Close" }, options);
                    //if showing student groups, show that here. Also, if showing filtered student show that here as well.
                },
                enterTransferGrades: function ()
                {
                    var button = $(this);
                    var data = button.data();
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/EnterTransferGradesPopup",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data: data,
                        success: function (returnData)
                        {
                            if (returnData.success == false && returnData.popupHTML)
                            {
                                checkAjaxResponseForErrors(returnData);
                            }
                            else
                            {
                                var buttons = [];
                                buttons.push({
                                    id: "saveStudentGradeBucketIndicatorPopup", text: "Save", click: function ()
                                    {
                                        var hideTransferRunIndicator = skyward.controls.getValue(dialog.content.find(".hideTransferGradeRunCheckbox"));
                                        $.ajax({
                                            url: skyward.global.virtualDir + "Gradebook/Gradebook/SaveStudentGradeBucketIndicators",
                                            type: "POST",
                                            dataType: "JSON",
                                            data:
                                            {
                                                StudentGradeBucketID: data.studentGradeBucketId,
                                                HideTransferIndicator: hideTransferRunIndicator
                                            },
                                            success: function (saveReturnData)
                                            {
                                                if (saveReturnData.success == false && saveReturnData.popupHTML)
                                                {
                                                    checkAjaxResponseForErrors(saveReturnData);
                                                }
                                                else if (hideTransferRunIndicator)
                                                {
                                                    button.find(".scoreDiv").removeClass("displayNone");
                                                    button.removeClass("needsTransferRunProcess");
                                                    button.find(".runTransferProcess").addClass("displayNone");
                                                    button.attr("data-click-action", button.data().originalClickAction);
                                                }
                                            }
                                        });
                                        dialog.close();
                                    }, icon: "Save"
                                });
                                buttons.push({ id: "closeStudentGradeBucketIndicatorPopup", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" });
                                var dialog = skyward.modalLayer.showDialog('Student Grade Information', returnData.htmlValue.Content, buttons, { anchorTo: button });
                            }
                        }
                    });
                },
                markInputScoreAsPending: function (input)
                {
                    if (!input.hasClass(PENDING_SCORE))
                    {
                        input.addClass(PENDING_SCORE);
                    }
                },
                completePendingInputScore: function (input)
                {
                    if (input.hasClass(PENDING_SCORE))
                    {
                        input.removeClass(PENDING_SCORE);
                    }
                },
                clearInputValueFromFailedSave: function (valuesToSaveArray)
                {
                    if (!Array.isArray(valuesToSaveArray))
                    {
                        valuesToSaveArray = [valuesToSaveArray];
                    }

                    $.each(valuesToSaveArray, function (valuesToSave)
                    {
                        var valuesToSave = this;
                        if (valuesToSave && valuesToSave.originalValues && valuesToSave.originalValues.Score)
                        {
                            var input;
                            if (valuesToSave.saveObject == "StudentGradeBucket")
                            {
                                input = $("#SubjectiveStudentGradeBucketGradeMark_" + valuesToSave.studentGradeBucketID);
                            }
                            else if (valuesToSave.saveObject == "StudentGradeBucketSubject")
                            {
                                input = $("#SubjectiveSubjectGradeMark_" + valuesToSave.studentGradeBucketSubjectID);
                            }
                            else if (valuesToSave.saveObject == "StudentGradeBucketAcademicStandard")
                            {
                                input = $("#SubjectiveAcademicStandardGradeMark_" + valuesToSave.studentGradeBucketAcademicStandardID);
                            }
                            if (input && input.length > 0)
                            {
                                skyward.gradebookcodeeel.setValue(input, valuesToSave.originalValues.Score.displayValue, valuesToSave.originalValues.Score.selectedValueID, true);
                                input.data("originalDisplayValue", valuesToSave.originalValues.Score.displayValue);
                                input.data("originalSelectedValueID", valuesToSave.originalValues.Score.selectedValueID);
                                input.data("originalValue", valuesToSave.originalValues.Score.displayValue);
                            }
                        }
                    });
                },
                getAssignmentScoreInput: function (assignmentID, studentSectionID)
                {
                    var input = $(".gradebookScoringModeControl.number.studentAssignment.assignment" + assignmentID + "[data-studentsectionid='" + studentSectionID + "'][data-fieldname='Score']");

                    if (input.length < 1)
                    {
                        input = $(".gradebookScoringModeControl.gradeMarkScoring.studentAssignment.assignment" + assignmentID + "[data-studentsectionid='" + studentSectionID + "'][data-fieldname='Score']");
                    }

                    return input;
                },
                getStudentGradeBucketCell: function (studentGradeBucketID)
                {
                    return gradebook.body.find("td.gradebookCell.gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']");
                },
                updateCurrentCellInRow: function (newColumnNumber)
                {
                    var row = getRowElement("unlocked", gradebook.currentRow);
                    var newCurrentCell = row.find("td.gradebookCell[data-column='" + newColumnNumber + "']");
                    setCurrentCellElement(newCurrentCell);
                },
                getClassesToPreventCollapseExpand: function ()
                {
                    return ".lockedGradingPeriodGradeBucket";
                },
                animateColumnExpand: function (focusElement, loadSettings, forceScroll)
                {
                    var lockedTableElement = gradebook.lockedBodyTable;
                    var elementToScroll = gradebook.unlockedBody;

                    var lockedRight = lockedTableElement ? (lockedTableElement.width() + lockedTableElement.offset().left) : 0;
                    var elementLeft = (focusElement && focusElement.offset()) ? focusElement.offset().left : lockedRight;
                    var elementRight = elementLeft + (focusElement ? focusElement.width() : 0);
                    var amountToScroll = lockedRight - elementLeft;

                    elementToScroll.trigger('mouseover');

                    var animate = loadSettings && loadSettings.animate == false
                        ? false
                        : true;

                    var returnData =
                    {
                        animationPromise: new $.Deferred()
                    };

                    if (amountToScroll)
                    {
                        var animationDuration = 0;
                        if (animate)
                        {
                            animationDuration = GRADEBOOK_EXPAND_ANIMATION_DURATION;
                            if (Math.abs(amountToScroll) < GRADEBOOK_EXPAND_ANIMATION_SCROLL_THRESHOLD)
                            {
                                animationDuration = animationDuration / 2;
                            }
                        }

                        var table = elementToScroll.find("table");

                        var requiresPostLoadScroll = false;
                        if (table && table.length > 0)
                        {
                            var lockedTableLeftPosition = Math.abs(table.position().left);
                            var amountAvailableToScroll = (table.width() - lockedTableLeftPosition) - window.outerWidth;
                            requiresPostLoadScroll = !forceScroll &&
                                amountAvailableToScroll < Math.abs(amountToScroll);
                        }
                        if (!requiresPostLoadScroll)
                        {
                            $.when(elementToScroll.animate({ scrollLeft: "-=" + amountToScroll }, animationDuration)).done(function ()
                            {
                                returnData.animationPromise.resolve();
                            });
                        }
                        else
                        {
                            returnData.animationPromise.resolve();
                        }

                        returnData.requiresPostLoadScroll = requiresPostLoadScroll;
                    }
                    else
                    {
                        returnData.animationPromise.resolve();
                    }

                    return returnData;
                },
                setStudents: function ()
                {
                    gradebook.students = [];
                    gradebook.unlockedBody.find(".browseRow:not(.noRecordsInBrowse)").each(function ()
                    {
                        var row = $(this);
                        var rowData = row.data();

                        var studentNameContainer = row.find(".studentNameContainer");

                        if (studentNameContainer && studentNameContainer.length)
                        {
                            var nameText = studentNameContainer.find(".anchorText").html();
                            if (nameText == null || nameText == "")
                            {
                                nameText = studentNameContainer.html();
                            }

                            gradebook.students.push({ name: nameText, row: rowData.row, studentSectionID: rowData.studentSectionId });
                        }
                    });

                    gradebook.students.sort(function (a, b)
                    {
                        if (a.name.toLowerCase() == b.name.toLowerCase())
                        {
                            return 0;
                        }
                        if (a.name.toLowerCase() > b.name.toLowerCase())
                        {
                            return 1;
                        }
                        else
                        {
                            return -1;
                        }
                    });
                },
                updateBucketNoCountIndicator: function (gradebookCell, gradeMarkNoCount)
                {
                    var studentGradeBucketIndicators = gradebookCell.find(".studentGradeBucketIndicators");
                    if (gradeMarkNoCount == true)
                    {
                        studentGradeBucketIndicators.removeClass('hiddenNoCountBucket');
                    }
                    else
                    {
                        studentGradeBucketIndicators.addClass('hiddenNoCountBucket');
                    }
                },
                markAsMissing: function (studentSectionID, assignmentID, valueOverride)
                {
                    var deferred = $.Deferred();

                    var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var isMissingField = scoreChangeAdvancedAssignmentColumnHandler.getMissingField(studentSectionID, assignmentID);
                        var isMissing = skyward.controls.getValue(isMissingField);

                        var newMissingValue = !isMissing;

                        if (valueOverride != null)
                        {
                            newMissingValue = valueOverride
                        }
                        scoreChangeAdvancedAssignmentColumnHandler.updateIsMissing(studentSectionID, assignmentID, newMissingValue);

                        gradebook.gradebookCheckboxChange(isMissingField);

                        deferred.resolve();
                    });

                    return deferred.promise();
                },
                markNoCount: function (studentSectionID, assignmentID)
                {
                    var deferred = $.Deferred();

                    var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var noCountField = scoreChangeAdvancedAssignmentColumnHandler.getNoCountField(studentSectionID, assignmentID);
                        var noCount = skyward.controls.getValue(noCountField);
                        scoreChangeAdvancedAssignmentColumnHandler.updateNoCount(studentSectionID, assignmentID, !noCount);

                        gradebook.gradebookCheckboxChange(noCountField);

                        deferred.resolve();
                    });

                    return deferred.promise();
                },
                markAsZero: function (studentSectionID, assignmentID)
                {
                    var data =
                    {
                        studentsectionid: studentSectionID,
                        assignmentid: assignmentID
                    };
                    var scoreTD = getAssignmentCellByField(data, "Score");
                    var scoreCell = null;

                    if (scoreTD && scoreTD.length > 0)
                    {
                        scoreCell = scoreTD.find(".studentAssignmentScoreInput");
                    }
                    if (scoreCell && scoreCell.length > 0 && (skyward.controls.getValue(scoreCell) != 0 || skyward.controls.getValue(scoreCell) === ''))
                    {
                        scoreCell.val(0.00);
                        scoreCell.trigger("focusout");
                    }
                },
                massUpdateAssignmentsSectionGradeBucket: function ()
                {
                    skyward.window.closePopup();
                    var element = $(this);
                    var data = element.data();
                    var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;

                    var expanderButton = gradebook.browse.find("#gradingPeriodGradeBucket" + gradingPeriodGradeBucketID + "_icons .gradeBucketExpander");
                    var collapsed = expanderButton.hasClass(COLLAPSED_CLASS_NAME);

                    var deferred = $.Deferred();
                    if (collapsed)
                    {

                        deferred = gradebook.toggleChildrenCellDisplay(expanderButton, { allowDuplicates: true, animate: false });
                    }
                    else
                    {
                        deferred.resolve();
                    }
                    $.when(deferred).done(function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/GetMassUpdateAssignmentsSectionGradeBucket/" + gradingPeriodGradeBucketID,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                                isInScoringMode: isInScoringMode()
                            },
                            success: function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                }
                                else
                                {
                                    var popupID = "MassAssignScores";
                                    var options =
                                    {
                                        anchorTo: element,
                                        id: popupID
                                    };
                                    var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": element.data() };
                                    var dialog = skyward.modalLayer.showDialog("Mass Update Assignments", returnData.htmlValue.Content, [saveButton, { text: "Cancel", icon: "Cancel" }], options)
                                }
                            }
                        });
                    });
                },

                massUpdateAssignmentsStudentGradeBucket: function ()
                {
                    skyward.window.closePopup();
                    var element = $(this);
                    var data = element.data();
                    var studentGradeBucketID = data.studentGradeBucketId;
                    var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;

                    var expanderButton = gradebook.browse.find("#gradingPeriodGradeBucket" + gradingPeriodGradeBucketID + "_icons .gradeBucketExpander");
                    var collapsed = expanderButton.hasClass(COLLAPSED_CLASS_NAME);

                    var deferred = $.Deferred();
                    if (collapsed)
                    {

                        deferred = gradebook.toggleChildrenCellDisplay(expanderButton, { allowDuplicates: true, animate: false });
                    }
                    else
                    {
                        deferred.resolve();
                    }
                    $.when(deferred).done(function ()
                    {
                        return $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/GetMassUpdateAssignmentsStudentGradeBucket/" + studentGradeBucketID,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                studentGradeBucketID: studentGradeBucketID,
                                isInScoringMode: isInScoringMode()
                            },
                            success: function (returnData)
                            {
                                if (returnData.success == false && returnData.popupHTML)
                                {
                                    checkAjaxResponseForErrors(returnData);
                                }
                                else
                                {
                                    var studentGradeBucketCell = gradebook.unlockedBody.find("td.gradeBucketCell[data-student-grade-bucket-id=" + studentGradeBucketID + "]");
                                    var popupID = "MassAssignScores";
                                    var options =
                                    {
                                        anchorTo: studentGradeBucketCell,
                                        id: popupID
                                    };
                                    var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": element.data() };
                                    var dialog = skyward.modalLayer.showDialog("Mass Update Assignments", returnData.htmlValue.Content, [saveButton, { text: "Cancel", icon: "Cancel" }], options);
                                }
                            }
                        });
                    });
                },
                filterToSpecificStudent: function ()
                {
                    var button = $(this);
                    var buttonData = button.data();
                    skyward.window.checkLoadContent('full', 'Gradebook', buttonData.controller, buttonData.screen, buttonData.studentSectionId, getRequiredGradebookData(null, true));
                },
                openSubjectDetails: function ()
                {
                    var button = $(this);
                    var calculationGroupSubjectGradeBucketID = button.data().calculationGroupSubjectGradeBucketId;
                    skyward.window.checkLoadContent('full', 'Gradebook', 'CalculationGroupSubjectGradeBucket', 'Gradebook', calculationGroupSubjectGradeBucketID, getRequiredGradebookData(null, true));
                },
                openAcademicStandardDetails: function ()
                {
                    var button = $(this);
                    var calculationGroupAcademicStandardGradeBucketID = button.data().calculationGroupAcademicStandardGradeBucketId;
                    skyward.window.checkLoadContent('full', 'Gradebook', 'CalculationGroupAcademicStandardGradeBucket', 'Gradebook', calculationGroupAcademicStandardGradeBucketID, getRequiredGradebookData(null, true));
                },
                applyScoreMask: function (input)
                {
                    if (input.data().decimalMask && !input.hasClass("masked"))
                    {
                        skyward.datamask.addDecimalMask(input, input.data().decimalMask.toString());
                    }
                },
                checkRemoveScoreMask: function (input)
                {
                    if (input.data().decimalMask && input.hasClass("masked") && (input.val() == '' || input.val() == '*'))
                    {
                        skyward.datamask.removeMask(input);
                        skyward.controls.setValue(input, '*');
                    }
                },
                getColumnsToResize: function (columnIndex, lockedBrowse)
                {
                    var cells = [];
                    // trying to avoid including the elements that are already being resized by the resize handler, as it can cause things to shift around in weird ways.
                    let selectors =
                        "tr.gradesheetBrowseRow td[data-column='" + columnIndex + "'] div[style*='width'], " +
                        "td[data-column='" + columnIndex + "'] div.locked.tdResizeDiv, " +
                        "tr#Gradebook_unlockedAveragesRowHeader td[data-column='" + columnIndex + "'].headerSpacerCell div, " +
                        "tr#Gradebook_lockedAveragesRowHeader td[data-column='" + columnIndex + "'].headerSpacerCell div";

                    if (lockedBrowse)
                    {
                        selectors = selectors + ", .unlockedHeader td[data-column='" + columnIndex + "'] div[style*='width']";
                    }
                    $.each(gradebook.browse.find(selectors), function ()
                    {
                        cells.push($(this));
                    });
                    return $(cells);
                },
                updateBaseGradebookColumnWidth: function (columnIndex, headerWidth)
                {
                    var headerCell = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + columnIndex + "']");
                    var cellData = headerCell.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateBaseGradebookColumnWidth";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            fieldName: cellData.fieldName,
                            columnIndex: columnIndex,
                            columnWidth: Math.round(headerWidth),
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId
                        }
                    });
                },
                updateGradeBucketColumnWidth: function (columnIndex, headerWidth)
                {
                    var headerCell = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + columnIndex + "']");
                    var cellData = headerCell.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateGradeBucketColumnWidth";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            objectType: cellData.objectType,
                            foreignKey: cellData.foreignKey,
                            width: Math.round(headerWidth),
                            gradingPeriodGradeBucketID: cellData.gradingPeriodGradeBucketId,
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId
                        }
                    });

                },
                setDisplayStudentGradeBucketIndicators: function (headerIndex, columnWidth)
                {
                    if (columnWidth < SHOW_INDICATORS_MIN_WIDTH) //or no score?
                    {
                        gradebook.unlockedBody.find(".gradebookCell[data-column='" + headerIndex + "'] .studentGradeBucketIndicators:not(.displayNone)").addClass('displayNone');
                    }
                    else
                    {
                        gradebook.unlockedBody.find(".gradebookCell[data-column='" + headerIndex + "'] .studentGradeBucketIndicators.displayNone").removeClass('displayNone');
                    }
                },
                applyResizeOnResize: function (headerIndex, columnWidth, locked)
                {
                    // jQuery Resizable doesn't always account for padding in elements being resized in a way that we might expect.
                    // For example, even though we are only changing the width on our columns, something will fire off in the jQuery that wants to recalculate the height,
                    // but it does not take the padding into account when doing so and will shrink inner elements of the resized div. We have to do our own calculation here.
                    // This can almost certainly be improved upon on our part, if we find time to update how our gradebook cells are built and the styles we use.
                    gradebook.getColumnsToResize(headerIndex, locked).each(function ()
                    {
                        // height
                        let current = $(this);
                        current.css("width", columnWidth);
                        let padTop = parseFloat(current.css("padding-top").replace('px', ''));
                        let padBot = parseFloat(current.css("padding-bottom").replace('px', ''));
                        let totalPadding = parseFloat(padTop + padBot);
                        current.css("height", current.height() + totalPadding);
                        if (current.children('.sizeMeUp').length > 0)
                        {
                            current.css("height", current.children().outerHeight());
                        }

                        let resizeWrapper = current.closest('.ui-gradebook-resize-wrapper');
                        if (resizeWrapper.length == 0)
                        {
                            return;
                        }

                        // width
                        let wrapperPadLeft = parseFloat(resizeWrapper.css("padding-left").replace('px', ''));
                        let wrapperPadRight = parseFloat(resizeWrapper.css("padding-right").replace('px', ''));
                        let wrapperWidthPadding = wrapperPadLeft + wrapperPadRight;
                        if (wrapperWidthPadding > 0)
                        {
                            current.css("width", current.width() - wrapperWidthPadding);
                        }

                        let gradebookCell = current.parents(".gradebookCell");
                        if (gradebookCell && gradebookCell.length > 0)
                        {
                            var gbCellData = gradebookCell.data();
                            if (gbCellData.resizeMinWidthSize && gbCellData.resizeMinWidthSize > 0)
                            {
                                gradebook.applyResizeRules(gradebookCell, gbCellData);
                            }
                        }
                    });
                },
                applyResizeRules: function (element, data)
                {
                    if (data.resizeMinWidthType == "Hide" && data.resizeMinWidthSelector)
                    {
                        if (element.width() <= data.resizeMinWidthSize)
                        {
                            element.find(data.resizeMinWidthSelector).hide();
                        }
                        else
                        {
                            element.removeClass("defaultHiddenText");
                            element.find(data.resizeMinWidthSelector).show();
                        }
                    }
                },
                applyResizeOnStop: function (headerIndex, columnWidth, locked)
                {
                    if (headerIndex != null)
                    {
                        var isBaseColumn = false;
                        var browseHeaderColumn = gradebook.unlockedRowHeader.find(".browseHeaderColumn[data-column='" + headerIndex + "']");
                        if (browseHeaderColumn.length && browseHeaderColumn.data().fieldName != null && browseHeaderColumn.data().gradingPeriodGradeBucketId == null)
                        {
                            isBaseColumn = true;
                        }
                        if (isBaseColumn)
                        {
                            gradebook.updateBaseGradebookColumnWidth(headerIndex, columnWidth);
                        }
                        else
                        {
                            gradebook.updateGradeBucketColumnWidth(headerIndex, columnWidth);
                        }

                        if (!locked)
                        {
                            gradebook.setDisplayStudentGradeBucketIndicators(headerIndex, columnWidth);
                        }
                        else
                        {
                            var shadowWidth = BORDER_SHADOW_WIDTH;
                            var total = shadowWidth;
                            $("#" + BROWSE_NAME + " .lockedBrowseBody tr:first-child td").each(function ()
                            {
                                total += $(this).width();
                            });
                            var lockedBrowseBody = $("#" + BROWSE_NAME + " .lockedBrowseBody");
                            var scrollWrapper = lockedBrowseBody.parent();
                            var scrollbarWidth = lockedBrowseBody.width() - scrollWrapper.width();
                            lockedBrowseBody.css("width", total + scrollbarWidth);
                            scrollWrapper.css("width", total);
                        }
                    }

                    resizeGradebook();
                },
                hideColumn: function (columnIndex, updateTeacherSetting, postData)
                {
                    var columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    columns.addClass(GRADE_COLUMN_HIDDEN_SELECTOR);

                    var columnExpanderButton = gradebook.unlockedRowSpacerHeader.find(".gradebookIconHeaderCell[data-column='" + columnIndex + "'] .gradebookHeaderExpandCollapseButton");

                    if (columnExpanderButton != null && columnExpanderButton.length)
                    {
                        var parentContainerID = columnExpanderButton.data().containerId;

                        $(".browseHeaderColumn." + parentContainerID).each(function ()
                        {
                            var column = $(this).data().column;
                            gradebook.hideColumn(column, false);
                        });
                    }
                    gradebook.recalculateColumnStylesOnColumnHidden(columnIndex, columns);

                    if (updateTeacherSetting)
                    {
                        gradebook.updateHiddenGradeBucketColumnSetting(postData);
                    }
                },
                showColumn: function (columnIndex, updateTeacherSetting, postData)
                {
                    var columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    columns.removeClass(GRADE_COLUMN_HIDDEN_SELECTOR);

                    if (updateTeacherSetting)
                    {
                        gradebook.updateHiddenGradeBucketColumnSetting(postData);
                    }
                },
                recalculateColumnStylesOnColumnHidden: function (columnIndex, columns)
                {
                    if (columns.length <= 0)
                    {
                        columns = $("#" + BROWSE_NAME + " td[data-column='" + columnIndex + "']");
                    }

                    var elements = null;
                    var tertiaryContainer = columns.find('.gradebookTertiaryContainer');
                    if (tertiaryContainer.length > 0)
                    {
                        elements = tertiaryContainer;
                    }
                    else
                    {
                        var secondaryContainer = columns.find('.gradebookSecondaryContainer');
                        if (secondaryContainer.length > 0)
                        {
                            elements = secondaryContainer;
                        }
                    }

                    if (elements)
                    {
                        elements.each(function ()
                        {
                            var element = $(this);
                            var td = element.closest('td.gradebookPrimaryContainer');
                            var tdData = td.data();
                            var gradingPeriodGradeBucketID = tdData.gradingPeriodGradeBucketId;

                            if (gradingPeriodGradeBucketID)
                            {
                                var elementData = element.data();
                                var otherUnhiddenElementsWithSameParentElement = null;
                                var parentElement = null;
                                var foreignKey = null;
                                if (elementData.parentAcademicStandardId)
                                {
                                    foreignKey = elementData.parentAcademicStandardId;
                                    parentElement = $('td.academicStandardHeaderCell[data-academic-standard-id="' + elementData.parentAcademicStandardId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                                    otherUnhiddenElementsWithSameParentElement = $('td.academicStandardHeaderCell[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]:not(.gradeBucketColumnHidden)[data-column!="' + columnIndex + '"] div[data-parent-academic-standard-id="' + elementData.parentAcademicStandardId + '"], td.assignmentHeaderCell.gpgb' + gradingPeriodGradeBucketID + 'academicStandard' + foreignKey);
                                }
                                else
                                {
                                    if (tdData.subjectId)
                                    {
                                        foreignKey = tdData.subjectId;
                                        parentElement = $('td.subjectHeaderColumn[data-subject-id="' + tdData.subjectId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                                        otherUnhiddenElementsWithSameParentElement = $('td.academicStandardHeaderCell[data-subject-id="' + tdData.subjectId + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]:not(.gradeBucketColumnHidden)[data-column!="' + columnIndex + '"], td.assignmentHeaderCell.gpgb' + gradingPeriodGradeBucketID + 'subject' + foreignKey);
                                    }
                                }

                                if (otherUnhiddenElementsWithSameParentElement && otherUnhiddenElementsWithSameParentElement.length <= 0 && parentElement)
                                {
                                    parentElement.removeClass('removeSideBorder');
                                    if (td.hasClass('cornerEnd'))
                                    {
                                        parentElement.addClass('cornerEnd').addClass('removeSideBorder').removeClass('stripe');
                                        var childrenToUpdate = parentElement.find('.stripe');
                                        if (childrenToUpdate && childrenToUpdate.length > 0)
                                        {
                                            childrenToUpdate.each(function ()
                                            {
                                                var child = $(this);
                                                child.removeClass('stripe').addClass('cornerEnd').addClass('removeSideBorder');
                                            });
                                        }
                                    }

                                    parentElement.find('div.removeSideBorder').removeClass('removeSideBorder');
                                    parentElement.find('div.expanded').removeClass('expanded').addClass('standAlone');

                                    var expander = $('a.gradebookHeaderExpandCollapseButton[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"][data-foreign-key="' + foreignKey + '"]');
                                    if (expander)
                                    {
                                        expander.addClass('displayNone');
                                    }
                                }
                            }
                        });
                    }
                },
                updateHiddenGradeBucketColumnSetting: function (postData)
                {
                    var gradebookData = gradebookBrowse.data();
                    var action = "UpdateGradeBucketColumnHidden";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                },
                showHiddenGradeBuckets: function ()
                {
                    var button = $(this);

                    gradebook.hideGradebookOnLoadBanner(button);

                    var gradingPeriodID = button.data().currentGradingPeriodId;
                    $("#" + BROWSE_NAME + " .browseHeaderColumn." + GRADE_COLUMN_HIDDEN_SELECTOR + "[data-grading-period-id='" + gradingPeriodID +"']").each(function ()
                    {
                        var column = $(this);
                        var columnData = column.data();
                        var columnIndex = columnData.column;
                        var hideButton = column.find(".hideGradeBucketColumn");

                        if (hideButton && hideButton.length)
                        {
                            var postData =
                            {
                                hidden: false,
                                gradingPeriodGradeBucketID: columnData.gradingPeriodGradeBucketId,
                                teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                                objectType: hideButton.data().objectType,
                                foreignKey: hideButton.data().foreignKey
                            };

                            gradebook.showColumn(columnIndex, true, postData);
                        }
                    });

                },
                closeHiddenGradeBucketsWarning: function ()
                {
                    var button = $(this);
                    var buttonData = button.data();
                    var gradebookData = gradebookBrowse.data();
                    var action = "DismissHiddenBucketsWarning";

                    if (gradebookData.isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                            gradingPeriodID: buttonData.currentGradingPeriodId,
                        }
                    });
                    gradebook.hideGradebookOnLoadBanner(button);
                },
                hideGradebookOnLoadBanner: function (button)
                {
                    var gradebookOnLoadWarningBanner = button.parents(ON_LOAD_WARNING_SELECTOR).first();
                    if (gradebookOnLoadWarningBanner && gradebookOnLoadWarningBanner.length > 0)
                    {
                        gradebookOnLoadWarningBanner.remove();
                    }
                }
            };
            gradebook.bodyData = gradebook.body.data();

            var updateRoundedCornerClassesOnExpand = function (element)
            {
                if (element.hasClass("standAlone"))
                {
                    element.removeClass("standAlone");
                    element.addClass("expanded");
                }

                if (element.hasClass("cornerEnd"))
                {
                    element.removeClass("cornerEnd");
                    element.addClass("stripe");
                }
            };

            var updateRoundedCornerClassesOnCollapse = function (element)
            {
                if (element.hasClass("expanded"))
                {
                    element.removeClass("expanded");
                    element.addClass("standAlone");
                }

                if (element.hasClass("stripe"))
                {
                    element.removeClass("stripe");
                    element.addClass("cornerEnd");
                }
            };

            var scoringModeControlsSelector = '.gradebookScoringModeControl:not(.scoringModeDoesntAffectState):not(.gradingPeriodCompleted):not(.skipStudentAssignment):not(.hasAttempts):not(.eELInputContainer), #GradebookUndo, #GradebookRedo';
            var scoringModeBodyFilter = '.assignmentSlider, .massAssignOptionButton, #GradebookUndo, #GradebookRedo';

            gradebook.data = gradebook.browse.data();

            gradebook.updateScoringModeControls();

            gradebook.enableControl = function (control)
            {
                control.removeClass('gradebookScoringMode-Off').removeClass("displayNone").addClass('gradebookScoringMode-On');
                control.find(".displayNone").removeClass("displayNone");

                var codeEEL = control.parents('.codeEEL, .gradebookCodeEEL');
                if (codeEEL.length > 0)
                {
                    codeEEL.find(".readonly").removeClass("readonly").addClass('addReadOnlyClassHere');
                    codeEEL.find(".ui-disabled").removeClass("ui-disabled").addClass('addUIDisabledHere');
                    codeEEL.find("[readOnly]").removeAttr("readOnly").addClass('addReadOnlyHere');
                    codeEEL.find("[disabled]").removeAttr("disabled").addClass('addDisabledHere');
                    codeEEL.find(".displayNone").removeClass("displayNone").addClass('addDisplayNoneHere');

                    var parentBox = control.parent('div.eELInputContainer.js-showEELContainer, div.gradebookCodeEEL');
                    if (parentBox.length > 0)
                    {
                        parentBox.removeClass('gradebookScoringMode-Off').addClass('gradebookScoringMode-On');
                    }
                }

                if (control.hasClass('skipStudentAssignment'))
                {
                    gradebook.disableControl(control);
                }
                else if (control.hasClass("gradebookInputCodeEEL"))
                {
                    control.removeAttr("disabled");
                    control.removeAttr("readOnly");
                    var dropDownButton = control.siblings(".gradebookCodeEELButton");
                    if (dropDownButton.length > 0 && dropDownButton.hasClass("displayNone"))
                    {
                        dropDownButton.removeClass("displayNone");
                    }

                    if (!control.hasClass("gradeMarkScoring"))
                    {
                        var wrapper = control.parent();
                        if (wrapper.length > 0 && wrapper.hasClass("displayNone"))
                        {
                            wrapper.removeClass("displayNone");
                        }

                        wrapper.next("span").addClass("displayNone");
                    }
                }
                else if (!control.hasClass('assignmentSlider') && control.attr("id") != "GradebookUndo" && control.attr("id") != "GradebookRedo")
                {
                    skyward.controls.enable(control);
                }
            };

            gradebook.disableControl = function (control)
            {
                control.removeClass('gradebookScoringMode-On').addClass('gradebookScoringMode-Off');

                var codeEEL = control.parents('.codeEEL, .gradebookCodeEEL');
                if (codeEEL.length > 0)
                {
                    codeEEL.find(".addReadOnlyClassHere").removeClass("addReadOnlyClassHere").addClass('readOnly');
                    codeEEL.find(".addUIDisabledHere").removeClass("addUIDisabledHere").addClass('ui-disabled');
                    codeEEL.find(".addReadOnlyHere").removeClass("addReadOnlyHere").attr('readOnly', 'readOnly');
                    codeEEL.find(".addDisabledHere").removeClass("addDisabledHere").attr('disabled', 'disabled');
                    codeEEL.find(".addDisplayNoneHere").removeClass("addDisplayNoneHere").addClass('displayNone');

                    var parentBox = control.parent('div.eELInputContainer.js-showEELContainer, div.gradebookCodeEEL');
                    if (parentBox.length > 0)
                    {
                        parentBox.removeClass('gradebookScoringMode-On').addClass('gradebookScoringMode-Off');
                    }
                }

                if (!control.hasClass('assignmentSlider'))
                {
                    skyward.controls.disable(control);

                    if (control.hasClass("gradebookInputCodeEEL"))
                    {
                        var dropDownButton = control.siblings(".gradebookCodeEELButton");
                        if (dropDownButton.length > 0 && !dropDownButton.hasClass("displayNone"))
                        {
                            dropDownButton.addClass("displayNone");
                        }

                        if (control.hasClass("subjectiveStudentGradeBucket") || control.hasClass("subjectiveStudentGradeBucketSubject") || control.hasClass("subjectiveStudentGradeBucketAcademicStandard"))
                        {
                            var wrapper = control.parent();
                            if (wrapper.length > 0 && !wrapper.hasClass("displayNone"))
                            {
                                wrapper.addClass("displayNone");
                            }

                            wrapper.next("span").removeClass("displayNone");
                        }
                    }

                    if (control.hasClass('checkbox') || control.hasClass('gradebookInputCodeEEL') || control.hasClass('codeEELDescription'))
                    {
                        return;
                    }
                    control.removeAttr('disabled');
                }
            };

            gradebook.browse.on('gradebook.scoringModeControlsChange', function ()
            {
                gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                gradebook.scoringModeControls.each(function ()
                {
                    var control = $(this);
                    if (gradebook.editMode)
                    {
                        gradebook.enableControl(control);
                    }
                    else
                    {
                        gradebook.disableControl(control);
                    }
                });
            });

            if ($.isEmptyObject(gradebook.data))
            {
                return;
            }

            var attachListeners = function ()
            {
                window.onresize = resizeGradebook;
                gradebook.controls.find('.assignmentRedirectButton:not(.ui-disabled)').on('click', skyward.gradebook.redirectToAssignment);
                gradebook.controls.find('.assignmentRestoreButton').on('click', skyward.gradebook.redirectToAssignment);

                gradebook.saveManager = createSaveManager(gradebook);

                $("#GradebookUndo").on("click", function ()
                {
                    if (!$(this).hasClass("ui-disabled"))
                    {
                        gradebook.saveManager.undo();
                    }
                });

                $("#GradebookRedo").on("click", function ()
                {
                    if (!$(this).hasClass("ui-disabled"))
                    {
                        gradebook.saveManager.redo();
                    }
                });

                gradebook.browse.on("keyup", ".browseRow .gradebookCell input:text", function (event)
                {
                    var field = $(this);
                    var fieldValue = skyward.controls.getValue(field);
                    var originalValue = getInputOriginalValue(field, true);

                    if (field.hasClass("number"))
                    {
                        fieldValue = parseFloat(fieldValue) || 0;
                        originalValue = parseFloat(originalValue) || 0;
                    }

                    if (fieldValue == originalValue)
                    {
                        gradebook.saveManager.setDirtyState(false);
                        return;
                    }

                    gradebook.saveManager.setDirtyState(true);
                });

                gradebook.browse.on("focusin", ".gradebookInput.gradebookScoringMode-On:text:not(.codeEELCode):not(.gradebookInputCodeEEL)", function ()
                {
                    var input = $(this);

                    gradebook.applyScoreMask(input);

                    var inputData = input.data();
                    if (inputData.fieldname == "Score")
                    {
                        gradebook.markInputScoreAsPending(input);
                    }
                });

                gradebook.browse.on("focusout", ".gradebookInput.gradebookScoringMode-On:text:not(.codeEELCode):not(.gradebookInputCodeEEL)", function ()
                {
                    gradebook.changeStudentAssignmentValue($(this));
                });

                gradebook.changeStudentAssignmentValue = function (input)
                {
                    // changeStudentAssignmentValue can be called asynchronously along with updateEditMode; add the ui-disabled class to the edit button immediately...
                    // ... so that we don't need to wait for it to happen in the save manager later down in this function;
                    // otherwise, it's possible to exit scoring mode before the assignment cell has finished updating
                    gradebook.editButton.addClass('ui-disabled');

                    gradebook.saveManager.setDirtyState(false);

                    var inputData = input.data();

                    if (inputData.fieldname != "Score")
                    {
                        gradebook.saveManager.save({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                        gradebook.editButton.removeClass('ui-disabled');
                        return;
                    }

                    var inputValue = input.val();

                    var deferred = $.Deferred();
                    if (inputData.originalAssignmentScore != inputValue && !isNaN(inputValue) && inputValue != "")
                    {
                        gradebook.markInputScoreAsPending(input);
                        deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(inputData.assignmentid, inputData.studentsectionid, inputValue);
                    }
                    else
                    {
                        deferred.resolve();
                    }

                    $.when(deferred).done(function ()
                    {
                        if (inputValue == "" || inputValue == ".")
                        {
                            gradebook.checkRemoveScoreMask(input);
                        }

                        gradebook.completePendingInputScore(input);
                        input.data('studentAssignmentScore', inputValue);

                        var saveData =
                        {
                            assignmentId: inputData.assignmentid,
                            studentSectionId: inputData.studentsectionid,
                            academicStandardId: inputData.academicStandardId,
                            isAvailable: inputData.isAvailable,
                            sectionId: getSectionIDFromCell(input)
                        };
                        gradebook.saveManager.save(saveData);

                        gradebook.editButton.removeClass('ui-disabled');
                    });
                };

                gradebook.browse.on("click", ".gradebookInputCodeEEL.subjectiveStudentGradeBucket, .gradebookInputCodeEEL.subjectiveStudentGradeBucketSubject, .gradebookInputCodeEEL.subjectiveStudentGradeBucketAcademicStandard", function (event)
                {
                    rowClick.apply($(this).parents("td"));
                    event.preventDefault();
                    event.stopPropagation();
                });

                gradebook.browse.on("keyup", ".codeEEL.quickEntryText", function () { markCommentQuickEntryAsValid($(this)); });
                gradebook.browse.on("eelComplete", ".codeEEL.quickEntryText", quickEntryTextEelComplete);
                gradebook.browse.on("focusout", ".quickEntryText", quickEntryTextEelComplete);

                gradebook.browse.on("focusin", ".gradebookInputCodeEEL.gradeMarkScoring", function (event, returnData)
                {
                    var input = $(this);
                    gradebook.markInputScoreAsPending(input);
                });
                gradebook.browse.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL.gradeMarkScoring", function (event, returnData)
                {
                    var input = $(this);
                    gradeMarkScoringEelComplete(event, returnData, gradebook, input);
                });
                gradebook.browse.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL.scoreClarifier", scoreClarifierEelComplete);

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucket", function (event, returnData)
                {
                    var input = $(this);
                    var studentGradeBucketID = input.parents('.gradeBucketCell').data('studentGradeBucketId');
                    var saveData =
                    {
                        isStudentGradeBucket: true,
                        studentGradeBucketID: studentGradeBucketID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucketSubject", function (event, returnData)
                {
                    var input = $(this);
                    var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                    var saveData =
                    {
                        isStudentGradeBucketSubject: true,
                        studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                gradebook.browse.on("gradebookInputCodeEELValid", ".subjectiveStudentGradeBucketAcademicStandard", function (event, returnData)
                {
                    var input = $(this);

                    var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                    var saveData =
                    {
                        isStudentGradeBucketAcademicStandard: true,
                        studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };
                    gradeMarkCodeEELValidHandler(input, saveData, returnData, gradebook);
                });

                var gradeMarkCodeEELValidHandler = function (input, saveData, returnData, gradebook)
                {
                    saveData.Score =
                    {
                        displayValue: returnData.matchedValue,
                        selectedValueID: returnData.selectedValueID
                    };

                    if (gradebook != null)
                    {
                        gradebook.saveManager.setDirtyState(false);
                    }

                    removeCellErrorClasses(input.parents("td").first(), "noGradeMarkMatch");

                    var inputValue = returnData.selectedValueID;

                    skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                    gradebook.saveManager.save(saveData);
                };

                gradebook.browse.on("gradebookInputCodeEELInvalid", ".subjectiveStudentGradeBucket, .subjectiveStudentGradeBucketSubject, .subjectiveStudentGradeBucketAcademicStandard, .gradeMarkScoring, .scoreClarifier", function (event, returnData)
                {
                    var input = $(this);
                    gradeMarkScoringEelFailed(event, returnData, input, gradebook);
                });

                gradebook.browse.on("click", ".gradebookCheckbox.mastery", function (event, returnData)
                {
                    var input = $(this);
                    rowClick.apply(input.parents("td"));
                    var mastered = input.is(":checked");
                    var primaryKey = input.attr("id").split("_")[1];

                    var saveData =
                    {
                        isStudentGradeBucketSubject: input.parents("td").first().hasClass("subjectCell"),
                        studentGradeBucketSubjectID: primaryKey,
                        isStudentGradeBucketAcademicStandard: input.parents("td").first().hasClass("academicStandardCell"),
                        studentGradeBucketAcademicStandardID: primaryKey,
                        type: "mastery",
                        studentSectionId: input.parents("tr").first().data().studentSectionId
                    };

                    gradebook.saveManager.save(saveData);
                    event.stopPropagation();
                });

                gradebook.browse.on("click", ".gradebookCheckbox:checkbox:not(.mastery)", function ()
                {
                    gradebook.gradebookCheckboxChange($(this));
                });

                gradebook.gradebookCheckboxChange = function (input)
                {
                    var inputData = input.data() || {};
                    gradebook.saveManager.save({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                };

                $('#closeMassAssign').on('click', function ()
                {
                    gradebook.massAssignHelper.collapseMassAssign(true);
                });

                gradebook.massAssignHelper = massAssign(gradebook.body, gradebook.massAssign, "input[type = 'radio'][name = 'massAssignRadiochild']:checked", gradebook.saveManager.save, gradebook.updateIsMissingValueAndCheckFailingScoreClarifier, gradebook);

                var radioButtons = gradebook.massAssign.find(gradebook.massAssignHelper.radioSet);
                radioButtons.change(gradebook.massAssignHelper.inputConfiguration);

                gradebook.editButton.on("click", updateEditMode);
                gradebook.browse.on("click", ".browseDataCell, .gradebookCell", rowClick);
                gradebook.browse.on("click", ".button[data-click-action='informationPopup.show']", function () { rowClick.apply($(this).closest(".browseRowOptions")); });
                gradebook.browse.on("click", ".button[alt='Row Menu']", function () { rowClick.apply($(this).closest(".browseRowOptions")); });

                skyward.browse.addBrowseScrollEvents(gradebook);

                gradebook.resize = resizeGradebook;

                gradebook.body.on("keydown", ".gradebookCell, .editableGradeBucketCell", browseKeyDown);

                gradebook.header.on("keydown", moveBodyOnHeaderTab);
                gradebook.header.on("click", ".assignmentHeaderIndicators", assignmentHeaderIndicatorsPopup);
                gradebook.controls.on("keydown", moveBodyOnHeaderTab);

                gradebook.browse.on("click", ".gradeBucketCell .studentGradeBucketIndicators", studentGradeBucketIndicatorPopup);
                gradebook.browse.on("click", ".subjectCell .studentGradeBucketIndicators", studentGradeBucketSubjectIndicatorPopup);
                gradebook.browse.on("click", ".academicStandardCell .studentGradeBucketIndicators", studentGradeBucketAcademicStandardIndicatorPopup);
                gradebook.browse.on("click", ".needsTransferRunProcess", gradebook.enterTransferGrades);

                gradebook.massAssign.on("keydown", browseKeyDown);

                gradebook.lockedBody.on('click', '.partiallyEnrolledButton', showTermAdjustmentInfo);

                gradebook.lockedBody.on('click', '.newStudentButton:not(.readOnly)', showNewStudentInfo);

                gradebook.lockedBody.on('click', '.alternativeCreditCourseStudent', showAlternativeCreditCourseStudentInfo);

                gradebookBrowse.debounce("Gradebook.UpdateLockedColumnState", gradebook.updateTeacherSectionSetting);

                gradebook.browse.on("click", "a.attemptCount", function (event, returnData)
                {
                    var data = $(this).data();
                    attemptsPopup(data, gradebook);
                });

                gradebook.header.on("click", ".hideGradeBucketColumn", function (event)
                {
                    event.stopPropagation();
                    event.preventDefault();

                    var button = $(this);
                    var cog = gradebook.lockedHeader.find(".gradebookSettingsCog");
                    var cell = button.parents(".browseHeaderColumn").first();
                    var cellData = cell.data();
                    var columnIndex = cellData.column;

                    var gradebookData = gradebook.browse.data();
                    var firstTimeHiding = gradebookData.showGradeBucketColumnHiddenAlert;

                    if (firstTimeHiding && !gradebookData.isTeacherTracker && button.data("objectType") == "GradeBucket")
                    {
                        gradebookData.showGradeBucketColumnHiddenAlert = false;
                        var htmlContent = "<div>You have hidden a grade column. Hidden grade columns can be maintained from the settings cog here.</div>";

                        var options =
                        {
                            anchorTo: cog,
                            id: "HideGradeBucketColumnAlert"
                        };

                        currentHeaderPopupDialog = skyward.modalLayer.showDialog("Hidden Grade Column", htmlContent, [], options);

                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/Gradebook/UpdateGradeBucketAlertSetting",
                            type: "POST",
                            dataType: "JSON",
                            activityIndicator: { silent: true },
                            data: {
                            },
                            success: function (response)
                            {

                            }
                        });
                    }

                    var postData =
                    {
                        hidden: true,
                        gradingPeriodGradeBucketID: cellData.gradingPeriodGradeBucketId,
                        teacherSectionSettingId: gradebookData.teacherSectionSettingId,
                        objectType: button.data().objectType,
                        foreignKey: button.data().foreignKey,
                        locked: button.data().locked
                    };
                    gradebook.hideColumn(columnIndex, true, postData);
                });

                addHeaderClickEvents();
            };

            var addHeaderClickEvents = function ()
            {
                var headers = gradebook.unlockedRowSpacerHeader;

                gradebook.header.on('click', ".browseColumnHeaderSort", changeSort);

                gradebook.header.on('click', '.gradeBucketExpander', gradebook.toggleBucketDisplay);
                gradebook.header.on('click', '.subjectExpander', gradebook.toggleSubjectDisplay);
                gradebook.header.on('click', '.academicStandardExpander', gradebook.toggleAcademicStandardDisplay);
                gradebook.header.on('click', '.assignmentExpander', gradebook.toggleAssignmentDisplay);
            };

            var resizeGradebook = function ()
            {
                var browseWidth = gradebook.browse.width();

                gradebook.lockedHeader.height(gradebook.unlockedHeader.height());

                var headerSpacer = 17;
                if (browseWidth > headerSpacer)
                {
                    gradebook.headerSpacer.width(browseWidth - headerSpacer);
                    gradebook.headerSpacerDiv.width(browseWidth - headerSpacer);
                }
                else
                {
                    gradebook.headerSpacer.width(0);
                    gradebook.headerSpacerDiv.width(0);
                }

                var lockedRows = gradebook.lockedBody.find('.browseRow');

                getRowHeights(lockedRows);
                gradebook.updateLockedBodyWidths();
                skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(gradebook);
            };

            var getRowHeights = function (rows)
            {
                $.each(rows, function ()
                {
                    var lockedRow = $(this);
                    var rowNumber = lockedRow.data().row;
                    var unlockedRow = $("#Gradebook_unlockedRow" + rowNumber);

                    var lockedRowHeight = lockedRow.height(); //getActualRowHeight(lockedRow);
                    var unlockedRowHeight = unlockedRow.height(); //getActualRowHeight(unlockedRow);

                    if (lockedRowHeight > unlockedRowHeight)
                    {
                        unlockedRow.height(lockedRowHeight);
                        lockedRow.height(lockedRowHeight);
                    }
                    else if (unlockedRowHeight > lockedRowHeight)
                    {
                        lockedRow.height(unlockedRowHeight);
                        unlockedRow.height(unlockedRowHeight);
                    }
                });
            };

            //TODO: Find a way to either do this quicker or not when the gradebook is loading. The loading icon stays too long when this is running on load
            var getActualRowHeight = function (element)
            {
                //This is was put in for IE.  In IE, if a child element is bigger than its parent, its height won't be reflected in the parent element's height.
                //If this is ever broken again, we probably just need this to dig a bit deeper and find the element that is pushing the height up.
                var height = element.outerHeight();
                var children = element.children();
                $.each(children, function ()
                {
                    var child = $(this);
                    if (child.outerHeight() > height)
                    {
                        height = child.outerHeight();
                    }
                });
                return height;
            };

            var rowClick = function ()
            {
                var cell = $(this);

                var data = cell.data();
                if (data == null)
                {
                    return;
                }

                var rowNumber = data.row;
                var columnNumber = data.column;
                if (!cell.hasClass("gradebookCell"))
                {
                    cell = getAssignmentCellForNewRow(rowNumber, columnNumber);
                    if (cell.length)
                    {
                        columnNumber = cell.data("column");
                    }
                }

                changeRow(rowNumber, columnNumber, cell);
            };

            var changeRow = function (rowNumber, columnNumber, browseCell)
            {
                setCurrentRecord(rowNumber, browseCell);
            };

            var changeSort = function ()
            {
                var clickedElement = $(this);
                var browseData = clickedElement.data();
                if (browseData == null)
                {
                    return;
                }

                var gradebookData = gradebookBrowse.data();

                var headers = gradebookBrowse.find(".browseHeader");
                headers.off('click', ".browseColumnHeaderSort", changeSort);

                var additionalData =
                {
                    sortField: browseData.sortField,
                    shift: skyward.keys.globalShiftPressed,
                    seekId: -1
                };

                if (browseData.sortDescending == null)
                {
                    additionalData.descending = false;
                }
                else
                {
                    additionalData.descending = !browseData.sortDescending || browseData.sortDescending === "false" || browseData.sortDescending === "False";
                }

                var action = "ChangeSort";
                if (gradebookData.isTeacherTracker)
                {
                    action += "TeacherTracker";
                }
                gradebook.reloadGradebook('Gradebook', 'Gradebook', action, additionalData);
            };

            var resetGradebookView = function (dialog)
            {
                var gradebookData = gradebookBrowse.data();
                var data = { "sectionID": gradebookData.sectionID };
                var action = "ResetGradesheetView";

                if (gradebookData.isTeacherTracker)
                {
                    action += "TeacherTracker";
                }

                gradebook.reloadGradebook('Gradebook', 'Gradebook', action, data);
                dialog.close();
            };

            var getRequiredGradebookData = function (browseData, removeSelectMode)
            {
                browseData = browseData || {};
                var browse = skyward.browse.browseList[BROWSE_NAME];
                var requiredData = gradebook.browse.data();
                var requiredBrowseData = skyward.browse.getRequiredBrowseData(browse, browseData);

                var gradebookRequiredLoadData = {};

                if (requiredBrowseData && requiredBrowseData.postData)
                {
                    if (JSON.parse(requiredBrowseData.postData).GradebookRequiredData != null)
                    {
                        gradebookRequiredLoadData = JSON.parse(JSON.parse(requiredBrowseData.postData).GradebookRequiredData);
                    }
                }
                requiredData.GradebookRequiredData = JSON.stringify(gradebookRequiredLoadData)

                $.extend(requiredData, requiredBrowseData);

                if (removeSelectMode == true)
                {
                    delete requiredData.selectMode;
                }

                return requiredData;
            };

            var setCurrentRecord = function (rowNumber, browseCell, shift, animate)
            {
                if (rowNumber >= 0 && gradebook.currentRow >= 0)
                {
                    var previousUnlockedRow = getRowElement("unlocked", gradebook.currentRow);
                    var previousLockedRow = getRowElement("locked", gradebook.currentRow);
                    previousLockedRow.removeClass("current");
                    previousUnlockedRow.removeClass("current");

                    gradebook.currentRow = rowNumber;

                    var lockedRow = getRowElement("locked", gradebook.currentRow);
                    var unlockedRow = getRowElement("unlocked", gradebook.currentRow);

                    lockedRow.addClass("current");
                    unlockedRow.addClass("current");

                    setCurrentRecordChildElementClasses(previousUnlockedRow, previousLockedRow, unlockedRow, lockedRow);

                    setCurrentCellElement(browseCell);

                    if (gradebook.unlockedBody.length > 0 && unlockedRow.length > 0)
                    {
                        var bodyTop = gradebook.unlockedBody.scrollTop();
                        var bodyBottom = bodyTop + gradebook.unlockedBody.height();

                        var rowTop = unlockedRow.offset().top - gradebook.unlockedBody.offset().top + bodyTop;
                        var rowBottom = rowTop + unlockedRow.height();

                        if (rowTop < bodyTop)
                        {
                            if (animate)
                            {
                                if (!gradebook.isGradebookFullyLoaded())
                                {
                                    gradebook.queueFunctionToCallOnCompletionOfLoad(scrollToCurrentRow, null, {});
                                    return;
                                }
                            }
                            else
                            {
                                unlockedRow[0].scrollIntoView(true);
                            }
                        }
                        else if (rowBottom > bodyBottom)
                        {
                            if (animate)
                            {
                                if (!gradebook.isGradebookFullyLoaded())
                                {
                                    gradebook.queueFunctionToCallOnCompletionOfLoad(scrollToCurrentRow, null, {});
                                    return;
                                }
                            }
                            else
                            {
                                unlockedRow[0].scrollIntoView(false);
                            }
                        }
                    }

                    scrollSpecificGradebookElementOver(browseCell);
                    updateAdditionalRowColors(previousUnlockedRow, unlockedRow, "subjectCell");
                    updateAdditionalRowColors(previousUnlockedRow, unlockedRow, "academicStandardCell");
                }
            };

            var scrollToCurrentRow = function ()
            {
                var row = getCurrentRow();
                var bodyTop = gradebook.unlockedBody.scrollTop();
                var rowTop = row.offset().top - gradebook.unlockedBody.offset().top + bodyTop;

                gradebook.unlockedBody.animate({ scrollTop: rowTop }, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                gradebook.lockedBody.animate({ scrollTop: rowTop }, GRADEBOOK_EXPAND_ANIMATION_DURATION);
            }

            var setCurrentRecordChildElementClasses = function (previousUnlockedRow, previousLockedRow, unlockedRow, lockedRow)
            {
                previousUnlockedRow.find('svg').removeClass('browseRowContent selectedRow');
                previousLockedRow.find('svg').removeClass('browseRowContent selectedRow');
                unlockedRow.find('svg').addClass('browseRowContent selectedRow');
                lockedRow.find('svg').addClass('browseRowContent selectedRow');
            };


            var scrollSpecificElementOver = function (elementToScroll, lockedTableElement, focusElement, alwaysMoveToLockedBody)
            {
                lockedTableElement = lockedTableElement ? $(lockedTableElement) : lockedTableElement;
                elementToScroll = elementToScroll ? $(elementToScroll) : elementToScroll;
                var lockedRight = lockedTableElement ? (lockedTableElement.width() + lockedTableElement.offset().left) : 0;
                var elementLeft = (focusElement && focusElement.offset()) ? focusElement.offset().left : lockedRight;
                var elementRight = elementLeft + (focusElement ? focusElement.width() : 0);
                var amountToScroll;
                if (elementLeft <= lockedRight || alwaysMoveToLockedBody == true)
                {
                    amountToScroll = lockedRight - elementLeft;
                    elementToScroll.animate({ scrollLeft: "-=" + amountToScroll }, 0);
                }
                else if (elementRight > elementToScroll.width())
                {
                    amountToScroll = elementRight - elementToScroll.width();
                    elementToScroll.animate({ scrollLeft: "+=" + amountToScroll }, 0);
                }
            };

            var scrollSpecificGradebookElementOver = function (focusElement, alwaysMoveToLockedBody)
            {
                if (focusElement == null || focusElement.parents(".lockedBrowseBody").length > 0)
                {
                    return;
                }
                scrollSpecificElementOver(gradebook.unlockedBody, gradebook.lockedBody.children('table'), focusElement, alwaysMoveToLockedBody);
            };

            var scrollElementOver = function (elementToScroll, lockedTableElement, targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody)
            {
                var focusableElements = $(':focusable:not([tabindex=-1]):not([disabled]):not(:hidden)');
                targetElement = targetElement ? $(targetElement) : focusableElements.filter(':focus');
                var offset = shift == true ? -1 : 1;
                var focusElement = focusableElements[focusableElements.index(targetElement) + offset];
                focusElement = focusElement ? $(focusElement) : focusElement;
                if (focusElementParentSelector)
                {
                    var closestFocusElement = focusElement.closest(focusElementParentSelector);
                    focusElement = closestFocusElement.length > 0 ? closestFocusElement : focusElement;
                }
                scrollSpecificElementOver(elementToScroll, lockedTableElement, focusElement, alwaysMoveToLockedBody);
            };

            var scrollGradebookElementOver = function (targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody)
            {
                scrollElementOver(gradebook.unlockedBody, gradebook.lockedBody.children('table'), targetElement, shift, focusElementParentSelector, alwaysMoveToLockedBody);
            };

            var setCurrentCellElement = function (newCell)
            {
                addCurrentCellClasses(newCell);
                if (newCell)
                {
                    var input = newCell.find("input");
                    input.focus().select();
                }
            };

            var updateAdditionalRowColors = function (previousUnlockedRow, unlockedRow, classname)
            {
                previousUnlockedRow.find("." + classname).each(function ()
                {
                    var cell = $(this);

                    if (!gradebook.hasBackgroundColorOverride(cell))
                    {
                        gradebook.resetCellBackgroundColor(cell);
                    }
                    else
                    {
                        cell.css({ backgroundColor: '', color: '' });
                    }
                });

                unlockedRow.find("." + classname).each(function ()
                {
                    var cell = $(this);
                    if (!gradebook.hasBackgroundColorOverride(cell))
                    {
                        cell.css({ backgroundColor: 'inherit', color: 'inherit' });
                    }
                });

                previousUnlockedRow.find("." + classname + ".updated").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });

                unlockedRow.find("." + classname + ".updated").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });

                unlockedRow.find("." + classname + ".hasErrors").each(function ()
                {
                    var cell = $(this);
                    cell.css({ backgroundColor: '', color: '' });
                });
            };

            var getMassAssignContent = function (assignmentId)
            {
                return $("#assignment" + assignmentId + "_MassAssignContent");
            };

            var getAverageScoreContent = function (assignmentId)
            {
                return $(".assignment" + assignmentId + "AverageHeaderCell");
            };

            var getAssignmentCellForNewRow = function (newRowNumber, newColumnNumber)
            {
                var activeElement = $(document.activeElement);
                if (activeElement.is(":text") || activeElement.is(":checkbox"))
                {
                    var assignmentCell = activeElement.closest(".assignmentCell");
                    if (assignmentCell.length)
                    {
                        var assignmentCellData = assignmentCell.data();

                        if (!$.isEmptyObject(assignmentCellData))
                        {
                            return getAssignmentCellElementByRowColumn(newRowNumber, assignmentCellData.column);
                        }
                    }
                }

                return getAssignmentCellElementByRowColumn(newRowNumber, newColumnNumber);
            };

            var getAssignmentCellElementByRowColumn = function (rowNumber, columnNumber)
            {
                return $("[data-row='" + rowNumber + "'][data-column='" + columnNumber + "']");
            };

            var addCurrentCellClasses = function (newCell)
            {
                if (gradebook.currentCell)
                {
                    gradebook.currentCell.removeClass("linkPanelCell--active");
                }
                if (newCell)
                {
                    newCell.addClass("linkPanelCell--active");
                    gradebook.currentCell = newCell;
                }
            };

            var updateIsMissingValue = function (inputData)
            {
                var isMissingCell = getAssignmentCellByField(inputData, "IsMissing").find('input');
                if (isMissingCell.is(":checked"))
                {
                    skyward.controls.setValue(isMissingCell, false);
                }
            };

            var getRowElement = function (rowType, rowNumber)
            {
                //rowType should be "unlocked" or "locked"
                return $("#" + BROWSE_NAME + "_" + rowType + "Row" + rowNumber);
            };

            var getCurrentRow = function ()
            {
                return gradebook.unlockedBody.find(".browseRow.current");
            };

            var getCurrentRowNumber = function ()
            {
                var currentRow = getCurrentRow();
                var currentRowData = currentRow.data();
                if (currentRowData == null)
                {
                    return null;
                }
                return currentRowData.row;
            };

            var getCurrentCellNumber = function ()
            {
                return $(".linkPanelCell--active").data("column");
            };

            gradebook.updateEditModeNoDialog = function (collapseAdvancedColumns, specificInputToUpdate)
            {
                if (gradebook.editButton.hasClass('ui-disabled'))
                {
                    setTimeout(gradebook.updateEditModeNoDialog, 500, collapseAdvancedColumns, specificInputToUpdate);
                }
                else
                {
                    updateEditMode(collapseAdvancedColumns, specificInputToUpdate);
                }
            };

            var updateEditMode = function (collapseAdvancedColumns, specificInputToUpdate)
            {
                if (gradebook.editButton.hasClass('ui-disabled'))
                {
                    var message = "Assignments are still being saved. Please try again.";
                    var options =
                    {
                        anchorTo: $(this),
                        id: "AssignmentsBeingSavedMessage"
                    };

                    var closeButton = { id: "closeAssignmentsBeingSavedPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                    var dialog = skyward.modalLayer.showDialog('Assignments Being Saved', message, [closeButton], options);
                    event.stopPropagation();
                    return;
                }

                gradebook.editButton.off("click", updateEditMode);
                gradebook.editButton.addClass('ui-disabled');

                var buttonText = gradebook.editButton.find('.textAfter');

                if (specificInputToUpdate)
                {
                    gradebook.scoringModeControls = $(specificInputToUpdate);
                    gradebook.gradebookBodyScoringModeControls = $(specificInputToUpdate);
                }
                else
                {
                    gradebook.scoringModeControls = gradebook.browse.find(scoringModeControlsSelector);
                    gradebook.gradebookBodyScoringModeControls = gradebook.scoringModeControls.not(scoringModeBodyFilter);
                }

                if (gradebook.editMode)
                {
                    exitScoringMode(buttonText, collapseAdvancedColumns);
                }
                else
                {
                    enterScoringMode(buttonText);
                }

                gradebook.editMode = !gradebook.editMode;
            };

            var exitScoringMode = function (buttonText, collapseAdvancedColumns)
            {
                var allSavesCompletedDeferred = new $.Deferred();
                if (gradebook.saveManager.stillProcessingSaves())
                {
                    var showPopup = true;
                    var stillProcessingPopup = null;
                    var checkStatus = function ()
                    {
                        if (gradebook.saveManager.stillProcessingSaves())
                        {
                            if (showPopup)
                            {
                                //Show it after we have waited once, most of the time this wont take longer than 500ms and the user doesn't need to see it.
                                showPopup = false;
                                stillProcessingPopup = skyward.modalLayer.showDialog("Processing Changes", "<p>Grade changes are still processing.  Scoring Mode will be exited when changes are complete.</p>");
                            }
                            setTimeout(checkStatus, 500);
                        }
                        else
                        {
                            if (stillProcessingPopup != null)
                            {
                                stillProcessingPopup.close();
                            }
                            allSavesCompletedDeferred.resolve();
                        }
                    }

                    setTimeout(checkStatus, 500);
                }
                else
                {
                    allSavesCompletedDeferred.resolve();
                }

                $.when(allSavesCompletedDeferred).done(function ()
                {
                    var animationDeferred = new $.Deferred();
                    gradebook.saveManager.reset();

                    //Need to do this, in some cases it passes this in as an object with values that we don't want
                    collapseAdvancedColumns = collapseAdvancedColumns == false ? false : true;

                    var modifierSelectorToPersistAfterExistingScoringMode = '.gradeBucketGradeChangeNotReviewedOrInProgress';
                    $(".subjectCell.updated:not(" + modifierSelectorToPersistAfterExistingScoringMode + "), .subjectCell.updatedWithErrors:not(" + modifierSelectorToPersistAfterExistingScoringMode + ")").each(function ()
                    {
                        var cell = $(this);
                        gradebook.resetCellBackgroundColor(cell);
                    });

                    $(".academicStandardCell.updated:not(" + modifierSelectorToPersistAfterExistingScoringMode + "), .academicStandardCell.updatedWithErrors:not(" + modifierSelectorToPersistAfterExistingScoringMode + ")").each(function ()
                    {
                        var cell = $(this);
                        gradebook.resetCellBackgroundColor(cell);
                    });

                    $('.gradebookCell.updated').removeClass('updated').data("numberOfUpdates", 0);
                    $('#GradebookErrorStatus').removeClass('errorDuringSave');

                    if (collapseAdvancedColumns == true)
                    {
                        gradebook.browse.find(".massAssignContentCell").attr('colspan', "1");
                        $('.assignmentHeaderCell.activeMassAssign').removeClass('activeMassAssign');

                        gradebook.browse.find(".assignmentExpander.gradebookContainerExpanded").each(function ()
                        {
                            gradebook.toggleChildrenCellDisplay($(this), { allowDuplicates: true, animate: false });
                        });
                    }

                    var overMaxScoreCell = $('.gradebookCell.updatedOverMaxScore');
                    overMaxScoreCell.removeClass('updatedOverMaxScore').data("numberOfUpdates", 0);
                    overMaxScoreCell.each(function ()
                    {
                        var currentOverMaxScoreCell = $(this);
                        var indicatorRow = currentOverMaxScoreCell.find('.assignmentIndicatorsFirstRow');
                        indicatorRow.addClass('hiddenWarning');
                        updateStudentAssignmentButtonDisplay(currentOverMaxScoreCell);
                    });

                    var errorScoreCell = $('.gradebookCell.updatedWithErrors');
                    errorScoreCell.removeClass('updatedWithErrors').data("numberOfUpdates", 0);
                    errorScoreCell.each(function ()
                    {
                        var currentErrorScoreCell = $(this);
                        var indicatorRow = currentErrorScoreCell.find('.assignmentIndicatorsFirstRow');
                        indicatorRow.addClass('hiddenWarning');
                        updateStudentAssignmentButtonDisplay(currentErrorScoreCell);
                    });

                    $.when(gradebook.massAssignHelper.collapseMassAssign(false, null, true)).done(function ()
                    {
                        animationDeferred.resolve();
                    });

                    gradebook.scoringModeControls.each(function ()
                    {
                        const control = $(this);
                        gradebook.disableControl(control);
                        gradebook.checkRemoveScoreMask(control);
                    });

                    gradebook.studentAssignmentInputs.each(function ()
                    {
                        var control = $(this);
                        var controlData = control.data();

                        if (controlData.fieldname == 'Score')
                        {
                            skyward.controls.setValue(control, controlData.displayValue, true);
                        }
                    });

                    gradebook.studentAssignmentGradeMarkInputs.each(function ()
                    {
                        resizeColumnsForGradeMarkScoring($(this), disabledGradeSheetGradeMarkScoringWidth, false);
                    });

                    $.when(animationDeferred).done(function ()
                    {
                        gradebook.editButton.removeClass('ui-disabled');
                        buttonText.text("Enter Scoring Mode");
                        gradebook.editButton.on("click", updateEditMode);
                    });

                    if (gradebook.hideDuringEditMode.length > 0)
                    {
                        gradebook.hideDuringEditMode.show();
                    }
                });
            };

            var enterScoringMode = function (buttonText)
            {
                var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
                var toolBarLeft = wrapper.parents(TOOLBAR_LEFT_SELECTOR).first();
                var gradebookOnLoadWarningBanner = toolBarLeft.find(ON_LOAD_WARNING_SELECTOR);
                if (gradebookOnLoadWarningBanner && gradebookOnLoadWarningBanner.length > 0)
                {
                    gradebookOnLoadWarningBanner.remove();
                }

                gradebook.scoringModeControls.each(function ()
                {
                    const control = $(this);
                    gradebook.enableControl(control);
                });

                gradebook.studentAssignmentInputs.each(function ()
                {
                    var control = $(this);
                    var controlData = control.data();

                    if (controlData.fieldname == 'Score' && !control.hasClass(PENDING_SCORE))
                    {
                        if (controlData.studentAssignmentScore == '')
                        {
                            controlData.studentAssignmentScore = '*';
                        }
                        skyward.controls.setValue(control, controlData.studentAssignmentScore, true);
                        gradebook.checkRemoveScoreMask(control);
                    }
                });

                gradebook.studentAssignmentGradeMarkInputs.each(function ()
                {
                    resizeColumnsForGradeMarkScoring($(this), enabledGradeSheetGradeMarkScoringWidth, true);
                });

                buttonText.text(GRADEBOOK_EXIT_SCORING_MODE);

                gradebook.editButton.removeClass('ui-disabled');
                gradebook.editButton.off("click", updateEditMode).on("click", updateEditMode);

                if (gradebook.hideDuringEditMode.length > 0)
                {
                    gradebook.hideDuringEditMode.hide();
                }
            };

            var getAssignmentCellByField = function (inputData, field)
            {
                return $("#Gradebook_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + field);
            };

            var resizeColumnsForGradeMarkScoring = function (control, width, enableGradeMark)
            {
                var controlData = control.data();
                control.width(width);

                if (controlData.secondaryfieldname == 'GradeMarkScore')
                {
                    if (enableGradeMark)
                    {
                        if (!control.hasClass(PENDING_SCORE))
                        {
                            skyward.controls.setValue(control, controlData.enabledGrademarkValue, true);
                        }
                    }
                    else
                    {
                        skyward.controls.setValue(control, controlData.disabledGrademarkValue, true);
                    }
                }
            };

            var moveBodyOnHeaderTab = function (event)
            {
                if (event.keyCode == 9)//tab
                {
                    var headerElementSelector = event.target.closest('.browseHeaderColumn') ? '.browseHeaderColumn' : undefined;
                    scrollGradebookElementOver(event.target, event.shiftKey, headerElementSelector);
                }
            };

            var browseKeyDown = function (event)
            {
                var eventTarget = $(event.target);

                var isGradebookInputCodeEEL = eventTarget.hasClass("gradebookInputCodeEEL");

                var eventTargetIsCommentField = eventTarget.closest(".assignmentCell").hasClass("gradebook_Comments");
                var eventTargetIsCheckboxField = eventTarget.closest(".assignmentCell").hasClass("gradesheetCheckboxColumn");
                var eventTargetIsGradeMarkScoringField = eventTarget.hasClass("gradeMarkScoring");
                var eventTargetIsScoreClarifierField = eventTarget.hasClass("scoreClarifier");
                var popupCount = skyward.window.getCurrentPopupId();
                if (popupCount != -1)
                {
                    return;
                }

                if (event.keyCode == 13 || event.keyCode == 40)//enter or down arrow
                {
                    selectNextVerticalCell(event.target, event.shiftKey);
                    event.preventDefault();
                    event.stopPropagation();
                }
                else if (event.keyCode == 38)//up arrow
                {
                    selectNextVerticalCell(event.target, !event.shiftKey);
                    event.preventDefault();
                    event.stopPropagation();
                }
                else if (event.keyCode == 9)//tab
                {
                    event.preventDefault();
                    selectNextHorizontalCell(event.target, event.shiftKey);
                }
                else if (event.keyCode >= 65 && event.keyCode <= 90)//a-z
                {
                    if (event.ctrlKey)
                    {
                        if ((event.keyCode == 89 && !event.shiftKey) || (event.keyCode == 90 && event.shiftKey))
                        {
                            gradebook.saveManager.redo();
                            event.preventDefault();
                            return;
                        }
                        else if (event.keyCode == 90 || (event.keyCode == 89 && event.shiftKey))
                        {
                            gradebook.saveManager.undo();
                            event.preventDefault();
                            return;
                        }
                    }

                    if (!event.shiftKey && event.altKey)
                    {
                        event.preventDefault();
                        event.stopPropagation();
                        var letter = String.fromCharCode(event.keyCode);
                        selectCorrespondingStudent(letter, event.shiftKey, true);
                        return;
                    }

                    if (eventTarget.hasClass("studentAssignmentScoreInput") || isGradebookInputCodeEEL)
                    {
                        var markAsMissing = event.keyCode == 77 && (!isGradebookInputCodeEEL || (event.ctrlKey));
                        if (markAsMissing) //M
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markAsMissing(data.studentsectionid, data.assignmentid);
                            return;
                        }
                        var markAsNoCount = event.keyCode == 69 && (!isGradebookInputCodeEEL || (event.ctrlKey));
                        if (markAsNoCount) //E
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markNoCount(data.studentsectionid, data.assignmentid);
                            return;
                        }
                        var markAsZero = event.keyCode == 90 && !isGradebookInputCodeEEL;
                        if (markAsZero) //z
                        {
                            event.preventDefault();
                            event.stopPropagation();
                            var data = eventTarget.data();
                            gradebook.markAsZero(data.studentsectionid, data.assignmentid);
                            return;
                        }
                    }


                }
                else if ((event.keyCode >= 48 && event.keyCode <= 57 && !event.shiftKey) ||
                    (event.keyCode >= 96 && event.keyCode <= 105 && !event.shiftKey) ||
                    event.keyCode == 46 ||
                    event.keyCode == 8 ||
                    (event.keyCode == 190 && !event.shiftKey) ||
                    event.keyCode == 110 ||
                    (event.keyCode == 187 && event.shiftKey) ||
                    (event.keyCode == 49 && event.shiftKey))
                {
                    //48-57: numbers
                    //8: backspace
                    //46: delete
                    //96-105: num lock numbers
                    //190 + 110: decimal point and num lock decimal point
                    //187 + shift  = "+"
                    //49 - !
                }
                else if (eventTargetIsCommentField || eventTargetIsGradeMarkScoringField)
                {
                    //if comment allow all characters
                }
                else if (eventTargetIsCheckboxField && event.keyCode == 32)
                {
                    //Allow space bar for checkboxes
                }
                else if (event.keyCode >= 112 && event.keyCode <= 123)
                {
                    //Allow all Function keys
                }
                else if (event.keyCode == 109 || event.keyCode == 189 || event.keyCode == 173 && eventTarget.attr('id') == 'adjustAllScoresInput')
                {
                    //Allow negative values for Adjust All Scores option within mass assign
                }
                else
                {
                    //event.preventDefault();
                    //event.stopPropagation();
                }
            };

            var selectCorrespondingStudent = function (letter, shift, editMode)
            {
                var studentsWithSameLastInitials = gradebook.students.filter(function (s)
                {
                    if (editMode && gradebook.currentCell != null && gradebook.currentCell.length > 0)
                    {
                        var nextGradebookCell = gradebook.unlockedBody.find("td.gradebookCell[data-row='" + s.row + "'][data-column='" + gradebook.currentCell.data().column + "']");
                        if (nextGradebookCell && nextGradebookCell.length > 0 && nextGradebookCell.find("input:not(:disabled):not([readonly])").length > 0)
                        {
                            return s.name[0] == letter;
                        }
                    }
                    else
                    {
                        return s.name[0] == letter;
                    }
                    return false;
                });

                if (studentsWithSameLastInitials.length > 0)
                {
                    var studentRows = [];
                    for (var i = 0; i < studentsWithSameLastInitials.length; i++)
                    {
                        studentRows.push(studentsWithSameLastInitials[i].row);
                    }

                    var currentRow = getCurrentRow();
                    var currentRowIndex = studentRows.indexOf(currentRow.data("row")); //will return -1 if the current student does not have a last initial of letter

                    //will get the first student w/ that last initial, or if i'm on a student w/ that last initial, will get the row of the next one alphabetically by last name.
                    var nextRowNumber = currentRowIndex + 1 < studentsWithSameLastInitials.length ? studentRows[currentRowIndex + 1] : studentRows[0];

                    var nextCell = $("#" + BROWSE_NAME + "_unlockedRow" + nextRowNumber).find("[data-column='" + getCurrentCellNumber(currentRow) + "']");
                    setCurrentRecord(nextRowNumber, nextCell, shift);
                }
            };

            var selectNextVerticalCell = function (element, shift)
            {
                var td = $(element).closest(".gradebookCell"); //assignmentCell
                if (td.length == 0)
                {
                    return;
                }

                var data = td.data();
                if (data == null)
                {
                    return;
                }

                var newRow;
                var newTdCell;
                var rowCount = 0;
                do
                {
                    if (rowCount > gradebook.rowCount)
                    {
                        return;
                    }

                    if (shift)
                    {
                        newRow = data.row - (rowCount + 1) < 0 ? gradebook.rowCount - 1 : data.row - (rowCount + 1);
                    }
                    else
                    {
                        newRow = data.row + (rowCount + 1) > gradebook.rowCount - 1 ? 0 : data.row + (rowCount + 1);
                    }
                    newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(".gradebookCell[data-column='" + data.column + "']"); //assignmentCell
                    rowCount++;
                }
                while (newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').length == 0 || newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').is(':disabled,[readonly],.ui-disabled'));

                if ($.contains(newTdCell.get(0), element))
                {
                    $("#UpdateEditMode").focus();
                    return;
                }

                setCurrentRecord(newRow, newTdCell, shift);
            };

            var selectNextHorizontalCell = function (element, shift)
            {
                var currentCellSelector = ".gradebookCell, .editableGradeBucketCell"; //assignmentCell
                var nextCellSelector = ".gradebookCell:visible:not('.gradesheetAttemptsColumn'), .editableGradeBucketCell:visible"; //assignmentCell

                var td = $(element).closest(currentCellSelector);
                if (td.length == 0)
                {
                    return;
                }

                var data = td.data();
                if ($.isEmptyObject(data))
                {
                    return;
                }

                var newTdCell;
                var rowCount = 0;
                do
                {
                    if (rowCount > gradebook.rowCount)
                    {
                        return;
                    }

                    if (shift)
                    {
                        newTdCell = td.prevAll(nextCellSelector).first();
                    }
                    else
                    {
                        newTdCell = td.nextAll(nextCellSelector).first();
                    }

                    if (td.parent().hasClass('locked'))
                    {
                        rowCount--;
                    }

                    if (newTdCell.length == 0)
                    {
                        var newRow;
                        rowCount++;
                        if (shift)
                        {
                            newRow = data.row - rowCount < 0 ? gradebook.rowCount - 1 : data.row - rowCount;
                            newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(nextCellSelector).last();
                        }
                        else
                        {
                            newRow = data.row + rowCount > gradebook.rowCount - 1 ? 0 : data.row + rowCount;
                            newTdCell = $("#" + BROWSE_NAME + "_unlockedRow" + newRow).find(nextCellSelector).first();
                        }
                    }

                    if (td.parent().hasClass('locked'))
                    {
                        rowCount++;
                    }

                    td = newTdCell;
                }
                while (newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').length == 0 || newTdCell.find('.gradebookInput, .gradebookCheckbox, .gradebookInputCodeEEL, .codeEELDescription, .attemptCount').is(':disabled,[readonly],.ui-disabled'));

                var newTdCellData = newTdCell.data();
                if ($.isEmptyObject(newTdCellData))
                {
                    return;
                }

                if ($.contains(newTdCell.get(0), element))
                {
                    $("#UpdateEditMode").focus();
                    return;
                }

                setCurrentRecord(newTdCellData.row, newTdCell, shift);
            };

            var buildLegendPopup = function ()
            {
                var buildPopup = function ()
                {
                    var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "BuildColumnLegendPopupTeacherTracker" : "BuildColumnLegendPopup";

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        activityIndicator: { silent: true },
                        type: "POST",
                        dataType: "viewparthtml"
                    });
                };

                var options =
                {
                    draggable: true,
                    width: '940px',
                    anchorTo: $(this)
                };

                skyward.modalLayer.showDialog("Gradesheet Legend", buildPopup, { text: "Close", icon: "Close" }, options);
            };

            var setFocusOnInput = function (currentCellInput)
            {
                if (currentCellInput.length == 0)
                {
                    return;
                }
                currentCellInput.focus();
            };

            gradebook.getAdvancedColumnCellsByAssignmentID = function (assignmentID, defaultCollapsed, setFocusOnInput)
            {
                var assignmentExpandChevronContainer = $("#Gradebook_unlockedRowSpacerHeader").find("#assignmentHeaderCell" + assignmentID);
                var data = assignmentExpandChevronContainer.data();
                var assignmentHeaderCell = $("#assignment" + assignmentID + "HeaderCell");
                $.extend(data, assignmentHeaderCell.data());

                var myPromise = new $.Deferred();

                if ($(".advancedAssignmentCell" + assignmentID + ":not(." + COLLAPSED_CLASS_NAME + ")").length == 0)
                {
                    var assignmentExpander = $("#assignmentHeaderCell" + assignmentID + ".gradebookIconHeaderCell").find(".assignmentExpander");

                    if (assignmentExpander == null || assignmentExpander.length == 0)
                    {
                        myPromise.resolve();
                    }
                    else
                    {
                        var togglePromise = new $.Deferred();

                        if (!defaultCollapsed || $(".assignmentCell.advancedAssignmentCell" + assignmentID).length == 0) //If we have the cells but they are just 'Collapsed' then we don't need to do anything here, no need to add another promise
                        {
                            togglePromise = gradebook.toggleChildrenCellDisplay(assignmentExpander, { allowDuplicates: true, defaultCollapsed: defaultCollapsed, animate: false, setFocusOnInput: setFocusOnInput });
                        }
                        else
                        {
                            togglePromise.resolve();
                        }

                        $.when(togglePromise).done(function ()
                        {
                            myPromise.resolve();
                        });
                    }
                }
                else
                {
                    myPromise.resolve();
                }

                return myPromise.promise();
            };

            gradebook.updateIsMissingValueAndCheckFailingScoreClarifier = function (assignmentID, studentSectionID, scoreEarned, maxScore, percentEarned)
            {
                var deferred = $.Deferred();

                var assignmentHeaderCell = $("#assignment" + assignmentID + "HeaderCell");
                maxScore = maxScore ? maxScore : assignmentHeaderCell.data("maxscore");
                var percentEarnedFloat = getPercentEarned(scoreEarned, maxScore, percentEarned);

                var assignmentInput = gradebook.getAssignmentScoreInput(assignmentID, studentSectionID);
                var isMissingPuck = assignmentInput.parents(".gradebookCell").find(".assignmentIndicators:not(.hiddenMissingScore)").find("svg.missingScore.svg, svg.isMissing");

                var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(false);

                if (scoreChangeAdvancedAssignmentColumnHandler.requiresAdvancedAssignmentColumns(percentEarnedFloat, gradebook.bodyData, isMissingPuck.length > 0))
                {
                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(assignmentID, true, false)).done(function ()
                    {
                        var inputDataForGetAssignmentCellByField = { studentsectionid: studentSectionID, assignmentid: assignmentID };

                        scoreChangeAdvancedAssignmentColumnHandler.handleAdvancedAssignmentColumnUpdates(percentEarnedFloat, gradebook.bodyData, studentSectionID, assignmentID, isMissingPuck, true);

                        deferred.resolve();
                    });
                }
                else
                {
                    deferred.resolve();
                }

                return deferred.promise();
            };
            var markCommentQuickEntryAsValid = function (quickEnty)
            {
                if (quickEnty.length < 1)
                {
                    return;
                }
               
                var codeEELDescription = quickEnty.find(".codeEELDescription");
                if (codeEELDescription.length < 1)
                {
                    return;
                }
                var data = codeEELDescription.data();
                data.lastValidatedValue = skyward.controls.getValue(quickEnty); //On gradesheet they dont need to select an existing item, they can type whatever.
            }

            var quickEntryTextEelComplete = function ()
            {
                var quickEnty = $(this);

                if (quickEnty.length < 1)
                {
                    return;
                }
                markCommentQuickEntryAsValid(quickEnty);

                var codeEELDescription = quickEnty.find(".codeEELDescription");

                if (codeEELDescription.length < 1)
                {
                    return;
                }
                gradebook.saveManager.setDirtyState(false);
                var data = codeEELDescription.data();
                gradebook.saveManager.save({ assignmentId: data.assignmentid, studentSectionId: data.studentsectionid, academicStandardId: data.academicStandardId, isAvailable: data.isAvailable, sectionId: getSectionIDFromCell(quickEnty) });
            };

            var scoreClarifierEelComplete = function (event, returnData)
            {
                var input = $(this);

                var inputData = input.data();

                removeCellErrorClasses(input.parents("td").first(), "noMatch");

                gradebook.saveManager.setDirtyState(false);

                var inputValue = returnData.selectedValueID;

                if (inputValue == null)
                {
                    inputValue = "";
                }

                skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                if (returnData.additionalFields && inputValue != "")
                {
                    $.each(returnData.additionalFields, function (key, value)
                    {
                        if ((key === "IsMissing" || key === "NoCount") && !value)
                        {
                            return;
                        }
                        var fieldDiv = getAssignmentCellByField(inputData, key);
                        if (fieldDiv.length && value == 'true')
                        {
                            var specificInput = fieldDiv.find("input");
                            specificInput.prop("checked", value);
                        }
                    });
                }

                var saveData =
                {
                    assignmentId: inputData.assignmentid,
                    studentSectionId: inputData.studentsectionid,
                    studentAssignmentId: inputData.studentassignmentid,
                    isAvailable: inputData.isAvailable,
                    sectionId: getSectionIDFromCell(input),
                    ScoreClarifierID:
                    {
                        displayValue: returnData.matchedValue
                    }
                };
                gradebook.saveManager.save(saveData);
            };

            var updateAssignmentHeaderCellExpandClasses = function (assignmentId, show)
            {
                var stripeClass = "advancedAssignmentStripe";
                var advancedExpandedClass = "advancedAssignmentExpanded";

                var assignmentHeaderCell = $(".browseHeaderColumn.assignmentHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell')");
                var assignmentCellRoundedCorners = assignmentHeaderCell.find(".assignmentCellRoundedCorners:not(.gradebookSecondaryContainer):not(.gradebookTertiaryContainer)");
                var tertiaryColumns = assignmentHeaderCell.find(".assignmentCellRoundedCorners.gradebookTertiaryContainer");
                var assignmentCellSecondaryContainers = assignmentHeaderCell.find(".assignmentCellRoundedCorners.gradebookSecondaryContainer");
                var assignmentHeaderSpacerCells = $(".assignmentHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell'):not('.browseHeaderColumn'), "
                    + ".assignmentHeaderCell.gradebookIconHeaderCell[data-assignmentid='" + assignmentId + "']:not('.advancedAssignmentCell')");

                if (show)
                {
                    if (assignmentHeaderCell.hasClass('lastColumnHideBorder'))
                    {
                        assignmentHeaderCell.removeClass('lastColumnHideBorder');
                        assignmentHeaderCell.addClass('lastColumnHideBorderExpanded');
                    }
                    assignmentHeaderCell.addClass(stripeClass);
                    assignmentCellRoundedCorners.addClass(advancedExpandedClass);
                    assignmentCellSecondaryContainers.addClass(stripeClass);
                    assignmentHeaderSpacerCells.addClass("expanded");

                    $.each(tertiaryColumns, function ()
                    {
                        var column = $(this);
                        if (column.hasClass("cornerEnd"))
                        {
                            column.removeClass("cornerEnd");
                            column.addClass("stripe");
                            column.addClass("cornerEndOnCollapse");
                        }
                    });

                }
                else
                {
                    if (assignmentHeaderCell.hasClass('lastColumnHideBorderExpanded'))
                    {
                        assignmentHeaderCell.addClass('lastColumnHideBorder');
                        assignmentHeaderCell.removeClass('lastColumnHideBorderExpanded');
                    }
                    assignmentHeaderCell.removeClass(stripeClass);
                    assignmentCellRoundedCorners.removeClass(advancedExpandedClass);
                    assignmentCellSecondaryContainers.removeClass(stripeClass);
                    assignmentHeaderSpacerCells.removeClass("expanded");

                    $.each(tertiaryColumns, function ()
                    {
                        var column = $(this);
                        if (column.hasClass("cornerEndOnCollapse"))
                        {
                            column.addClass("cornerEnd");
                            column.removeClass("stripe");
                            column.removeClass("cornerEndOnCollapse");
                        }
                    });
                }
            };

            var setAssignmentHeaderCellToDefaultColors = function (assignmentId)
            {

                var assignmentCell = $('#assignment' + assignmentId + 'HeaderCell');
                setAssignmentCellToColors(assignmentId, assignmentCell.data("defaultBackgroundColor"), assignmentCell.data("defaultTextColor"));
            };

            var setAssignmentCellToColors = function (assignmentId, categoryBackgroundColor, categoryTextColor)
            {

                var assignmentCell = $('#assignment' + assignmentId + 'HeaderCell');
                assignmentCell.css({ 'background-color': categoryBackgroundColor, 'color': categoryTextColor });
                $('.assignmentHeaderCell.advancedAssignmentCell' + assignmentId + ':not(.assignmentInformation)').css({ 'background-color': categoryBackgroundColor, 'color': categoryTextColor });
            };

            var saveUndrop = function (assignmentData)
            {
                var undropButton = $('#saveUndropScore');
                undropButton.off('click');

                gradebook.saveManager.setDirtyState(false);
                gradebook.saveManager.save({ studentAssignmentId: assignmentData.studentassignmentid, IsDropped: false, assignmentId: assignmentData.assignmentid, studentSectionId: assignmentData.studentsectionid, academicStandardId: assignmentData.academicStandardId, isAvailable: assignmentData.isAvailable, sectionId: assignmentData.sectionId });
            };

            var gradingPeriodOptionsPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(gradingPeriodOptionsPopup, element, {});
                    return;
                }

                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var gradebookData = gradebook.dataContainer.data();

                var data = element.data();
                var gradingPeriodID = data.gradingPeriodId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                var sectionID = data.sectionId;
                var isLockedGradeBucketColumn = element.parents(".lockedHeader").length > 0;
                var readOnly = $('#' + BROWSE_NAME).data().readOnly.toString().toLowerCase() == 'true';
                var action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GradingPeriodOptionsTeacherTracker" : localGradebookData.classGroupId ? "GradingPeriodOptionsClassGroup" : "GradingPeriodOptions";
                var sectionIDHash = localGradebookData.sectionIdHash;
                var inScoringMode = isInScoringMode();
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        gradingPeriodID: gradingPeriodID,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        calculationGroupID: gradebookData.calculationgroupid,
                        districtID: gradebookData.districtid,
                        sectionID: sectionID,
                        readOnly: readOnly,
                        isLockedGradeBucketColumn: isLockedGradeBucketColumn,
                        gradebookType: localGradebookData.gradebookType,
                        assignmentID: localGradebookData.assignmentId, //This will only be set on single assignment score entry
                        sectionIDHash: sectionIDHash,
                        classGroupID: localGradebookData.classGroupId,
                        classGroupIDHash: localGradebookData.classGroupIdHash,
                        filteredStudentSectionId: localGradebookData.filteredStudentSectionId,
                        isInScoringMode: inScoringMode
                    },
                    success: async function (response)
                    {
                        if (response.htmlValue)
                        {
                            //The below commented out code can be used again when we determine what we want to do about disabling/enabling buttons
                            //if (!inScoringMode|| !response.massScoreIsDisabled)
                            //{
                            const htmlContent = $(await skyward.global.processViewPartHtml(response.htmlValue.Content))
                            var hasSubjectsOrStandardsToDisplayBrowse = htmlContent.find(".subjectsToDisplayBrowse").length > 0 || htmlContent.find(".academicStandardsToDisplayBrowse").length > 0;
                            var saveButton = (readOnly || inScoringMode) && !hasSubjectsOrStandardsToDisplayBrowse ? null : { id: "saveGradingPeriodOptions", text: "Save", click: function () { gradingPeriodOptionsSave(gradingPeriodID, sectionID, currentHeaderPopupDialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, localGradebookData.isTeacherTracker); }, icon: "Save" };
                            var cancelButton = { id: "cancelGradingPeriodOptions", text: "Cancel", click: function () { currentHeaderPopupDialog.close(); }, icon: "Cancel" };
                            var options =
                            {
                                anchorTo: element,
                                id: "gradingPeriodOptionsPopup"
                            };

                            var buttons = [];

                            if (saveButton != null)
                            {
                                buttons.push(saveButton);
                            }

                            buttons.push(cancelButton);
                            currentHeaderPopupDialog = skyward.modalLayer.showDialog("Grading Period Options", response.htmlValue.Content, buttons, options);
                            //}
                        }
                        return;
                    }
                });
            };

            var gradingPeriodOptionsSave = function (gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)
            {
                var currentButton = $("#saveGradingPeriodOptions");
                currentButton.addClass("ui-disabled");
                $.when(gradingPeriodOptionsSaveAjax(gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)).done(function ()
                {
                    currentButton.removeClass("ui-disabled");
                });
            };

            var gradingPeriodOptionsSaveAjax = function (gradingPeriodID, sectionID, dialog, isLockedGradeBucketColumn, gradingPeriodGradeBucketID, isTeacherTracker)
            {
                var completedCheckbox = dialog.content.find('#gradingPeriodOptions_Completed');
                var completed = completedCheckbox.is(':checked');
                var calculationGroupGradeBucketIDLocked = skyward.controls.getValue(dialog.content.find('#CalculationGroupGradeBucketIDLocked_value'));

                var subjectsToDisplay = dialog.container.find(".subjectsToDisplayBrowse");
                var academicStandardsToDisplay = dialog.container.find(".academicStandardsToDisplayBrowse");

                var saveAction = "GradingPeriodOptionsSave";
                if (isTeacherTracker.toString().toLowerCase() == "true")
                {
                    saveAction += "TeacherTracker";
                }

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + saveAction,
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        gradingPeriodID: gradingPeriodID,
                        sectionID: sectionID,
                        completed: completed,
                        calculationGroupGradeBucketIDLocked: calculationGroupGradeBucketIDLocked,
                        isLockedGradeBucketColumn: isLockedGradeBucketColumn,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        SubjectsToDisplay: subjectsToDisplay.length > 0 ? JSON.stringify(subjectsToDisplay.data("editablebrowsedata")) : null,
                        AcademicStandardsToDisplay: academicStandardsToDisplay.length > 0 ? JSON.stringify(academicStandardsToDisplay.data("editablebrowsedata")) : null,
                        markUnscoredPastDueAssignmentsAsMissing: skyward.controls.getValue(dialog.content.find(".markUnscoredPastDueAssignmentsAsMissing")),
                    },
                    success: function (response)
                    {
                        dialog.close();
                        if (response.success)
                        {
                            if (response.requiresRefresh)
                            {
                                dialog.close();
                                var action = "ReloadGradebook";
                                if (gradebookData.isTeacherTracker)
                                {
                                    action += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                                return;
                            }

                            if (completed)
                            {
                                gradingPeriodOptionsDisableCompleted(gradingPeriodID, gradingPeriodGradeBucketID);
                            }

                            $('#Gradebook').trigger('gradebook.scoringModeControlsChange');
                        }
                    }
                });
            };

            var nonAssignmentMassAssignPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var inScoringModeOnButtonClick = isInScoringMode();
                var postData = $.extend({}, data);

                if (inScoringModeOnButtonClick === false)
                {
                    updateEditMode();
                }

                var popupID = "MassAssignScores";
                var headerText = "Mass Assign Scores";

                if (currentHeaderPopupDialog)
                {
                    currentHeaderPopupDialog.close();
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + data.screen,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                };

                var saveButton = {
                    text: "Save", "click": function ()
                    {
                        $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function (errors)
                        {
                            if (errors && errors.length > 0)
                            {
                                var errorMessage = errors.join("<br />");
                                skyward.modalLayer.showErrorDialog("Mass Assign Scores", errorMessage);
                            }
                            else
                            {
                                dialog.close();
                            }
                        });
                    }, "icon": "Save", "data": data
                };
                var closeButton = { text: "Cancel", "click": function () { dialog.close(); }, "icon": "Cancel" };
                var options =
                {
                    closeOnEscape: false,
                    draggable: true,
                    id: popupID
                };
                var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);
                dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
                dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
                dialog.content.on("keydown", ".gradebookInputCodeEEL", browseKeyDown);

                dialog.modalLayer.options.afterClose = function (result)
                {
                    var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);

                    var errorsOnSave = wrapper.hasClass("errorDuringSave") || wrapper.hasClass("studentAssignmentError") || wrapper.hasClass("studentGradeBucketError");
                    if (inScoringModeOnButtonClick === false && !errorsOnSave)
                    {
                        gradebook.updateEditModeNoDialog();
                    }
                };
            };

            var currentHeaderPopupDialog;
            var assignmentHeaderPopup = function ()
            {
                var element = $(this);

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(assignmentHeaderPopup, element, {});
                    return;
                }

                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                //check if it's scoring mode and pass that
                var data = element.data();
                var postData =
                {
                    allowMassScoreOptions: data.allowmassscoreoptions,
                    assignmentID: data.assignmentid,
                    representedAssignmentIDs: data.representedAssignmentIds,
                    sectionID: data.sectionid,
                    districtID: gradebook.dataContainer.data().districtid,
                    isInScoringMode: isInScoringMode(),
                };
                var controllerAction = "AssignmentHeaderPopup";
                var popupID = "AssignmentHeaderPopup";
                var headerText = "Assignment Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var saveAcademicStandardsToDisplay = function (data, dialog)
            {
                var academicStandardsToDisplay = dialog.container.find(".academicStandardsToDisplayBrowse");

                data.AcademicStandardsToDisplay = academicStandardsToDisplay.length > 0
                    ? JSON.stringify(academicStandardsToDisplay.data("editablebrowsedata"))
                    : null;

                var action = "SaveAcademicStandardsToDisplay";
                if (gradebook.data.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action += "TeacherTracker";
                }

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: function (response)
                    {
                        dialog.close();
                        if (response.success)
                        {
                            if (response.requiresRefresh)
                            {
                                dialog.close();
                                var action = "ReloadGradebook";
                                if (gradebookData.isTeacherTracker)
                                {
                                    action += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                                return;
                            }
                        }
                    }
                });
            };

            var standardHeaderPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(standardHeaderPopup, element, {});
                    return;
                }

                var gradebookData = gradebook.dataContainer.data();
                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var data = element.data();
                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();

                var postData =
                {
                    calculationGroupAcademicStandardGradeBucketID: data.calculationGroupAcademicStandardGradeBucketId,
                    academicStandardID: data.academicStandardId,
                    districtID: gradebook.dataContainer.data().districtid,
                    gradingPeriodGradeBucketID: data.gradingPeriodGradeBucketId,
                    gradingPeriodID: data.gradingPeriodId,
                    calculationGroupID: data.calculationGroupId,
                    sectionID: data.sectionId,
                    classGroupId: gradebookData.classGroupId,
                    isInScoringMode: isInScoringMode(),
                    filteredStudentSectionId: localGradebookData.filteredStudentSectionId
                };
                var controllerAction = "StandardHeaderPopup";
                var popupID = "StandardHeaderPopup";
                var headerText = "Academic Standard Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var subjectHeaderPopup = function ()
            {
                var element = $(this);

                if (element.hasClass(PREVENT_CLICK_CLASS_NAME))
                {
                    return;
                }

                if (!gradebook.isGradebookFullyLoaded())
                {
                    gradebook.queueFunctionToCallOnCompletionOfLoad(subjectHeaderPopup, element, {});
                    return;
                }

                var gradebookData = gradebook.dataContainer.data();
                //Because we are potentially queuing this function there is a chance other popup actions got queued and we don't want multiple popups. So whichever was queued last will win
                skyward.window.closePopup();

                var data = element.data();
                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var postData =
                {
                    calculationGroupSubjectGradeBucketID: data.calculationGroupSubjectGradeBucketId,
                    gradingPeriodGradeBucketID: data.gradingPeriodGradeBucketId,
                    gradingPeriodID: data.gradingPeriodId,
                    calculationGroupID: data.calculationGroupId,
                    sectionID: data.sectionId,
                    classGroupId: gradebookData.classGroupId,
                    subjectID: data.subjectId,
                    districtID: gradebook.dataContainer.data().districtid,
                    isInScoringMode: isInScoringMode(),
                    filteredStudentSectionId: localGradebookData.filteredStudentSectionId
                };
                var controllerAction = "SubjectHeaderPopup";
                var popupID = "SubjectHeaderPopup";
                var headerText = "Subject Options";

                currentHeaderPopupDialog = sharedHeaderPopup(element, postData, controllerAction, popupID, headerText);
            };

            var sharedHeaderPopup = function (element, data, controllerAction, popupID, headerText)
            {
                if (element.hasClass('gradebookScoringMode-On'))
                {
                    return;
                }

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var gradebookData = gradebook.dataContainer.data();

                var requiredData = getRequiredGradebookData();
                if (requiredData.GradebookRequiredData)
                {
                    data.GradebookType = JSON.parse(requiredData.GradebookRequiredData).GradebookType;
                }
                var isLockedGradeBucketColumn = element.parents(".lockedHeader").length > 0;
                var readOnly = $('#' + BROWSE_NAME).data().readOnly.toString().toLowerCase() == 'true';

                controllerAction += localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "TeacherTracker" : localGradebookData.classGroupId ? "ClassGroup" : "";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + controllerAction,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    success: async function (response)
                    {
                        if (response.htmlValue)
                        {
                            var buttons = [];

                            const responseContent = $(await skyward.global.processViewPartHtml(response.htmlValue.Content))

                            if (responseContent.find("#AcademicStandardsToDisplay").length > 0 || response.requiresSaveButton)
                            {
                                var saveButton = {
                                    text: "Save", click: function ()
                                    {
                                        saveAcademicStandardsToDisplay(data, currentHeaderPopupDialog);
                                    }, icon: "Save"
                                };

                                var cancelButton = { text: "Cancel", click: function () { currentHeaderPopupDialog.close(); }, icon: "Cancel" };

                                buttons.push(saveButton);
                                buttons.push(cancelButton);
                            }

                            var options =
                            {
                                anchorTo: element,
                                id: popupID
                            };
                            currentHeaderPopupDialog = skyward.modalLayer.showDialog(headerText, responseContent, buttons, options);
                            return currentHeaderPopupDialog;
                        }
                        return;
                    }
                });
            };

            var viewGradingScale = function ()
            {
                var button = $(this);

                var buttonData = button.data();
                var action = buttonData.screen;
                var closeButton = { id: "cancelButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: buttonData,
                    });
                };
                var options =
                {
                    anchorTo: button,
                    allowNoButtons: true,
                    draggable: true
                };

                var dialog = skyward.modalLayer.showDialog("Grading Scale", buildPopup, [closeButton], options);
                return dialog;
            };

            var viewStudentGradeContainerAudit = function ()
            {
                var button = $(this);

                var buttonData = button.data();
                var action = "StudentGradeContainerOverrideAudit";
                if (buttonData && buttonData.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action = action + "TeacherTracker";
                }
                var closeButton = { id: "cancelButton", text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: buttonData,
                    });
                };
                var options =
                {
                    anchorTo: button,
                    allowNoButtons: true,
                    draggable: true
                };

                var dialog = skyward.modalLayer.showDialog("Grade History", buildPopup, [closeButton], options);
                return dialog;
            };


            var gradingPeriodOptionsDisableCompleted = function (gradingPeriodID, gradingPeriodGradeBucketID)
            {
                var elements = $('.gradebookScoringModeControl[data-grading-period-id="' + gradingPeriodID + '"], .gradingPeriodCompletedButton[data-grading-period-id="' + gradingPeriodID + '"], .browseHeaderAssignmentIconContainer[data-grading-period-id="' + gradingPeriodID + '"], .gradeBucketCell[data-grading-period-id="' + gradingPeriodID + '"], .subjectCell[data-grading-period-id="' + gradingPeriodID + '"], .academicStandardCell[data-grading-period-id="' + gradingPeriodID + '"]');

                $.each(elements, function ()
                {
                    var element = $(this);

                    if (element.hasClass("gradeBucketCell") || element.hasClass("subjectCell") || element.hasClass("academicStandardCell"))
                    {
                        element.find(".gradebookInputCodeEEL").addClass('gradingPeriodCompleted scoringModeDoesntAffectState').attr('disabled', 'true').attr('readonly', 'readonly');
                    }

                    element.addClass('gradingPeriodCompleted scoringModeDoesntAffectState');
                    element.attr('readonly', 'readonly');
                    element.attr('disabled', 'true');
                });

            };

            var disableTransferInputs = function (transferAndDoNotPostStudentSectionsThatShouldNotHaveTheirScoringModeClassesRemoved, gradingPeriodID, gradingPeriodGradeBucketID)
            {
                $(transferAndDoNotPostStudentSectionsThatShouldNotHaveTheirScoringModeClassesRemoved).each(function ()
                {
                    currentStudentSection = $(this);
                    var elements = $('.scoringModeDoesntAffectState[data-grading-period-id="' + gradingPeriodID + '"][data-studentsectionid="' + currentStudentSection['0'].StudentSectionID + '"], .codeEELDescription[data-grading-period-id="' + gradingPeriodID + '"]' + "[data-studentsectionid='" + currentStudentSection['0'].StudentSectionID + "']");
                    elements.removeClass('transferOrDoNotPostGradeShouldNotBeActivated').addClass('transferOrDoNotPostGradeShouldNotBeActivated');
                });
            };

            var showNewStudentInfo = function ()
            {
                var button = $(this);
                var data = button.data();
                var isTeacherTracker = gradebookData.isTeacherTracker.toString().toLowerCase() == "true";
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + (isTeacherTracker ? "NewStudentPopupTeacherTracker" : "NewStudentPopup"),
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: data,
                    success: function (htmlData)
                    {
                        if (htmlData.success == false && htmlData.popupHTML)
                        {
                            checkAjaxResponseForErrors(htmlData);
                        }
                        else
                        {
                            checkPopupSaveButton(htmlData, "hideNewStudentIndicator");

                            var options = {};
                            if (!data.clickAction)
                            {
                                options = { anchorTo: button };
                            }

                            var hidePopupButton = { id: "hideNewStudentIndicator", text: "Save", click: function () { hideNewStudentIndicator(data, dialog); }, icon: "Save" };
                            var cancelButton = { id: "cancelNewStudentStartingPercents", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                            var dialog = skyward.modalLayer.showDialog("New Student", htmlData.htmlValue.Content, [isTeacherTracker ? null : hidePopupButton, cancelButton], options);
                        }
                    }
                });
            };

            var showAlternativeCreditCourseStudentInfo = function ()
            {
                var button = $(this);
                var data = button.data();
                var isTeacherTracker = gradebookData.isTeacherTracker.toString().toLowerCase() == "true";
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + (isTeacherTracker ? "AlternativeCreditCourseInfoTeacherTracker" : "AlternativeCreditCourseInfo"),
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: data,
                    success: function (returnData)
                    {
                        if (returnData.success == false && returnData.popupHTML)
                        {
                            checkAjaxResponseForErrors(returnData);
                        }
                        else
                        {
                            var options = {};
                            if (!data.clickAction)
                            {
                                options = { anchorTo: button };
                            }

                            skyward.modalLayer.showInformationDialog("Alternative Credit Course", returnData.htmlValue.Content, null, options);
                        }
                    }
                });
            };

            var hideNewStudentIndicator = function (data, dialog)
            {
                var hidePopupButton = $('#hideNewStudentIndicator');
                var hideIndicator = dialog.content.find('#hideIndicatorCheckbox').is(':checked');
                hidePopupButton.off('click');

                var ajaxData =
                {
                    studentSectionID: data.studentSectionId,
                    hideNewStudentIcon: hideIndicator
                };

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/HideNewStudentIndicator",
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: ajaxData,
                    success: function (response)
                    {
                        hidePopupButton.on('click', hideNewStudentIndicator);
                        var button = $('#Gradebook_body .newStudentButton[data-student-section-id="' + data.studentSectionId + '"]');
                        var transferButton = $('#Gradebook_body .runTransferProcess[data-student-section-id="' + data.studentSectionId + '"]');
                        if (response.success)
                        {
                            if (hideIndicator)
                            {
                                //button selects for locked and unlocked browse, but we only want to check one of the two in the condition
                                var buttonAtIndexZero = $(button[0]);
                                if (buttonAtIndexZero.siblings(".displayNone").length === buttonAtIndexZero.siblings().length)
                                {
                                    button.parent(".buttonsVisible").removeClass("buttonsVisible");
                                }
                                if (!button.hasClass("displayNone"))
                                {
                                    button.addClass("displayNone");
                                    transferButton.addClass("displayNone");
                                }
                            }
                            if (!hideIndicator)
                            {
                                if ($(button).parent(":not(buttonsVisible)").length > 0)
                                {
                                    button.parent(":not(buttonsVisible)").addClass("buttonsVisible");
                                }
                                if (button.hasClass("displayNone"))
                                {
                                    button.removeClass("displayNone");
                                    transferButton.removeClass("displayNone");
                                }
                            }
                        }
                        dialog.close();
                    }
                });
            };

            var exportBrowse = function ()
            {
                var data = getRequiredGradebookData();
                var gradebookRequiredData = {};
                Object.assign(gradebookRequiredData, data);
                data.GradebookRequiredData = gradebookRequiredData;

                var url = skyward.global.virtualDir + "Gradebook/Gradebook/GetBrowseExport";
                skyward.window.submitForm(url, data, { openNewWindow: false, downloadOnMobile: true });
            };

            var printBlankGradesheet = function ()
            {
                var element = $(this);
                var data = element.data();

                var action = "BlankGradesheetOptionPopup";
                if (data.isTeacherTracker.toString().toLowerCase() == "true")
                {
                    action += "TeacherTracker";
                }
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true }
                    });
                };

                var createButton = { id: 'blankGradesheetPopupCreate', text: "Print Preview", click: function () { blankGradesheetCreate(dialog); }, icon: "Eye" };
                var exportButton = { id: 'blankGradesheetPopupViewExport', text: "Export Preview", click: function () { blankGradesheetViewExport(dialog); }, icon: "Eye" };
                var closeButton = { id: 'printBlankGradesheetPopupClose', text: "Close", click: function () { dialog.close(); }, icon: "Close" };

                var dialog = skyward.modalLayer.showDialog('Print/Export Blank Gradesheet Options', buildPopup, [exportButton, createButton, closeButton]);
            };

            var blankGradesheetCreate = function (dialog)
            {
                var buildGrid = blankGradesheetBuild(dialog, 'CreateBlankGradesheet');
                var downloadButton = { id: 'blankGradesheetPopupPrint', text: "Download", click: function () { blankGradesheetDownload(dialog); gridPopup.close(); }, icon: "Download" };
                var printButton = { id: 'blankGradesheetPopupPrint', text: "Print", click: function () { blankGradesheetPrint(dialog); gridPopup.close(); }, icon: "PrintAvailable" };
                var closeButton = { id: 'blankGradesheetPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Print Blank Gradesheet Options', buildGrid, [printButton, downloadButton, closeButton]);

                gridPopup.container[0].className += " maxWidth90";
            };

            var blankGradesheetViewExport = function (dialog)
            {
                var buildGrid = blankGradesheetBuild(dialog, 'CreateClassRosterExport');

                var exportButton = { id: 'blankGradesheetPopupExport', text: "Export", click: function () { blankGradesheetExport(gridPopup); }, icon: "Excel" };
                var closeButton = { id: 'blankGradesheetPopupClose', text: "Close", click: function () { gridPopup.close(); }, icon: "Close" };

                var gridPopup = skyward.modalLayer.showDialog('Blank Gradesheet Export Preview', buildGrid, [exportButton, closeButton]);

                gridPopup.container[0].className += " maxWidth90";
            };

            var blankGradesheetExport = function (popup)
            {
                var browseid = popup.content.find('.browse').attr('id');
                var browse = skyward.browse.browseList[browseid];

                var data = skyward.browse.getRequiredBrowseData(browse, {});
                data.GradebookRequiredData = getRequiredGradebookData();

                var url = skyward.global.virtualDir + "Scheduling/StudentSection/GetBrowseExport";
                skyward.window.submitForm(url, data, { openNewWindow: false, downloadOnMobile: true });
                popup.close();
            };

            var blankGradesheetBuild = function (dialog, action)
            {
                return function ()
                {
                    var data = GetBlankGradesheetData(dialog);
                    data.filteredStudentSectionId = getRequiredGradebookData().filteredStudentSectionId;
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
                };
            };

            var GetBlankGradesheetData = function (dialog)
            {
                //todo: pass in gradebook required data
                var printClassDetails = dialog.content.find('.printClassOptionHeader').is(':checked');
                var showStudentNames = dialog.content.find('.showStudentNames').is(':checked');
                var showStudentNumbers = dialog.content.find('.showStudentNumbers').is(':checked');
                var showStudentGradeLevels = dialog.content.find('.showStudentGradeLevels').is(':checked');
                var showStudentIndicators = dialog.content.find('.showStudentIndicators').is(':checked');
                var numberOfColumns = dialog.content.find('.numberOfColumns').val();
                var columnWidth = dialog.content.find('#columnWidthRadioButtonGroup.radioButtonGroupValue').val();
                var rowHeight = dialog.content.find('#rowHeightRadioButtonGroup.radioButtonGroupValue').val();

                var data = $('.printBlankGradesheetOptionsPopupContent').data();
                var sectionID = data.sectionid.toString();

                var returnData =
                {
                    printClassDetails: printClassDetails,
                    showStudentNames: showStudentNames,
                    showStudentNumbers: showStudentNumbers,
                    showStudentGradeLevels: showStudentGradeLevels,
                    showStudentIndicators: showStudentIndicators,
                    numberOfColumns: numberOfColumns,
                    columnWidth: columnWidth,
                    rowHeight: rowHeight,
                    sectionID: sectionID
                };

                return returnData;
            };

            var blankGradesheetDownload = function (dialog)
            {
                skyward.printScreen.launchWorkflow(skyward.global.virtualDir + 'Gradebook/Gradebook/PrintBlankGradesheet', GetBlankGradesheetData(dialog));

                return true;
            };

            var blankGradesheetPrint = function ()
            {
                var data = document.getElementsByClassName('blankGradesheet')[0].innerHTML;
                var mywindow = window.open('', 'Print Gradesheet');
                mywindow.document.write('<html lang="en-us"><head><title>Blank Gradesheet</title>');
                //Using the browser's print preview requires using a new window. Need to set styles in-line, due to new window not having stylesheet.
                mywindow.document.write('</head><body><style type="text/css">@media all {table > tbody > tr.blankGradeSheetRow_small { height:25px; }');
                mywindow.document.write('table > tbody > tr.blankGradeSheetRow_medium { height:40px; }');
                mywindow.document.write('table > tbody > tr.blankGradeSheetRow_large { height:65px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.small  { width:45px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.medium { width:70px; }');
                mywindow.document.write('table > tbody > tr > td > .cellDiv.large, table > tbody > tr > td > .cellDiv.lockedColumnCellDiv { width:130px; }');
                mywindow.document.write('tr { page-break-inside:avoid;}');
                mywindow.document.write('table, table > tbody > tr > td { border-color:Black; border-style:solid; border-width:1px; border-collapse:collapse; font-size: x-small;}}');
                mywindow.document.write('.fieldWrapper { border-style:none; display:inline-block; }');
                mywindow.document.write('label.title { font-weight:bold; text-align:right; color:#4f4f4d; display:inline-block; vertical-align:top; max-width: 234px; font-size: x-small; }');
                mywindow.document.write('.fieldWrapper .message { display:inline-block; text-align:left; color:#4f4f4d; padding:1px 5px 2px 5px; font-size: x-small;}');
                mywindow.document.write('.boldFont { font-weight:bold;}');
                mywindow.document.write('</style>');
                mywindow.document.write(data);
                mywindow.document.write('</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10

                setTimeout(() =>
                {
                    mywindow.print();
                    mywindow.close();
                });

                return true;
            };

            var studentSectionNote = function ()
            {
                var button = $(this);
                var data = button.data();
                var title = data.title;
                var requiredData = getRequiredGradebookData();

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/StudentSectionNote/" + (data.isTeacherTracker.toString().toLowerCase() == "true" ? "TeacherTracker" : "") + "GradebookPopup",
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: $.extend(data, requiredData)
                    });
                };
                var options =
                {
                    anchorTo: button
                };
                skyward.modalLayer.showInformationDialog(title, buildPopup, null, options);
            };

            var handlePercentAdjustmentTabbing = function (studentGradeBucketID)
            {
                var percentAdjustmentComment = $("#PercentAdjustmentComment_" + studentGradeBucketID);
                var percentAdjustmentValue = $("#PercentAdjustment_" + studentGradeBucketID);

                if (percentAdjustmentValue.length != 0 && percentAdjustmentComment.length != 0)
                {
                    if (skyward.controls.getValue(percentAdjustmentValue).length == 0)
                    {
                        skyward.controls.setValue(percentAdjustmentComment, "", true);
                        percentAdjustmentComment.attr('readOnly', true);
                        $('#cancelStudentGradeBucketOptions').focus();
                    }
                    else
                    {
                        percentAdjustmentComment.attr('readOnly', false);
                        percentAdjustmentComment.focus();
                    }
                }
            };

            var handleGradeMarkOverrideTabbing = function (studentGradeBucketID)
            {
                var gradeMarkOverrideComment = $("#GradeMarkOverrideComment_" + studentGradeBucketID);
                var gradeMarkOverrideValue = $("#GradeMarkOverride_" + studentGradeBucketID + "_code");

                if (gradeMarkOverrideValue.length != 0 && gradeMarkOverrideComment.length != 0)
                {
                    if (skyward.controls.getValue(gradeMarkOverrideValue).length == 0)
                    {
                        skyward.controls.setValue(gradeMarkOverrideComment, "");
                        gradeMarkOverrideComment.attr('readOnly', true);
                        $('#cancelStudentGradeBucketOptions').focus();
                    }
                    else
                    {
                        gradeMarkOverrideComment.attr('readOnly', false);
                        gradeMarkOverrideComment.focus();
                    }
                }
            };

            var studentGradeBucketOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketId;
                var row = element.parents("tr").first();
                data.studentSectionId = row.data().studentSectionId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, false, false);
            };

            var studentGradeBucketOptionsPopupSelfPacedOnly = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketId;
                return studentGradeBucketObjectOptions(true, element, data, objectID, false, false);
            };

            var studentGradeBucketSubjectOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketSubjectId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, true, false);
            };

            var studentGradeBucketAcademicStandardOptionsPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var objectID = data.studentGradeBucketAcademicStandardId;
                return studentGradeBucketObjectOptions(false, element, data, objectID, false, true);
            };

            var html;
            var gradingScale;
            var isActiveOrUnlocked;

            var studentGradeBucketObjectOptions = function (isSelfPacedOnly, element, data, objectID, isSubject, isAcademicStandard)
            {
                var isInScoringMode = $("#UpdateEditMode").children("span").text() === GRADEBOOK_EXIT_SCORING_MODE || $(".gradebookScoringMode-On").length > 0;

                if (isInScoringMode == true)
                {
                    if (isSubject || isAcademicStandard)
                    {
                        //Potentially implement later if needed
                        return;
                    }
                    return studentGradeBucketOptionsScoringMode(element, data);
                }

                var studentGradeBucketID = data.studentGradeBucketId;
                var gradingPeriodID = data.gradingPeriodId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                var gradebookData = gradebook.dataContainer.data();
                var sectionID = gradebook.getSectionData(element).sectionID;
                var bucketEnabled = true;

                var gpgbElement = $('.gradeBucketHeaderCell[data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                var gpgbData = gpgbElement.data();
                var bucketDisplayType = gpgbData.bucketDisplayType;
                var bucketSectionIsSelfPacedAndActive = gpgbData.bucketSectionIsSelfPacedAndActive;

                var localGradebookBrowse = $('#' + BROWSE_NAME);
                var localGradebookData = localGradebookBrowse.data();
                var objectLabel = "";
                var objectDialogLabel = "";

                var readOnly = localGradebookData.readOnly;
                readOnly = readOnly.toString().toLowerCase() == 'true';
                bucketSectionIsSelfPacedAndActive = bucketSectionIsSelfPacedAndActive.toString().toLowerCase() == 'true';
                if (readOnly)
                {
                    bucketEnabled = false;
                }

                var data =
                {
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    calculationGroupID: gradebookData.calculationgroupid,
                    bucketDisplayType: bucketDisplayType,
                    readOnly: readOnly
                };
                $.extend(data, gradebook.getSectionData(element));

                if (isSubject == true)
                {
                    var calculationGroupSubjectGradeBucketID = element.data('calculationGroupSubjectGradeBucketId');
                    var subjectHeaderElement = $('.subjectHeaderCell[data-calculation-group-subject-grade-bucket-id="' + calculationGroupSubjectGradeBucketID + '"]');

                    if (subjectHeaderElement.length >= 0)
                    {
                        objectDialogLabel = subjectHeaderElement.children('.subjectHeaderTextContainerDiv').text();
                    }

                    objectLabel = "Subject";
                    $.extend(data, { studentGradeBucketSubjectID: objectID });
                }
                else if (isAcademicStandard == true)
                {
                    objectDialogLabel = "Academic Standard";
                    objectLabel = "AcademicStandard";
                    $.extend(data, { studentGradeBucketAcademicStandardID: objectID });
                }

                var deferred = $.Deferred();

                if (isSelfPacedOnly && !(isSubject == true || isAcademicStandard == true))
                {
                    $.when(buildPopup(true, data, localGradebookData, objectLabel)).done(function (responseData)
                    {
                        if (html)
                        {
                            if ((!isActiveOrUnlocked && !bucketSectionIsSelfPacedAndActive) || !bucketEnabled)
                            {
                                bucketEnabled = false;
                            }

                            var dialog = getDialog("Mark a student's grade complete for ", bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, bucketSectionIsSelfPacedAndActive, data, responseData);
                            updateAdjustedGrade(dialog, gradingScale);
                        }
                        deferred.resolve();
                    });
                }
                else
                {
                    $.when(buildPopup(false, data, localGradebookData, objectLabel)).done(function (responseData)
                    {
                        if (html)
                        {
                            if ((!isActiveOrUnlocked && !bucketSectionIsSelfPacedAndActive) || !bucketEnabled)
                            {
                                bucketEnabled = false;
                            }
                            var dialog = getDialog("Override or Adjust Student's Grade for ", bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, bucketSectionIsSelfPacedAndActive, data, responseData);
                            dialog.content.on("change", "input.percentAdjustmentTextBox", function () { handlePercentAdjustmentTabbing(objectID); });
                            dialog.content.on("input", "input.percentAdjustmentTextBox", function () { updateAdjustedGrade(dialog, gradingScale); });
                            dialog.content.on("eelComplete", ".codeEEL", function ()
                            {
                                handleGradeMarkOverrideTabbing(objectID);
                                updateAdjustedGrade(dialog, gradingScale);
                            });
                            updateAdjustedGrade(dialog, gradingScale);
                        }
                        deferred.resolve();
                    });
                }
                html = null;
                gradingScale = null;
                isActiveOrUnlocked = null;
                return deferred.promise();
            };

            var getDialog = function (message, bucketEnabled, objectID, gradingPeriodID, sectionID, bucketDisplayType, element, gpgbData, html, isSubject, isAcademicStandard, objectLabel, objectDialogLabel, isSelfPacedAndActive, data, ajaxResponseData)
            {
                var saveButton;
                var elementData = element.data();
                var isAvailable = elementData.isAvailable;
                var studentSectionID = element.parents('.gradesheetBrowseRow').data('studentSectionId');
                var academicStandardID = elementData.academicStandardId;
                var subjectID = elementData.subjectId;
                var gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketID;
                var studentGradeBucketID = data.studentGradeBucketID;
                var calculationType = $(html).find('.calculationType');

                if (bucketEnabled &&
                    ((isSelfPacedAndActive.toString().toLowerCase() == "true" && (isSubject == false && isAcademicStandard == false)) ||
                        (calculationType.length > 0 && calculationType.val().toLowerCase() != "notgraded")))
                {
                    if (isSubject == true)
                    {
                        saveButton = { id: "saveStudentGradeBucket" + objectLabel + "Options", text: "Save", click: function () { studentGradeBucketSubjectOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, element); }, icon: "Save" };
                    }
                    else if (isAcademicStandard == true)
                    {
                        saveButton = { id: "saveStudentGradeBucket" + objectLabel + "Options", text: "Save", click: function () { studentGradeBucketAcademicStandardOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, element); }, icon: "Save" };
                    }
                    else
                    {
                        saveButton = { id: "saveStudentGradeBucketOptions", text: "Save", click: function () { studentGradeBucketOptionsSave(objectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, element); }, icon: "Save" };
                    }
                }
                var cancelButton = { id: "cancelStudentGradeBucket" + objectLabel + "Options", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                var options =
                {
                    anchorTo: element,
                    id: "studentGradeBucket" + objectLabel + "OptionsPopup",
                    width: 650
                };

                var buttons = [];

                if (saveButton)
                {
                    buttons.push(saveButton);
                }
                buttons.push(cancelButton);
                var dialog = skyward.modalLayer.showDialog(message + gpgbData.bucketLabel + " " + objectDialogLabel, html, buttons, options);
                return dialog;
            };

            var buildPopup = function (isSelfPacedOnly, data, localGradebookData, objectLabel)
            {
                var localDeferred = new $.Deferred();
                var action;
                if (isSelfPacedOnly.toString().toLowerCase() == "true")
                {
                    action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentGradeBucketOptionsTeacherTrackerSelfPacedOnly" : "StudentGradeBucketOptionsSelfPacedOnly";
                }
                else
                {
                    action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentGradeBucket" + objectLabel + "OptionsTeacherTracker" : "StudentGradeBucket" + objectLabel + "Options";
                }
                var ajax = $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    data: data,
                    activityIndicator: { silent: true },
                    success: function (response)
                    {
                        if (response != null && response.html != null && response.gradingScaleString != null && response.isActiveOrUnlocked != null)
                        {
                            html = response.html.Content;
                            gradingScale = JSON.parse(response.gradingScaleString);
                            isActiveOrUnlocked = response.isActiveOrUnlocked;
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                        }

                        localDeferred.resolve(response);
                    }
                });

                return localDeferred.promise();
            };

            var IsActiveSelfPacedAndComplete = function (gpgbData, studentGradeBucketID)
            {
                var studentGradeBucket = $('.gradeBucketCell[data-student-grade-bucket-id="' + studentGradeBucketID + '"]');
                var studentGradeBucketData = studentGradeBucket.data();
                if (gpgbData.bucketSectionIsSelfPacedAndActive && studentGradeBucketData.isCompleteByTeacher != null && studentGradeBucketData.isCompleteByTeacher)
                {
                    return true;
                }
                return false;
            };

            var updateAdjustedGrade = function (dialog, gradingScale)
            {
                var percentAdjustmentCommentTextBoxElement = dialog.content.find('.percentAdjustmentCommentTextBox');
                var percentAdjustmentTextBoxElement = dialog.content.find('.percentAdjustmentTextBox');
                var percentAdjustmentTextBox = percentAdjustmentTextBoxElement.val();
                var gradeMarkOverrideEEL = dialog.content.find(".codeEELCode").val();
                var originalGradeLabel = dialog.content.find(".originalGradeMessage");
                var calculatedGradeLabel = dialog.content.find(".calculatedGradeLabel");
                var adjustedGradeLabel = dialog.content.find(".adjustedGradeMessage");
                var hiddenPercentAdjustment = dialog.content.find(".hiddenPercentAdjustment").val();

                var gradeMarkPercentOverride = null;
                var gradeMarkOverrideEELControl = dialog.content.find(".codeEEL");
                var gradeMarkOverridePercentTextbox = dialog.content.find(".gradeMarkOverridePercent");

                var percentAdjustment = null;
                if (percentAdjustmentTextBox || gradeMarkOverrideEEL)
                {
                    percentAdjustment = parseFloat(percentAdjustmentTextBox) || null;

                    var originalPoints = originalGradeLabel.data().originalPoints;
                    var pointsText = originalPoints != null && originalPoints != "" ? originalPoints + " pts" : null;

                    var originalGradePercent = calculatedGradeLabel.length > 0
                        ? parseFloat(calculatedGradeLabel.data().calculatedPercent)
                        : parseFloat(originalGradeLabel.data().originalPercent);

                    if (isNaN(originalGradePercent) && percentAdjustment != null && percentAdjustment >= 0)
                    {
                        originalGradePercent = 0;
                    }

                    var percentToUse = percentAdjustment + originalGradePercent;
                    percentToUse = (percentToUse === null || isNaN(percentToUse) || percentToUse < 0) ? 0 : percentToUse;

                    var adjustedGradePercent = percentToUse.toFixed(2);

                    if (percentAdjustmentTextBox === undefined && hiddenPercentAdjustment !== undefined)
                    {
                        var percentWithAdjustment;
                        if (hiddenPercentAdjustment === "")
                        {
                            adjustedGradePercent = null;
                        }
                        else
                        {
                            percentWithAdjustment = parseFloat(hiddenPercentAdjustment) || 0;
                            percentWithAdjustment = percentWithAdjustment < 0 ? 0 : percentWithAdjustment;
                            adjustedGradePercent = percentWithAdjustment.toFixed(2);
                        }
                    }
                    //EW 3/2/26: Potential future change. If grademarkoverride is changed (or cleared), and new override has no percent, we could recalc original grade so the adjusted grade reflects what happens once the override is gone?
                    //Currently if you have an override with a percent, and you clear it, the adjusted grade might say N/A then on save it will recalculate it back to what it should be.
                    var useGradeMarkPercentOverride = false;
                    var clearPercentAdjustment = false
                    if (gradeMarkOverrideEELControl != null && gradeMarkOverrideEELControl.length > 0)
                    {
                        var additionalFields = gradeMarkOverrideEELControl.data("additionalFields");
                        if (additionalFields != null && additionalFields.UsePercentOverride == true &&
                            additionalFields.PercentOverrideValueApplicableForStudentGrade == true)
                        {
                            useGradeMarkPercentOverride = true;

                            if (additionalFields.OverrideValueToUse != null)
                            {
                                gradeMarkPercentOverride = parseFloat(additionalFields.OverrideValueToUse);
                            }

                            if (additionalFields.ClearPercentAdjustment != null && additionalFields.ClearPercentAdjustment == true)
                            {
                                clearPercentAdjustment = true;
                            }
                            else if (additionalFields.ClearPercentAdjustment == false && percentAdjustment != null)
                            {
                                if (gradeMarkPercentOverride == null)
                                {
                                    gradeMarkPercentOverride = percentAdjustment;
                                }
                                else
                                {
                                    gradeMarkPercentOverride = gradeMarkPercentOverride + percentAdjustment
                                }
                            }
                            if (gradeMarkOverridePercentTextbox != null && gradeMarkOverridePercentTextbox.length > 0)
                            {
                                if (gradeMarkOverridePercentTextbox.data("gradingScaleTypeCode") == "PO")
                                {
                                    pointsText = gradeMarkPercentOverride != null && gradeMarkPercentOverride != "" ? gradeMarkPercentOverride + " pts" : null;
                                }
                                else
                                {
                                    pointsText = null;
                                }
                            }
                            if (gradeMarkPercentOverride != null)
                            {
                                gradeMarkPercentOverride = gradeMarkPercentOverride.toFixed(2);
                            }

                            adjustedGradePercent = gradeMarkPercentOverride; //this needs to happen after. Should this account for individual percent adjustment? Disable that and clear it out?
                        }
                    }
                    if (gradeMarkOverridePercentTextbox != null && gradeMarkOverridePercentTextbox.length > 0)
                    {
                        skyward.controls.setValue(gradeMarkOverridePercentTextbox, gradeMarkPercentOverride);
                        if (useGradeMarkPercentOverride)
                        {
                            gradeMarkOverridePercentTextbox.show();
                        }
                        else
                        {
                            gradeMarkOverridePercentTextbox.hide();
                        }
                    }

                    if (percentAdjustmentTextBoxElement.length > 0)
                    {
                        if (clearPercentAdjustment)
                        {
                            var percentAdjustmentCommentTextBoxElementData = percentAdjustmentCommentTextBoxElement.data();
                            skyward.controls.disable(percentAdjustmentTextBoxElement);
                            skyward.controls.disable(percentAdjustmentCommentTextBoxElement);
                            skyward.controls.setValue(percentAdjustmentTextBoxElement, null);
                            skyward.controls.setValue(percentAdjustmentCommentTextBoxElement, null);
                            percentAdjustmentCommentTextBoxElement.attr("placeholder", percentAdjustmentCommentTextBoxElementData.clearedPlaceholder);
                        }
                        else
                        {
                            var percentAdjustmentTextBoxElementData = percentAdjustmentTextBoxElement.data();
                            var percentAdjustmentCommentTextBoxElementData = percentAdjustmentCommentTextBoxElement.data();
                            var readOnlyPersists = percentAdjustmentTextBoxElementData.readOnlyPersists;
                            if (readOnlyPersists.toString().toLowerCase() == "false")
                            {
                                skyward.controls.enable(percentAdjustmentTextBoxElement);
                                percentAdjustmentCommentTextBoxElement.attr("placeholder", percentAdjustmentCommentTextBoxElementData.defaultPlaceholder);
                            }
                        }
                    }

                    var adjustedGradeMark = gradeMarkOverrideEEL || getGradeMark(gradingScale, adjustedGradePercent);

                    var textToShow;
                    if (isNaN(adjustedGradePercent))
                    {
                        adjustedGradePercent = null;
                    }
                    var percentOrPointsToShow = pointsText == null ? adjustedGradePercent : pointsText;
                    if (!percentOrPointsToShow)
                    {
                        textToShow = adjustedGradeMark;
                    }
                    else
                    {
                        textToShow = adjustedGradeMark + " / " + percentOrPointsToShow;
                    }

                    adjustedGradeLabel.text(textToShow);
                }
                else
                {
                    adjustedGradeLabel.text("N/A");

                    if (gradeMarkOverridePercentTextbox != null && gradeMarkOverridePercentTextbox.length > 0)
                    {
                        skyward.controls.setValue(gradeMarkOverridePercentTextbox, null);
                        gradeMarkOverridePercentTextbox.hide()
                    }

                    if (percentAdjustmentTextBoxElement.length > 0)
                    {
                        var percentAdjustmentTextBoxElementData = percentAdjustmentTextBoxElement.data();
                        var percentAdjustmentCommentTextBoxElementData = percentAdjustmentCommentTextBoxElement.data();
                        var readOnlyPersists = percentAdjustmentTextBoxElementData.readOnlyPersists;
                        if (readOnlyPersists.toString().toLowerCase() == "false")
                        {
                            skyward.controls.enable(percentAdjustmentTextBoxElement);
                            percentAdjustmentCommentTextBoxElement.attr("placeholder", percentAdjustmentCommentTextBoxElementData.defaultPlaceholder);
                        }
                    }
                }
            };

            var getGradeMark = function (gradingScale, updatedPercent)
            {
                if (updatedPercent == null)
                {
                    return "";
                }
                else if (updatedPercent < 0)
                {
                    updatedPercent = 0;
                }

                if (gradingScale.length < 1)
                {
                    return "N/A";
                }
                for (i = 0; i < gradingScale.length; i++)
                {
                    if (updatedPercent >= gradingScale[i].percentLow && updatedPercent <= gradingScale[i].percentHigh)
                    {
                        return gradingScale[i].gradeMarkCode;
                    }
                }
                return gradingScale[0].gradeMarkCode;
            };

            var UpdatePercentAdjustedStudentGradeBuckets = function (affectedStudentGradeBuckets)
            {
                $(affectedStudentGradeBuckets).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }

                    var isLessThanMinimumPercent = this.IsLessThanMinimumPercent;

                    updateGradeBucketValueWithPercentAdjustment(this, isGradeModified, isLessThanMinimumPercent);

                    var bucketData = $(this).get(0);
                    var element = $("#Gradebook_" + bucketData.StudentSectionID + "_" + bucketData.GradeBucketID);
                    var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                    updateStudentGradeBucketCellClasses(null, element, bucketData);
                    if (bucketData.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(element);
                    }
                    else if (bucketData.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(element);
                    }

                    applyGradeColors("class", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, element, colorData);
                });
            };

            var UpdatePercentAdjustedStudentGradeBucketSubjects = function (affectedStudentGradeBucketSubjects)
            {
                var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                $(affectedStudentGradeBucketSubjects).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }
                    var studentGradeBucketSubject = $('td.subjectCell[id^="Gradebook_' + this.StudentSectionID + '_"][id$="_' + this.SubjectID + '"][data-grading-period-grade-bucket-id="' + this.GradingPeriodGradeBucketID + '"]');

                    applyGradeColors("subject", this.GradeMarkIDToUse, this.BackingPercent, studentGradeBucketSubject, colorData);
                    updateGradeBucketSubjectValueWithPercentAdjustment(this, isGradeModified);
                });
            };

            var UpdatePercentAdjustedStudentGradeBucketAcademicStandards = function (affectedStudentGradeBucketAcademicStandards)
            {
                var colorData = $('#' + BROWSE_NAME + '_unlockedBody').data().grademarkcolordata;
                $(affectedStudentGradeBucketAcademicStandards).each(function ()
                {
                    var isGradeModified = true;

                    if (!this.IsGradeMarkOverridden && !this.IsPercentAdjusted)
                    {
                        isGradeModified = false;
                    }
                    var studentGradeBucketAcademicStandard = $('td.academicStandardCell[id^="Gradebook_' + this.StudentSectionID + '_"][id$="_' + this.AcademicStandardID + '"][data-grading-period-grade-bucket-id="' + this.GradingPeriodGradeBucketID + '"]');

                    applyGradeColors("standard", this.GradeMarkIDToUse, this.BackingPercent, studentGradeBucketAcademicStandard, colorData);
                    updateGradeBucketAcademicStandardValueWithPercentAdjustment(this, isGradeModified);
                });
            };

            var updateGradeBucketValueWithPercentAdjustment = function (studentGradeBucket, isGradeModified, isLessThanMinimumPercent)
            {
                var cells = $("td[data-student-grade-bucket-id='" + studentGradeBucket.StudentGradeBucketID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.gradeBucketScoreSpan > span");
                    if (studentGradeBucket.NewDisplay != null)
                    {
                        cellDiv.html(studentGradeBucket.NewDisplay).removeClass('boldFont');
                        if (isGradeModified || isLessThanMinimumPercent)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    else
                    {
                        cellDiv.html("");
                    }

                    var infoIcon = cell.find('.studentGradeBucketIsAdminOverrideButton');
                    var studentGradeBucketIndicatorsCell = infoIcon.parents('.studentGradeBucketIndicators');
                    var hasUnscoredFeederBucket = studentGradeBucketHasUnscoredFeederBucket(studentGradeBucket);

                    if (hasUnscoredFeederBucket && studentGradeBucketIndicatorsCell.hasClass('hiddenIsAdminOverride'))
                    {
                        infoIcon.data('hasUnscoredRequiredFeederBucket', 'true');
                        studentGradeBucketIndicatorsCell.removeClass('hiddenIsAdminOverride');
                    }
                    if (!hasUnscoredFeederBucket && !studentGradeBucketIndicatorsCell.hasClass('hiddenIsAdminOverride'))
                    {
                        studentGradeBucketIndicatorsCell.addClass('hiddenIsAdminOverride');
                    }
                });
            };

            var studentGradeBucketHasUnscoredFeederBucket = function (studentGradeBucket)
            {
                return studentGradeBucket.HasUnscoredRequiredFeederBucket && (studentGradeBucket.GradeMarkID == null) && !studentGradeBucket.IsGradeMarkOverridden && !studentGradeBucket.IsPercentAdjusted;
            };

            var updateGradeBucketSubjectValueWithPercentAdjustment = function (studentGradeBucketSubject, isGradeModified)
            {
                var cells = $("td[data-student-grade-bucket-subject-id='" + studentGradeBucketSubject.StudentGradeBucketSubjectID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.subjectScoreSpan > span");
                    if (!cellDiv.parent().hasClass("mastery"))
                    {
                        cellDiv.html(studentGradeBucketSubject.NewDisplay).removeClass('boldFont');
                        if (isGradeModified)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    if (studentGradeBucketSubject.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(cell);
                    }
                    else if (studentGradeBucketSubject.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(cell);
                    }
                });
            };

            var updateGradeBucketAcademicStandardValueWithPercentAdjustment = function (studentGradeBucketAcademicStandard, isGradeModified)
            {
                var cells = $("td[data-student-grade-bucket-academic-standard-id='" + studentGradeBucketAcademicStandard.StudentGradeBucketAcademicStandardID + "']");

                cells.each(function ()
                {
                    var cell = $(this);
                    var cellDiv = cell.find("span.academicStandardScoreSpan > span");
                    if (!cellDiv.parent().hasClass("mastery"))
                    {
                        cellDiv.html(studentGradeBucketAcademicStandard.NewDisplay).removeClass('boldFont');
                        if (isGradeModified)
                        {
                            cellDiv.addClass('boldFont');
                        }
                    }
                    if (studentGradeBucketAcademicStandard.IsGradeMarkOverridden)
                    {
                        removeCellErrorClasses(cell);
                    }
                    else if (studentGradeBucketAcademicStandard.HasInvalidGradeMark)
                    {
                        addCellErrorClasses(cell);
                    }
                });
            };

            var UpdateStudentAssignmentEntryTextBoxes = function (completeByTeacherStudentGradeBuckets, gradingPeriodID)
            {
                $.each(completeByTeacherStudentGradeBuckets, function (key, value)
                {
                    for (var i = 0; i < value.length; i++)
                    {
                        var sgbCell = gradebook.getStudentGradeBucketCell(value[i]);
                        var sgbData = sgbCell.data();
                        var studentSectionData = sgbCell.parents("tr").first().data();

                        if (key === "No")
                        {
                            var action = "ReloadGradebook";
                            if (gradebookData.isTeacherTracker)
                            {
                                action += "TeacherTracker";
                            }
                            gradebook.reloadGradebook('Gradebook', 'Gradebook', action);
                            return false;
                        }
                        else if (key !== "Yes")
                        {
                            return;
                        }

                        UpdateAssignmentTextBoxes(sgbData.gradingPeriodId, sgbData.gradingPeriodGradeBucketId, sgbData.studentGradeBucketId, studentSectionData.studentSectionId);
                    }
                });
            };

            var UpdateAssignmentTextBoxes = function (gradingPeriodID, gradingPeriodGradeBucketID, studentGradeBucketID, studentSectionID)
            {
                var cells = $(".gradebookScoringModeControl[data-studentsectionid='" + studentSectionID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".codeEELDescription[data-studentsectionid='" + studentSectionID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".subjectCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated), " +
                    ".academicStandardCell[data-student-grade-bucket-id='" + studentGradeBucketID + "']" + "[data-grading-period-id='" + gradingPeriodID + "']" + "[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "']:not(.transferOrDoNotPostGradeShouldNotBeActivated)");

                var validCells = [];
                cells.each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();
                    if (cellData.specificGradingPeriodGradeBucketId != null && cellData.specificGradingPeriodGradeBucketId != undefined)
                    {
                        if (cellData.specificGradingPeriodGradeBucketId == gradingPeriodGradeBucketID)
                        {
                            validCells.push(cell);
                        }
                    }
                    else
                    {
                        validCells.push(cell);
                    }
                });
                var disableCell = function (cell)
                {
                    if (!(cell.hasClass("gradebookScoringModeControl")))
                    {
                        cell.addClass("gradebookScoringModeControl");
                    }
                    gradebook.disableControl(cell);
                    gradebook.disableControl(cell.siblings());
                    cell.siblings().attr("disabled", "disabled");
                    cell.addClass("scoringModeDoesntAffectState");
                };
                $.each(validCells, function ()
                {
                    var cell = $(this);
                    if (cell.hasClass("ContainsDisabledSubjectiveCodeEELs"))
                    {
                        disableCell(cell);
                    }
                    cell.parents("td").find(".gradebookScoringModeControl, .gradebookScoringMode-On, .gradebookScoringMode-Off, .hasSubjectiveCodeEEL, .ContainsDisabledSubjectiveCodeEELs").each(function () { disableCell($(this)); });
                    cell.find(".gradebookScoringModeControl, .gradebookScoringMode-On, .gradebookScoringMode-Off, .hasSubjectiveCodeEEL, .ContainsDisabledSubjectiveCodeEELs").each(function () { disableCell($(this)); });
                });
            };

            var studentGradeBucketOptionsSave = function (studentGradeBucketID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketID).val();
                var completeByTeacher = dialog.content.find('#CompleteByTeacher_' + studentGradeBucketID);
                var completeByTeacherCode = completeByTeacher.is(':checked') == true ? "Y" : completeByTeacher.length > 0 ? "N" : "D";

                var buttons = $("#studentGradeBucketOptionsPopup").find("button, a");
                var saveButton = $('#saveStudentGradeBucketOptions');
                $.each(buttons, function ()
                {
                    $(this).addClass("ui-disabled");
                });
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketID: studentGradeBucketID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        completeByTeacherCode: completeByTeacherCode,
                        isAvailable: isAvailable,
                        gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                        studentSectionID: studentSectionID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);

                        saveButton.on("click", function () { studentGradeBucketOptionsSave(studentGradeBucketID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, gradingPeriodGradeBucketID, studentSectionID, gradebookCell); });
                        $.each(buttons, function ()
                        {
                            $(this).removeClass("ui-disabled");
                        });

                        if (response.success)
                        {
                            dialog.close();

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.completeByTeacherStudentGradeBuckets && completeByTeacherCode)
                            {
                                UpdateStudentAssignmentEntryTextBoxes(response.completeByTeacherStudentGradeBuckets, gradingPeriodID);
                            }

                            if (response.completeByTeacherStudentGradeBuckets)
                            {
                                $.each(response.completeByTeacherStudentGradeBuckets, function (k, v)
                                {
                                    for (var i = 0; i < v.length; i++)
                                    {
                                        var sgbCell = gradebook.getStudentGradeBucketCell(v[i]);
                                        var studentGradeBucketIndicators = sgbCell.find(".studentGradeBucketIndicators");

                                        if (k == 'Yes')
                                        {
                                            studentGradeBucketIndicators.removeClass('hiddenIsComplete');
                                        }
                                        else if (!studentGradeBucketIndicators.hasClass('hiddenIsComplete'))
                                        {
                                            studentGradeBucketIndicators.addClass('hiddenIsComplete');
                                        }
                                    }
                                });
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var studentGradeBucketSubjectOptionsSave = function (studentGradeBucketSubjectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketSubjectID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketSubjectID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketSubjectID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketSubjectID).val();
                var completeByTeacherCode = (dialog.content.find('#CompleteByTeacher_' + studentGradeBucketSubjectID).is(':checked') == true ? "Y" : "N");

                var saveButton = $('#saveStudentGradeBucketSubjectOptions');
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketSubjectOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        isAvailable: isAvailable,
                        studentGradeBucketID: studentGradeBucketID,
                        subjectID: subjectID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);
                        saveButton.on("click", function () { studentGradeBucketSubjectOptionsSave(studentGradeBucketSubjectID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, subjectID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell); });

                        if (response.success)
                        {
                            dialog.close();

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            var studentGradeBucketSubject = $('td.subjectCell[id^="Gradebook_' + studentSectionID + '_"][id$="_' + subjectID + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                            if (gradeMarkIDOverride)
                            {
                                removeCellErrorClasses(studentGradeBucketSubject);
                            }

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.affectedStudentGradeBucketSubjects)
                            {
                                UpdatePercentAdjustedStudentGradeBucketSubjects(response.affectedStudentGradeBucketSubjects, gradingPeriodID);
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var studentGradeBucketAcademicStandardOptionsSave = function (studentGradeBucketAcademicStandardID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell)
            {
                var gradeMarkIDOverride = dialog.content.find('#GradeMarkOverride_' + studentGradeBucketAcademicStandardID + '_value').val();
                var gradeMarkOverrideComment = dialog.content.find('#GradeMarkOverrideComment_' + studentGradeBucketAcademicStandardID).val();
                var percentAdjustment = dialog.content.find('#PercentAdjustment_' + studentGradeBucketAcademicStandardID).val();
                var percentAdjustmentComment = dialog.content.find('#PercentAdjustmentComment_' + studentGradeBucketAcademicStandardID).val();
                var completeByTeacherCode = (dialog.content.find('#CompleteByTeacher_' + studentGradeBucketAcademicStandardID).is(':checked') == true ? "Y" : "N");

                var saveButton = $('#saveStudentGradeBucketAcademicStandardOptions');
                saveButton.off("click");

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketAcademicStandardOptionsSave",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                        gradingPeriodID: gradingPeriodID,
                        gradeMarkIDOverride: gradeMarkIDOverride,
                        gradeMarkOverrideComment: gradeMarkOverrideComment,
                        sectionID: sectionID,
                        percentAdjustment: percentAdjustment,
                        percentAdjustmentComment: percentAdjustmentComment,
                        isAvailable: isAvailable,
                        studentGradeBucketID: studentGradeBucketID,
                        academicStandardID: academicStandardID,
                        preSaveWarningHash: saveButton.data().preSaveWarningHash
                    },
                    success: function (response)
                    {
                        saveButton.data("preSaveWarningHash", response.preSaveWarningHash);
                        saveButton.on("click", function () { studentGradeBucketAcademicStandardOptionsSave(studentGradeBucketAcademicStandardID, gradingPeriodID, sectionID, bucketDisplayType, dialog, isAvailable, studentGradeBucketID, academicStandardID, studentSectionID, gradingPeriodGradeBucketID, gradebookCell); });

                        if (response.success)
                        {
                            dialog.close();

                            var saveManager = createSaveManager(gradebook);
                            saveManager.updateAverageValues(response);

                            var studentGradeBucketAcademicStandard = $('td.academicStandardCell[id^="Gradebook_' + studentSectionID + '_"][id$="_' + academicStandardID + '"][data-grading-period-grade-bucket-id="' + gradingPeriodGradeBucketID + '"]');
                            if (gradeMarkIDOverride)
                            {
                                removeCellErrorClasses(studentGradeBucketAcademicStandard);
                            }

                            gradebook.updateBucketNoCountIndicator(gradebookCell, response.gradeMarkNoCount);

                            if (response.affectedStudentGradeBuckets)
                            {
                                UpdatePercentAdjustedStudentGradeBuckets(response.affectedStudentGradeBuckets);
                            }
                            if (response.affectedStudentGradeBucketSubjects)
                            {
                                UpdatePercentAdjustedStudentGradeBucketSubjects(response.affectedStudentGradeBucketSubjects, gradingPeriodID);
                            }
                            if (response.affectedStudentGradeBucketAcademicStandards)
                            {
                                UpdatePercentAdjustedStudentGradeBucketAcademicStandards(response.affectedStudentGradeBucketAcademicStandards, gradingPeriodID);
                            }
                            else
                            {
                                var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                                skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                            }
                        }
                        else
                        {
                            checkAjaxResponseForErrors(response);
                            var baseErrorContainer = dialog.content.find('#CurrentRecordContentBaseError');
                            skyward.validation.displayValidationMessages(response, dialog.container, baseErrorContainer);
                        }
                    }
                });
            };

            var buildLockedColumnsDisplayPopup = function ()
            {
                var data = gradebookBrowse.data();
                var gradingPeriodIDs = [];
                $.each(gradebook.unlockedRowHeader.find(".gradeBucketHeaderCell"), function ()
                {
                    gradingPeriodIDs.push($(this).data().gradingPeriodId);
                });
                data.gradingPeriodIDs = JSON.stringify(gradingPeriodIDs);
                var action = data.isTeacherTracker ? "BuildLockedColumnsDisplayPopupTeacherTracker" : "BuildLockedColumnsDisplayPopup";
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/GradebookSettings/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        data: data,
                        activityIndicator: { silent: true },
                        success: function (htmlData)
                        {
                            checkPopupSaveButton(htmlData, "saveLockedColumnDisplaySettings");
                        }
                    });
                };

                var save = function (isTeacherTracker)
                {
                    var data =
                    {
                        "DisplayStudentGroups": skyward.controls.getValue($("#DisplayStudentGroups")),
                        "DisplayStudentGradeLevel": skyward.controls.getValue($("#DisplayStudentGradeLevel")),
                        "DisplayStudentNumber": skyward.controls.getValue($("#DisplayStudentNumber")),
                        "DisplayMethodOfInstruction": skyward.controls.getValue($("#DisplayMethodOfInstruction")),
                        "DisplayCourseDescription": skyward.controls.getValue($("#DisplayCourseDescription")),
                        "DisplayAttendance": skyward.controls.getValue($("#DisplayAttendance")),
                        "DisplayMissingAssignment": skyward.controls.getValue($("#DisplayMissingAssignment")),
                        "DisplayUnscoredPastDueAssignments": skyward.controls.getValue($("#DisplayUnscoredPastDueAssignments")),
                        "DisplayIsActive": skyward.controls.getValue($("#DisplayIsActive")),
                        "CalculationGroupGradeBucketIDLocked": skyward.controls.getValue($("#CalculationGroupGradeBucketIDLocked")),
                        "StudentNameDisplayTypeCode": skyward.controls.getValue($("#StudentNameDisplayTypeCode")),
                        "StudentGroupSelect": JSON.stringify(skyward.controls.getValue($("#StudentGroupSelectEEL"))),
                        "HiddenGradeBucketsSelect": JSON.stringify(skyward.controls.getValue($("#HiddenGradeBucketsSelectEEL"))),
                        "DisplayStudentGroupColors": skyward.controls.getValue($("#DisplayStudentGroupColors")),
                        "ShowGradeColors": skyward.controls.getValue($("#ShowGradeColors")),
                    };
                    var action = "SaveLockedColumnDisplaySettings";
                    if (isTeacherTracker)
                    {
                        action += "TeacherTracker";
                    }
                    gradebook.reloadGradebook('Gradebook', 'Gradebook', action, data);
                    dialog.close();
                };

                var saveButton = { id: "saveLockedColumnDisplaySettings", text: "Save", click: function () { save(data.isTeacherTracker); }, icon: "Save" };
                var cancelButton = { id: "cancelLockedColumnDisplaySettings", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };
                var resetButton = { id: "resetView", text: "Reset to Default Display", click: function () { resetGradebookView(dialog); }, icon: "Update" };
                var options =
                {
                    anchorTo: $(this)
                };
                var dialog = skyward.modalLayer.showDialog("Display Settings", buildPopup, [resetButton, saveButton, cancelButton], options);
            };

            var loadAverages = function ()
            {
                if (gradebook.unlockedAveragesRowHeader.length < 1)
                {
                    return;
                }
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GetGradebookAveragesTeacherTracker" : "GetGradebookAverages";


                var averageData = {};
                $.extend(averageData, gradebookData);

                averageData.academicStandardIDsDisplayed = {};
                averageData.subjectIDsDisplayed = {};

                gradebook.unlockedHeader.find(".academicStandardHeaderCell").each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();

                    if (averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId] == null)
                    {
                        averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId] = [];
                    }

                    averageData.academicStandardIDsDisplayed[cellData.gradingPeriodGradeBucketId].push(cellData.academicStandardId);
                });

                gradebook.unlockedHeader.find(".subjectHeaderColumn").each(function ()
                {
                    var cell = $(this);
                    var cellData = cell.data();

                    if (averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId] == null)
                    {
                        averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId] = [];
                    }

                    averageData.subjectIDsDisplayed[cellData.gradingPeriodGradeBucketId].push(cellData.subjectId);
                });

                averageData.academicStandardIDsDisplayed = JSON.stringify(averageData.academicStandardIDsDisplayed);
                averageData.subjectIDsDisplayed = JSON.stringify(averageData.subjectIDsDisplayed);

                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: averageData,
                    success: function (response)
                    {
                        updateGradingPeriodGradeBucketAverages(response.gradingPeriodGradeBucketAverages);
                        updateStudentGradeBucketChildRecordAverages(response.studentGradeBucketSubjectAverages, "subjectGradeBucket");
                        updateStudentGradeBucketChildRecordAverages(response.studentGradeBucketAcademicStandardAverages, "academicStandardGradeBucket");
                        updateAssignmentAverages(response.assignmentAverages);
                    }
                });
            };

            var loadAssignmentCounts = function ()
            {
                var showingMissingAssignments = gradebook.lockedHeader.find(".MissingAssignmentCount").length > 0;
                var showingUnscoredPastDueAssignments = gradebook.lockedHeader.find(".UnscoredPastDueAssignmentCount").length > 0;

                if (!showingMissingAssignments && !showingUnscoredPastDueAssignments)
                {
                    return;
                }

                var studentSectionIDs = [];
                $.each(gradebook.students, function ()
                {
                    studentSectionIDs.push($(this).get(0).studentSectionID);
                });

                var action = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "GetMissingAssignmentCountsTeacherTracker" : "GetMissingAssignmentCounts";
                $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data:
                    {
                        sectionID: gradebookData.sectionid,
                        sectionIDHash: gradebookData.sectionIdHash,
                        classGroupID: gradebookData.classGroupId,
                        classGroupIDHash: gradebookData.classGroupIdHash
                    },
                    success: function (returnData)
                    {
                        if (returnData.assignmentCounts)
                        {
                            updateIsMissingCount(returnData.assignmentCounts);
                        }
                    }
                });
            };

            var massAssignScoresPopup = function ()
            {
                var element = $(this);
                var data = element.data();
                var inScoringModeOnButtonClick = isInScoringMode();
                var postData =
                {
                    assignmentID: data.assignmentId,
                    districtID: gradebook.dataContainer.data().districtid,
                };

                if (inScoringModeOnButtonClick === false)
                {
                    updateEditMode();
                }

                var advancedAssignmentHeaderCell = $("#assignmentHeaderCell" + data.assignmentId);
                var assignmentHeaderCell = $("#assignment" + data.assignmentId + "HeaderCell");
                if (assignmentHeaderCell.length < 1 || advancedAssignmentHeaderCell.length < 1)
                {
                    return;
                }
                var headerCellData = assignmentHeaderCell.data();
                $.extend(headerCellData, advancedAssignmentHeaderCell.data());
                gradebook.getAdvancedColumnCellsByAssignmentID(data.assignmentId, false);  //populate the advanced cells so that the NoCount/missing/etc work

                var popupID = "MassAssignScores";
                var headerText = "Mass Assign Scores";

                if (currentHeaderPopupDialog)
                {
                    currentHeaderPopupDialog.close();
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + data.screen,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: postData
                    });
                };

                var saveButton = { text: "Save", "click": function () { $.when(gradebook.massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Save", "data": data };
                var closeButton = { text: "Cancel", "click": function () { dialog.close(); }, "icon": "Cancel" };
                var options =
                {
                    closeOnEscape: false,
                    draggable: true,
                    id: popupID
                };

                var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);

                dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
                dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
                dialog.content.on("keydown", ".gradebookInputCodeEEL", browseKeyDown);

                dialog.modalLayer.options.afterClose = function (result)
                {
                    var wrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);

                    var errorsOnSave = wrapper.hasClass("errorDuringSave") || wrapper.hasClass("studentAssignmentError") || wrapper.hasClass("studentGradeBucketError");
                    if (inScoringModeOnButtonClick === false && !errorsOnSave)
                    {
                        gradebook.updateEditModeNoDialog();
                    }
                };
            };

            var studentGradeBucketOptionsScoringMode = function (element, data)
            {
                var postData =
                {
                    studentGradeBucketID: data.studentGradeBucketId,
                };

                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/StudentGradeBucketOptionsScoringMode/" + data.studentGradeBucketId,
                    type: "POST",
                    dataType: "JSON",
                    activityIndicator: { silent: true },
                    data: postData,
                    success: function (returnData)
                    {
                        if (returnData.success == false && returnData.popupHTML)
                        {
                            checkAjaxResponseForErrors(returnData);
                        }
                        else if (returnData.htmlValue && returnData.htmlValue.Content)
                        {
                            var options =
                            {
                                anchorTo: element
                            };
                            skyward.modalLayer.showDialog("Student Grade Options", returnData.htmlValue.Content, [], options);
                        }
                    }
                });
            };

            attachListeners();

            resizeGradebook();

            if (gradebookData.singleassignment == true)
            {
                gradebook.browse.find('.gradeMarkScoring').each(function ()
                {
                    var control = $(this);
                    var controlData = control.data();
                    skyward.controls.setValue(control, controlData.enabledGrademarkValue, true);
                    document.getElementById(control.attr('id')).style.width = enabledGradeSheetGradeMarkScoringWidth;
                });

                gradebook.gradebookBodyScoringModeControls.each(function ()
                {
                    $(this).addClass("js-maskInitialized");
                });
            }

            gradebook.currentRow = getCurrentRowNumber();

            var assignmentIndicatorPopup = function ()
            {
                var button = $(this);
                var firstRow;

                if (button.find("svg:visible").length < 1)
                {
                    return;
                }

                button.find('.assignmentIndicators').each(function ()
                {
                    var span = $(this);
                    if (span.hasClass('assignmentIndicatorsFirstRow'))
                    {
                        firstRow = span;
                    }
                });

                var assignmentCell = button.closest('.assignmentCell');
                var inputElement = assignmentCell.find('.gradebookInput');
                var inputElementData = inputElement.data();

                var inputElementGrademarkScoring = assignmentCell.find('.gradeMarkScoring');
                var inputElementDataGrademarkScoring = inputElementGrademarkScoring.data();

                if (inputElementData == null || inputElementData.sectionId == null && inputElementDataGrademarkScoring != null)
                {
                    inputElement = inputElementGrademarkScoring;
                    inputElementData = inputElementDataGrademarkScoring;
                }

                inputElementData.sectionId = gradebook.getSectionData(assignmentCell).sectionID;

                var sectionData = gradebook.getSectionData(inputElement);

                var studentSectionID = inputElementData.studentsectionid;
                var assignmentID = gradebook.getRepresentedAssignmentID(inputElementData.assignmentid, inputElementData.sectionId);
                var score = skyward.controls.getValue(inputElement);
                var sectionID = sectionData.sectionID;
                var sectionIDHash = sectionData.sectionIDHash;
                var showScoreWarning = !firstRow.hasClass('hiddenWarning');
                var popupAction = gradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? "AdvancedStudentAssignmentPopupTeacherTracker" : undefined;

                var additionalButtonsFunc = function (html)
                {
                    var undropButton = null;
                    var activeAssignment = $(html).find('.InactiveGradesheetBucket').length == 0;

                    if (activeAssignment && gradebook.editMode && !firstRow.hasClass('hiddenDroppedAssignment'))
                    {
                        var allowUnDrop = button.find("div.noUnDrop").length < 1;

                        if (allowUnDrop)
                        {
                            undropButton = { id: "saveUndropScore", text: "Un-Drop", click: function () { saveUndrop(inputElementData); skyward.modalLayer.closeModalLayer(".modalLayer"); }, icon: "Check" };
                        }
                    }

                    return undropButton ? [undropButton] : [];
                };

                displayAssignmentIndicatorPopup(button, studentSectionID, assignmentID, score, sectionID, sectionIDHash, showScoreWarning, popupAction, additionalButtonsFunc);
            };

            var gradeBucketAcademicStandardPopup = function ()
            {
                var element = $(this);
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() === "true" ? "AcademicStandardDetailsPopupTeacherTracker" : "AcademicStandardDetailsPopup";

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: element.data()
                    });
                };

                var cancelButton = { id: "academicStandardDetailsPopup", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog('Academic Standard Details', buildPopup, [cancelButton],
                    {
                        anchorTo: element,
                        width: 460
                    });
            };

            var studentGradeBucketAcademicStandardSummaryPopup = function ()
            {
                var element = $(this);
                var action = gradebookData.isTeacherTracker.toString().toLowerCase() === "true" ? "StudentGradeBucketAcademicStandardSummaryPopupTeacherTracker" : "StudentGradeBucketAcademicStandardSummaryPopup";
                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: element.data()
                    });
                };

                var closeButton = { id: "academicStandardSummaryDetailsPopupClose", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog('Academic Standard Score Details', buildPopup, [closeButton],
                    {
                        anchorTo: element
                    });
            };

            var selectAcademicStandardsToDisplay = function ()
            {
                var button = $(this);
                var data = button.data();
                var action = "SelectStandardsDisplayBucketSettings";
                var isTeacherTracker = data.isTeacherTracker.toString().toLowerCase() == "true";
                if (isTeacherTracker)
                {
                    action += "TeacherTracker";
                }

                var buildPopup = function ()
                {
                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
                };

                var options =
                {
                    draggable: true
                };

                var title = "Select Academic Standards To Display";

                var saveButton =
                {
                    id: "saveDisplayType", text: "Save",
                    click: function ()
                    {

                        var saveButtonDomElement = $("#saveDisplayType");
                        var saveAction = "SelectStandardsDisplayBucketSettingsSave";

                        if (isTeacherTracker)
                        {
                            saveAction += "TeacherTracker";
                        }

                        saveButtonDomElement.off();
                        $.ajax({
                            url: skyward.global.virtualDir + "Gradebook/TeacherSectionStandardsDisplayGradeBucketSetting/" + saveAction,
                            type: "POST",
                            dataType: "JSON",
                            data:
                            {
                                "SelectAcademicStandardsDisplayRepeater": JSON.stringify($("#SelectAcademicStandardsDisplayRepeater").data().savedata),
                                "TeacherSectionSettingID": data.teacherSectionSettingId,
                                "TeacherSectionSettingIDHash": data.teacherSectionSettingIdHash,
                                "SectionID": data.sectionId,
                                "SectionIDHash": data.sectionIdHash
                            },
                            success: function ()
                            {
                                var reloadAction = "ReloadGradebook";

                                if (isTeacherTracker)
                                {
                                    reloadAction += "TeacherTracker";
                                }
                                gradebook.reloadGradebook('Gradebook', 'Gradebook', reloadAction);
                            }
                        });

                        dialog.close();
                    },
                    icon: "Save"
                };

                var cancelButton = { id: "cancelSelect", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog(title, buildPopup, [saveButton, cancelButton], options);

                dialog.content.on("contentLoaded", function ()
                {
                    dialog.content.find('#SelectAcademicStandardsDisplayRepeater').on('change', '.standardsSummarySelectShowBucket', updateStandardsSummaryCheckboxes);
                });

                dialog.content.on('ajaxRepeaterTemplateLoaded', function (event, element)
                {
                    var checkbox = $(element).find('.standardsSummarySelectShowBucket');
                    updateStandardsSummaryCheckboxes(checkbox);
                });
            };

            var updateStandardsSummaryCheckboxes = function (element)
            {
                var parentCheckbox = element.length > 0 ? element : $(this);

                parentCheckbox.parents('.ajaxRepeaterPlaceHolder').find('.academicStandardDisplayCheckbox').each(function ()
                {
                    var checkbox = $(this);
                    if (!parentCheckbox.is(':checked'))
                    {
                        skyward.controls.disable(checkbox);
                    }
                    else
                    {
                        skyward.controls.enable(checkbox);
                    }
                });
            };

            gradebook.removeDefaultKeyEvents();

            //This should always be the last thing in the init. We don't want to resolve gradebookLoadComplete before we have defined all of the functions that might get called
            var rowsSkipped = gradebookData.rowsskipped; //TODO: Remove with the stream dream..STREAM DREAM! STREAM DREAM!
            if (rowsSkipped == null || rowsSkipped == "")
            {
                rowsSkipped = 0;
            }
            if (gradebookData.usingOffset.toString().toLowerCase() == "true" && (gradebook.rowCount + rowsSkipped) >= gradebookData.numberOfRowsToFetch)
            {
                gradebook.fetchGradebookRows(1, gradebookData.numberOfRowsToFetch);

                $.when(gradebook.gradebookFullyLoadedPromise).done(function ()
                {
                    gradebook.gradebookLoadComplete(gradebook.browse, true, { requireMissingCountLoad: true, requiresStaffMeetUpdate: true });
                });
            }
            else
            {
                gradebook.gradebookFullyLoadedPromise.resolve();
                gradebook.gradebookLoadComplete(gradebook.browse, false, { requireMissingCountLoad: true, requiresStaffMeetUpdate: true });
            }

            var initEvents =
            {
                'gradingPeriodOptionsPopup': gradingPeriodOptionsPopup,
                'getBrowseExport': exportBrowse,
                'studentSectionNote': studentSectionNote,
                'studentGradeBucketOptionsPopup': studentGradeBucketOptionsPopup,
                'studentGradeBucketOptionsPopupSelfPacedOnly': studentGradeBucketOptionsPopupSelfPacedOnly,
                'studentGradeBucketSubjectOptionsPopup': studentGradeBucketSubjectOptionsPopup,
                'studentGradeBucketAcademicStandardOptionsPopup': studentGradeBucketAcademicStandardOptionsPopup,
                'expandCollapseLockedColumns': gradebook.expandCollapseLockedColumns,
                'buildLockedColumnsDisplayPopup': buildLockedColumnsDisplayPopup,
                'assignmentIndicatorPopup': assignmentIndicatorPopup,
                'gradeBucketAcademicStandardPopup': gradeBucketAcademicStandardPopup,
                'studentGradeBucketAcademicStandardSummaryPopup': studentGradeBucketAcademicStandardSummaryPopup,
                'printBlankGradesheet': printBlankGradesheet,
                'showNewStudentInfo': showNewStudentInfo,
                'buildLegendPopup': buildLegendPopup,
                'selectAcademicStandardsToDisplay': selectAcademicStandardsToDisplay,
                'subjectHeaderPopup': subjectHeaderPopup,
                'standardHeaderPopup': standardHeaderPopup,
                'assignmentHeaderPopup': assignmentHeaderPopup,
                'massAssignScoresPopup': massAssignScoresPopup,
                'nonAssignmentMassAssignPopup': nonAssignmentMassAssignPopup,
                'viewGradingScale': viewGradingScale,
                'viewStudentGradeContainerAudit': viewStudentGradeContainerAudit,
                'displayStudentGroupInfo': gradebook.displayStudentGroupInfo,
                'displayGradebookFilterInfo': gradebook.displayGradebookFilterInfo,
                'filterToSpecificStudent': gradebook.filterToSpecificStudent,
                'openSubjectDetails': gradebook.openSubjectDetails,
                'openAcademicStandardDetails': gradebook.openAcademicStandardDetails,
                'displayGradebookFilterInfo': gradebook.displayGradebookFilterInfo,
                'massUpdateAssignmentsSectionGradeBucket': gradebook.massUpdateAssignmentsSectionGradeBucket,
                'massUpdateAssignmentsStudentGradeBucket': gradebook.massUpdateAssignmentsStudentGradeBucket,
                'showHiddenGradeBuckets': gradebook.showHiddenGradeBuckets,
                'closeHiddenGradeBucketsWarning': gradebook.closeHiddenGradeBucketsWarning
            };

            //Bootstrap
            skyward.events.registerEvents('gradebook', initEvents);
        };

        var isInScoringMode = function ()
        {
            var scoringModeControl = $("#UpdateEditMode");
            return (scoringModeControl.children("span").text() === GRADEBOOK_EXIT_SCORING_MODE) || $(".gradebookScoringMode-On").length > 0;
        };

        var updateStudentAssignmentButtonDisplay = function (assignmentScoreCell)
        {
            var button = assignmentScoreCell.find('.assignmentIndicatorButton');
            var firstRow;

            if (button.length == 0)
            {
                return;
            }

            button.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    firstRow = span;
                }
            });

            if (firstRow.hasClass('hiddenMissingScore') && firstRow.hasClass('hiddenScoreClarifier') && firstRow.hasClass('hiddenNoCount') && firstRow.hasClass('hiddenMultipleAttempts') &&
                firstRow.hasClass('hiddenComment') && firstRow.hasClass('hiddenWarning') && firstRow.hasClass('hiddenDroppedAssignment') && firstRow.hasClass('hiddenTransferGrade') &&
                firstRow.hasClass('hiddenMoreInfo') && firstRow.hasClass('hiddenAttendanceType') && firstRow.hasClass('hiddenHasAttachments') && firstRow.hasClass('hiddenOnlineAssignment') &&
                firstRow.hasClass('hiddenDoNotPostToFASA'))
            {
                button.addClass('displayNone');
            }
            else
            {
                button.removeClass('displayNone');
            }
        };

        var validationErrorDetailsPopup = function ()
        {
            var element = $(this);
            var assignmentsWithErrors = $(".assignmentCell.updatedWithErrors, .assignmentCell.hasErrors");
            var gradeBucketsWithErrors = $(".gradeBucketCell.updatedWithErrors, .gradeBucketCell.hasErrors");
            var subjectsWithErrors = $(".subjectCell.updatedWithErrors, .subjectCell.hasErrors");
            var academicStandardsWithErrors = $(".academicStandardCell.updatedWithErrors, .academicStandardCell.hasErrors");
            var assignmentErrorMessage = "";
            var SGBErrorMessage = "";
            var SGBSubjectErrorMessage = "";
            var SGBAcademicStandardErrorMessage = "";
            var hasAssignmentErrors = false;
            var hasSGBErrors = false;
            var hasSGBSubjectErrors = false;
            var hasSGBAcademicStandardErrors = false;

            var assignmentPromise = function ()
            {
                if (assignmentsWithErrors.length > 0)
                {
                    var errors = {};
                    assignmentsWithErrors.each(function ()
                    {
                        var cell = $(this);

                        var data = cell.data();

                        if (data.errors && !$.isEmptyObject(data.errors))
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var assignmentId = idParts[2];
                            var key = studentSectionId + "_" + assignmentId;
                            errors[key] = data.errors;
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            assignmentErrorMessage = data.html;
                            hasAssignmentErrors = true;
                        }
                    }).promise();
                }
            };

            var gradeBucketPromise = function ()
            {
                if (gradeBucketsWithErrors.length > 0)
                {
                    var errors = {};
                    gradeBucketsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketId: data.studentGradeBucketId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBErrorMessage = data.html;
                            hasSGBErrors = true;
                        }
                    }).promise();
                }
            };

            var subjectPromise = function ()
            {
                if (subjectsWithErrors.length > 0)
                {
                    var errors = {};
                    subjectsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketSubjectId: data.studentGradeBucketSubjectId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorSubjectGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        silent: true,
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBSubjectErrorMessage = data.html;
                            hasSGBSubjectErrors = true;
                        }
                    }).promise();
                }
            };

            var academicStandardPromise = function ()
            {
                var errors = {};
                if (academicStandardsWithErrors.length > 0)
                {
                    academicStandardsWithErrors.each(function ()
                    {
                        var cell = $(this);
                        var data = cell.data();

                        if (data.errors)
                        {
                            var idParts = cell.attr("id").split("_");
                            var studentSectionId = idParts[1];
                            var studentGradeBucketId = data.studentGradeBucketId;
                            var key = studentSectionId + "_" + studentGradeBucketId;
                            errors[key] =
                            {
                                errors: data.errors,
                                studentGradeBucketAcademicStandardId: data.studentGradeBucketAcademicStandardId
                            };
                        }
                    });

                    return $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/ValidationErrorAcademicStandardGradeBucketDetailsPopup/",
                        type: "POST",
                        dataType: "JSON",
                        silent: true,
                        data:
                        {
                            errors: JSON.stringify(errors)
                        },
                        success: function (data)
                        {
                            SGBAcademicStandardErrorMessage = data.html;
                            hasSGBAcademicStandardErrors = true;
                        }
                    }).promise();
                }
            };

            var promise = function ()
            {
                var myDeferred = $.Deferred();

                $.when(assignmentPromise(), gradeBucketPromise(), subjectPromise(), academicStandardPromise()).done(function ()
                {
                    myDeferred.resolve();
                });

                return myDeferred.promise();
            };

            $.when(promise()).done(function ()
            {
                var errorMessage = "";
                if (hasAssignmentErrors && (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors))
                {
                    errorMessage = "<h1>Assignments</h1>" + assignmentErrorMessage + "\n\n<h1>Grades</h1>" + SGBErrorMessage + SGBSubjectErrorMessage + SGBAcademicStandardErrorMessage;
                }
                else
                {
                    errorMessage = assignmentErrorMessage + SGBErrorMessage + SGBSubjectErrorMessage + SGBAcademicStandardErrorMessage;
                }
                var popupHeader = hasAssignmentErrors ? (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors) ? "Assignment/Grade " : "Assignment " : (hasSGBErrors || hasSGBSubjectErrors || hasSGBAcademicStandardErrors) ? "Grade " : "";
                var cancelButton = { id: "academicStandardDetailsPopup", text: "Ok", click: function () { dialog.close(); }, icon: "Check" };

                var dialog = skyward.modalLayer.showDialog(popupHeader + 'Errors', errorMessage, [cancelButton],
                    {
                        anchorTo: element
                    });
            });
        };

        var createSaveManager = function (gradebook)
        {
            var manager = {};

            // DOM elements
            var undoButton = $("#GradebookUndo");
            var redoButton = $("#GradebookRedo");
            var updateStatusWrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
            var updateStatusSpan = $("#GradebookUpdateStatus");
            var errorStatusSpan = $("#GradebookErrorStatus");

            //.morebutton is a generic classname, this could be a problem if there are other more buttons on the screen
            var buttonsToDisableDuringSave = $(".gradebook--rightToolbar").find(".button:not(.moreButton, #GradebookLegend, #GradebookUndo, #GradebookRedo, .alwaysDisabled)");

            var updateErrorStatusClass = function (newClass)
            {
                errorStatusSpan.removeClass('errorDuringSave');

                if (newClass)
                {
                    errorStatusSpan.addClass(newClass);
                }
            };

            var updateStatusWrapperClass = function (newClass)
            {
                updateStatusWrapper.removeClass('unsavedChanges processing savesCompleted errorDuringSave');
                if (newClass)
                {
                    updateStatusWrapper.addClass(newClass);
                }

                if ($(".assignmentCell.updatedWithErrors").length || newClass === "errorDuringSave")
                {
                    updateErrorStatusClass('errorDuringSave');
                }
                else
                {
                    updateErrorStatusClass();
                }

                //reflow responsive controls
                $(window).trigger("resize");
            };

            $('body').off("click", "#GradebookErrorStatus.errorDuringSave").on("click", "#GradebookErrorStatus.errorDuringSave", validationErrorDetailsPopup);

            // Status variables
            var lastStatusMessage = "";
            var lastStatusClass = "";
            var unsavedChanges = false;

            // Managers
            var assignmentManager = createAssignmentManager();
            var undoManagerOptions =
            {
                execute: updateUndoButtons,
                undo: updateUndoButtons,
                redo: updateUndoButtons,
                reset: updateUndoButtons
            };
            var undoManager = skyward.autoSaveManagers.createUndoManager(undoManagerOptions);
            var saveManagerOptions =
            {
                postDataAttributeName: "gradesheetUpdateData",
                savesStarted: function ()
                {
                    skyward.changeTracking.overrideGlobalDirtyState(true);
                    buttonsToDisableDuringSave.addClass("ui-disabled");
                    lastStatusMessage = "Processing changes...";
                    lastStatusClass = 'processing';
                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }
                },
                update: function (status)
                {
                    lastStatusMessage = "Processing record " + status.numberOfCompletedRequests + " of " + status.numberOfTotalRequests + "...";
                    lastStatusClass = 'processing';
                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }
                },
                savesCompleted: function ()
                {
                    lastStatusMessage = "All successful changes have been saved on " + getCurrentTimeString();
                    lastStatusClass = 'savesCompleted';

                    if (!unsavedChanges)
                    {
                        updateStatusSpan.html(lastStatusMessage);
                        updateStatusWrapperClass(lastStatusClass);
                    }

                    skyward.changeTracking.overrideGlobalDirtyState(false);
                    buttonsToDisableDuringSave.removeClass("ui-disabled");
                }
            };
            var saveManager = skyward.autoSaveManagers.createSaveManager(saveManagerOptions);

            var setUpAllManagers = function (assignmentManager, undoManager, saveManager)
            {
                manager.saveManager = saveManager;
                manager.undoManager = undoManager;
                manager.assignmentManager = assignmentManager;
            };

            setUpAllManagers(assignmentManager, undoManager, saveManager);

            function updateUndoButtons(status)
            {
                if (status.canUndo)
                {
                    undoButton.removeClass("ui-disabled");
                    skyward.controls.enable(undoButton);
                }
                else
                {
                    undoButton.addClass("ui-disabled");
                }

                if (status.canRedo)
                {
                    redoButton.removeClass("ui-disabled");
                    skyward.controls.enable(redoButton);
                }
                else
                {
                    redoButton.addClass("ui-disabled");
                }
            }

            function getCurrentTimeString()
            {
                var format = function (number)
                {
                    var numberString = number.toString();

                    if (numberString.length < 2)
                    {
                        numberString = "0" + numberString;
                    }

                    return numberString;
                };

                var currentdate = skyward.time.now();
                var hours = currentdate.getHours();
                var ampm = "am";
                if (hours >= 12)
                {
                    hours -= 12;
                    ampm = "pm";
                }
                if (hours === 0)
                {
                    hours = 12;
                }
                var datestring = (currentdate.getMonth() + 1) + "/"
                    + currentdate.getDate() + "/"
                    + currentdate.getFullYear() + " at "
                    + hours + ":"
                    + format(currentdate.getMinutes()) + " " + ampm;

                return datestring;
            }

            manager.save = function (saveObjects)
            {
                var valuesToSave = assignmentManager.getChangedValues(saveObjects);

                if (!valuesToSave.length || !gradebook.editMode)
                {
                    return;
                }

                var deferred = $.Deferred();

                // todo This logic can be cleaned up when we send mass assign saves in a single batch again
                var command =
                {
                    execute: function ()
                    {
                        if (valuesToSave.length == 0)
                        {
                            deferred.resolve();
                        }
                        var count = 0;
                        var valuesToSaveLength = valuesToSave.length;
                        for (var i = 0; i < valuesToSave.length; i++)
                        {
                            var data = $.extend({}, valuesToSave[i]);
                            delete data.originalValues;
                            delete data.hasChanges;

                            if (assignmentManager.setValues(data, false) == true)
                            {
                                var encodedData = {};
                                $.each(data, function (key, value)
                                {
                                    if (value != null && typeof value === 'string') //Don't want to try to encode any objects. Numbers will not need this
                                    {
                                        encodedData[key] = skyward.extensions.encodeHtml(value);
                                    }
                                    else
                                    {
                                        encodedData[key] = value;
                                    }
                                });

                                var promise = saveManager.save(encodedData, "Gradebook/Gradebook/UpdateGradeSheetData");
                                $.when(promise).then(function (response)
                                {
                                    setSaveResponseOriginalValues(response, valuesToSave);

                                    if (gradebook)
                                    {
                                        checkAjaxResponseForErrors(response, assignmentManager.handleSaveResponse, [false, response, gradebook, response.objectsToUpdate]);
                                    }
                                    else if (response && response.success == false)
                                    {
                                        skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
                                    }
                                    else
                                    {
                                        assignmentManager.handleSaveResponse(false, response, gradebook, response.objectsToUpdate);
                                    }
                                    count++;
                                    if (count == valuesToSaveLength)
                                    {
                                        deferred.resolve();
                                    }
                                });
                            }
                        }
                    },
                    undo: function ()
                    {
                        for (var i = 0; i < valuesToSave.length; i++)
                        {
                            var data = $.extend({}, valuesToSave[i], valuesToSave[i].originalValues);
                            delete data.originalValues;
                            delete data.hasChanges;

                            if (assignmentManager.setValues(data, true) == true)
                            {
                                var promise = saveManager.save(data, "Gradebook/Gradebook/UpdateGradeSheetData");
                                $.when(promise).then(function (response)
                                {
                                    setSaveResponseOriginalValues(response, valuesToSave);
                                    assignmentManager.handleSaveResponse(true, response, gradebook, response.objectsToUpdate);
                                });
                            }
                        }
                    }
                };

                undoManager.execute(command);
                return deferred;
            };

            manager.setDirtyState = function (hasUnsavedChanges)
            {
                unsavedChanges = hasUnsavedChanges;

                if (unsavedChanges)
                {
                    updateStatusSpan.html("There are unsaved changes");
                    updateStatusWrapperClass('unsavedChanges');
                }
                else
                {
                    if (updateStatusWrapper.hasClass('errorDuringSave'))
                    {
                        if (updateStatusWrapper.hasClass('studentAssignmentError') || updateStatusWrapper.hasClass('studentGradeBucketError'))
                        {
                            lastStatusMessage = "Error Updating Grades";
                        }
                        lastStatusClass = 'errorDuringSave';
                    }

                    updateStatusSpan.html(lastStatusMessage);
                    updateStatusWrapperClass(lastStatusClass);
                }
            };

            manager.undo = function ()
            {
                undoManager.undo();
            };

            manager.redo = function ()
            {
                undoManager.redo();
            };

            manager.reset = function ()
            {
                updateStatusWrapperClass();
                undoManager.reset();
            };

            manager.updateAverageValues = function (returnData)
            {
                assignmentManager.updateAverageValues(returnData, gradebook);
            };

            manager.stillProcessingSaves = function ()
            {
                return lastStatusClass == 'processing';
            }

            return manager;
        };

        var createAssignmentManager = function ()
        {
            var updateStatusWrapper = $("#" + GRADEBOOK_UPDATE_STATUS_WRAPPER);
            var updateStatusSpan = $("#GradebookUpdateStatus");
            var errorStatusSpan = $("#GradebookErrorStatus");
            var manager = {};

            var updateStatusWrapperClass = function (newClass)
            {
                updateStatusWrapper.removeClass('unsavedChanges processing savesCompleted errorDuringSave');

                if (newClass)
                {
                    updateStatusWrapper.addClass(newClass);
                }
                if (newClass === "errorDuringSave")
                {
                    errorStatusSpan.addClass(newClass);
                }
                else
                {
                    errorStatusSpan.removeClass("errorDuringSave");
                }
            };

            var updateStudentAssignmentReadOnly = function (studentAssignmentData, studentAssignmentElement, gradebook)
            {
                var enabled = true;
                if (studentAssignmentData.isDropped != null)
                {
                    enabled = !studentAssignmentData.isDropped;
                }

                if (enabled == true && studentAssignmentElement.hasClass('hasAttempts'))
                {
                    enabled = false;
                }

                var offClassName = "gradebookScoringMode-Off";
                var onClassName = "gradebookScoringMode-On";
                var scoringModeDoesntAffectStateClassName = "scoringModeDoesntAffectState";

                //Make sure we have the right element because there are 2 in the dom for each student assignment
                if (!studentAssignmentElement.hasClass("gradebookInput") && !studentAssignmentElement.hasClass("gradeMarkScoring"))
                {
                    studentAssignmentElement = studentAssignmentElement.siblings(".gradebookInput");
                }

                if (enabled)
                {
                    studentAssignmentElement.addClass(onClassName);
                    studentAssignmentElement.removeClass(offClassName);
                    studentAssignmentElement.removeClass(scoringModeDoesntAffectStateClassName);
                    gradebook.enableControl(studentAssignmentElement);
                }
                else
                {
                    studentAssignmentElement.removeClass(onClassName);
                    studentAssignmentElement.addClass(offClassName);
                    studentAssignmentElement.addClass(scoringModeDoesntAffectStateClassName);
                    gradebook.disableControl(studentAssignmentElement);
                }
            };

            manager.updateChangedClass = function (element, isUndo, bucketData)
            {
                var inputElement = element;

                var isScore = inputElement.data().fieldname == "Score";
                if (element.is("input"))
                {
                    element = element.closest(".assignmentCell");
                }

                //handle closed grading period grade change classes
                element.removeClass('gradeBucketGradeChangeDenied').removeClass('gradeBucketGradeChangeNotReviewedOrInProgress');

                var updates = element.data("numberOfUpdates") || 0;
                isUndo ? updates-- : updates++;
                element.data("numberOfUpdates", updates);

                if (isScore)
                {
                    if (updates > 0)
                    {
                        updateAssignmentCellClasses(inputElement, element);
                    }
                    else
                    {
                        removeCellErrorClasses(element, "updatedOverMaxScore updated");
                        setWarningIconClass(element, '.assignmentIndicatorsFirstRow', false);
                    }
                }
                else
                {
                    updates > 0 ? removeCellErrorClasses(element.addClass("updated")) : element.removeClass("updated");
                    updateStudentGradeBucketCellClasses(inputElement, element, bucketData);
                }
            };

            var updateAssignmentCellClasses = function (inputElement, element)
            {
                var indicatorSpan = '.assignmentIndicatorsFirstRow';
                var overMaxScore = updateChangedAssignmentCell(inputElement);
                if (overMaxScore)
                {
                    removeCellErrorClasses(element.addClass("updatedOverMaxScore"), "updated");
                    setWarningIconClass(element, indicatorSpan, true);
                }
                else
                {
                    removeCellErrorClasses(element.addClass("updated"), "updatedOverMaxScore");
                    setWarningIconClass(element, indicatorSpan, false);
                }
            };

            var updateChangedAssignmentCell = function (element)
            {
                if (!element.hasClass('gradeMarkScoring') && parseFloat(skyward.controls.getValue(element)) > parseFloat(element.data('maxscore')))
                {
                    return true;
                }
                return false;
            };

            manager.setOriginalStudentAssignmentValues = function (input, value)
            {
                if (input.hasClass("studentAssignment"))
                {
                    input.data("original-assignment-score", value);
                }
            };

            manager.setInputOriginalValue = function (input, value)
            {
                if (input.hasClass("codeEELCode"))
                {
                    input.siblings(".codeEELValue").data("original-value", value);
                }
                else if (input.hasClass("gradebookInputCodeEEL"))
                {
                    skyward.gradebookcodeeel.setOriginalValueData(input, skyward.gradebookcodeeel.getData(input).displayValue, value);
                }
                else
                {
                    input.data("original-value", value);
                    manager.setOriginalStudentAssignmentValues(input, value);
                }
            };

            var getStudentGradeBucketChangedValues = function (studentGradeBucketData, inputParam, studentGradeBucketID)
            {
                var input = inputParam.find(".gradebookInputCodeEEL");
                var studentSectionID = input.parents('.gradesheetBrowseRow').data('studentSectionId');
                var gradingPeriodGradeBucketID = input.parents('.gradeBucketCell').data('gradingPeriodGradeBucketId');

                var saveData =
                {
                    saveManagerId: studentSectionID,
                    isStudentGradeBucket: true,
                    hasChanges: false,
                    studentGradeBucketID: studentGradeBucketID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: input.data().isavailable,
                    studentSectionID: studentSectionID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    saveObject: "StudentGradeBucket",
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    Score: studentGradeBucketData.Score,
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getStudentGradeBucketSubjectChangedValues = function (studentGradeBucketSubjectData)
            {
                var studentGradeBucketSubjectID = studentGradeBucketSubjectData.studentGradeBucketSubjectID;

                var input = $("#SubjectiveSubjectGradeMark_" + studentGradeBucketSubjectID);

                var inputData = input.data();
                var subjectID = inputData.subjectId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var saveData =
                {
                    saveManagerId: studentGradeBucketSubjectData.studentSectionId,
                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                    subjectID: subjectID,
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: false,
                    Score: studentGradeBucketSubjectData.Score,
                    saveObject: "StudentGradeBucketSubject",
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getMasteryStudentGradeBucketSubjectChangedValues = function (studentGradeBucketSubjectData)
            {
                var studentGradeBucketSubjectID = studentGradeBucketSubjectData.studentGradeBucketSubjectID;

                var input = $("#MasterySubjectGradeMark_" + studentGradeBucketSubjectID);
                var isMastered = input.is(":checked");

                var inputData = input.data();
                var subjectID = inputData.subjectId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;
                var studentGradeBucketID = inputData.studentGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketSubjectData.studentSectionId,
                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                    subjectID: subjectID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: true,
                    isMastered: isMastered,
                    isMastery: true,
                    originalValues:
                    {
                        isMastered: !isMastered
                    },
                    saveObject: "StudentGradeBucketSubject"
                };
                return saveData;
            };

            var getStudentGradeBucketAcademicStandardChangedValues = function (studentGradeBucketAcademicStandardData)
            {
                var studentGradeBucketAcademicStandardID = studentGradeBucketAcademicStandardData.studentGradeBucketAcademicStandardID;

                var input = $("#SubjectiveAcademicStandardGradeMark_" + studentGradeBucketAcademicStandardID);

                var inputData = input.data();
                var academicStandardID = inputData.academicStandardId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketAcademicStandardData.studentSectionId,
                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                    academicStandardID: academicStandardID,
                    gradeMarkID: skyward.gradebookcodeeel.getData(input).selectedValueID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: false,
                    Score: studentGradeBucketAcademicStandardData.Score,
                    saveObject: "StudentGradeBucketAcademicStandard",
                    originalValues: {}
                };

                setInputData(input, saveData, true);

                return saveData;
            };

            var getMasteryStudentGradeBucketAcademicStandardChangedValues = function (studentGradeBucketAcademicStandardData)
            {
                var studentGradeBucketAcademicStandardID = studentGradeBucketAcademicStandardData.studentGradeBucketAcademicStandardID;

                var input = $("#MasteryAcademicStandardGradeMark_" + studentGradeBucketAcademicStandardID);
                var isMastered = input.is(":checked");

                var inputData = input.data();
                var academicStandardID = inputData.academicStandardId;
                var studentGradeBucketID = inputData.studentGradeBucketId;
                var gradingPeriodGradeBucketID = inputData.gradingPeriodGradeBucketId;

                var saveData =
                {
                    saveManagerId: studentGradeBucketAcademicStandardData.studentSectionId,
                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                    academicStandardID: academicStandardID,
                    sectionID: getSectionIDFromCell(input),
                    isAvailable: inputData.isavailable,
                    studentGradeBucketID: studentGradeBucketID,
                    gradingPeriodGradeBucketID: gradingPeriodGradeBucketID,
                    hasChanges: true,
                    isMastered: isMastered,
                    isMastery: true,
                    originalValues:
                    {
                        isMastered: !isMastered
                    },
                    saveObject: "StudentGradeBucketAcademicStandard"
                };

                return saveData;
            };

            var getAssignmentChangedValues = function (assignment)
            {
                var studentSectionId = assignment.studentSectionId;
                var assignmentId = assignment.assignmentId;
                var academicStandardId = assignment.academicStandardId;
                var isAvailable = assignment.isAvailable;
                var inputs = $("input[data-studentsectionid='" + studentSectionId + "'][data-assignmentid='" + assignmentId + "']");
                var useGradeMarkScoringEEL = inputs.parent().find('.gradeMarkScoring').length > 0;

                assignmentId = getRepresentedAssignmentID(assignmentId, assignment.sectionId);

                if (assignmentId == null)
                {
                    return {};
                }

                var studentAssignmentData =
                {
                    saveManagerId: studentSectionId,
                    id: "Gradebook_" + studentSectionId + "_" + assignmentId,
                    assignmentId: assignmentId,
                    studentSectionId: studentSectionId,
                    academicStandardId: academicStandardId,
                    isAvailable: isAvailable,
                    hasChanges: false,
                    sectionId: assignment.sectionId,
                    saveObject: "StudentAssignment",
                    displayValue: assignment.displayValue,
                    scoreClarifierCode: assignment.displayValue,
                    gradeMarkDisplayValue: assignment.displayValue,
                    originalValues: {},
                    skipUpdateLastScoredTime: assignment.skipUpdateLastScoredTime
                };

                for (var i = 0; i < inputs.length; i++)
                {
                    setInputData($(inputs[i]), studentAssignmentData, useGradeMarkScoringEEL);
                }

                if (assignment.IsDropped != null)
                {
                    studentAssignmentData["IsDropped"] = assignment.IsDropped;
                    studentAssignmentData.originalValues["IsDropped"] = !assignment.IsDropped;
                    studentAssignmentData.hasChanges = true;
                }

                return studentAssignmentData;
            };

            var setInputData = function (input, objectToAddDataTo, useGradeMarkScoringEEL)
            {
                if (!input)
                {
                    return;
                }

                var inputData = input.data();
                var value = getInputValue(input);
                var originalValue = getInputOriginalValue(input);
                var fieldName = inputData.fieldname ? inputData.fieldname : "Score";

                if (value != originalValue && !(originalValue == "*" && value == "" ))
                {
                    if (fieldName === "Score" && value > 0)
                    {
                        var isMissingInput = $("#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_IsMissing").find(".checkbox");

                        if (isMissingInput.length > 0)
                        {
                            var isMissingField = "IsMissing";
                            var isMissingValue = getInputValue(isMissingInput);

                            if (isMissingValue === true)
                            {
                                objectToAddDataTo[isMissingField] = false;
                                objectToAddDataTo.originalValues[isMissingField] = isMissingValue;
                                objectToAddDataTo.hasChanges = true;
                            }
                        }
                    }

                    if (!input.hasClass("gradebookInputCodeEEL"))
                    {
                        objectToAddDataTo[fieldName] = value;
                        objectToAddDataTo.originalValues[fieldName] = originalValue;
                    }
                    else
                    {
                        objectToAddDataTo[fieldName] =
                        {
                            displayValue: inputData.displayValue,
                            selectedValueID: value
                        };

                        objectToAddDataTo.originalValues[fieldName] = {};
                        objectToAddDataTo.originalValues[fieldName]["displayValue"] = skyward.gradebookcodeeel.getOriginalValueData(input).originalDisplayValue;
                        objectToAddDataTo.originalValues[fieldName]["selectedValueID"] = skyward.gradebookcodeeel.getOriginalValueData(input).originalSelectedValueID;
                    }
                    objectToAddDataTo.hasChanges = true;
                }
            };

            var setStudentGradeBucketValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                $(".gradeBucketCell[data-student-grade-bucket-id='" + studentGradeBucketData.studentGradeBucketID + "']").each(function ()
                {
                    var input = $(this).find(".gradebookInputCodeEEL");
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                });

                return valid;
            };

            var setStudentGradeBucketSubjectValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                if (studentGradeBucketData.isMastery)
                {
                    var checkbox = $("#MasterySubjectGradeMark_" + studentGradeBucketData.studentGradeBucketSubjectID);
                    if (!checkbox.is(':disabled, [readonly], .ui-disabled'))
                    {
                        skyward.controls.setValue(checkbox, studentGradeBucketData.isMastered);
                    }
                    else
                    {
                        valid = false;
                    }
                }
                else
                {
                    var input = $("#SubjectiveSubjectGradeMark_" + studentGradeBucketData.studentGradeBucketSubjectID);
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                }

                return valid;
            };

            var setStudentGradeBucketAcademicStandardValues = function (studentGradeBucketData, isUndo)
            {
                var valid = true;

                if (studentGradeBucketData.isMastery)
                {
                    var checkbox = $("#MasteryAcademicStandardGradeMark_" + studentGradeBucketData.studentGradeBucketAcademicStandardID);
                    if (!checkbox.is(':disabled, [readonly], .ui-disabled'))
                    {
                        skyward.controls.setValue(checkbox, studentGradeBucketData.isMastered);
                    }
                    else
                    {
                        valid = false;
                    }
                }
                else
                {
                    var input = $("#SubjectiveAcademicStandardGradeMark_" + studentGradeBucketData.studentGradeBucketAcademicStandardID);
                    if (!input.is(':disabled') && !input.is('[readonly]'))
                    {
                        skyward.gradebookcodeeel.setValue(input, studentGradeBucketData.Score.displayValue, studentGradeBucketData.Score.selectedValueID, true);
                        manager.setInputOriginalValue(input, getInputValue(input));
                    }
                    else
                    {
                        valid = false;
                    }
                }

                return valid;
            };

            var setAssignmentValuesFromUpdateGradeSheetDataReturnData = function (studentAssignment)
            {
                var assignment =
                {
                    assignmentId: studentAssignment.assignmentId,
                    studentSectionId: studentAssignment.studentSectionId,
                    ScoreClarifierID: studentAssignment.scoreClarifierId,
                    IsMissing: studentAssignment.isMissing,
                    AttemptCount: studentAssignment.attempts
                };
                return setAssignmentValues(assignment, false);
            };

            var setAssignmentValues = function (assignment, isUndo)
            {
                var valid = true;
                var assignmentId = getDriverAssignmentID(assignment.assignmentId);
                var studentSectionId = assignment.studentSectionId;
                var fields = $("[data-assignmentid='" + assignmentId + "'][data-studentsectionid='" + studentSectionId + "']");

                for (var i = 0; i < fields.length; i++)
                {
                    var input = $(fields[i]);
                    var fieldName = input.data("fieldname");

                    if (!assignment.hasOwnProperty(fieldName))
                    {
                        continue;
                    }

                    if (input.is(':disabled') || input.is('[readonly]'))
                    {
                        valid = false;
                        break;
                    }

                    if (input.hasClass("codeEELCode"))
                    {
                        skyward.controls.setValue(input.parent(), assignment[fieldName]);
                    }
                    else if (fieldName === "ScoreClarifierID")
                    {
                        if (input.hasClass("gradebookInputCodeEEL"))
                        {
                            skyward.gradebookcodeeel.setValue(input, assignment.ScoreClarifierID.displayValue, assignment.ScoreClarifierID.selectedValueID, true);
                        }
                        else
                        {
                            skyward.controls.setValue(input, assignment.scoreClarifierCode);
                        }
                    }
                    else if (input.hasClass("gradebookInputCodeEEL") && input.hasClass("gradeMarkScoring"))
                    {
                        skyward.gradebookcodeeel.setValue(input, assignment.Score.displayValue, assignment.Score.selectedValueID, true);
                    }
                    else
                    {
                        skyward.controls.setValue(input, assignment[fieldName]);
                    }

                    var inputData = input.data();

                    manager.setInputOriginalValue(input, getInputValue(input));
                    updateAssignmentIndicatorSvg(input, "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score", "#" + BROWSE_NAME);
                    updateAssignmentIndicatorSvgSecondRow(input, { overrideShow: false }, "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score");
                    manager.updateChangedClass(input, isUndo, {});
                }

                return valid;
            };

            var updateStudentAssignmentId = function (studentSectionId, assignmentId, studentAssignmentId)
            {
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_Score input.gradebookInput").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_ScoreClarifierID input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_NoCount input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_IsMissing input").data("studentassignmentid", studentAssignmentId);
                $("#" + BROWSE_NAME + "_" + studentSectionId + "_" + assignmentId + "_Comments input").data("studentassignmentid", studentAssignmentId);
            };

            var updatePassedStudentAssignmentDisplay = function (affectedStudentAssignment, gradebook, isUndo)
            {
                var studentAssignmentCell = $("#" + BROWSE_NAME + "_" + affectedStudentAssignment.studentSectionId + "_" + affectedStudentAssignment.assignmentId + "_Score");
                var studentAssignmentCellData = studentAssignmentCell.data();

                var studentAssignmentInput = studentAssignmentCell.find("input.studentAssignment");

                var studentAssignmentData = studentAssignmentInput.data();
                if (studentAssignmentData.secondaryfieldname == 'GradeMarkScore')
                {
                    studentAssignmentInput.data('enabledGrademarkValue', affectedStudentAssignment.grademarkvalue);
                    studentAssignmentInput.data('disabledGrademarkValue', affectedStudentAssignment.displayValue);
                }

                studentAssignmentInput.data('displayValue', affectedStudentAssignment.displayValue);
                studentAssignmentInput.data('studentAssignmentScore', affectedStudentAssignment.score);

                var isParent = studentAssignmentData.isParent.toString().toLowerCase() == "true";
                if (isParent && skyward.controls.getValue(studentAssignmentInput) != affectedStudentAssignment.score)
                {
                    if (studentAssignmentData.secondaryfieldname == 'GradeMarkScore')
                    {
                        skyward.controls.setValue(studentAssignmentInput, affectedStudentAssignment.displayValue, true);
                    }
                    else
                    {
                        skyward.controls.setValue(studentAssignmentInput, affectedStudentAssignment.score, true);
                    }

                    manager.updateChangedClass(studentAssignmentInput, isUndo, {});
                }

                if (!isParent)
                {
                    updateStudentAssignmentReadOnly(affectedStudentAssignment, studentAssignmentInput, gradebook);
                }

                if (affectedStudentAssignment.isDropped != null)
                {
                    updateAssignmentIndicatorSvgSecondRow(studentAssignmentInput, { fieldnameOverride: "IsDropped", isDropped: affectedStudentAssignment.isDropped }, "#" + BROWSE_NAME + "_" + studentAssignmentData.studentsectionid + "_" + studentAssignmentData.assignmentid + "_" + "Score");
                }

                if (studentAssignmentData.istransferassignment != null && studentAssignmentData.istransferassignment.toString().toLowerCase() === "true")
                {
                    updateAssignmentIndicatorSvg(studentAssignmentInput, "#" + BROWSE_NAME + "_" + studentAssignmentData.studentsectionid + "_" + studentAssignmentData.assignmentid + "_" + "Score", "#" + BROWSE_NAME, "TransferGrade", shouldShowTransferIcon(affectedStudentAssignment));
                }


                applyGradeColors("assignment", affectedStudentAssignment.GradeMarkID, affectedStudentAssignment.BackingPercent, studentAssignmentCell, gradebook.colorData());

                //Clear any Existing Errors
                studentAssignmentCell.data("errors", {});
                removeCellErrorClasses(studentAssignmentCell);
                checkToggleErrorButton();
            };

            var checkToggleErrorButton = function ()
            {
                var cellsWithError = $('.gradebookCell.updatedWithErrors:not(.noMatch)');
                var errorButton = $('#GradebookErrorStatus');
                if (cellsWithError.length > 0)
                {
                    if (!errorButton.hasClass('errorDuringSave'))
                    {
                        errorButton.addClass('errorDuringSave');
                    }
                }
                else if (errorButton.hasClass('errorDuringSave'))
                {
                    errorButton.removeClass('errorDuringSave');
                }
            };

            var updateFailedStudentAssignmentDisplay = function (studentAssignment)
            {
                var studentAssignmentCell = $("#" + BROWSE_NAME + "_" + studentAssignment.studentSectionId + "_" + studentAssignment.assignmentId + "_Score");
                studentAssignmentCell.removeClass('updated updatedOverMaxScore').addClass('updatedWithErrors');
                studentAssignmentCell.data("errors", studentAssignment.errors);
                var studentAssignmentCellData = studentAssignmentCell.data();
                updateAssignmentIndicatorSvgSecondRow(studentAssignmentCell, { overrideShow: true }, "#" + BROWSE_NAME + "_" + studentAssignmentCellData.studentsectionid + "_" + studentAssignmentCellData.assignmentid + "_" + "Score", "#" + BROWSE_NAME);
            };

            var updateFailedGradeBucketValue = function (cells, errors)
            {
                cells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }
                    //remove colors if subject/standard...
                    cell.removeClass('updated updatedOverMaxScore').addClass('updatedWithErrors');
                    var errorString = "";
                    for (var error in Object.keys(errors))
                    {
                        var objectValue = Object.values(errors).valueOf(error);
                        if (objectValue != "" && objectValue != null && objectValue != undefined)
                        {
                            errorString += objectValue + ", ";
                        }
                    }

                    cell.css({ backgroundColor: '', color: '' });

                    errorString = errorString.substring(0, errorString.length - 2);
                    cell.data("errors", errors);
                });
            };

            var updateGradeBucketValue = function (isUndo, bucketData, gradebook)
            {
                var cells = $("td[data-student-grade-bucket-id='" + bucketData.StudentGradeBucketID + "']:not(.subjectCell, .academicStandardCell)");
                cells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var cellScoreSpan = cell.find('.gradeBucketScoreSpan');

                    var input = cell.find(".subjectiveStudentGradeBucket");
                    if (cellScoreSpan != undefined && input.length > 0)
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(input, bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }
                    cell.find("span.gradeBucketScoreSpan > span").html(bucketData.Value);

                    applyGradeColors("class", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());
                    manager.updateChangedClass(cell, isUndo, bucketData);

                    //TODO: loop through bucketData.AffectedStudentGradeBucketSubjects and update the appropriate student grade bucket subject cells.
                });

            };

            var updateGradeBucketSubjectValue = function (isUndo, bucketData, gradebook)
            {
                var subjectCells = $("td[data-student-grade-bucket-subject-id='" + bucketData.StudentGradeBucketSubjectID + "']");
                subjectCells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var subjectID = cell.data().subjectId;
                    var headerCell = $(".subjectHeaderCell[data-calculation-group-subject-grade-bucket-id=" + cell.data().calculationGroupSubjectGradeBucketId + "]");

                    if (headerCell.length > 0 && headerCell.data() != null && headerCell.data().calculationType == "S")
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(cell.find(".subjectiveStudentGradeBucketSubject"), bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }

                    applyGradeColors("subject", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());
                    manager.updateCellClassesAndColors("span.subjectScoreSpan > span", bucketData, cell, isUndo);
                });
            };

            var updateGradeBucketAcademicStandardValue = function (isUndo, bucketData, gradebook)
            {
                var academicStandardCells = $("td[data-student-grade-bucket-academic-standard-id='" + bucketData.StudentGradeBucketAcademicStandardID + "']");
                academicStandardCells.each(function ()
                {
                    var cell = $(this);
                    if (cell.length < 1)
                    {
                        //If the cell does not exist then the bucket is hidden and we have nothing to update
                        return;
                    }

                    var academicStandardID = cell.data().academicStandardId;
                    var headerCell = $(".academicStandardHeaderCell[data-calculation-group-academic-standard-grade-bucket-id=" + cell.data().calculationGroupAcademicStandardGradeBucketId + "]");

                    if (headerCell.length > 0 && headerCell.data() != null && headerCell.data().calculationType == "S")
                    {
                        cell.data("displayValue", bucketData.GradeMarkCode);
                        skyward.gradebookcodeeel.setValue(cell.find(".subjectiveStudentGradeBucketAcademicStandard"), bucketData.GradeMarkCode, bucketData.GradingScaleGroupGradeMarkID, true);
                    }

                    manager.updateCellClassesAndColors("span.academicStandardScoreSpan > span", bucketData, cell, isUndo);
                    applyGradeColors("standard", bucketData.GradeMarkIDToUse, bucketData.BackingPercent, cell, gradebook.colorData());

                });
            };

            manager.updateCellClassesAndColors = function (spanSelector, bucketData, cell, isUndo)
            {
                cell.find(spanSelector).html(bucketData.Value);

                if (bucketData.HasClosedGradingPeriodGradeChangeRequestInProgress)
                {
                    if (!cell.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
                    {
                        cell.addClass("gradeBucketGradeChangeNotReviewedOrInProgress");
                    }
                }
                manager.updateChangedClass(cell, isUndo, bucketData);

                if (isUndo == false || cell.hasClass('updated') || cell.hasClass('gradeBucketGradeChangeNotReviewedOrInProgress'))
                {
                    //Since we hard code a color for subjects we need to remove it for updated ones
                    cell.css({ backgroundColor: '', color: '' });
                }
                else
                {
                    var cellData = cell.data();
                    cell.css({ backgroundColor: cellData.backgroundColor, color: cellData.color });
                }
            };

            manager.handleSaveResponse = function (isUndo, returnData, gradebook, valuesToSave)
            {
                if (returnData == null)
                {
                    return;
                }

                if (!returnData.success)
                {
                    if (gradebook)
                    {
                        gradebook.clearInputValueFromFailedSave(valuesToSave);
                    }

                    if (returnData.affectedStudentAssignments.length == 0 && returnData.affectedStudentGradeBuckets.length == 0 && returnData.affectedStudentGradeBucketSubjects.length == 0 && returnData.affectedStudentGradeBucketAcademicStandards.length == 0)
                    {
                        return; //no where to display errors
                    }
                    else
                    {
                        updateStatusWrapperClass('errorDuringSave');
                    }

                    if (returnData.affectedStudentAssignments.length > 0)
                    {
                        //only handle the studentAssignments, StudentGradeBuckets can be added back when we need to get the errors off of them
                        for (var j = 0; j < returnData.createdStudentAssignments.length; j++)
                        {
                            var studentAssignment = returnData.createdStudentAssignments[j];
                            updateFailedStudentAssignmentDisplay(studentAssignment);
                        }

                        for (var h = 0; h < returnData.affectedStudentAssignments.length; h++)
                        {
                            var affectedStudentAssignment = returnData.affectedStudentAssignments[h];
                            updateFailedStudentAssignmentDisplay(affectedStudentAssignment);
                        }
                        updateStatusWrapper.addClass('studentAssignmentError');
                    }

                    if (returnData.affectedStudentGradeBuckets != null)
                    {
                        for (var j in returnData.affectedStudentGradeBuckets)
                        {
                            var studentGradeBucket = returnData.affectedStudentGradeBuckets[j];
                            if (Object.keys(studentGradeBucket.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-id='" + studentGradeBucket.StudentGradeBucketID + "']:not(.subjectCell, .academicStandardCell)");
                                updateFailedGradeBucketValue(cells, studentGradeBucket.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    if (returnData.affectedStudentGradeBucketAcademicStandards != null)
                    {
                        for (var j in returnData.affectedStudentGradeBucketAcademicStandards)
                        {
                            var studentGradeBucketAcademicStandard = returnData.affectedStudentGradeBucketAcademicStandards[j];
                            if (Object.keys(studentGradeBucketAcademicStandard.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-academic-standard-id='" + studentGradeBucketAcademicStandard.StudentGradeBucketAcademicStandardID + "']");
                                updateFailedGradeBucketValue(cells, studentGradeBucketAcademicStandard.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    if (returnData.affectedStudentGradeBucketSubjects != null)
                    {
                        for (var j in returnData.affectedStudentGradeBucketSubjects)
                        {
                            var studentGradeBucketSubject = returnData.affectedStudentGradeBucketSubjects[j];
                            if (Object.keys(studentGradeBucketSubject.Errors).length > 0)
                            {
                                var cells = $("td[data-student-grade-bucket-subject-id='" + studentGradeBucketSubject.StudentGradeBucketSubjectID + "']");
                                updateFailedGradeBucketValue(cells, studentGradeBucketSubject.Errors);
                            }
                        }
                        updateStatusWrapper.addClass('studentGradeBucketError');
                    }

                    updateStatusSpan.html('Error Updating Grades');
                }
                else
                {
                    for (var i = 0; i < returnData.affectedStudentGradeBuckets.length; i++)
                    {
                        var bucket = returnData.affectedStudentGradeBuckets[i];
                        updateGradeBucketValue(isUndo, bucket, gradebook);
                    }

                    if (returnData.affectedStudentGradeBucketAcademicStandards != undefined)
                    {
                        for (var i = 0; i < returnData.affectedStudentGradeBucketAcademicStandards.length; i++)
                        {
                            var bucket = returnData.affectedStudentGradeBucketAcademicStandards[i];
                            updateGradeBucketAcademicStandardValue(isUndo, bucket, gradebook);
                        }
                    }

                    if (returnData.affectedStudentGradeBucketSubjects != undefined)
                    {
                        for (var i = 0; i < returnData.affectedStudentGradeBucketSubjects.length; i++)
                        {
                            var bucket = returnData.affectedStudentGradeBucketSubjects[i];
                            updateGradeBucketSubjectValue(isUndo, bucket, gradebook);
                        }
                    }

                    for (var j = 0; j < returnData.createdStudentAssignments.length; j++)
                    {
                        var studentAssignment = returnData.createdStudentAssignments[j];
                        var assignmentId = getDriverAssignmentID(studentAssignment.assignmentId);

                        if (assignmentId != null)
                        {
                            studentAssignment.assignmentId = assignmentId;
                            updateStudentAssignmentId(studentAssignment.studentSectionId, studentAssignment.assignmentId, studentAssignment.studentAssignmentId);
                        }
                    }

                    for (var k = 0; k < returnData.affectedStudentAssignments.length; k++)
                    {
                        var affectedStudentAssignment = returnData.affectedStudentAssignments[k];
                        var assignmentId = getDriverAssignmentID(affectedStudentAssignment.assignmentId);

                        if (assignmentId != null)
                        {
                            affectedStudentAssignment.assignmentId = assignmentId;
                            updatePassedStudentAssignmentDisplay(affectedStudentAssignment, gradebook, isUndo);
                        }
                    }

                    updateIsMissingCount(returnData.assignmentCounts);
                    updateAttemptCount(returnData.affectedStudentAssignments, returnData.createdStudentAssignments, isUndo, manager);
                }

                performUpdateAverageValues(returnData, gradebook);
            };

            manager.updateAverageValues = function (returnData, gradebook)
            {
                performUpdateAverageValues(returnData, gradebook);
            };

            var performUpdateAverageValues = function (returnData, gradebook)
            {
                var hasAveragesDisplay = $('#' + BROWSE_NAME + '_body').hasClass("hasAveragesDisplay");
                if (hasAveragesDisplay)
                {
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetUpdatedAverages",
                        type: "POST",
                        dataType: "JSON",
                        activityIndicator: { silent: true },
                        data:
                        {
                            affectedStudentAssignments: JSON.stringify(returnData.affectedStudentAssignments),
                            affectedStudentGradeBuckets: JSON.stringify(returnData.affectedStudentGradeBuckets),
                            affectedStudentGradeBucketAcademicStandards: JSON.stringify(returnData.affectedStudentGradeBucketAcademicStandards),
                            affectedStudentGradeBucketSubjects: JSON.stringify(returnData.affectedStudentGradeBucketSubjects)
                        },
                        success: function (averageReturnData)
                        {
                            if (averageReturnData.assignmentAverages)
                            {
                                updateAssignmentAverages(averageReturnData.assignmentAverages);
                            }

                            if (averageReturnData.gradingPeriodGradeBucketAverages)
                            {
                                updateGradingPeriodGradeBucketAverages(averageReturnData.gradingPeriodGradeBucketAverages);
                            }

                            if (averageReturnData.studentGradeBucketSubjectAverages)
                            {
                                updateStudentGradeBucketChildRecordAverages(averageReturnData.studentGradeBucketSubjectAverages, "subjectGradeBucket");
                            }

                            if (averageReturnData.studentGradeBucketAcademicStandardAverages)
                            {
                                updateStudentGradeBucketChildRecordAverages(averageReturnData.studentGradeBucketAcademicStandardAverages, "academicStandardGradeBucket");
                            }
                        }
                    });
                }
                gradebook.resize();
            };

            manager.getChangedValues = function (saveObjects)
            {
                if (!Array.isArray(saveObjects))
                {
                    saveObjects = [saveObjects];
                }

                var data = [];
                for (var i = 0; i < saveObjects.length; i++)
                {
                    var affectedData = saveObjects[i];
                    if (affectedData != null)
                    {
                        if (affectedData.isStudentGradeBucket)
                        {
                            $(".gradeBucketCell[data-student-grade-bucket-id='" + affectedData.studentGradeBucketID + "']").each(function ()
                            {
                                var input = $(this);
                                data.push(getStudentGradeBucketChangedValues(affectedData, input, affectedData.studentGradeBucketID));
                            });
                        }
                        else if (affectedData.isStudentGradeBucketSubject)
                        {
                            if (affectedData.type && affectedData.type == "mastery")
                            {
                                data.push(getMasteryStudentGradeBucketSubjectChangedValues(affectedData));
                            }
                            else
                            {
                                data.push(getStudentGradeBucketSubjectChangedValues(affectedData));
                            }
                        }
                        else if (affectedData.isStudentGradeBucketAcademicStandard)
                        {
                            if (affectedData.type && affectedData.type == "mastery")
                            {
                                data.push(getMasteryStudentGradeBucketAcademicStandardChangedValues(affectedData));
                            }
                            else
                            {
                                data.push(getStudentGradeBucketAcademicStandardChangedValues(affectedData));
                            }
                        }
                        else
                        {
                            data.push(getAssignmentChangedValues(affectedData));
                        }
                    }
                }

                return data.filter(function (saveData)
                {
                    return saveData.hasChanges;
                });
            };

            manager.setValues = function (objectsToChange, isUndo)
            {
                var valid = true;

                if (!Array.isArray(objectsToChange))
                {
                    objectsToChange = [objectsToChange];
                }

                for (var i = 0; i < objectsToChange.length; i++)
                {
                    var objectType = objectsToChange[i].saveObject;
                    if (!objectType || objectType === "StudentAssignment")
                    {
                        valid &= setAssignmentValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucket")
                    {
                        valid &= setStudentGradeBucketValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucketSubject")
                    {
                        valid &= setStudentGradeBucketSubjectValues(objectsToChange[i], isUndo);
                    }
                    else if (objectType === "StudentGradeBucketAcademicStandard")
                    {
                        valid &= setStudentGradeBucketAcademicStandardValues(objectsToChange[i], isUndo);
                    }
                }

                return valid;
            };

            return manager;
        };

        var applyGradeColors = function (type, gradeMarkID, percent, cell, colorData)
        {
            //var colorData = gradebook.unlockedBody.data().grademarkcolordata;
            var colorToApply = null;
            $.each(colorData, function ()
            {
                var color = $(this)[0];

                var isForType = false;
                switch (type)
                {
                    case "assignment":
                        isForType = color.ApplyToAssignments;
                        break;
                    case "standard":
                        isForType = color.ApplyToAcademicStandardGrades;
                        break;
                    case "subject":
                        isForType = color.ApplyToSubjectGrades;
                        break;
                    case "class":
                        isForType = color.ApplyToClassGrades;
                        break;
                }

                if (isForType)
                {
                    if (color.RangeTypeCode == "GM")
                    {
                        if (gradeMarkID != null && $.inArray(gradeMarkID, color.GradeMarkIDs) > -1)
                        {
                            colorToApply = color.Color;
                            return;
                        }
                    }
                    else
                    {
                        if ((color.PercentHigh == null || color.PercentHigh >= percent) && (color.PercentLow == null || color.PercentLow <= percent))
                        {
                            colorToApply = color.Color;
                            return;
                        }
                    }
                }

            });

            if (colorToApply != null)
            {
                cell.css('box-shadow', '0px 0px 0px 2px ' + colorToApply + ' inset');
            }
            else
            {
                cell.css("box-shadow", 'inherit');
            }
        };

        skyward.gradebook.redirectToSpecificGradeBucketSubject = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketSubjectBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketSubjectId);
        };

        skyward.gradebook.redirectToSpecificGradeBucketAcademicStandard = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketAcademicStandardBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketAcademicStandardId);
        };

        skyward.gradebook.redirectToSpecificGradeBucket = function ()
        {
            var data = $(this).data();
            var accessmode = $("#accessmode").val();
            var breakdownPage = "GradeBucketBreakdown";
            redirectToGradeBucketBreakdown(data, accessmode, breakdownPage, data.studentGradeBucketId);
        };

        redirectToGradeBucketBreakdown = function (data, accessmode, breakdownScreen, id)
        {
            var module = "Gradebook";
            var object = "ProgressReport";
            var screen = "";

            if (data.isStudentInformationPopup.toLowerCase() === "true")
            {
                screen = breakdownScreen + "StudentInformationPopup" + data.currentPortal;
            }
            else if (accessmode == "StudentAccess" || accessmode == "FamilyAccess" || accessmode == "Grading")
            {
                module = "Grading";
                object = "StudentSection";
                screen = "ProgressReport" + accessmode;
            }
            else
            {
                screen = data.isTeacherTracker.toLowerCase() === "true"
                    ? breakdownScreen + "TeacherTracker"
                    : breakdownScreen;
            }

            skyward.window.loadContent("popout", module, object, screen, id, data);
        };

        skyward.gradebook.redirectToAssignment = function ()
        {
            var button = $(this);
            button.off("click", skyward.gradebook.redirectToAssignment);
            var data = button.data();

            if (!data || !data.assignmentid || (button.hasClass('isTeacherTracker') && !data.sectionid))
            {
                return;
            }
            var classGroupID = data.classGroupId;
            if (classGroupID == null)
            {
                var gradebookbrowse = $("#Gradebook");
                var gradebookbrowseData = gradebookbrowse.data();
                if (gradebookbrowseData)
                {
                    classGroupID = gradebookbrowseData.classGroupId;
                }
            }

            var screen = button.hasClass('isTeacherTracker') ? "DetailsTeacherTracker" : classGroupID != null ? "ClassGroupDetails" : "Details";

            if (!data.tab)
            {
                button.data('tab', 'tabScoreEntry');
            }

            if (button.hasClass('assignmentRedirectButton'))
            {
                var assignmentNavigationDirect = "previous";
                if (button.attr('id') == "nextAssignment" || button.attr('id') == "editAssignment_nextAssignment")
                {
                    assignmentNavigationDirect = "next";
                }
                skyward.window.loadContent("full", "Gradebook", "Gradebook", button.hasClass('isTeacherTracker')
                    ? "AssignmentNavigationTeacherTracker"
                    : "AssignmentNavigation",
                    null,
                    {
                        assignmentNavigate: assignmentNavigationDirect,
                        assignmentID: data.assignmentid,
                        tab: data.tab,
                        screen: screen,
                        sectionID: data.sectionid,
                        classGroupID: classGroupID
                    });
            }
            else if (button.hasClass('assignmentRestoreButton'))
            {
                skyward.window.loadContent("full", "Gradebook", "Assignment", "RestoreAssignment", data.assignmentid);
            }
            else
            {
                skyward.window.loadContent("full", "Gradebook", "Assignment", screen, data.assignmentid, data);
            }
        };

        skyward.gradebook.deleteSectionGradingScaleGroup = function (sectionID, configID)
        {
            $.ajax({
                url: skyward.global.virtualDir + "Scheduling/Section/SectionGradingScaleGroupDelete/" + sectionID,
                type: "POST",
                dataType: "JSON",
                success: function (data)
                {
                    if (data.success)
                    {
                        skyward.window.loadContent("full", "Gradebook", "ConfigEntityGroupYear", "Details", configID, data);
                    }
                    else
                    {
                        $(".error-list").html("<li class='error-list'>" + data.errors + "</li>");
                    }
                }
            });
        };

        var updateIsMissingCount = function (assignmentCounts)
        {
            for (var key in assignmentCounts)
            {
                if (!assignmentCounts.hasOwnProperty(key))
                {
                    continue;
                }

                var missingAssignmentSelector = '.missingAssignmentCountDiv[data-student-section-id="' + key + '"]';
                var unscoredPastDueAssignmentSelector = '.unscoredPastDueAssignmentCountDiv[data-student-section-id="' + key + '"]';

                var missingAssignmentAnchor = $(missingAssignmentSelector).find('a');
                var missingAssignmentTextSpan = missingAssignmentAnchor.find('.anchorText');
                var unscoredPastDueAssignmentAnchor = $(unscoredPastDueAssignmentSelector).find('a');
                var unscoredPastDueAssignmentTextSpan = unscoredPastDueAssignmentAnchor.find('.anchorText');

                var counts = assignmentCounts[key];
                var missingAssignmentCount = counts.missingAssignmentCount;
                var unscoredPastDueAssignmentCount = counts.unscoredPastDueAssignmentCount;

                missingAssignmentTextSpan.html(missingAssignmentCount);
                unscoredPastDueAssignmentTextSpan.html(unscoredPastDueAssignmentCount);

                if (missingAssignmentCount == 0)
                {
                    missingAssignmentAnchor.addClass('hidden');
                }
                else
                {
                    missingAssignmentAnchor.removeClass('hidden');
                }
                if (unscoredPastDueAssignmentCount == 0)
                {
                    unscoredPastDueAssignmentAnchor.addClass('hidden');
                }
                else
                {
                    unscoredPastDueAssignmentAnchor.removeClass('hidden');
                }
            }
        };

        var updateAttemptCount = function (affectedStudentAssignments, createdStudentAssignments, isUndo, manager)
        {
            for (var i = 0; i < affectedStudentAssignments.length; i++)
            {
                performUpdateAttemptCount(affectedStudentAssignments[i]);
            }

            for (var i = 0; i < createdStudentAssignments.length; i++)
            {
                performUpdateAttemptCount(createdStudentAssignments[i]);
            }

            function performUpdateAttemptCount(studentAssignment)
            {
                var attemptCountAnchor = $('.attemptCount[data-studentsectionid="' + studentAssignment.studentSectionId + '"][data-assignmentid="' + studentAssignment.assignmentId + '"]');
                var attemptCountTextSpan = attemptCountAnchor.find('.anchorText');

                if (attemptCountTextSpan.length > 0 && attemptCountTextSpan[0].innerText != studentAssignment.attemptCount)
                {
                    var parentCell = attemptCountAnchor.parents('td.gradesheetAttemptsColumn.assignmentCell');
                    manager.updateChangedClass(parentCell, isUndo, studentAssignment);
                }

                attemptCountTextSpan.html(studentAssignment.attemptCount);

                if (studentAssignment.attemptCount == 0)
                {
                    attemptCountAnchor.addClass('hidden');
                }
                else
                {
                    attemptCountAnchor.removeClass('hidden');
                }
            }
        };

        var completedGradingPeriod = function (event)
        {
            var element = $(this);
            var message = "Grade changes have been marked completed.";
            var options =
            {
                anchorTo: element,
                id: "CompletedGradingPeriodPopup"
            };

            skyward.modalLayer.showInformationDialog('Completed Grading Period', message, null, options);

            event.stopPropagation();
        };

        var unscoredPastDueAssignments = function (event)
        {
            var element = $(this);
            var data = element.data();
            var message = data.message;
            var options =
            {
                anchorTo: element,
                id: "UnscoredPastDueAssignments"
            };

            skyward.modalLayer.showInformationDialog('Unscored Past Due Assignments', message, null, options);

            event.stopPropagation();
        };

        var roundedAdjustedWeightFormula = function (event)
        {
            var button = $(this);
            var options =
            {
                anchorTo: button
            };

            var popupContent = "";

            if (button.data())
            {
                if (button.data("roundbucketpercentforcalculation"))
                {
                    popupContent += '<span class="help" >The percentage used in the adjusted weight formula has been rounded.</span>';
                }
                if (button.data("capweightedcategoriesat100percent"))
                {
                    popupContent += '<span class="help" >The percent earned used in the adjusted weight formula has been capped at 100%.</span>';
                }
            }

            skyward.modalLayer.showInformationDialog('About This Calculation', popupContent, null, options);

            event.stopPropagation();
        };

        var studentGradeBucketIsAdminOverride = function (event)
        {
            var button = $(this);
            var studentGradeBucketID = button.data("studentGradeBucketId") != null ? button.data("studentGradeBucketId") : button.parents('.gradeBucketCell').data('studentGradeBucketId');
            var studentGradeBucketIDHash = button.data("studentGradeBucketIdHash");
            var sectionID = button.data("sectionId") != null ? button.data("sectionId") : $('#Gradebook').data('sectionid');
            var isAdminOverride = button.data("isAdminOverride");
            var hasGradeChangeRequests = button.data("hasGradeChangeRequests");
            var lockedForClassRank = button.data("lockedForClassRank");
            var classRankMessage = button.data("classRankMessage");
            var hasUnscoredRequiredFeederBucket = button.data("hasUnscoredRequiredFeederBucket");
            var isTransferBucket = button.data("isTransferBucket");
            var gradeChangeRequestExists = button.data("gradeChangeRequestExists");
            var portal = button.data("currentPortal");

            event.stopPropagation();
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/IsAdminOverridePopup" + portal,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data:
                {
                    studentGradeBucketID: studentGradeBucketID,
                    studentGradeBucketIDHash: studentGradeBucketIDHash,
                    sectionID: sectionID,
                    isAdminOverride: isAdminOverride,
                    lockedForClassRank: lockedForClassRank,
                    classRankMessage: classRankMessage,
                    hasUnscoredRequiredFeederBucket: hasUnscoredRequiredFeederBucket,
                    hasGradeChangeRequests: hasGradeChangeRequests,
                    gradeChangeRequestExists: gradeChangeRequestExists,
                    isTransferBucket: isTransferBucket
                },
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Grade Information", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var studentGradeBucketHasTransferGrade = function (event)
        {
            var button = $(this);
            var studentGradeBucketID = button.data("studentGradeBucketId") != null ? button.data("studentGradeBucketId") : button.parents('.gradeBucketCell').data('studentGradeBucketId');
            var studentGradeBucketIDHash = button.data("studentGradeBucketIdHash");
            var sectionID = button.data("sectionId") != null ? button.data("sectionId") : $('#Gradebook').data('sectionid');
            var isTransferBucket = button.data("isTransferBucket");
            var portal = button.data("currentPortal");

            event.stopPropagation();
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/HasTransferGradePopup" + portal,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data:
                {
                    studentGradeBucketID: studentGradeBucketID,
                    studentGradeBucketIDHash: studentGradeBucketIDHash,
                    sectionID: sectionID,
                    isTransferBucket: isTransferBucket
                },
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Grade Information", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var gradingPeriodUnlocked = function (event)
        {
            var element = $(this);
            var data = element.data();
            var message = "<div class='gradebookInformationPopup'><div>This Grading Period has been unlocked for grade changes.</div>";
            var title = 'Unlocked Grading Period';
            var options =
            {
                anchorTo: element,
                id: 'UnlockedGradingPeriodPopup'
            };

            if (data.useSnapshotGrade.toLowerCase() == "true" && data.snapshotGradeExtendedEndDate)
            {
                message += "<div class='sectionHeader'><h3 class='sectionHeader__text'>Snapshot Grade Information</h3></div>"
                    + "<div>" + data.gradeBucketLabel + " has a <span class='boldFont'>snapshot</span> grade</div> "
                    + "<div> Snapshot grade for " + data.gradeBucketLabel + (data.isPastTense ? " was" : " will be") + " taken on " + data.snapshotGradeExtendedEndDate + "</div>";
            }
            message += "</div>";

            skyward.modalLayer.showInformationDialog(title, message, null, options);
            event.stopPropagation();
        };

        var showTermAdjustmentInfo = function ()
        {
            var button = $(this);

            var action = $("#" + BROWSE_NAME).data().isTeacherTracker.toString().toLowerCase() == "true" ? "TermAdjustedStudentPopupTeacherTracker" : "TermAdjustedStudentPopup";
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: button.data(),
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var options =
                        {
                            anchorTo: button
                        };
                        skyward.modalLayer.showInformationDialog("Student Enrollment Dates", returnData.htmlValue.Content, null, options);
                    }
                }
            });
        };

        var getAverageDiv = function (avgPercent, avgPoints, usePoints)
        {
            if (usePoints.toString() == true.toString())
            {
                return "<div>Avg:</div>" +
                    "<div class='gradebookAverageScoreDiv'><span class='boldFont'>" + avgPoints.toFixed(2) + " pts</span></div>";
            }
            else if (avgPercent != null && avgPercent != "")
            {
                return "<div>Avg:</div>" +
                    "<div class='gradebookAverageScoreDiv'><span class='boldFont'>" + avgPercent + "%</span></div>";
            }
            else
            {
                return "<div class='gradebookAverageScoreDiv'>Avg: <span class='boldFont'></span></div>";
            }
        };

        var updateGradingPeriodGradeBucketAverages = function (gradingPeriodGradeBucketAverages)
        {
            $.each(gradingPeriodGradeBucketAverages, function (key, value)
            {
                var displayMessage = getAverageDiv(value.AveragePercent, value.AveragePoints, value.UsePoints);

                var className = "gradingPeriodGradeBucket" + key + "AverageHeaderCell";
                $("." + className).each(function ()
                {
                    var div = $(this).find("div").get(0);
                    if (div)
                    {
                        div.innerHTML = displayMessage;
                    }
                });
            });
        };

        var updateStudentGradeBucketChildRecordAverages = function (studentGradeBucketChildRecordAverages, objectType)
        {
            $.each(studentGradeBucketChildRecordAverages, function (gpgbID, innerDictionary)
            {
                $.each(innerDictionary, function (key, value)
                {
                    var displayMessage = getAverageDiv(value.AveragePercent, value.AveragePoints, value.UsePoints);

                    var className = objectType + gpgbID + "-" + key + "AverageHeaderCell";
                    $("." + className).each(function ()
                    {
                        var div = $(this).find("div").get(0);
                        if (div)
                        {
                            div.innerHTML = displayMessage;
                        }
                    });
                });
            });
        };

        var updateAssignmentAverages = function (assignmentAverages)
        {
            $.each(assignmentAverages, function (key, value)
            {
                var percentOrPoints = "";
                if (value.UsePoints.toString() == true.toString())
                {
                    var averagePoints = value.AveragePoints ? value.AveragePoints.toFixed(2) + " pts" : "";
                    percentOrPoints = "<div>Avg: <span class='boldFont'>" + averagePoints + "</span></div>";
                }
                else if (value.AveragePercent != null && value.AveragePercent != "")
                {
                    percentOrPoints = "<div>Avg: <span class='boldFont'>" + value.AveragePercent + "%</span></div>";
                }
                else
                {
                    percentOrPoints = "<div>Avg: <span class='boldFont'></span></div>";
                }

                var displayMessage = percentOrPoints + "<div class='gradebookAverageScoreDiv'>Avg Score: <span class='boldFont'>" + value.AverageScore + "</span></div>";
                var className = "assignment" + key + "AverageHeaderCell";
                var div = $("." + className).find("div").get(0);
                if (div)
                {
                    div.innerHTML = displayMessage;
                }
            });
        };


        var studentGradeBucketIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketIndicators");
        };

        var studentGradeBucketSubjectIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketSubjectIndicators");
        };

        var studentGradeBucketAcademicStandardIndicatorPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetStudentGradeBucketAcademicStandardIndicators");
        };

        var assignmentHeaderIndicatorsPopup = function (event)
        {
            getIndicatorPopup(event, $(this), "GetAssignmentHeaderIndicators", "Assignment Information", false)
        };

        var getIndicatorPopup = function (event, button, actionPrefix, popupHeader, needAnchor)
        {
            if (button.find("a:visible").length < 1 && needAnchor !== false)
            {
                return;
            }

            event.stopPropagation();

            var cell = button.closest('td');

            var localGradebookBrowse = $('#' + BROWSE_NAME);
            var localGradebookData = localGradebookBrowse.data();

            var data = cell.data();
            data.classGroupID = localGradebookData.classGroupId;

            var studentGroupData = {};
            var studentGroupIndicators = cell.find('.studentGroupColorStrip');
            if (studentGroupIndicators.length > 0) {
                studentGroupIndicators.each(function () {
                    var indicatorData = $(this).data();
                    studentGroupData[indicatorData.name] = indicatorData.color;
                })
            }
            data.studentGroupData = JSON.stringify(studentGroupData);

            var action = localGradebookData.isTeacherTracker.toString().toLowerCase() == "true" ? actionPrefix + "TeacherTracker" : actionPrefix;

            buildIndicatorPopup(data, action, button, popupHeader);
        };

        var buildIndicatorPopup = function (data, action, anchorTo, popupHeader)
        {
            return $.ajax({
                url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: data,
                success: function (returnData)
                {
                    if (returnData.success == false && returnData.popupHTML)
                    {
                        checkAjaxResponseForErrors(returnData);
                    }
                    else
                    {
                        var buttons = [];
                        var closeButton = { id: "closeStudentGradeBucketIndicatorPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
                        if (returnData.requiresSave)
                        {
                            buttons.push({
                                id: "saveStudentGradeBucketIndicatorPopup", text: "Save", click: function ()
                                {
                                    var hideTransferRunIndicator = skyward.controls.getValue(dialog.content.find(".hideTransferGradeRunCheckbox"));
                                    $.ajax({
                                        url: skyward.global.virtualDir + "Gradebook/Gradebook/SaveStudentGradeBucketIndicators",
                                        type: "POST",
                                        dataType: "JSON",
                                        data:
                                        {
                                            StudentGradeBucketID: data.studentGradeBucketId,
                                            HideTransferIndicator: hideTransferRunIndicator
                                        },
                                        success: function (saveReturnData)
                                        {
                                            if (saveReturnData.success == false && saveReturnData.popupHTML)
                                            {
                                                checkAjaxResponseForErrors(saveReturnData);
                                            }
                                            else if (hideTransferRunIndicator)
                                            {
                                                anchorTo.addClass("hiddenTransferGradeRun");
                                            }
                                            else
                                            {
                                                anchorTo.removeClass("hiddenTransferGradeRun");
                                            }
                                        }
                                    });
                                    dialog.close();
                                }, icon: "Save"
                            });
                            closeButton.text = "Cancel";
                            closeButton.icon = "Cancel";
                        }
                        buttons.push(closeButton);

                        var dialog = skyward.modalLayer.showDialog(popupHeader != null ? popupHeader : 'Student Grade Information', returnData.html, buttons, { anchorTo: anchorTo });
                    }
                }
            });
        };

        $('body').on('WorkflowCompleted.Gradebook.StudentSectionNote.Add', function ()
        {
            var gradebook = $('#Gradebook');

            if (gradebook.length == 0)
            {
                return;
            }

            var gradebookData = gradebook.data();
            var sectionID = gradebookData.sectionid;

            $.ajax({
                url: skyward.global.virtualDir + "Gradebook/StudentSectionNote/GetStudentSectionsThatHaveNotes",
                type: "POST",
                dataType: "JSON",
                activityIndicator: { silent: true },
                data: gradebookData,
                success: function (data)
                {
                    for (var i = 0; i < data.studentSectionIDs.length; i++)
                    {
                        var studentSectionID = data.studentSectionIDs[i];
                        var noteButtonSelector = '.studentSectionNoteButton[data-student-section-id="' + studentSectionID + '"]';
                        var noteButton = $(noteButtonSelector);
                        noteButton.removeClass('displayNone');
                        noteButton.parent().addClass('buttonsVisible');
                    }
                }
            });
        });

        var initProgressReportSelector = function (selector)
        {
            $(selector).find('#ProgressReportStudentSelector').on('change', function ()
            {
                var eel = $(this);
                var isTeacherTracker = eel.data().isTeacherTracker;
                var id = skyward.controls.getValue(eel);
                skyward.window.checkLoadContent('full', 'Gradebook', 'ProgressReport', isTeacherTracker.toString().toLowerCase() == "true" ? 'TeacherTrackerDetails' : 'Details', id);
            });
        };

        var showGradebookLoadTimes = function ()
        {
            var message = "";
            var browseStats = gradebookLoadTimes;

            if (browseStats == null)
            {
                message = "No browse load times available.";
            }
            else
            {
                var gradebookStatsLabels = Object.keys(browseStats);
                for (var i = 0; i < gradebookStatsLabels.length; i++)
                {
                    var label = gradebookStatsLabels[i];
                    message += label + ": " + gradebookLoadTimes[label] + "ms <br/>";
                }
            }
            skyward.modalLayer.showDialog("Gradebook Load Times", message, [{ text: "OK", "icon": "Check" }]);
        };

        skyward.gradebook.viewStudentSchedule = function (module, object, action)
        {
            var button = $(this);
            var data = button.data();

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + module + '/' + object + '/' + action,
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: data
                });
            };

            var resizeStudentSchedulePopup = function (dialog)
            {
                dialog.animateModalContents();
            };

            var options =
            {
                draggable: true,
                closeOnClick: false,
                closeOnEscape: false
            };
            var title = data.studentName ? data.studentName + " - Schedule With Grades" : "Student Schedule With Grades";
            var dialog = skyward.modalLayer.showInformationDialog(title, buildPopup, [{ text: "Ok", icon: "Check" }], options);
            $(dialog).find('.browseBody').on("browseLoaded", function ()
            {
                resizeStudentSchedulePopup(dialog);
            });

            return dialog;
        };

        var viewStudentSchedule = function ()
        {
            var gradebookbrowse = $("#Gradebook");
            var gradebookbrowseData = gradebookbrowse.data();
            var screen = gradebookbrowseData.isTeacherTracker.toString().toLowerCase() == "true" ? "StudentScheduleWithGradesTeacherTracker" : "StudentScheduleWithGrades";
            skyward.gradebook.viewStudentSchedule.bind(this, "Gradebook", "Gradebook", screen)();
        };

        var copyMatchingTransferAssignments = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferAssignmentDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();
            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Gradebook/Assignment/CopyMatchingTransferAssignments" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        if (!data.matchingScores || $.isEmptyObject(data.matchingScores))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Assignments", "<span>There were no valid matching assignments found to copy from.</span>");
                            return;
                        }

                        $.each(data.matchingScores, function (key, value)
                        {
                            var assignmentScoreElement = $("#" + key);

                            if (assignmentScoreElement.length)
                            {
                                var originalValue = skyward.controls.getValue(assignmentScoreElement);

                                if (typeof (originalValue) == "boolean")
                                {
                                    value = (value === true || value === "true" || value === "True");
                                }

                                if (originalValue != value)
                                {
                                    flashUpdateCell(assignmentScoreElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                }
                                skyward.controls.setValue(assignmentScoreElement, value);
                            }
                        });
                    }
                });
        };

        var clearTransferValues = function ()
        {
            var button = $(this);
            var destinationBrowse = button.parents(".transferGradeSplitBrowse").find(".transferDestinationBrowse");

            destinationBrowse.find("input.clearable, .codeEEL.clearable, .eELInputContainer.clearable > input").each(function ()
            {
                var input = $(this);
                var value = skyward.controls.getValue(input);
                skyward.controls.clearValue(input);

                if (value != null && value != "" && value != false)
                {
                    flashUpdateCell(input.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                }
            });
        };

        var flashUpdateCell = function (cell, flashUpdateCellColor, flashUpdateCellDuration)
        {
            if (cell.is(':animated')) {
                return;
            }

            var oldColor = cell.css("background-color");
            cell.css("background-color", flashUpdateCellColor);
            cell.animate({ backgroundColor: oldColor }, { duration: flashUpdateCellDuration });
        };

        var copyMatchingTransferClosedBuckets = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferClosedBucketDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            if (destinationBrowseData.sourceClassOod && destinationBrowseData.sourceClassOod.toString().toLowerCase() === "true")
            {
                return copyMatchingOutOfDistrictTransferClosedBuckets.apply($(this));
            }

            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingTransferClosedBuckets" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Closed Terms", "<span>There were no valid matching closed terms found to copy from.</span>");
                            return;
                        }

                        var updateCounts = 0;
                        $.each(data.matchingValues, function (key, value)
                        {
                            var closedBucketValueElement = destinationBrowse.find("td input[data-grade-bucket-id='" + key + "']");
                            if (!closedBucketValueElement.length)
                            {
                                closedBucketValueElement = destinationBrowse.find("td input[data-grade-bucket-label='" + value.GradeBucketLabel + "']");
                            }

                            if (closedBucketValueElement.length)
                            {
                                var currentValue = skyward.controls.getValue(closedBucketValueElement);

                                skyward.controls.setValue(closedBucketValueElement, value.PercentWithAdjustment);
                                if (currentValue != value.PercentWithAdjustment)
                                {
                                    flashUpdateCell(closedBucketValueElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                }
                                updateCounts++;
                            }
                        });

                        if (updateCounts < 1)
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Closed Terms", "<span>There were no valid matching closed terms found to copy from.</span>");
                        }
                    }
                });
        };

        var copyMatchingTransferSubjectStandards = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferSubjectStandardDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            var postData =
            {
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId,
                gradingPeriodGradeBucketIDs: JSON.stringify(destinationBrowseData.gradingPeriodGradeBucketIds)
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingTransferSubjectStandards" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data) {
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues)) {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching subject / academic standards found to copy from.</span>");
                            return;
                        }

                        var updateCounts = 0;
                        $.each(data.matchingValues, function (key, value) {
                            var gradeBucketID = key;

                            if (value && value != null)
                            {
                                $.each(value, function (typeCode, innerValue)
                                {
                                    $.each(innerValue, function (curriculumElementForeignKey, curriculumElementValue)
                                    {
                                        var newGradingScaleGroupGradeMarkID = curriculumElementValue.Item1;

                                        var masteryElement = destinationBrowse.find("td input:checkbox[data-grade-bucket-id='" + gradeBucketID + "'][data-calculation-group-curriculum-element-foreign-key-id='" + curriculumElementForeignKey + "'][data-calculation-group-curriculum-element-type='" + typeCode + "']");
                                        if (masteryElement.length > 0)
                                        {
                                            var newValue = (newGradingScaleGroupGradeMarkID != null && newGradingScaleGroupGradeMarkID != "");

                                            if (newValue || newValue == "true") //If a standard was mastered in the destination but not source, we don't want to clear that out.
                                            {
                                                if (newValue != skyward.controls.getValue(masteryElement))
                                                {
                                                    flashUpdateCell(masteryElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                                }
                                                skyward.controls.setValue(masteryElement, newValue);
                                                updateCounts++;
                                            }
                                        }
                                        else
                                        {
                                            var newGradingScaleGroupGradeMarkID = curriculumElementValue.Item1;
                                            var newGradeMarkCode = curriculumElementValue.Item2;

                                            var destinationElement = destinationBrowse.find("td div[data-grade-bucket-id='" + gradeBucketID + "'][data-calculation-group-curriculum-element-foreign-key-id='" + curriculumElementForeignKey + "'][data-calculation-group-curriculum-element-type='" + typeCode + "']");
                                            if (destinationElement.length)
                                            {
                                                var currentValue = skyward.controls.getValue(destinationElement);
                                                if (currentValue == '')
                                                {
                                                    currentValue = null;
                                                }
                                                if (newGradingScaleGroupGradeMarkID != currentValue)
                                                {
                                                    flashUpdateCell(destinationElement.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                                                }
                                                skyward.controls.setValue(destinationElement.find(".codeEELValue"), newGradingScaleGroupGradeMarkID, true);
                                                skyward.controls.setValue(destinationElement.find(".codeEELCode"), newGradeMarkCode, true);
                                                updateCounts++;
                                            }
                                        }
                                    });
                                });
                            }
                        });

                        if (updateCounts < 1) {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching subject / academic standards found to copy from.</span>");
                        }
                    }
                });
        };

        var copyMatchingTransferClosedGradeCategories = function ()
        {
            var updateCount = 0;

            $(".destinationClosedBucketCategoriesTemplate").find(".browse").each(function ()
            {
                var browse = $(this);
                var browseData = browse.data();

                browse.find("input.number").each(function ()
                {
                    var destinationCategory = $(this);
                    var destinationCategoryID = destinationCategory.attr("id").split("-")[2];

                    var sourceBucketBrowse = $(".sourceClosedBucketCategoriesTemplate .browse[data-grade-bucket-id='" + browseData.gradeBucketId + "']");

                    if (sourceBucketBrowse.length > 0)
                    {
                        var sourceCategory = sourceBucketBrowse.find("td[data-categoryid='" + destinationCategoryID + "']");

                        if (sourceCategory.length > 0)
                        {
                            var currentValue = skyward.controls.getValue(destinationCategory);
                            var newValue = sourceCategory.find("div").html();
                            if (currentValue != newValue)
                            {
                                flashUpdateCell(destinationCategory.parents("td").first(), FLASH_COLOR, GRADEBOOK_EXPAND_ANIMATION_DURATION);
                            }
                            skyward.controls.setValue(destinationCategory, newValue);
                            updateCount++;
                        }
                    }
                });
            });

            if (updateCount == 0)
            {
                skyward.modalLayer.showInformationDialog("No Matching Categories", "<span>There were no valid matching categories found to copy from.</span>");
            }
        };

        var copyMatchingOutOfDistrictTransferClosedBuckets = function ()
        {
            var destinationBrowse = $(this).parents(".transferGradeSplitBrowse").find(".transferClosedBucketDestinationBrowse");
            var destinationBrowseData = destinationBrowse.data();

            var postData =
            {
                gradingPeriodGradeBucketID: destinationBrowseData.gradingPeriodGradeBucketId,
                sourceStudentSectionID: destinationBrowseData.sourceStudentSectionId,
                studentSectionID: destinationBrowseData.studentSectionId,
                isPartiallyEnrolled: destinationBrowseData.partiallyEnrolled
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/Assignment/CopyMatchingOutOfDistrictTransferClosedBuckets" + destinationBrowseData.portal,
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        var matchingCount = 0;
                        if (!data.matchingValues || $.isEmptyObject(data.matchingValues))
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching grades found to copy from.</span>");
                            return;
                        }

                        $.each(data.matchingValues, function (key, value)
                        {
                            var closedBucketGradeMarkValueElement = destinationBrowse.find(".codeEEL[data-grade-bucket-id='" + key + "']");
                            var closedBucketPercentValueElement = destinationBrowse.find(".studentGradeBucketPercentScore[data-grade-bucket-id='" + key + "']");

                            if (closedBucketGradeMarkValueElement.length)
                            {
                                matchingCount++;
                                skyward.controls.setValue(closedBucketGradeMarkValueElement, value.Item1);
                                closedBucketGradeMarkValueElement.trigger('eelComplete');
                            }
                            if (closedBucketPercentValueElement.length)
                            {
                                matchingCount++;
                                skyward.controls.setValue(closedBucketPercentValueElement, value.Item2);
                            }
                        });

                        if (matchingCount == 0)
                        {
                            skyward.modalLayer.showInformationDialog("No Matching Grades", "<span>There were no valid matching grades found to copy from.</span>");
                            return;
                        }
                    }
                });
        };

        var updatePercentFromGradeMarkDefaultPercent = function (element, basePercentName)
        {
            var codeEEL = element;
            var codeEELID = codeEEL.attr('id');
            var gradingPeriodGradeBucketID = codeEELID.split('-')[1];
            var percentField = $('#' + basePercentName + '-' + gradingPeriodGradeBucketID);

            var codeEELValue = codeEEL.find(".codeEELValue");
            var codeEELValueData = codeEELValue.data();
            var postData = { "securityHash": codeEELValueData.securityHash };

            return $.ajax(
                {
                    url: skyward.global.virtualDir + codeEELValueData.area + "/" + codeEELValueData.controller + "/codeeel/" + codeEELValue.val(),
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    activityIndicator: { silent: true },
                    success: function (data)
                    {
                        codeEEL.data("additionalFields", data.additionalFields);

                        if (percentField)
                        {
                            var additionalFields = codeEEL.data('additionalFields');

                            if (additionalFields)
                            {
                                var defaultPercent = additionalFields['DefaultCalculationPercent'];
                                percentField.val(parseFloat(defaultPercent).toFixed(2));
                            }
                            else
                            {
                                skyward.controls.clearValue(percentField);
                            }
                        }
                    }
                });
        };

        var checkPopupSaveButton = function (htmlData, id)
        {
            var hasEditableInput = false;
            if (htmlData)
            {
                $(htmlData).find("input:enabled").each(function ()
                {
                    if ($(this).attr("type") != "hidden")
                    {
                        hasEditableInput = true;
                    }
                });

                if (!hasEditableInput)
                {
                    $("#" + id).addClass("hidden");
                }
            }
        };

        var getUnlockedRowFromCell = function (cell)
        {
            var row = cell.parents("tr").first();

            if (row.parents(".lockedBrowseBody").length > 0)
            {
                row = $("#" + BROWSE_NAME + "_unlockedRow" + row.data().row);
            }
            return row;
        };

        var progressReportSubHeaderPopup = function ()
        {
            var button = $(this);
            var data = button.data();

            var message = '<div>';
            if (data.adminOverrideMessage != "")
            {
                message += addMessageToContent(data.adminOverrideMessage);
            }
            if (data.snapshotGradeMessage != "")
            {
                message += addMessageToContent(data.snapshotGradeMessage);
            }
            if (data.roundedGradeMessage != "")
            {
                message += addMessageToContent(data.roundedGradeMessage);
            }
            if (data.capCalculationMessage != "")
            {
                message += addMessageToContent(data.capCalculationMessage);
            }
            if (data.gradebookLockMessage != "")
            {
                message += addMessageToContent(data.gradebookLockMessage);
            }
            if (data.recalculateGradebookMessage != "")
            {
                message += addMessageToContent(data.recalculateGradebookMessage);
            }
            if (data.grademarkOverrideMessage != "")
            {
                message += addMessageToContent(data.grademarkOverrideMessage);
                if (data.grademarkOverrideComment != "")
                {
                    message += addMessageToContent("Grade mark override comment: ", "progressReportInformationPopupFieldName");
                    message += addMessageToContent(data.grademarkOverrideComment, "");
                }
            }
            if (data.percentAdjustmentMessage != "")
            {
                message += addMessageToContent(data.percentAdjustmentMessage);
                message += addMessageToContent("Percent adjustment comment: ", "progressReportInformationPopupFieldName");
                message += addMessageToContent(data.percentAdjustmentComment, "");
            }
            if (data.gradeChangeDeniedMessage != "")
            {
                message += addMessageToContent(data.gradeChangeDeniedMessage);
            }
            if (data.subjectiveMessage != "")
            {
                message += addMessageToContent(data.subjectiveMessage);
            }
            if (data.notGradedMessage != "")
            {
                message += addMessageToContent(data.notGradedMessage);
            }
            if (data.minimumPercentMessage != "")
            {
                message += addMessageToContent(data.minimumPercentMessage);
            }
            if (data.innerBucketHasGradeChangeMessage && data.innerBucketHasGradeChangeMessage != "")
            {
                message += addMessageToContent(data.innerBucketHasGradeChangeMessage);
            }
            message += '</div>';

            var closeButton = { id: "closeProgressReportInformationPopup", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
            var options =
            {
                anchorTo: button
            };

            var dialog = skyward.modalLayer.showDialog("Student Grade Information", message, [closeButton], options);
        };

        var addMessageToContent = function (messageToAdd, otherClassName)
        {
            var className = typeof otherClassName === "undefined" ? "progressReportInformationPopupSpan" : otherClassName;
            return '<span class="' + className + '"><span>' + messageToAdd + '</span></span>';
        };

        var validateCopyAssignmentCheckbox = function ()
        {
            var input = $(this);
            var inputId = input.attr("id");
            var inputChecked = input.is(":checked");
            var browse = $("#SourceAssignments");
            var id = inputId.split("-")[1] || "";
            var checkboxes;

            switch (inputId.split(/[-_]/)[0])
            {
                case "CopyAssignment":
                    checkboxes = browse.find('[id^="SyncAssignment-' + id + '"]');
                    checkboxes.each(function ()
                    {
                        var checkbox = $(this);
                        skyward.controls.setValue(checkbox, inputChecked);
                    });
                    break;
                case "SyncAssignment":
                    if (inputChecked)
                    {
                        checkboxes = browse.find('[id^="CopyAssignment-' + id + '"]');
                        checkboxes.each(function ()
                        {
                            var checkbox = $(this);
                            skyward.controls.setValue(checkbox, true);
                        });
                    }
                    break;
            }
        };

        var updateClosedGradingPeriodGradeChange = function ()
        {
            var button = $(this);
            var data = button.data();
            var rowNumber = button.parents('.browseRow').find('.browseRowOptions').data('row');
            var postData =
            {
                id: data.id,
                reviewed: data.reviewed
            };

            $.ajax(
                {
                    url: skyward.global.virtualDir + "GradeBook/ClosedGradingPeriodStudentGradeBucketChange/UpdateClosedGradingPeriodStudentGradeBucketChangeStatus",
                    type: "POST",
                    dataType: "JSON",
                    data: postData,
                    success: function (data)
                    {
                        if (data.Success)
                        {
                            var browseId = 'CGPGCClosedGradingPeriodStudentGradeBucketChanges';
                            var browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }

                            browseId = 'ClosedGradingPeriodStudentGradeBucketChanges';
                            browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }

                            browseId = 'detailsPanel_ClosedGradingPeriodStudentGradeBucketChanges';
                            browse = skyward.browse.browseList[browseId];
                            if (browse)
                            {
                                skyward.browse.setCurrentRecord(browseId, rowNumber, { loadRelatedBrowses: false });
                                skyward.browse.setCurrentBrowseName(browseId);
                                skyward.browse.get(browseId, browse.data);
                            }
                        }
                    }
                });
        };

        var getSectionIDFromCell = function (cell)
        {
            if (cell.parents(".studentAssignmentMobileCard").length > 0)
            {
                return cell.parents(".studentAssignmentMobileCard").data().sectionId;
            }
            var parent = cell.parents("tr").first();
            if (parent != null && parent.length > 0)
            {
                return parent.data().sectionId;
            }
            return null;
        };

        var getRepresentedAssignmentID = function (assignmentId, sectionId)
        {
            var headerCell = $("#assignment" + assignmentId + "HeaderCell");
            var headerCellData = headerCell.data();
            if (headerCellData && headerCellData.representedAssignmentIds && headerCellData.representedAssignmentIds[sectionId])
            {
                return headerCellData.representedAssignmentIds[sectionId];
            }

            return null;
        };

        var getDriverAssignmentID = function (assignmentId)
        {
            if (assignmentId == null)
            {
                return null;
            }

            var driveHeaderCell = $("#assignment" + assignmentId + "HeaderCell");

            if (driveHeaderCell.length == 0)
            {
                driveHeaderCell = $(".syncedAssignment" + assignmentId + "HeaderCell");
            }

            if (driveHeaderCell.length == 0)
            {
                return null;
            }
            return driveHeaderCell.data().assignmentid;
        };

        var resizeLockedBrowseBodyForHorizontalScrollBar = function ()
        {
            skyward.browse.resizeLockedBrowseBodyForHorizontalScrollBar(
                {
                    unlockedBody: $('#' + BROWSE_NAME + '_unlockedBody'),
                    lockedBody: $('#' + BROWSE_NAME + '_lockedBody'),
                });
        };

        var getClassSelectorFromAllClassesOnElement = function (element)
        {
            var classSelector = "";
            var classes = element.attr("class").split(' ');

            $.each(classes, function (k, v)
            {
                if (v != null && v != "" && v != " ")
                {
                    classSelector += "." + v;
                }
            });

            return classSelector;
        };

        var mobileAssignmentHeaderIndicatorsPopup = function ()
        {
            if (!skyward.global.mobileAccess)
            {
                return;
            }

            var button = $(this);
            var indicatorsContainer = button.find(".assignmentHeaderIndicators");

            var data =
            {
                assignmentID: indicatorsContainer.data("assignmentid"),
                isMobile: true
            };

            buildIndicatorPopup(data, "GetAssignmentHeaderIndicators", indicatorsContainer, "Assignment Information");
        };

        var assignmentIndicatorPopup = function ()
        {
            if (!skyward.global.mobileAccess)
            {
                // Currently the assignment indicator popup only works outside of gradebook in mobile
                return;
            }

            var assignmentIndicatorButton = $(this);
            var buttonData = assignmentIndicatorButton.data();

            var showScoreWarning;
            assignmentIndicatorButton.find('.assignmentIndicators').each(function ()
            {
                var span = $(this);
                if (span.hasClass('assignmentIndicatorsFirstRow'))
                {
                    showScoreWarning = !span.hasClass('hiddenWarning');
                }
            });

            var studentAssignmentMobileCard = assignmentIndicatorButton.parents(".studentAssignmentMobileCard");

            var additionalPostData =
            {
                isMissingOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("input.IsMissing")),
                scoreClarifierIDOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("[data-fieldname='ScoreClarifierID']")), //todo: PR 2727610, this will probably change from codeeel to gradebookCodeEEL
                useScoreClarifierOverride: true,
                noCountOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("input.NoCount")),
                commentsOverride: skyward.controls.getValue(studentAssignmentMobileCard.find("[data-fieldname='Comments']")),
                useCommentsOverride: true,
                multipleAttemptsOverride: true
            };

            displayAssignmentIndicatorPopup(assignmentIndicatorButton, buttonData.studentSectionId, buttonData.assignmentId, skyward.controls.getValue(assignmentIndicatorButton.siblings("input.Score")), buttonData.sectionId, buttonData.sectionIdHash, showScoreWarning, null, null, additionalPostData);
        };

        var displayAssignmentIndicatorPopup = function (assignmentIndicatorButton, studentSectionID, assignmentID, score, sectionID, sectionIDHash, showScoreWarning, popupAction, getAdditionalButtons, additionalPostData)
        {
            popupAction = popupAction || "AdvancedStudentAssignmentPopup";

            var data =
            {
                studentSectionID: studentSectionID,
                assignmentID: assignmentID,
                showScoreWarning: showScoreWarning,
                score: score,
                sectionID: sectionID,
                sectionIDHash: sectionIDHash
            };

            if (additionalPostData != null)
            {
                $.extend(data, additionalPostData);
            }

            var buildPopup = function ()
            {
                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + popupAction,
                        type: "POST",
                        dataType: "viewparthtml",
                        activityIndicator: { silent: true },
                        data: data
                    });
            };

            $.when(buildPopup()).done(function (html)
            {
                var additionalButtons = typeof getAdditionalButtons === "function" ? getAdditionalButtons(html) : [];
                var cancelButton = { id: "cancelButton", text: "Cancel", click: function () { dialog.close(); }, icon: "Cancel" };

                var dialog = skyward.modalLayer.showDialog('Student Assignment Information', html, additionalButtons.concat([cancelButton]), { anchorTo: assignmentIndicatorButton });
            });
        };

        var massAssignScoresPopupMobile = function ()
        {
            var element = $(this);
            var data = element.data();
            var postData =
            {
                assignmentID: data.assignmentId
            };

            var popupID = "MassAssignScores";
            var headerText = "Mass Assign Scores";

            var buildPopup = function ()
            {
                return $.ajax({
                    url: skyward.global.virtualDir + "Gradebook/Gradebook/MassAssignScores",
                    type: "POST",
                    dataType: "viewparthtml",
                    activityIndicator: { silent: true },
                    data: postData
                });
            };

            var saveFunc = function ()
            {
                //todo: Auto save? Right now its just going to update dom and make the user click save
            };

            var massAssignHelper = massAssign($("#editStudentAssignments"), $('#MassAssignScores'), "[name = 'massAssignRadio']", saveFunc, mobileUpdateIsMissingValueAndCheckFailingScoreClarifier, null, false);

            var saveButton = { text: "Apply", "click": function () { $.when(massAssignHelper.applyButtonClick.call($(this))).done(function () { dialog.close(); }); }, "icon": "Select", "data": data };
            var closeButton = { text: "Cancel", "click": function () { dialog.close(); }, "icon": "Cancel" };
            var options =
            {
                closeOnEscape: false,
                draggable: true,
                id: popupID
            };

            var dialog = skyward.modalLayer.showDialog(headerText, buildPopup, [saveButton, closeButton], options);

            dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", gradeMarkScoringEelCompleteMassAssign);
            dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);
        };

        var gradeMarkScoringEelCompleteMassAssign = function (event, returnData)
        {
            var input = $(this);

            removeCellErrorClasses(input.parents("td").first(), "noMatch");

            var inputValue = returnData.selectedValueID;

            if (inputValue == "" || inputValue == ".")
            {
                returnData.matchedValue = '*';
            }

            skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);
        };

        var gradeMarkScoringEelComplete = function (event, returnData, gradebook, input)
        {
            removeCellErrorClasses(input.parents("td").first(), "noMatch");

            if (gradebook != null)
            {
                gradebook.saveManager.setDirtyState(false);
            }

            var inputData = input.data();

            var backingPercent = returnData.backingPercent;

            var inputValue = returnData.selectedValueID;

            if (inputValue == null)
            {
                inputValue = "";
            }

            if (backingPercent == null)
            {
                backingPercent = "";
            }

            //use deferred since checkFailingScoreClarifier retrieves advanced cells
            var deferred = $.Deferred();
            if (input.hasClass("gradeMarkScoring") && inputData.originalAssignmentScore != inputValue && !isNaN(backingPercent) && backingPercent !== "")
            {
                if (gradebook != null)
                {
                    deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(inputData.assignmentid, inputData.studentsectionid, null, null, backingPercent);
                }
            }
            else
            {
                deferred.resolve();
            }

            $.when(deferred).done(function ()
            {
                if (gradebook != null)
                {
                    gradebook.completePendingInputScore(input);
                }
                skyward.gradebookcodeeel.setValue(input, returnData.matchedValue, inputValue, true);

                var saveData =
                {
                    assignmentId: inputData.assignmentid,
                    studentSectionId: inputData.studentsectionid,
                    academicStandardId: inputData.academicStandardId,
                    isAvailable: inputData.isAvailable,
                    sectionId: getSectionIDFromCell(input),
                    Score:
                    {
                        displayValue: returnData.matchedValue
                    }
                };
                if (gradebook != null)
                {
                    return gradebook.saveManager.save(saveData);
                }
            });
        };

        var gradeMarkScoringEelFailed = function (event, returnData, input, gradebook)
        {
            input = input ? input : $(this);

            if (gradebook != null)
            {
                gradebook.saveManager.setDirtyState(false);
            }

            var mostRecentDisplayValue = skyward.gradebookcodeeel.getData(input).mostRecentEditableDisplayValue;

            if (mostRecentDisplayValue == null)
            {
                if (input.hasClass("gradeMarkScoring"))
                {
                    mostRecentDisplayValue = input.data().enabledGrademarkValue;
                }
                else
                {
                    mostRecentDisplayValue = input.data().originalValue;
                }
            }
            skyward.controls.setValue(input, mostRecentDisplayValue, true);
            input.parents("td").first().addClass("updated updatedWithErrors noMatch").css({ backgroundColor: '', color: '' });
            if (returnData.success == false && returnData.popupHTML)
            {
                checkAjaxResponseForErrors(returnData);
            }
            //Clear out value and then make cell red. returnData.Errors
        };

        var getPercentEarned = function (pointsEarned, maxScore, percentEarned)
        {
            if (percentEarned != null)
            {
                return percentEarned;
            }
            if (pointsEarned != null && maxScore != null && maxScore != 0)
            {
                var pointsEarnedFloat = parseFloat(pointsEarned);
                var maxScoreFloat = parseFloat(maxScore);
                if (pointsEarnedFloat != null && maxScoreFloat != null)
                {
                    return (pointsEarnedFloat / maxScoreFloat) * 100.0;
                }
            }
            else if (maxScore == 0)
            {
                if (pointsEarned > 0)
                {
                    return 100;
                }
                else if (pointsEarned == 0)
                {
                    return 0;
                }
            }

            return null;
        };

        var mobileUpdateIsMissingValueAndCheckFailingScoreClarifier = function (assignmentID, studentSectionID, pointsEarned, maxScore, percentEarned)
        {
            var input = $(this);
            var inputData = input.data();

            if (maxScore == null)
            {
                maxScore = inputData.maxscore;
            }

            var percentEarnedFloat = getPercentEarned(pointsEarned, maxScore, percentEarned);

            if (percentEarnedFloat == null)
            {
                return;
            }

            var dataObjectViewer = input.parents(".mobileGradebookScoreEntry.dataObjectViewer").find(".mobileGradebookScoreEntryDataContainer");
            var dataObjectViewerData = dataObjectViewer.data();

            //next check if we have a failing grade score clarifier to look at.
            var useFailingScoreClarifier = dataObjectViewerData.usefailingscoreclarifier;
            if (useFailingScoreClarifier !== true)
            {
                return;
            }

            var assignmentFieldset = input.parents('.fieldWrapper.studentAssignmentScore');
            var isMissingPuck = assignmentFieldset.find(".assignmentIndicatorButton:not(.hiddenMissingScore)").find("svg.missingScore.svg, svg.isMissing");

            var scoreChangeAdvancedAssignmentColumnHandler = getScoreChangeAdvancedAssignmentColumnHandler(true);
            scoreChangeAdvancedAssignmentColumnHandler.handleAdvancedAssignmentColumnUpdates(percentEarnedFloat, dataObjectViewerData, studentSectionID, assignmentID, isMissingPuck);
        };

        var getScoreChangeAdvancedAssignmentColumnHandler = function (isMobile)
        {
            var handler =
            {
                requiresIsMissingUpdate: function (percentEarnedFloat, isCurrentlyMissing)
                {
                    return percentEarnedFloat > 0 &&
                        isCurrentlyMissing;
                },
                requiresScoreClarifierUpdate: function (percentEarnedFloat, gradebookBodyData, removeFailingScoreClarifier)
                {
                    var useFailingScoreClarifier = gradebookBodyData.usefailingscoreclarifier;
                    if (useFailingScoreClarifier !== true)
                    {
                        return false;
                    }

                    var failingGradeThresholdPercent = gradebookBodyData.failinggradethresholdpercent;

                    if (percentEarnedFloat == null || isNaN(percentEarnedFloat) || failingGradeThresholdPercent == null)
                    {
                        return false;
                    }
                    percentEarnedFloat = parseFloat(percentEarnedFloat) || 0;
                    failingGradeThresholdPercent = parseFloat(failingGradeThresholdPercent) || 0;

                    if (removeFailingScoreClarifier == true)
                    {
                        return percentEarnedFloat >= failingGradeThresholdPercent;
                    }

                    return percentEarnedFloat < failingGradeThresholdPercent;
                },
                requiresAdvancedAssignmentColumns: function (percentEarnedFloat, gradebookBodyData, isCurrentlyMissing)
                {
                    return handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData) ||
                        handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData, true) ||
                        handler.requiresIsMissingUpdate(percentEarnedFloat, isCurrentlyMissing);
                },
                updateIsMissing: function (studentSectionID, assignmentID, value, suppressChangeEvents)
                {
                    var isMissingField = handler.getMissingField(studentSectionID, assignmentID);
                    if (isMissingField.length)
                    {
                        if (isMobile == true)
                        {
                            isMissingField.data('original-value', value);
                        }
                        skyward.controls.setValue(isMissingField, value, suppressChangeEvents);
                    }
                },
                updateNoCount: function (studentSectionID, assignmentID, value, suppressChangeEvents)
                {
                    var noCountField = handler.getNoCountField(studentSectionID, assignmentID);
                    if (noCountField.length)
                    {
                        if (isMobile == true)
                        {
                            noCountField.data('original-value', value);
                        }
                        skyward.controls.setValue(noCountField, value, suppressChangeEvents);
                    }
                },
                updateFailingScoreClarifier: function (gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, removeFailingScoreClarifier)
                {
                    var scoreClarifierIDFailing = gradebookBodyData.scoreclarifieridfailing;
                    var scoreClarifierFailingIsMissing = gradebookBodyData.scoreclarifierfailingismissing;
                    var scoreClarifierFailingNoCount = gradebookBodyData.scoreclarifierfailingnocount;
                    var scoreClarifierFailingCode = gradebookBodyData.scoreclarifierfailingcode;

                    var scoreClarifierField = $("[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='ScoreClarifierID']");
                    if (scoreClarifierField.length > 0)
                    {
                        if (removeFailingScoreClarifier == true)
                        {
                            var inputToCheckValueOf = scoreClarifierField.find('input.codeEELCode').length > 0 ? scoreClarifierField.find('input.codeEELCode') : scoreClarifierField;
                            if (getInputValue(inputToCheckValueOf) == scoreClarifierIDFailing)
                            {
                                if (isMobile == true)
                                {
                                    scoreClarifierField.data('original-value', '');
                                    var otherInputs = scoreClarifierField.find('input');
                                    otherInputs.data('original-value', '');
                                    skyward.controls.setValue(scoreClarifierField, null, suppressChangeEvents);
                                }
                                else
                                {
                                    skyward.gradebookcodeeel.setValue(scoreClarifierField, null, null, suppressChangeEvents);
                                }
                            }
                            return;
                        }
                        else
                        {
                            if (isMobile == true)
                            {
                                scoreClarifierField.data('original-value', scoreClarifierIDFailing);
                                var otherInputs = scoreClarifierField.find('input');
                                otherInputs.data('original-value', scoreClarifierIDFailing);
                                skyward.controls.setValue(scoreClarifierField, scoreClarifierIDFailing, suppressChangeEvents);
                            }
                            else
                            {
                                skyward.gradebookcodeeel.setValue(scoreClarifierField, scoreClarifierFailingCode, scoreClarifierIDFailing, suppressChangeEvents);
                            }
                        }
                    }

                    if (scoreClarifierFailingIsMissing === true)
                    {
                        var isMissingField = $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='IsMissing']");
                        if (isMissingField.length)
                        {
                            if (isMobile == true)
                            {
                                isMissingField.data('original-value', true);
                            }
                            skyward.controls.setValue(isMissingField, true, suppressChangeEvents);
                        }
                    }

                    if (scoreClarifierFailingNoCount === true)
                    {
                        var noCountField = $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='NoCount']");
                        if (noCountField.length)
                        {
                            if (isMobile == true)
                            {
                                noCountField.data('original-value', true);
                            }
                            skyward.controls.setValue(noCountField, true, suppressChangeEvents);
                        }
                    }
                },
                handleAdvancedAssignmentColumnUpdates: function (percentEarnedFloat, gradebookBodyData, studentSectionID, assignmentID, isMissingPuck, suppressChangeEvents)
                {
                    if (suppressChangeEvents == null)
                    {
                        suppressChangeEvents = false;
                    }

                    if (handler.requiresIsMissingUpdate(percentEarnedFloat, isMissingPuck.length > 0))
                    {
                        handler.updateIsMissing(studentSectionID, assignmentID, false, suppressChangeEvents);
                    }

                    if (handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData))
                    {
                        handler.updateFailingScoreClarifier(gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, false);
                    }
                    else if (handler.requiresScoreClarifierUpdate(percentEarnedFloat, gradebookBodyData, true))
                    {
                        handler.updateFailingScoreClarifier(gradebookBodyData, studentSectionID, assignmentID, suppressChangeEvents, true);
                    }
                },
                getMissingField: function (studentSectionID, assignmentID)
                {
                    return $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='IsMissing']");
                },
                getNoCountField: function (studentSectionID, assignmentID)
                {
                    return $("input[data-studentsectionid='" + studentSectionID + "'][data-assignmentid='" + assignmentID + "'][data-fieldname='NoCount']"); //todo: verify fieldname
                }
            };

            return handler;
        };

        //contentsToUpdateContainer = gradebook.body
        //massAssignContainer = gradebook.massAssign
        //selectedOptionSelector = massAssign.radioSet + ":checked"
        //saveFunc = gradebook.saveManager.save(assignmentsToUpdate)
        //assignmentPostCheckFunc = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier
        var massAssign = function (contentsToUpdateContainer, massAssignContainer, selectedOptionSelector, saveFunc, assignmentPostCheckFunc, gradebook, suppressChangeEvent)
        {
            if (suppressChangeEvent == null)
            {
                suppressChangeEvent = true;
            }

            var button;
            var data;
            var assignmentId;
            var studentGradeBucketID;
            var subjectID;
            var academicStandardID;
            var gradingPeriodGradeBucketID;
            var massAssign =
            {
                options: {
                    get buttons() { return $('.massAssignOptionButton'); },
                    get maxPointsLabel() { return $('#maxPointsForAssignment'); },
                    get allScoresInput() { return $('#allScoresInput'); },
                    get overwriteScoresCheckbox() { return $('#overwriteScoresCheckbox'); },
                    get overwriteScoresCheckboxCopyFromPreviousBucket() { return $('#overwriteScoresCheckboxCopyFromPreviousBucket'); },
                    get assignmentColumnTabColor() { return $('#columnColorTab'); },
                    get adjustAllScoresInput() { return $('#adjustAllScoresInput'); },
                    get adjustAllScoresCheckbox() { return $('#adjustAllScoresCheckbox'); },
                    get closeButton() { return $('#closeMassAssign'); },
                    get applyButton() { return $('#applyMassAssign'); },
                    get actionButtons() { return $('.massAssignActionButton'); },
                    get optionButtons() { return $('.massAssignOptionButton'); },
                    get massAssignSubjectiveGradeMark() { return $('#MassAssignSubjectiveGradeMark'); },
                    get massAssignMasteryGradeMark() { return $('#MassAssignMasteryGradeMark'); },
                    get massAssignBucketSelector() { return $('#MassAssignBucketSelector'); },
                    get assignAllStudentGradeBucketAcademicStandardScores() { return $('#assignAllStudentGradeBucketAcademicStandardScores'); },
                    get copyFromPreviousStudentGradeBucketAcademicStandardScores() { return $('#copyFromPreviousStudentGradeBucketAcademicStandardScores'); },
                    get assignAllScoresGradeMarkScoringInput() { return $('#AssignAllScoresGradeMarkScoringInput'); },
                    get tableRow() { return $('.massAssignRow'); } // locked and unlocked row
                },
                cleanup: function ()
                {
                    massAssign.options.actionButtons.addClass('visibilityHidden');
                },
                focusAndSelect: function (input)
                {
                    input.focus();
                    //Edge does not allow select() in here we can uncomment when this is fixed
                    //input.select();
                },
                applyButtonClick: function ()
                {
                    var deferred = $.Deferred();
                    massAssignContainer = $('#MassAssignScores');
                    var saveButton = $(this);
                    saveButton.addClass('ui-disabled');

                    var selected = skyward.controls.getValue(massAssignContainer.find(selectedOptionSelector));
                    var returnErrors = null;

                    var unbreakableGlass = skyward.modalLayer.newModalLayer(null, null,
                        {
                            closeOnClick: false,
                            closeOnRecordSelected: false,
                            closeOnEscape: false,
                            transparentGlass: true
                        });
                    if (selected.length > 0)
                    {
                        $.when(actions[selected]($(this))).done(function (assignmentsToUpdate, errors)
                        {
                            if (errors && errors.length > 0)
                            {
                                unbreakableGlass.close();
                                returnErrors = errors;
                                saveButton.removeClass('ui-disabled');
                                deferred.resolve(returnErrors);
                            }
                            else
                            {
                                if (assignmentsToUpdate != null)
                                {
                                    var sectionIDsProcessed = [];
                                    $.each(assignmentsToUpdate, function (k, v)
                                    {
                                        if (!sectionIDsProcessed.includes(v.sectionId))
                                        {
                                            sectionIDsProcessed.push(v.sectionId);
                                            v.skipUpdateLastScoredTime = false;
                                        }
                                        else
                                        {
                                            v.skipUpdateLastScoredTime = true;
                                        }
                                    });
                                }

                                $.when(saveFunc.apply(null, [assignmentsToUpdate])).done(function ()
                                {
                                    deferred.resolve();
                                    unbreakableGlass.close();
                                });
                            }
                        });
                    }
                    else
                    {
                        deferred.resolve();
                        unbreakableGlass.close();
                    }
                    return deferred;
                },
                inputConfiguration: function ()
                {
                    var radioButton = $(this);
                    massAssignContainer.find('input[type=text]').attr('disabled', true);
                    massAssignContainer.find('input[type=checkbox]').addClass("ui-disabled").attr("aria-readonly", "true");

                    if (radioButton.attr('id') == 'assignAllScores-RadioButton')
                    {
                        $('#overwriteScoresCheckbox').removeClass("ui-disabled").removeAttr("aria-readonly");
                        massAssign.options.allScoresInput.attr('disabled', false);
                        massAssign.focusAndSelect(massAssign.options.allScoresInput);
                    }
                    else if (radioButton.attr('id') == 'adjustAllScores-RadioButton')
                    {
                        massAssign.options.adjustAllScoresInput.attr('disabled', false);
                        massAssign.options.adjustAllScoresCheckbox.removeClass("ui-disabled").removeAttr("aria-readonly");
                        massAssign.focusAndSelect(massAssign.options.adjustAllScoresInput);
                    }
                },
                removePreviousMassAssign: function (previousMassAssignActiveCell)
                {
                    var previousMassAssignContent = previousMassAssignActiveCell.find('.massAssign.massAssignContent');
                    previousMassAssignContent.detach();
                    previousMassAssignActiveCell.removeClass('active');

                    gradebook.massAssign.append(previousMassAssignContent);

                    var previousAssignmentID = previousMassAssignActiveCell.data().assignmentid;

                    setAssignmentHeaderCellToDefaultColors(previousAssignmentID);
                },
                collapseMassAssign: function (alwaysCollapse, buttonData, collapseAndExit)
                {
                    massAssign.cleanup();
                    var myDeferred = $.Deferred();
                    var animation;

                    if (collapseAndExit)
                    {
                        animation = runAnimations('expanded', 'collapsed');
                    }
                    else
                    {
                        if (gradebook.body.hasClass('collapsed'))
                        {
                            myDeferred.resolve();
                            return myDeferred.promise();
                        }
                        if (!alwaysCollapse && buttonData.assignmentId != massAssign.options.applyButton.data().assignmentId)
                        {
                            myDeferred.resolve(); // collapse an open assignment region that is not the one that the mass assign is bound to.
                            return myDeferred.promise();
                        }
                        animation = runAnimations('expanded', 'collapsed');
                    }
                    massAssign.options.optionButtons.removeClass('expanded');
                    animation.done(function ()
                    {
                        if (!collapseAndExit)
                        {
                            gradebook.gradebookBodyScoringModeControls.each(function ()
                            {
                                var scoringModeControl = $(this);
                                skyward.controls.enable(scoringModeControl);
                                if (scoringModeControl.hasClass('codeEELCodeButton'))
                                {
                                    scoringModeControl.removeClass("gradebookScoringMode-Off").addClass("gradebookScoringMode-On");
                                }
                            });
                        }
                        myDeferred.resolve();
                    });
                    return myDeferred.promise();
                }
            };

            var enabledControlSelector = ":not(.scoringModeDoesntAffectState):not(.skipStudentAssignment):not(.hasAttempts)";

            var actions =
            {
                assignAllScores: function (button)
                {
                    setActionData(button);

                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var newAssignedScore = massAssign.options.allScoresInput.val();
                    var assignmentsToUpdate = [];

                    // ToDo: when checkget is updated to allow a null value we will add the ability to save a blank score for all inputs, making them ungraded
                    var deferred = $.Deferred();

                    var count = 0;
                    var desiredCount = inputs.length;
                    if (massAssign.options.overwriteScoresCheckbox.prop('checked'))
                    {
                        inputs.each(function ()
                        {
                            var input = $(this);
                            skyward.controls.setValue(input, newAssignedScore);

                            var value = input.val();
                            var inputData = input.data();

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, newAssignedScore]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }
                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });

                                //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                count++;
                                if (count == desiredCount)
                                {
                                    deferred.resolve(assignmentsToUpdate);
                                }
                            });
                        });
                    }
                    else
                    {
                        inputs.each(function ()
                        {
                            var input = $(this);
                            var value = input.val();
                            var inputData = input.data();

                            if (isNaN(value) || value == '') // assign new score to unscored, either empty or asterisk
                            {
                                skyward.controls.setValue(input, newAssignedScore);

                                var postCheckDeferred = $.Deferred();
                                if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                                {
                                    postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, newAssignedScore]);
                                }
                                else
                                {
                                    postCheckDeferred.resolve();
                                }

                                $.when(postCheckDeferred).done(function ()
                                {
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                                    //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                    count++;
                                    if (count == desiredCount)
                                    {
                                        deferred.resolve(assignmentsToUpdate);
                                    }
                                });
                            }
                            else
                            {
                                count++;
                            }
                        });

                        //if this is true, then all of the assignments had scores and so we don't need to wait for the inner deferred objects to resolve.
                        if (count == desiredCount)
                        {
                            deferred.resolve(assignmentsToUpdate);
                        }
                    }

                    return deferred;
                },
                adjustAllScores: function (button)
                {
                    setActionData(button);

                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    var adjustAllScoresValue = massAssign.options.adjustAllScoresInput.val();
                    var adjustmentFloat = parseFloat(adjustAllScoresValue) || 0;

                    if (adjustAllScoresValue == 0)
                    {
                        massAssign.options.adjustAllScoresInput.val("0.00");
                        return [];
                    }

                    if (massAssign.options.adjustAllScoresCheckbox.prop('checked') == false)
                    {
                        var unfilteredInputs = inputs;

                        inputs = [];
                        unfilteredInputs.each(function ()
                        {
                            var input = $(this);
                            var value = input.val();
                            if (!isNaN(value) && value != "") // filter out empty scores and asterisks
                            {
                                inputs.push(input);
                            }
                        });
                    }

                    var inputLength = inputs.length;
                    var count = 0;
                    var deferred = $.Deferred();
                    for (var i = 0; i < inputLength; i++)
                    {
                        var input = $(inputs[i]);
                        var currentCellValue = input.val();
                        var inputData = input.data();
                        currentCellValue = parseFloat(currentCellValue) || 0;

                        var adjustedCellValue;
                        if ((currentCellValue + adjustmentFloat) <= 0)  //a score cannot be less than 0
                        {
                            adjustedCellValue = 0.00;
                        }
                        else if ((currentCellValue + adjustmentFloat) > Math.abs(parseFloat(massAssign.options.allScoresInput.data().decimalMask)))
                        {
                            adjustedCellValue = massAssign.options.allScoresInput.data().decimalMask;
                        }
                        else
                        {
                            adjustedCellValue = parseFloat(currentCellValue + adjustmentFloat).toFixed(2);
                        }

                        skyward.controls.setValue(input, adjustedCellValue);

                        var postCheckDeferred = $.Deferred();
                        if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                        {
                            postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, adjustedCellValue]);
                        }
                        else
                        {
                            postCheckDeferred.resolve();
                        }

                        $.when(postCheckDeferred).done(function ()
                        {
                            assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                            count++;
                            if (count == inputLength)
                            {
                                deferred.resolve(assignmentsToUpdate);
                            }
                        });
                    }
                    if (inputLength == 0)
                    {
                        return assignmentsToUpdate;
                    }
                    return deferred;
                },
                removeAllScores: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    return actions.removeAllScoresShared(inputs);

                },
                removeAllScoresStudentGradeBucket: function (button)
                {
                    setActionData(button);
                    var buttonData = button.data();
                    var inputs = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ' .studentAssignment');
                    return actions.removeAllScoresShared(inputs);
                },
                removeAllScoresShared: function (inputs)
                {
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = input.data();

                        var isAssignmentGradeMarkScoring = input.hasClass("gradeMarkScoring") || input.parent().hasClass("gradeMarkScoring");

                        if (isAssignmentGradeMarkScoring)
                        {
                            if (input.hasClass("gradebookInputCodeEEL"))
                            {
                                skyward.gradebookcodeeel.setValue(input, null, null, suppressChangeEvent);
                            }
                            else
                            {
                                skyward.controls.setValue(input, null, null, suppressChangeEvent);
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(input, '*');
                        }
                        assignmentsToUpdate.push({ assignmentId: inputData.assignmentid, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input), isAssignmentGradeMarkScoring: isAssignmentGradeMarkScoring });
                    });

                    return assignmentsToUpdate;
                },
                scoreUnscoredMissingAsZeroSectionGradeBucket: function (button)
                {
                    return actions.scoreUnscoredMissingAsZero(button, "GetUnscoredMissingAssignmentsGradingPeriodGradeBucket");
                },
                scoreUnscoredMissingAsZeroStudentGradeBucket: function (button)
                {
                    return actions.scoreUnscoredMissingAsZero(button, "GetUnscoredMissingAssignments");
                },
                scoreUnscoredMissingAsZero: function (button, action)
                {
                    var deferred = $.Deferred();
                    var assignmentExpansionDeferreds = [];
                    var assignmentsToUpdate = [];
                    var buttonData = button.data();
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: function (response)
                        {
                            if (response.success == false && response.popupHTML)
                            {
                                checkAjaxResponseForErrors(response);
                            }
                            else if (response && response.assignmentIDsBySectionIDByStudentSectionID)
                            {
                                $.each(response.assignmentIDsBySectionIDByStudentSectionID, function (sectionID, assignmentIDsUpdatedByStudentSectionID)
                                {
                                    $.each(assignmentIDsUpdatedByStudentSectionID, function (studentSectionID, assignmentIDs)
                                    {
                                        if (assignmentIDs != null)
                                        {
                                            $.each(assignmentIDs, function (index, assignmentID)
                                            {
                                                var assignmentExpansionDeferred = $.Deferred();
                                                assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                                                var effectiveAssignmentID = gradebook.getEffectiveAssignmentID(assignmentID, studentSectionID, sectionID, buttonData.gradingPeriodGradeBucketId);
                                                var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");

                                                $.when(gradebook.getAdvancedColumnCellsByAssignmentID(effectiveAssignmentID, true, false)).done(function ()
                                                {
                                                    var input = studentAssignmentCell.find("input.gradebookInput" + enabledControlSelector);
                                                    var inputData = input.data();

                                                    var postCheckDeferred = $.Deferred();
                                                    if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function" && input && input.length > 0 && !input.hasClass("gradeMarkScoring"))
                                                    {
                                                        postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, 0]);
                                                    }
                                                    else
                                                    {
                                                        postCheckDeferred.resolve();
                                                    }

                                                    $.when(postCheckDeferred).done(function ()
                                                    {
                                                        if (input && input.length > 0 && !input.hasClass("gradeMarkScoring"))
                                                        {
                                                            gradebook.markInputScoreAsPending(input);
                                                            skyward.controls.setValue(input, '0.00');
                                                            assignmentsToUpdate.push({ assignmentId: effectiveAssignmentID, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                                                        }

                                                        assignmentExpansionDeferred.resolve();
                                                    });
                                                });
                                            });
                                        }
                                    });
                                });
                            }
                            $.when.apply($, assignmentExpansionDeferreds).done(function ()
                            {
                                deferred.resolve(assignmentsToUpdate);
                            });
                        }
                    });

                    return deferred.promise();
                },
                markUnscoredPastDueAsMissingStudentGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignments", false);
                },
                updateUnscoredPastDueZeroMarkMissingStudentGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignments", true);
                },
                markUnscoredPastDueAsMissingSectionGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignmentsGradingPeriodGradeBucket", false);
                },
                updateUnscoredPastDueZeroMarkMissingSectionGradeBucket: function (button)
                {
                    return actions.updateUnscoredPastDueAssignments(button, "GetUnscoredPastDueAsMissingAssignmentsGradingPeriodGradeBucket", true);
                },
                updateUnscoredPastDueAssignments: function (button, action, markAsZero)
                {
                    var deferred = $.Deferred();
                    var assignmentExpansionDeferreds = [];
                    var assignmentsToUpdate = [];
                    var buttonData = button.data();
                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/" + action,
                        type: "POST",
                        dataType: "JSON",
                        data: buttonData,
                        success: function (response)
                        {
                            if (response.success == false && response.popupHTML)
                            {
                                checkAjaxResponseForErrors(response);
                            }
                            else if (response && response.assignmentIDsBySectionIDByStudentSectionID)
                            {
                                $.each(response.assignmentIDsBySectionIDByStudentSectionID, function (sectionID, assignmentIDsUpdatedByStudentSectionID)
                                {
                                    $.each(assignmentIDsUpdatedByStudentSectionID, function (studentSectionID, assignmentIDs)
                                    {
                                        if (assignmentIDs != null)
                                        {
                                            $.each(assignmentIDs, function (index, assignmentID)
                                            {
                                                var effectiveAssignmentID = gradebook.getEffectiveAssignmentID(assignmentID, studentSectionID, sectionID, buttonData.gradingPeriodGradeBucketId);
                                                var studentAssignmentCell = $("#Gradebook_" + studentSectionID + "_" + effectiveAssignmentID + "_Score");

                                                if (studentAssignmentCell.length > 0)
                                                {
                                                    var assignmentExpansionDeferred = $.Deferred();
                                                    assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                                                    $.when(gradebook.getAdvancedColumnCellsByAssignmentID(effectiveAssignmentID, true, false)).done(function ()
                                                    {
                                                        var checkBox = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + studentSectionID + '] .IsMissing.assignment' + effectiveAssignmentID + ':not(:checked)' + enabledControlSelector);
                                                        var scoreInput = studentAssignmentCell.find("input.gradebookInput");

                                                        var inputData = checkBox.data();
                                                        skyward.controls.setValue(checkBox, true);

                                                        var postCheckDeferred = $.Deferred();
                                                        if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function" && markAsZero && scoreInput && scoreInput.length > 0 && !scoreInput.hasClass("gradeMarkScoring"))
                                                        {
                                                            postCheckDeferred = assignmentPostCheckFunc.apply(checkBox, [inputData.assignmentid, inputData.studentsectionid, 0]);
                                                        }
                                                        else
                                                        {
                                                            postCheckDeferred.resolve();
                                                        }

                                                        $.when(postCheckDeferred).done(function ()
                                                        {
                                                            if (markAsZero)
                                                            {
                                                                var value = scoreInput.val();
                                                                if (value == "" || isNaN(value))
                                                                {
                                                                    gradebook.markInputScoreAsPending(scoreInput);

                                                                    if (scoreInput && !scoreInput.hasClass("gradeMarkScoring"))
                                                                    {
                                                                        skyward.controls.setValue(scoreInput, '0.00');
                                                                    }
                                                                }
                                                            }

                                                            assignmentsToUpdate.push({ assignmentId: effectiveAssignmentID, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                                                            assignmentExpansionDeferred.resolve();
                                                        });

                                                    });
                                                }
                                            });
                                        }
                                    });
                                });
                            }
                            $.when.apply($, assignmentExpansionDeferreds).done(function ()
                            {
                                deferred.resolve(assignmentsToUpdate);
                            });
                        }
                    });

                    return deferred.promise();
                },
                removeAllMissingStudentGradeBucket: function (button)
                {
                    var deferred = $.Deferred();
                    setActionData(button);
                    var buttonData = button.data();
                    var assignmentExpansionDeferreds = [];
                    var missingSVGs = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ' svg.missingScore');
                    var assignmentsToUpdate = [];
                    missingSVGs.each(function ()
                    {
                        var missingSVG = $(this);
                        var scoreCell = missingSVG.parents("td").first();
                        var scoreInput = scoreCell.find("input.gradebookInput");
                        var scoreInputData = scoreInput.data();

                        var assignmentExpansionDeferred = $.Deferred();
                        assignmentExpansionDeferreds.push(assignmentExpansionDeferred);
                        $.when(gradebook.getAdvancedColumnCellsByAssignmentID(scoreInputData.assignmentid, true, false)).done(function (test123)
                        {
                            var checkBox = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + scoreInputData.studentsectionid + '] .IsMissing.assignment' + scoreInputData.assignmentid + ':checked');

                            if (checkBox.length > 0)
                            {
                                skyward.controls.setValue(checkBox, false);
                                assignmentsToUpdate.push({ assignmentId: scoreInputData.assignmentid, studentSectionId: scoreInputData.studentsectionid, academicStandardId: scoreInputData.academicStandardId, isAvailable: scoreInputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                            }
                            assignmentExpansionDeferred.resolve();

                        });
                    });

                    $.when.apply($, assignmentExpansionDeferreds).done(function ()
                    {
                        deferred.resolve(assignmentsToUpdate);
                    });

                    return deferred.promise();
                },
                setAllToNoCountStudentGradeBucket: function (button)
                {
                    return actions.updateAllNoCountStudentGradeBucket(button, true);
                },
                removeAllNoCountStudentGradeBucket: function (button)
                {
                    return actions.updateAllNoCountStudentGradeBucket(button, false);
                },
                updateAllNoCountStudentGradeBucket: function (button, noCountValue)
                {
                    var deferred = $.Deferred();
                    setActionData(button);
                    var buttonData = button.data();
                    var assignmentExpansionDeferreds = [];
                    var noCountCells;

                    if (noCountValue)
                    {
                        noCountCells = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ':not(:has("svg.noCount:visible"))');
                    }
                    else
                    {
                        noCountCells = contentsToUpdateContainer.find('tr.gradesheetBrowseRow[data-student-section-id=' + buttonData.studentSectionId + '] .assignmentCell.js_gradingPeriodGradeBucketID' + buttonData.gradingPeriodGradeBucketId + ':has("svg.noCount")');
                    }
                    var assignmentsToUpdate = [];
                    noCountCells.each(function ()
                    {
                        var scoreCell = $(this);
                        var scoreInput = scoreCell.find("input.gradebookInput");
                        var scoreInputData = scoreInput.data();

                        var assignmentExpansionDeferred = $.Deferred();
                        assignmentExpansionDeferreds.push(assignmentExpansionDeferred);

                        $.when(gradebook.getAdvancedColumnCellsByAssignmentID(scoreInputData.assignmentid, true, false)).done(function ()
                        {
                            var checkedSelector;
                            if (noCountValue == true)
                            {
                                checkedSelector = ':not(:checked)'
                            }
                            else
                            {
                                checkedSelector = ':checked';
                            }
                            var checkBox = getAssociatedEnabledInputs('tr.gradesheetBrowseRow[data-student-section-id=' + scoreInputData.studentsectionid + '] .NoCount.assignment' + scoreInputData.assignmentid + checkedSelector);

                            if (checkBox.length > 0)
                            {
                                skyward.controls.setValue(checkBox, noCountValue);
                                assignmentsToUpdate.push({ assignmentId: scoreInputData.assignmentid, studentSectionId: scoreInputData.studentsectionid, academicStandardId: scoreInputData.academicStandardId, isAvailable: scoreInputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                            }
                            assignmentExpansionDeferred.resolve();
                        });

                    });

                    $.when.apply($, assignmentExpansionDeferreds).done(function ()
                    {
                        deferred.resolve(assignmentsToUpdate);
                    });

                    return deferred.promise();
                },

                setAllToNoCount: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.NoCount.assignment' + assignmentId + ':not(:checked)' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, true);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllNoCount: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.NoCount.assignment' + assignmentId + ':checked' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, false);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllMissing: function (button)
                {
                    setActionData(button);
                    var checkBoxes = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + ':checked' + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    checkBoxes.each(function ()
                    {
                        var checkBox = $(this);
                        var inputData = checkBox.data();
                        skyward.controls.setValue(checkBox, false);
                        assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(checkBox) });
                    });

                    return assignmentsToUpdate;
                },
                removeAllScoreClarifiers: function (button)
                {
                    setActionData(button);
                    var scoreClarifiers = contentsToUpdateContainer.find('div.scoreClarifier.assignment' + assignmentId + ':not([readonly]):not(.scoringModeDoesntAffectState)');
                    var assignmentsToUpdate = [];
                    scoreClarifiers.each(function ()
                    {
                        var scoreClarifier = $(this);
                        if (scoreClarifier.length)
                        {
                            var eel = scoreClarifier;

                            if (eel.hasClass("gradebookCodeEEL"))
                            {
                                eel = eel.find('.gradebookInputCodeEEL');
                                if (!eel.hasClass('scoringModeDoesntAffectState'))
                                {
                                    skyward.gradebookcodeeel.setValue(eel, null, null, true);
                                    var inputData = eel.data();
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(scoreClarifier) });
                                }
                            }
                            else if (eel.parent().hasClass('codeEEL'))
                            {
                                eel = scoreClarifier.parent(".codeEEL");
                                if (!eel.hasClass('scoringModeDoesntAffectState'))
                                {
                                    skyward.controls.setValue(eel, null, null, true);
                                    var inputData = eel.find(".codeEELCode").data();
                                    $.extend(inputData, eel.data());
                                    assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(scoreClarifier) });
                                }
                            }
                        }
                    });

                    return assignmentsToUpdate;
                },
                updateZeroMarkMissing: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = input.data();
                        var value = input.val();
                        if (value == "" || isNaN(value))
                        {
                            skyward.controls.setValue(input, '0.00');
                            var isMissingCell = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + enabledControlSelector + '[data-studentsectionid=' + inputData.studentsectionid + ']');
                            skyward.controls.setValue(isMissingCell, true);

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [inputData.assignmentid, inputData.studentsectionid, 0]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }

                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: inputData.isAvailable, sectionId: getSectionIDFromCell(input) });
                            });
                        }
                    });

                    return assignmentsToUpdate;
                },
                gradeMarkScoringMarkUnscoredAsMissing: function (button)
                {
                    setActionData(button);
                    var inputs = contentsToUpdateContainer.find('.studentAssignment.assignment' + assignmentId + enabledControlSelector);
                    var assignmentsToUpdate = [];
                    inputs.each(function ()
                    {
                        var input = $(this);
                        var inputData = $.extend({}, input.data(), input.parent().data());
                        var value = skyward.controls.getValue(input);
                        if (input.hasClass("gradebookInputCodeEEL"))
                        {
                            value = skyward.gradebookcodeeel.getData(input).displayValue;
                        }

                        if (value == null || value == "" || value == "*")
                        {
                            //todo: PR 2727610, make sure we check what the input type is and get value the correct way, either for code eel or gradebook code eel or decimal textbox
                            var isMissingCell = contentsToUpdateContainer.find('.IsMissing.assignment' + assignmentId + enabledControlSelector + '[data-studentsectionid=' + inputData.studentsectionid + ']');
                            skyward.controls.setValue(isMissingCell, true);
                            assignmentsToUpdate.push({ assignmentId: assignmentId, studentSectionId: inputData.studentsectionid, academicStandardId: inputData.academicStandardId, isAvailable: isMissingCell.data().isAvailable, sectionId: getSectionIDFromCell(input) });
                        }
                    });

                    return assignmentsToUpdate;
                },
                assignAllStudentGradeBucketScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                    }

                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucket[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    var studentGradeBucketIDs = [];

                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        var studentGradeBucketID = input.parents('.gradeBucketCell').data('studentGradeBucketId');
                        if (!studentGradeBucketIDs.includes(studentGradeBucketID)
                            && (overwriteScores || !value || value === null || value === "" || value === "*"))
                        {
                            removeCellErrorClasses(input.parents("td").first(), "noMatch");
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            studentGradeBucketIDs.push(studentGradeBucketID);
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucket: true,
                                    studentGradeBucketID: studentGradeBucketID,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    }
                                });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketSubjectMasteryScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }
                    var isMastered = skyward.controls.getValue(massAssign.options.massAssignMasteryGradeMark);

                    var checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "']");

                    var gradeBuckets = [];
                    checkboxes.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        if (isMastered != skyward.controls.getValue(input))
                        {
                            skyward.controls.setValue(input, isMastered, suppressChangeEvent);
                        }

                        var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                        gradeBuckets.push({ isStudentGradeBucketSubject: true, studentGradeBucketSubjectID: studentGradeBucketSubjectID, type: "mastery" });
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketSubjectScores: function (callingButton)
                {
                    if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                    {
                        return actions["assignAllStudentGradeBucketSubjectMasteryScores"](callingButton);
                    }
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucketSubject[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value === "*")
                        {
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucketSubject: true,
                                    studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    },
                                    studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketAcademicStandardMasteryScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }
                    var isMastered = skyward.controls.getValue(massAssign.options.massAssignMasteryGradeMark);

                    var checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + data.academicStandardId + "']");

                    var gradeBuckets = [];
                    checkboxes.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();

                        if (isMastered != skyward.controls.getValue(input))
                        {
                            skyward.controls.setValue(input, isMastered, suppressChangeEvent);

                            var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                            gradeBuckets.push({ isStudentGradeBucketAcademicStandard: true, studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID, type: "mastery" });
                        }
                    });
                    return gradeBuckets;
                },
                assignAllStudentGradeBucketAcademicStandardScores: function (callingButton)
                {
                    if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                    {
                        return actions["assignAllStudentGradeBucketAcademicStandardMasteryScores"](callingButton);
                    }
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.massAssignSubjectiveGradeMark);

                    var gradingScaleGroupID = null;
                    var massAssignSubjectiveGradeMarkData = massAssign.options.massAssignSubjectiveGradeMark.data();

                    if (massAssignSubjectiveGradeMarkData)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignSubjectiveGradeMarkData.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".subjectiveStudentGradeBucketAcademicStandard[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + academicStandardID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']");

                    var gradeBuckets = [];
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value === "*")
                        {
                            skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);

                            var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                            gradeBuckets.push(
                                {
                                    isStudentGradeBucketAcademicStandard: true,
                                    studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                                    studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                    Score:
                                    {
                                        selectedValueID: gradebookcodeeelData.selectedValueID,
                                        displayValue: gradebookcodeeelData.displayValue
                                    }
                                });
                        }
                    });
                    return gradeBuckets;
                },
                copyFromPreviousStudentGradeBucketAcademicStandardScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        academicStandardID = data.academicStandardId;
                    }

                    var overwriteScores = massAssign.options.overwriteScoresCheckboxCopyFromPreviousBucket.prop('checked');

                    var gradeBuckets = [];
                    var deferred = $.Deferred();
                    var selectedCalculationGroupGradeBucketID = skyward.controls.getValue(massAssign.options.massAssignBucketSelector);

                    if (selectedCalculationGroupGradeBucketID == null || selectedCalculationGroupGradeBucketID === "")
                    {
                        var errors = [];
                        errors.push('A Previous Bucket is required if you choose the "Copy from Previous Bucket" option.');
                        return deferred.resolve(gradeBuckets, errors);
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetStudentGradeBucketAcademicStandardGrades",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            calculationGroupGradeBucketID: selectedCalculationGroupGradeBucketID,
                            academicStandardID: academicStandardID
                        },
                        success: function (response)
                        {
                            var eels;
                            var checkboxes;

                            eels = $(".subjectiveStudentGradeBucketAcademicStandard[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + academicStandardID + "']");
                            checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-academic-standard-id='" + data.academicStandardId + "']");

                            if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                            {
                                checkboxes.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                    var isMastered = null;
                                    $.each(JSON.parse(response.grades), function ()
                                    {
                                        var thisGrade = $(this);

                                        if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                        {
                                            isMastered = thisGrade[0].GradingScaleGroupGradeMarkID != null;
                                            return;
                                        }
                                    });

                                    if (isMastered != skyward.controls.getValue(input) &&
                                        //Intentionally checking that isMastered equals either true or false here to avoid attempting to set null (which is the default value of isMastered we set above)
                                        (isMastered == true || (overwriteScores == true && isMastered == false)))
                                    {
                                        skyward.controls.setValue(input, isMastered, suppressChangeEvent);

                                        var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                                        gradeBuckets.push({ isStudentGradeBucketAcademicStandard: true, studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID, type: "mastery" });
                                    }
                                });
                            }
                            else
                            {
                                eels.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var value = skyward.controls.getValue(input);

                                    if (overwriteScores == true || !value || value === null || value === "" || value === "*")
                                    {
                                        var studentGradeBucketAcademicStandardID = input.parents('.academicStandardCell').data('studentGradeBucketAcademicStandardId');
                                        var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                        var grade;
                                        $.each(JSON.parse(response.grades), function ()
                                        {
                                            var thisGrade = $(this);

                                            if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                            {
                                                grade = thisGrade[0];
                                                return;
                                            }
                                        });

                                        if (grade &&
                                            (overwriteScores == true || grade.GradingScaleGroupGradeMarkID != null))
                                        {
                                            skyward.gradebookcodeeel.setValue(input, grade.GradeMarkCode, grade.GradingScaleGroupGradeMarkID, true);

                                            gradeBuckets.push(
                                            {
                                                isStudentGradeBucketAcademicStandard: true,
                                                studentGradeBucketAcademicStandardID: studentGradeBucketAcademicStandardID,
                                                studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                                Score:
                                                {
                                                    selectedValueID: grade.GradingScaleGroupGradeMarkID,
                                                    displayValue: grade.GradeMarkCode
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                            deferred.resolve(gradeBuckets);
                        }
                    });

                    return deferred;
                },
                copyFromPreviousStudentGradeBucketSubjectScores: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        gradingPeriodGradeBucketID = data.gradingPeriodGradeBucketId;
                        subjectID = data.subjectId;
                    }

                    var overwriteScores = massAssign.options.overwriteScoresCheckboxCopyFromPreviousBucket.prop('checked');

                    var gradeBuckets = [];
                    var deferred = $.Deferred();
                    var selectedCalculationGroupGradeBucketID = skyward.controls.getValue(massAssign.options.massAssignBucketSelector);

                    if (selectedCalculationGroupGradeBucketID == null || selectedCalculationGroupGradeBucketID === "")
                    {
                        var errors = [];
                        errors.push('A Previous Bucket is required if you choose the "Copy from Previous Bucket" option.');
                        return deferred.resolve(gradeBuckets, errors);
                    }

                    $.ajax({
                        url: skyward.global.virtualDir + "Gradebook/Gradebook/GetStudentGradeBucketSubjectGrades",
                        type: "POST",
                        dataType: "JSON",
                        data:
                        {
                            calculationGroupGradeBucketID: selectedCalculationGroupGradeBucketID,
                            subjectID: subjectID
                        },
                        success: function (response)
                        {
                            var eels;
                            var checkboxes;

                            eels = $(".subjectiveStudentGradeBucketSubject[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + subjectID + "']");
                            checkboxes = $(".checkbox.mastery.gradebookCheckbox[data-grading-period-grade-bucket-id='" + gradingPeriodGradeBucketID + "'][data-subject-id='" + data.subjectId + "']");

                            if (massAssign.options.massAssignMasteryGradeMark.length > 0)
                            {
                                checkboxes.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                    var isMastered = null;
                                    $.each(JSON.parse(response.grades), function ()
                                    {
                                        var thisGrade = $(this);

                                        if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                        {
                                            isMastered = thisGrade[0].GradingScaleGroupGradeMarkID != null;
                                            return;
                                        }
                                    });

                                    if (isMastered != skyward.controls.getValue(input) &&
                                        //Intentionally checking that isMastered equals either true or false here to avoid attempting to set null (which is the default value of isMastered we set above)
                                        (isMastered == true || (overwriteScores == true && isMastered == false)))
                                    {
                                        skyward.controls.setValue(input, isMastered, suppressChangeEvent);

                                        var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                                        gradeBuckets.push({ isStudentGradeBucketSubject: true, studentGradeBucketSubjectID: studentGradeBucketSubjectID, type: "mastery" });
                                    }
                                });
                            }
                            else
                            {
                                eels.each(function ()
                                {
                                    var input = $(this);
                                    var data = input.data();
                                    var value = skyward.controls.getValue(input);

                                    if (overwriteScores == true || !value || value === null || value === "" || value === "*")
                                    {
                                        var studentGradeBucketSubjectID = input.parents('.subjectCell').data('studentGradeBucketSubjectId');
                                        var studentSectionID = input.parents('tr.gradesheetBrowseRow').data('studentSectionId');

                                        var grade;
                                        $.each(JSON.parse(response.grades), function ()
                                        {
                                            var thisGrade = $(this);

                                            if (thisGrade.length > 0 && thisGrade[0].StudentSectionID == studentSectionID)
                                            {
                                                grade = thisGrade[0];
                                                return;
                                            }
                                        });

                                        if (grade &&
                                            (overwriteScores == true || grade.GradingScaleGroupGradeMarkID != null))
                                        {
                                            skyward.gradebookcodeeel.setValue(input, grade.GradeMarkCode, grade.GradingScaleGroupGradeMarkID, true);

                                            gradeBuckets.push(
                                            {
                                                isStudentGradeBucketSubject: true,
                                                studentGradeBucketSubjectID: studentGradeBucketSubjectID,
                                                studentSectionId: input.parents("tr.gradesheetBrowseRow").first().data().studentSectionId,
                                                Score:
                                                {
                                                    selectedValueID: grade.GradingScaleGroupGradeMarkID,
                                                    displayValue: grade.GradeMarkCode
                                                }
                                            });
                                        }
                                    }
                                });
                            }
                            deferred.resolve(gradeBuckets);
                        }
                    });

                    return deferred;
                },
                assignAllScoresGradeMarkScoring: function (callingButton)
                {
                    button = callingButton;
                    data = button.data();
                    if (data != null)
                    {
                        assignmentID = data.assignmentId;
                        studentSectionID = data.studentSectionId;
                    }
                    var overwriteScores = massAssign.options.overwriteScoresCheckbox.prop('checked');
                    var gradebookcodeeelData = skyward.gradebookcodeeel.getData(massAssign.options.assignAllScoresGradeMarkScoringInput);

                    var gradingScaleGroupID = null;
                    var massAssignGradeMarkScores = massAssign.options.assignAllScoresGradeMarkScoringInput.data();

                    if (massAssignGradeMarkScores)
                    {
                        gradingScaleGroupID = JSON.parse(massAssignGradeMarkScores.postData).gradingscalegroupidmostused;
                    }

                    var eels = $(".gradeMarkScoring[data-assignmentId='" + assignmentID + "'][data-grading-scale-group-id='" + gradingScaleGroupID + "']:not([readonly]):not(.scoringModeDoesntAffectState)");

                    var assignmentsToUpdate = [];
                    var deferred = $.Deferred();
                    var count = 0;
                    var inputCount = eels.length;
                    eels.each(function ()
                    {
                        var input = $(this);
                        var data = input.data();
                        var value = skyward.controls.getValue(input);

                        if (overwriteScores || !value || value === null || value === "" || value == "*")
                        {
                            if (input.parent().hasClass("gradebookCodeEEL"))
                            {
                                skyward.gradebookcodeeel.setValue(input, gradebookcodeeelData.displayValue, gradebookcodeeelData.selectedValueID, true);
                            }
                            else
                            {
                                skyward.controls.setValue(input, gradebookcodeeelData.selectedValueID, suppressChangeEvent);
                            }

                            var postCheckDeferred = $.Deferred();
                            if (assignmentPostCheckFunc && typeof (assignmentPostCheckFunc) == "function")
                            {
                                postCheckDeferred = assignmentPostCheckFunc.apply(input, [data.assignmentid, data.studentsectionid, gradebookcodeeelData.backingPercent, data.maxScore]);
                            }
                            else
                            {
                                postCheckDeferred.resolve();
                            }
                            $.when(postCheckDeferred).done(function ()
                            {
                                assignmentsToUpdate.push({ isAssignmentGradeMarkScoring: true, assignmentId: data.assignmentid, studentSectionId: data.studentsectionid, academicStandardId: data.academicStandardId, isAvailable: data.isAvailable, sectionId: getSectionIDFromCell(input), displayValue: gradebookcodeeelData.displayValue });

                                //count++ is fine, javascript has a single thread that processes callbacks in a queue so this increment won't conflict with other calls in this loop
                                count++;
                                if (count == inputCount)
                                {
                                    deferred.resolve(assignmentsToUpdate);
                                }
                            });
                        }
                        else
                        {
                            count++;
                            if (count == inputCount)
                            {
                                deferred.resolve(assignmentsToUpdate);
                            }
                        }
                    });

                    if (inputCount == 0)
                    {
                        return assignmentsToUpdate;
                    }
                    return deferred;
                }
            };

            var setActionData = function (callingButton)
            {
                button = callingButton;
                data = button.data();
                if (data != null)
                {
                    assignmentId = data.assignmentId;
                }
            };

            var getAssociatedEnabledInputs = function (studentAssignmentInputSelector)
            {
                return contentsToUpdateContainer.find(studentAssignmentInputSelector + enabledControlSelector);
            };

            var runAnimations = function (removingClass, addingClass)
            {
                var myDeferred = $.Deferred();
                var promises = [];

                var primaryPromise = $('.massAssign').switchClass(removingClass, addingClass, 5).promise();
                promises.push(primaryPromise);

                var secondaryPromise = contentsToUpdateContainer.switchClass(removingClass, addingClass, 5).promise();
                promises.push(secondaryPromise);

                if (removingClass == "collapsed")
                {
                    massAssign.options.tableRow.removeClass(removingClass);
                }

                $.when.apply($, promises).done(function ()
                {
                    if (gradebook)
                    {
                        gradebook.unlockedRowHeader.removeClass(removingClass).addClass(addingClass);
                    }

                    massAssign.options.tableRow.addClass(addingClass);

                    if (gradebook)
                    {
                        gradebook.lockedRowHeader.height(gradebook.unlockedRowHeader.height());

                        gradebook.resize();
                    }
                    myDeferred.resolve();
                });
                return myDeferred.promise(); // return when all animations completed
            };
            return massAssign;
        };

        var getInputValue = function (input)
        {
            var value = "*";

            if (input.hasClass("codeEELCode"))
            {
                value = input.parent().siblings('.codeEELValue').val();
            }
            else if (input.hasClass("gradebookInputCodeEEL"))
            {
                value = skyward.gradebookcodeeel.getData(input).selectedValueID;
            }
            else if (input.is(':checkbox'))
            {
                value = input.is(":checked");
            }
            else if (input.is(':text') || input.hasClass('Score'))
            {
                value = input.val();
            }

            return value;
        };

        var getInputOriginalValue = function (input, retrieveDisplayValue)
        {
            var value;

            if (input.hasClass("codeEELCode"))
            {
                value = input.siblings(".codeEELValue").data("original-value") || "";
            }
            else if (input.hasClass("gradebookInputCodeEEL"))
            {
                if (retrieveDisplayValue == true)
                {
                    value = skyward.gradebookcodeeel.getOriginalValueData(input).originalDisplayValue;
                }
                else
                {
                    value = skyward.gradebookcodeeel.getOriginalValueData(input).originalSelectedValueID;
                }
            }
            else
            {
                if (input.hasClass("studentAssignment"))
                {
                    value = input.data("original-assignment-score");
                }
                else
                {
                    value = input.data("original-value");
                }
            }

            return value;
        };

        var shouldShowTransferIcon = function (affectedStudentAssignment)
        {
            return affectedStudentAssignment.isMissing || affectedStudentAssignment.noCount || affectedStudentAssignment.scoreClarifierId != null ||
                (affectedStudentAssignment.score != null && affectedStudentAssignment.score !== "" && affectedStudentAssignment.score !== "*") ||
                (affectedStudentAssignment.grademarkvalue != null && affectedStudentAssignment.grademarkvalue !== "" && affectedStudentAssignment.grademarkvalue !== "*") ||
                (affectedStudentAssignment.comments != null && affectedStudentAssignment.comments !== "");
        };

        var updateAssignmentIndicatorSvg = function (input, assignmentIndicatorSelector, hiddenSvgContainerSelector, fieldNameOverride, showOverride)
        {
            var inputData = input.data();
            var fieldType = input.attr("type");
            var fieldName = inputData.fieldname;
            if (fieldNameOverride)
            {
                fieldName = fieldNameOverride;
            }

            var show;
            if (showOverride != null)
            {
                show = showOverride;
            }
            else
            {
                if (fieldType == "text" || input.hasClass("Score"))
                {
                    var value = getInputValue(input);
                    show = value != null && value != "";
                }
                else if (fieldType == "checkbox")
                {
                    show = input.is(":checked");
                }
            }

            var classToUpdate;
            switch (fieldName)
            {
                case 'IsMissing':
                    classToUpdate = 'hiddenMissingScore';
                    break;
                case 'ScoreClarifierID':
                    classToUpdate = 'hiddenScoreClarifier';
                    break;
                case 'NoCount':
                    classToUpdate = 'hiddenNoCount';
                    break;
                case 'Comments':
                    classToUpdate = 'hiddenComment';
                    break;
                case 'DroppedAssignment':
                    classToUpdate = 'hiddenDroppedAssignment';
                    break;
                case 'TransferGrade':
                    classToUpdate = 'hiddenTransferGrade';
                    break;
                case 'MoreInfo':
                    classToUpdate = 'hiddenMoreInfo';
                    break;
                default:
                    classToUpdate = '';
                    break;
            }

            if (show)
            {
                var svgName;
                switch (fieldName)
                {
                    case 'IsMissing':
                        svgName = 'MissingScore';
                        break;
                    case 'ScoreClarifierID':
                        svgName = 'ScoreClarifier';
                        break;
                    case 'Comments':
                        svgName = 'Comment';
                        break;
                    case 'Score':
                        svgName = 'Warning';
                        if (parseFloat(inputData.originalAssignmentScore) <= parseFloat(inputData.maxscore))
                        {
                            return;
                        }
                        break;
                    default:
                        svgName = fieldName;
                        break;
                }

                addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
            }
            else
            {
                removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
            }
        };

        var addSVGToStudentAssignment = function (svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector)
        {
            var assignmentScoreCell = $(assignmentIndicatorSelector);
            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorDiv = assignmentScoreCell.find('.assignmentIndicators');
            if (assignmentIndicatorDiv.length < 1)
            {
                return;
            }

            if (svgName == null)
            {
                return;
            }
            var safeSvgName = svgName.charAt(0).toLowerCase() + svgName.slice(1);

            if (assignmentIndicatorDiv.find("svg." + safeSvgName).length == 0)
            {
                var clone = $(hiddenSvgContainerSelector).find(".svg." + safeSvgName).first().clone();
                clone.removeClass("svgHidden");
                clone.appendTo(assignmentScoreCell.find(".assignmentIndicators.hidden" + svgName));
            }
            assignmentIndicatorDiv.removeClass(classToUpdate);
            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var removeSVGFromStudentAssignment = function (assignmentIndicatorSelector, classToUpdate)
        {
            var assignmentScoreCell = $(assignmentIndicatorSelector);
            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorDiv = assignmentScoreCell.find('.assignmentIndicators');
            if (assignmentIndicatorDiv.length < 1)
            {
                return;
            }

            assignmentIndicatorDiv.addClass(classToUpdate);
            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var updateAssignmentIndicatorSvgSecondRow = function (input, options, assignmentIndicatorSelector)
        {
            options = options || {};

            var inputData = input.data();

            var assignmentScoreCell = $(assignmentIndicatorSelector);

            if (assignmentScoreCell.length < 1)
            {
                return;
            }

            var assignmentIndicatorSpan = assignmentScoreCell.find('.assignmentIndicatorsFirstRow');
            if (assignmentIndicatorSpan.length < 1)
            {
                return;
            }

            var fieldName = options.fieldnameOverride == null ? input.fieldname : options.fieldnameOverride;

            var classToUpdate;
            var show;
            switch (fieldName)
            {
                case 'Score':
                    classToUpdate = 'hiddenWarning';
                    show = parseFloat(inputData.originalAssignmentScore) > parseFloat(inputData.maxscore);
                    break;
                case 'IsDropped':
                    classToUpdate = 'hiddenDroppedAssignment';
                    show = options.isDropped;
                    break;
                default:
                    return;
            }

            if (options.overrideShow)
            {
                input.find('.assignmentIndicatorsFirstRow').addClass(classToUpdate);
            }

            if (show)
            {
                assignmentIndicatorSpan.removeClass(classToUpdate);
            }
            else
            {
                assignmentIndicatorSpan.addClass(classToUpdate);
            }

            updateStudentAssignmentButtonDisplay(assignmentScoreCell);
        };

        var updateAssignmentIndicatorsMobile = function ()
        {
            var assignmentManager = createAssignmentManager();

            var updateSvgsForInput = function (inputToUpdateSVGFor, fieldname)
            {
                assignmentManager.setOriginalStudentAssignmentValues(inputToUpdateSVGFor, getInputValue(inputToUpdateSVGFor));
                updateAssignmentIndicatorSvg(inputToUpdateSVGFor, inputToUpdateSVGFor.parents(".studentAssignmentMobileCard").find(".assignmentIndicatorButton").parent(), inputToUpdateSVGFor.parents(".dataObjectViewer"));
                updateAssignmentIndicatorSvgSecondRow(inputToUpdateSVGFor, { fieldnameOverride: fieldname, overrideShow: false }, inputToUpdateSVGFor.parents(".studentAssignmentMobileCard").find(".assignmentIndicatorButton").parent());
                assignmentManager.updateChangedClass(inputToUpdateSVGFor, false, {});
            };

            var input = $(this);

            var inputData = input.data();
            if (input.hasClass("quickEntryText"))
            {
                input = input.find("input.codeEELDescription");
                input.data("fieldname", inputData.fieldname);
            }
            else if (input.hasClass("Score"))
            {
                var maxScore = inputData.maxscore;

                mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(input, [inputData.assignmentid, inputData.studentsectionid, skyward.controls.getValue(input), maxScore]);
            }
            else if (input.hasClass("codeEEL"))
            {
                input = input.find("input.codeEELCode:not(.mobile-eel-placeholder)");
                input.data("fieldname", inputData.fieldname);

                var codeEEL = input.parents('div.codeEEL'); //todo: make gradebook codeeel after PR 2727610
                var codeEELData = codeEEL.data();

                if (codeEELData.additionalFields && skyward.controls.getValue(codeEEL) != "") //todo: make gradebook codeeel after PR 2727610
                {
                    if (codeEELData.fieldname == "Score")
                    {
                        mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(codeEEL, [codeEELData.assignmentid, codeEELData.studentsectionid, null, inputData.maxScore, codeEELData.additionalFields.DefaultCalculationPercent]);
                    }
                    else
                    {
                        $.each(codeEELData.additionalFields, function (key, value)
                        {
                            if ((key === "IsMissing" || key === "NoCount") && !value)
                            {
                                return;
                            }
                            var inputToUpdate = codeEEL.parent().find("input[data-fieldname=" + key + "]");

                            if (inputToUpdate.length)
                            {
                                inputToUpdate.prop("checked", value);
                                updateSvgsForInput(inputToUpdate, key);
                            }
                        });
                    }
                }
            }

            updateSvgsForInput(input, inputData.fieldname);
        };

        var attemptsPopup = function (data, gradebook)
        {
            var isMobile = !gradebook;
            data.specificassignmentid = getRepresentedAssignmentID(data.assignmentid, data.sectionid);
            var saveButton =
            {
                text: "Save",
                "click": function ()
                {
                    var deferred = new $.Deferred;
                    var valuesToSave = [];
                    var counter = 0;

                    var popup = $(this).parents('.messageBox.skywardContentPanel');
                    var rows = popup.find('tr.childrecordquickentryrow:not(".removedElement")');
                    rows.each(function ()
                    {
                        var currentRow = $(this);

                        var valueToSaveForRow = [];
                        currentRow.find('td input:not(".codeEELValue")').each(function ()
                        {
                            var input = $(this)[0];
                            if (input.value != "" && input.value != null)
                            {
                                if (input.id.includes('GradeMarkID'))
                                {
                                    if ($(input).data('selectedValueID') != null && $(input).data('selectedValueID') != "")
                                    {
                                        valueToSaveForRow.push({ id: input.id, value: $(input).data('selectedValueID') });
                                    }
                                }
                                else if (input.id.includes('IsUsed'))
                                {
                                    valueToSaveForRow.push({ id: input.id, value: $(input).is(':checked') });
                                }
                                else
                                {
                                    valueToSaveForRow.push({ id: input.id, value: input.value });
                                }
                            }
                        });

                        if (valueToSaveForRow.length > 1 || (valueToSaveForRow.length == 1 && valueToSaveForRow[0].id.includes('IsUsed') && valueToSaveForRow[0].value == true))
                        {
                            valuesToSave.push(valueToSaveForRow);
                        }

                        if (++counter >= rows.length)
                        {
                            deferred.resolve();
                        }
                    });
                    $.when(deferred).done(function ()
                    {
                        $.ajax(
                            {
                                url: skyward.global.virtualDir + "Gradebook/StudentAssignment/StudentAssignmentAttemptPopupSave",
                                type: "POST",
                                dataType: "JSON",
                                data:
                                {
                                    valuesToSave: JSON.stringify(valuesToSave),
                                    studentSectionID: data.studentsectionid,
                                    assignmentID: data.specificassignmentid ? data.specificassignmentid : data.assignmentid,
                                    warninghash: popup.data('warninghash')
                                },
                                success: function (returnData)
                                {
                                    if (returnData.success == true)
                                    {
                                        var input = $('input.studentAssignment[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"], div.studentAssignment[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"]');
                                        var inputData = input.data();

                                        var inputCodeEEL = input.find('input.codeEELCode');
                                        if (inputCodeEEL.length > 0)
                                        {
                                            input = inputCodeEEL;
                                        }

                                        var inputHadMultipleAttempts = input.hasClass('hasAttempts');
                                        input.removeClass('hasAttempts');

                                        var label = $('a.attemptCount[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"] span.anchorText');
                                        if (returnData.totalAttemptCount > 0)
                                        {
                                            label.text(returnData.totalAttemptCount);
                                        }
                                        else if ((input.val() != null && input.val() != '' && input.val() != '*') || returnData.UpdatedScore != null || returnData.UpdatedGradeMark != null)
                                        {
                                            label.text(1);
                                        }

                                        var handleCodeEELInputs = function (input, idToSet, valueToSet)
                                        {
                                            var codeEEL = input.parents('.gradebookCodeEEL, .codeEEL');
                                            if (isMobile)
                                            {
                                                skyward.controls.setValue(input, valueToSet, true);
                                                var otherInput = codeEEL.find('input.codeEELValue');
                                                skyward.controls.setValue(otherInput, idToSet, true);
                                            }
                                            else
                                            {
                                                //Don't want to perform the normal save because we don't want undo/redo to be affected.
                                                skyward.controls.setValue(input, valueToSet, true);
                                                skyward.gradebookcodeeel.handleChangeNoSave(codeEEL, idToSet);
                                            }
                                        };

                                        if (returnData.UpdatedGradeMark != null && returnData.UpdatedGradingScaleGroupGradeMarkID != null)
                                        {
                                            handleCodeEELInputs(input, returnData.UpdatedGradingScaleGroupGradeMarkID, returnData.UpdatedGradeMark);
                                        }
                                        else if (returnData.UpdatedScore != null)
                                        {
                                            if (isMobile)
                                            {
                                                skyward.controls.setValue(input, returnData.UpdatedScore, true);
                                            }
                                            else
                                            {
                                                skyward.controls.setValue(input, returnData.UpdatedScore);
                                            }
                                        }
                                        else
                                        {
                                            skyward.controls.setValue(input, '');
                                        }

                                        var inputValue = input.val();

                                        var deferred = $.Deferred();
                                        if (inputData.displayValue != inputValue && !isNaN(returnData.UpdatedScore) && inputValue != "")
                                        {
                                            if (!isMobile)
                                            {
                                                deferred = gradebook.updateIsMissingValueAndCheckFailingScoreClarifier(data.assignmentid, data.studentsectionid, returnData.UpdatedScore);
                                            }
                                            else
                                            {
                                                deferred = mobileUpdateIsMissingValueAndCheckFailingScoreClarifier.apply(input, [data.assignmentid, data.studentsectionid, returnData.UpdatedScore, inputData.maxScore]);
                                            }
                                        }
                                        else
                                        {
                                            deferred.resolve();
                                        }

                                        $.when(deferred).done(function ()
                                        {
                                            if (inputValue == "" || inputValue == ".")
                                            {
                                                skyward.controls.setValue(input, '*');
                                            }

                                            input.data('studentAssignmentScore', inputValue);
                                            input.data('displayValue', inputValue);

                                            var unbreakableGlass = skyward.modalLayer.newModalLayer(null, null,
                                                {
                                                    closeOnClick: false,
                                                    closeOnRecordSelected: false,
                                                    closeOnEscape: false,
                                                    transparentGlass: true
                                                });

                                            var advancedAssignmentInputs = $('input.scoreClarifier[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"], input.checkbox[data-studentsectionid="' + data.studentsectionid + '"][data-assignmentid="' + data.assignmentid + '"]');

                                            var inScoringMode = isInScoringMode();
                                            if (inScoringMode == false && !isMobile)
                                            {
                                                gradebook.updateEditModeNoDialog(true, input);
                                                gradebook.enableControl(advancedAssignmentInputs);
                                            }
                                            else if (inputHadMultipleAttempts == true && !isMobile)
                                            {
                                                gradebook.enableControl(input);
                                            }

                                            var saveData =
                                            {
                                                assignmentId: data.assignmentid,
                                                studentSectionId: data.studentsectionid,
                                                studentAssignmentId: inputData.studentassignmentid,
                                                isAvailable: inputData.isAvailable,
                                                sectionId: getSectionIDFromCell(input),
                                                Score: inputValue,
                                                displayValue: inputValue
                                            };

                                            var performGradesheetUpdateAndSave = function (gradebook, saveData)
                                            {
                                                var deferred = new $.Deferred();

                                                var valueToSave = gradebook.saveManager.assignmentManager.getChangedValues(saveData);
                                                if (valueToSave.length > 0)
                                                {
                                                    var data = $.extend({}, valueToSave[0]);
                                                    delete data.originalValues;
                                                    delete data.hasChanges;

                                                    data.ForceRecalculation = true;
                                                    data.SkipGradesheetResultValueChangeCheck = true;

                                                    var promise = gradebook.saveManager.saveManager.save(data, "Gradebook/Gradebook/UpdateGradeSheetData");
                                                    gradebook.saveManager.assignmentManager.setValues(data, false);
                                                    $.when(promise).then(function (response)
                                                    {
                                                        setSaveResponseOriginalValues(response, valueToSave);
                                                        if (gradebook)
                                                        {
                                                            checkAjaxResponseForErrors(response, gradebook.saveManager.assignmentManager.handleSaveResponse, [false, response, gradebook, response.objectsToUpdate]);
                                                        }
                                                        else if (response && response.success == false)
                                                        {
                                                            skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
                                                        }
                                                        else
                                                        {
                                                            gradebook.saveManager.assignmentManager.handleSaveResponse(false, response, gradebook, response.objectsToUpdate);
                                                        }
                                                        deferred.resolve();
                                                    });
                                                }
                                                else
                                                {
                                                    deferred.resolve();
                                                }

                                                return deferred;
                                            };

                                            var svgName = 'MultipleAttempts';
                                            var classToUpdate = 'hiddenMultipleAttempts';

                                            if (!isMobile)
                                            {
                                                $.when(performGradesheetUpdateAndSave(gradebook, saveData)).done(function ()
                                                {
                                                    if (inScoringMode == false)
                                                    {
                                                        gradebook.updateEditModeNoDialog(false, input);
                                                        gradebook.disableControl(advancedAssignmentInputs);
                                                    }
                                                    var assignmentIndicatorSelector = "#" + BROWSE_NAME + "_" + inputData.studentsectionid + "_" + inputData.assignmentid + "_" + "Score";
                                                    var hiddenSvgContainerSelector = "#" + BROWSE_NAME;

                                                    if (returnData.totalAttemptCount > 1)
                                                    {
                                                        input.addClass('hasAttempts');
                                                        gradebook.disableControl(input);
                                                        addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
                                                    }
                                                    else
                                                    {
                                                        if (isInScoringMode == true)
                                                        {
                                                            gradebook.enableControl(input);
                                                        }
                                                        removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
                                                    }
                                                    unbreakableGlass.close();
                                                    dialog.close();
                                                });
                                            }
                                            else
                                            {
                                                var assignmentIndicatorSelector = ".fieldWrapper.studentAssignmentScore[data-assignmentid='" + inputData.assignmentid + "'][data-studentsectionid='" + inputData.studentsectionid + "']";
                                                var hiddenSvgContainerSelector = "#editStudentAssignments";
                                                var inputElement = input.length > 0 ? input[0] : null;
                                                if (returnData.totalAttemptCount > 1)
                                                {
                                                    input.addClass('hasAttempts');
                                                    inputElement.disabled = true;
                                                    inputElement.readOnly = true;

                                                    var gradeMarkScoringEEL = input.parents('div.gradeMarkScoring');
                                                    if (gradeMarkScoringEEL.length > 0)
                                                    {
                                                        var button = input.siblings('a');
                                                        if (button.length > 0)
                                                        {
                                                            button.addClass('ui-disabled');
                                                        }

                                                        var innerCodeEELDiv = input.parent();
                                                        if (innerCodeEELDiv.length > 0)
                                                        {
                                                            innerCodeEELDiv.addClass('readonly');
                                                        }
                                                    }

                                                    addSVGToStudentAssignment(svgName, classToUpdate, assignmentIndicatorSelector, hiddenSvgContainerSelector);
                                                }
                                                else
                                                {
                                                    inputElement.disabled = false;
                                                    inputElement.readOnly = false;

                                                    var gradeMarkScoringEEL = input.parents('div.gradeMarkScoring');
                                                    if (gradeMarkScoringEEL.length > 0)
                                                    {
                                                        var button = input.siblings('a');
                                                        if (button.length > 0)
                                                        {
                                                            button.removeClass('ui-disabled');
                                                        }

                                                        var innerCodeEELDiv = input.parent();
                                                        if (innerCodeEELDiv.length > 0)
                                                        {
                                                            innerCodeEELDiv.removeClass('readonly');
                                                        }
                                                    }

                                                    removeSVGFromStudentAssignment(assignmentIndicatorSelector, classToUpdate);
                                                }
                                                unbreakableGlass.close();
                                                dialog.close();
                                            }
                                        });
                                    }
                                    else
                                    {
                                        var baseErrorContainer = dialog.container.find('#CurrentRecordContentBaseError');
                                        skyward.validation.displayValidationMessages(returnData, dialog.container, baseErrorContainer);
                                    }
                                }
                            });
                    });
                },
                "icon": "Save",
                "data": data
            };

            var cancelButton =
            {
                text: "Cancel",
                "click": function () { dialog.close(); },
                "icon": "Cancel"
            };

            var options =
            {
                closeOnEscape: true,
                draggable: false
            };

            var buildPopup = function ()
            {
                var localGradebookData = $('#' + BROWSE_NAME).data();

                return $.ajax(
                    {
                        url: skyward.global.virtualDir + "Gradebook/StudentAssignment/StudentAssignmentAttemptPopup" + (localGradebookData != null && localGradebookData.isTeacherTracker ? "TeacherTracker" : ""),
                        type: "POST",
                        converters:
                        {
                            'HTML updatedHTML': function (returnData)
                            {
                                const html = $(returnData);
                                const attemptNumberLabels = html.find(".attemptNumberLabel");
                                for (let counter = 1; counter <= attemptNumberLabels.length; counter++)
                                {
                                    const currentLabel = attemptNumberLabels[counter - 1];
                                    currentLabel.textContent = counter;
                                }

                                return html.html();
                            }
                        },
                        dataType: "updatedHTML",
                        data: data,
                        success: function (returnData)
                        {
                            if (returnData == null || returnData == "")
                            {
                                dialog.close();
                            }
                            else if (returnData.includes('AttemptsPopupChildRecordQuickEntryIsDisabled') && returnData.split('AttemptsPopupChildRecordQuickEntryIsDisabled')[1].startsWith('="True"'))
                            {
                                dialog.container.find('button[title="Save"]').remove();
                            }
                        }
                    }).promise();
            };

            var dialog = skyward.modalLayer.showDialog('Attempts', buildPopup, [saveButton, cancelButton], options);

            dialog.content.on('change', 'input[id^="DateAttempted-"]', function (event, clearedRow)
            {
                var defaultAttemptType = dialog.content.find('div.childrecordquickentry').data('defaultattempttype');
                if (defaultAttemptType == 'R')
                {
                    SelectAttemptByDateAttempted();
                }
            });

            dialog.content.on('change', 'input[id^="Score-"]', function (event, clearedRow)
            {
                var input = $(this);
                HandleScoreChanged(input);
            });

            dialog.content.on('childrecordquickentry-row-added', function (event)
            {
                var popup = $(this);
                HandleAttemptCount(popup, null, false);

                var gradeMarkCodeEEL = popup.find('.gradebookInputCodeEEL:last').parents('.gradebookCodeEEL');
                if (gradeMarkCodeEEL.length > 0)
                {
                    skyward.gradebookcodeeel.registerCodeEEL(gradeMarkCodeEEL);
                }

                var checkbox = $("input.checkbox[id^='IsUsed-']:last");
                $("input.masked[id^='Score-']:last").data("originalValue", "");
                checkbox.click();
            });

            dialog.content.on('childrecordquickentry-row-cleared', function (event, clearedRow, isRowBeingRemoved)
            {
                var popup = $(this);
                HandleAttemptCount(popup, clearedRow, isRowBeingRemoved);

                var clearedRowCheckbox = clearedRow.find('input.checkbox[id^="IsUsed-"]');
                if (clearedRowCheckbox.is(':checked'))
                {
                    SelectAttempt(clearedRow, popup);
                }
            });

            dialog.content.on('childrecordquickentry-row-removed', function (event, clearedRow)
            {
                var popup = $(this);
                HandleAttemptCount(popup, clearedRow, true);

                var clearedRowCheckbox = clearedRow.find('input.checkbox[id^="IsUsed-"]');
                if (clearedRowCheckbox.is(':checked'))
                {
                    SelectAttempt(clearedRow, popup);
                }
            });

            dialog.content.on("gradebookInputCodeEELValid", ".gradebookInputCodeEEL", function (event, returnData)
            {
                var input = $(this);
                $.when(gradeMarkScoringEelComplete(event, returnData, gradebook, input)).done(function ()
                {
                    HandleScoreChanged(input);
                });
                input.data('selectedValueID', returnData.gradeMarkID);
            });

            dialog.content.on("gradebookInputCodeEELInvalid", ".gradebookInputCodeEEL", gradeMarkScoringEelFailed);

            dialog.content.on("click", "input.checkbox[id^='IsUsed-']", function ()
            {
                var input = $(this);
                var allCheckboxes = $("input.checkbox[id^='IsUsed-']");
                allCheckboxes.each(function ()
                {
                    var checkbox = $(this);
                    if (!checkbox.is(input))
                    {
                        skyward.controls.setValue(checkbox, false);
                    }
                    else
                    {
                        skyward.controls.setValue(checkbox, true);
                    }
                });
            });

            function HandleScoreChanged(input)
            {
                var defaultAttemptType = dialog.content.find('div.childrecordquickentry').data('defaultattempttype');
                var datePicker = input.parents('tr.childrecordquickentryrow').find('input[id^="DateAttempted-"]');
                var pickedDate = datePicker.val();
                if (pickedDate == '' || pickedDate == null)
                {
                    skyward.controls.setValue(datePicker, skyward.time.now());
                }

                var inputValue = input.val();
                if (inputValue == "" || inputValue == ".")
                {
                    skyward.controls.setValue(input, getInputOriginalValue(input), true);
                }

                if (defaultAttemptType == 'S')
                {
                    SelectAttemptByScore();
                }
            }

            function SelectAttempt(clearedRow, popup)
            {
                var defaultAttemptType = popup.find('div.childrecordquickentry').data('defaultattempttype');

                if (defaultAttemptType == 'S')
                {
                    SelectAttemptByScore(clearedRow);
                }
                else if (defaultAttemptType == 'R')
                {
                    SelectAttemptByDateAttempted(clearedRow);
                }
                else
                {
                    var lastRow = $("tr.childrecordquickentryrow:visible:last");
                    var checkbox = lastRow.find("input.checkbox[id^='IsUsed-']:last");
                    if (lastRow.is(clearedRow))
                    {
                        checkbox = lastRow.siblings(':not(".removedElement"):visible').last().find('input.checkbox[id^="IsUsed-"]');
                    }
                    checkbox.click();
                }
            }

            function SelectAttemptByScore(clearedRow)
            {
                var rows = $("tr.childrecordquickentryrow:visible");
                var rowToUse;
                for (var i = 0; i < rows.length; i++)
                {
                    var currentRow = $(rows[i]);

                    if (currentRow.hasClass('removedElement'))
                    {
                        continue;
                    }
                    rowToUse = rowToUse || currentRow;

                    var useGradeMarkScoring = false;

                    var oldTop = rowToUse.find("input[id^='Score-']:last");
                    if (oldTop.length < 1)
                    {
                        oldTop = rowToUse.find('input[id^="GradeMarkID-"]:last');
                        useGradeMarkScoring = true;
                    }

                    var current = currentRow.find("input[id^='Score-']:last");
                    if (current.length < 1)
                    {
                        current = currentRow.find('input[id^="GradeMarkID-"]:last');
                        useGradeMarkScoring = true;
                    }

                    if ((useGradeMarkScoring == false && Number(current.val()) >= Number(oldTop.val()) && !currentRow.is(clearedRow)) ||
                        (useGradeMarkScoring == true && current.val() && current.val() != '' && Number(current.data('backingPercent')) >= Number(oldTop.data('backingPercent'))))
                    {
                        rowToUse = currentRow;
                    }
                }
                var checkbox = rowToUse.find("input.checkbox[id^='IsUsed-']:last");
                checkbox.click();
            }

            function SelectAttemptByDateAttempted(clearedRow)
            {
                var rows = $("tr.childrecordquickentryrow:visible");
                var rowToUse;
                for (var i = 0; i < rows.length; i++)
                {
                    var currentRow = $(rows[i]);
                    rowToUse = rowToUse || currentRow;

                    var current = skyward.time.parseDate(currentRow.find("input[id^='DateAttempted-']:last").val().split(' ')[0]);
                    var oldTop = skyward.time.parseDate(rowToUse.find("input[id^='DateAttempted-']:last").val().split(' ')[0]);
                    if (current instanceof Date && oldTop instanceof Date && current >= oldTop && !currentRow.is(clearedRow))
                    {
                        rowToUse = $(currentRow);
                    }
                }
                var checkbox = rowToUse.find("input.checkbox[id^='IsUsed-']:last");
                checkbox.click();
            }

            function HandleAttemptCount(popup, clearedRow, isRowBeingRemoved)
            {
                var rows = popup.find('tr[id*="-studentassignmentattempt-studentassignmentid-"]:not(".removedElement"):not(":hidden")');
                var counter = 0;

                rows.each(function ()
                {
                    var row = $(this);
                    if (clearedRow && clearedRow.is(row) && isRowBeingRemoved == true)
                    {
                        return;
                    }
                    var attemptCountLabel = row.find('.attemptsPopupAttemptNumber .attemptNumberLabel');
                    attemptCountLabel.text(++counter);
                });
            }
        };

        var setSaveResponseOriginalValues = function (response, valuesToSave)
        {
            if (!response || !response.objectsToUpdate || !valuesToSave)
            {
                return;
            }

            for (var i = 0; i < response.objectsToUpdate.length; i++)
            {
                var updateObject = response.objectsToUpdate[i];

                for (var i = 0; i < valuesToSave.length; i++)
                {
                    if (valuesToSave[i].saveManagerId === updateObject.saveManagerId)
                    {
                        updateObject.originalValues = valuesToSave[i].originalValues;
                        break;
                    }
                }
            }
        };

        var updateStudentGradeBucketCellClasses = function (inputElement, element, bucketData)
        {
            var indicatorSpan = '.studentGradeBucketIndicators';
            var gradeBucketScoreSpan = element.find(".gradeBucketScoreSpan");

            if (bucketData.IsOverMaxExtraCredit)
            {
                gradeBucketScoreSpan.removeClass("updated").addClass("updatedOverMaxExtraCredit");
                element.data("pointsOverMaxExtraCredit", bucketData.PointsOverMaxExtraCredit);
                setWarningIconClass(element, indicatorSpan, true);
            }
            else
            {
                gradeBucketScoreSpan.removeClass('updatedOverMaxExtraCredit').addClass("updated");
                setWarningIconClass(element, indicatorSpan, false);
            }

            if (bucketData.HasClosedGradingPeriodGradeChangeRequestInProgress)
            {
                if (!element.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
                {
                    element.addClass("gradeBucketGradeChangeNotReviewedOrInProgress");
                }
            }
            else if (element.hasClass("gradeBucketGradeChangeNotReviewedOrInProgress"))
            {
                element.removeClass("gradeBucketGradeChangeNotReviewedOrInProgress");
            }

            gradeBucketScoreSpan.removeClass('boldFont');
            if (bucketData.IsGradeModified || bucketData.IsLessThanMinimumPercent)
            {
                gradeBucketScoreSpan.addClass('boldFont');
            }

            HandleTransferBuckets(element, bucketData);

            setInfoIconClass(element, indicatorSpan, bucketData.HasUnscoredRequiredFeederBucket, bucketData.IsAdminOverride);
        };

        var HandleTransferBuckets = function (element, bucketData)
        {
            if (bucketData.IsTransferBucket == true)
            {
                if (element.hasClass('needsTransferRunProcess') && bucketData.GradeMarkID != null)
                {
                    element.find(".scoreDiv").removeClass("displayNone");
                    element.removeClass("needsTransferRunProcess");
                    element.find(".runTransferProcess").addClass("displayNone");
                    element.attr("data-click-action", element.data().originalClickAction);
                }
                else if (!element.hasClass('needsTransferRunProcess') && bucketData.GradeMarkID == null)
                {
                    element.find(".scoreDiv").addClass("displayNone");
                    element.addClass("needsTransferRunProcess");
                    element.find(".runTransferProcess").removeClass("displayNone");
                    element.removeAttr("data-click-action");
                }
            }
        };

        var setInfoIconClass = function (element, span, hasUnscoredRequiredFeederBucket, isAdminOverride)
        {
            var indicatorSpan = element.find(span);

            if (indicatorSpan.length < 1)
            {
                return;
            }
            if (hasUnscoredRequiredFeederBucket || isAdminOverride)
            {
                indicatorSpan.find('.studentGradeBucketIsAdminOverrideButton').data('hasUnscoredRequiredFeederBucket', hasUnscoredRequiredFeederBucket);
                indicatorSpan.removeClass('hiddenIsAdminOverride');
            }
            else
            {
                indicatorSpan.addClass('hiddenIsAdminOverride');
            }
        };

        var setWarningIconClass = function (element, span, show)
        {
            var indicatorSpan = element.find(span);

            if (indicatorSpan.length < 1)
            {
                return;
            }
            show ? indicatorSpan.removeClass('hiddenWarning') : indicatorSpan.addClass('hiddenWarning');
        };

        var removeCellErrorClasses = function (element, additionalClassesToRemove)
        {
            element.removeClass("updatedWithErrors hasErrors");
            if (additionalClassesToRemove)
            {
                element.removeClass(additionalClassesToRemove);
            }
        };

        var checkAjaxResponseForErrors = function (response, callback, callbackParams, thisElement) //callbackParams and thisElement is optional
        {
            if (response && response.success == false && response.popupHTML && response.popupHTML.Content)
            {
                skyward.modalLayer.showReloadDialog(ALERT_HEADER, response.popupHTML.Content);
            }
            else if (callback instanceof Function)
            {
                if (callbackParams == null)
                {
                    callbackParams = [];
                    callbackParams.push(response);
                }
                callback.apply(thisElement, callbackParams);
            }
        }

        var addCellErrorClasses = function (element)
        {
            element.css({ backgroundColor: '', color: '' });
            element.addClass('hasErrors');
        };

        var initMassDeleteTeacherOverridesTempSectionsBrowse = function ()
        {
            var browse = $(this);

            var updateSettingBrowse = function ()
            {
                var currentRow = browse.find(".current");
                var noteColumn = currentRow.find("td[data-note]");
                var value = "";
                if (noteColumn && noteColumn.length > 0)
                {
                    value = noteColumn.data().note;
                }

                var hideAssignmentsBrowse = true;
                var hideGradeBucketsBrowse = true;
                if (value == "Assignment")
                {
                    hideAssignmentsBrowse = false;
                    browse.parents('.threeBrowses').removeClass('threeBrowses').addClass('twoBrowses');
                }
                else if (value == "Grade Bucket")
                {
                    hideGradeBucketsBrowse = false;
                    browse.parents('.twoBrowses').removeClass('twoBrowses').addClass('threeBrowses');
                }

                if (hideAssignmentsBrowse)
                {
                    $("#TempSectionAssignments").hide();
                    $("#TempAssignmentErrors").hide();
                }
                else
                {
                    $("#TempSectionAssignments").show();
                    $("#TempAssignmentErrors").show();

                    $("#TempSectionAssignments").parents('.threeBrowses').removeClass('threeBrowses').addClass('twoBrowses');
                }

                if (hideGradeBucketsBrowse)
                {
                    $("#TempSectionGradeBuckets").hide();
                }
                else
                {
                    $("#TempSectionGradeBuckets").show();

                    $("#TempSectionGradeBuckets").parents('.twoBrowses').removeClass('twoBrowses').addClass('threeBrowses');
                }
            };

            browse.on("rowChanged", function ()
            {
                updateSettingBrowse();
            });

            browse.on("browseLoaded." + browse.attr("id"), function () { updateSettingBrowse(); });
        }

        var events =
        {
            'redirectToSpecificGradeBucket': skyward.gradebook.redirectToSpecificGradeBucket,
            'redirectToSpecificGradeBucketSubject': skyward.gradebook.redirectToSpecificGradeBucketSubject,
            'redirectToSpecificGradeBucketAcademicStandard': skyward.gradebook.redirectToSpecificGradeBucketAcademicStandard,
            'completedGradingPeriod': completedGradingPeriod,
            'gradingPeriodUnlocked': gradingPeriodUnlocked,
            'studentGradeBucketIsAdminOverride': studentGradeBucketIsAdminOverride,
            'studentGradeBucketHasTransferGrade': studentGradeBucketHasTransferGrade,
            'unscoredPastDueAssignments': unscoredPastDueAssignments,
            'roundedAdjustedWeightFormula': roundedAdjustedWeightFormula,
            'showGradebookLoadTimes': showGradebookLoadTimes,
            'viewStudentSchedule': viewStudentSchedule,
            'copyMatchingTransferAssignments': copyMatchingTransferAssignments,
            'clearTransferValues': clearTransferValues,
            'copyMatchingTransferClosedBuckets': copyMatchingTransferClosedBuckets,
            'copyMatchingTransferSubjectStandards': copyMatchingTransferSubjectStandards,
            'copyMatchingOutOfDistrictTransferClosedBuckets': copyMatchingOutOfDistrictTransferClosedBuckets,
            'copyMatchingTransferClosedGradeCategories': copyMatchingTransferClosedGradeCategories,
            'progressReportSubHeaderPopup': progressReportSubHeaderPopup,
            'redirectToAssignment': skyward.gradebook.redirectToAssignment,
            'updateClosedGradingPeriodGradeChange': updateClosedGradingPeriodGradeChange,
            'assignmentIndicatorPopup': assignmentIndicatorPopup,
            'massAssignScoresPopupMobile': massAssignScoresPopupMobile,
            'updateAssignmentIndicatorsMobile': updateAssignmentIndicatorsMobile,
            'mobileAssignmentHeaderIndicatorsPopup': mobileAssignmentHeaderIndicatorsPopup,
            'initMassDeleteTeacherOverridesTempSectionsBrowse': initMassDeleteTeacherOverridesTempSectionsBrowse
        };

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);
        skyward.window.registerLoadDOMCallback(initProgressReportSelector);
        skyward.window.registerLayoutResizeCallback(resizeLockedBrowseBodyForHorizontalScrollBar);
        skyward.events.registerEvents('gradebook', events);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
